var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-masonry-registry.ts
import {
  MasonryDriverActionController,
  MasonryDriverNodeRenderersRegistry as MasonryDriverNodeRenderersRegistry2,
  MasonryWSDriverNodeRenderersRegistry
} from "@leagueplatform/masonry";

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-widget-v2.component.tsx
import React8 from "react";
import {
  StackLayout as StackLayout6
} from "@leagueplatform/genesis-core";
import { Orientation } from "@leagueplatform/masonry-api";
import { useGetTraitsForMedia } from "@leagueplatform/masonry-widgets";
import camelcaseKeys from "camelcase-keys";

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-header-v2.component.tsx
import React from "react";
import {
  HeadingText,
  StackLayout,
  TextAction
} from "@leagueplatform/genesis-core";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import {
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent,
  EVENT_NAME
} from "@leagueplatform/analytics";
import { SCREEN_NAMES } from "@leagueplatform/health-journey-common";
var ActivityStackHeaderV2 = ({
  heading,
  headerButtonLabel,
  headerLinkUrl
}) => {
  const trackViewAllClick = () => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.JOURNEY,
      sub_product_area: SUB_PRODUCT_AREA.ACTIVITY_STACK_WIDGET,
      screen_name: SCREEN_NAMES.ACTIVITY_TIMELINE,
      detail: headerButtonLabel,
      sub_detail: heading
    });
  };
  return /* @__PURE__ */ React.createElement(
    StackLayout,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: {
        width: "100%"
      }
    },
    heading && /* @__PURE__ */ React.createElement(HeadingText, { level: "3", size: "xl", css: { textWrap: "balance" } }, heading),
    headerButtonLabel && headerLinkUrl && /* @__PURE__ */ React.createElement(
      TextAction,
      {
        as: RouterLink,
        to: headerLinkUrl,
        css: { textDecoration: "none", textWrap: "nowrap" },
        onClick: trackViewAllClick
      },
      headerButtonLabel
    )
  );
};

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-content-v2.component.tsx
import React7 from "react";
import {
  Box,
  StackLayout as StackLayout5,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";

// src/components/configurable-journey-experience/priority-activity-card/priority-activity-card.component.tsx
import React6 from "react";
import {
  JOURNEY_ROUTES,
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION2,
  ComposableActivityCard,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE2,
  ActivityCardEyebrow
} from "@leagueplatform/health-journey-common";

// src/components/configurable-journey-experience/configurable-activity-card/utils/select-activity-analytics.util.ts
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2,
  PRODUCT_AREA as PRODUCT_AREA2
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES2 } from "@leagueplatform/health-journey-common";
var selectActivityAnalytics = (activity) => {
  const {
    campaignInfo,
    id,
    name,
    type,
    status,
    priority,
    detailLevel,
    activityProgressData
  } = activity;
  const activityProgressDataGoalTotal = (activityProgressData == null ? void 0 : activityProgressData.length) && activityProgressData[0].goalTotal || 0;
  const activityProgressDataCurrentProgress = (activityProgressData == null ? void 0 : activityProgressData.length) && activityProgressData[0].currentProgress || 0;
  return trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA2.JOURNEY,
    screen_name: SCREEN_NAMES2.ACTIVITY_TIMELINE,
    detail: "view health campaign activity",
    health_campaign_name: campaignInfo == null ? void 0 : campaignInfo.name,
    health_campaign_id: campaignInfo == null ? void 0 : campaignInfo.campaignId,
    health_campaign_type: campaignInfo == null ? void 0 : campaignInfo.campaignType,
    health_campaign_activity_id: id,
    health_campaign_activity_name: name,
    health_campaign_activity_type: type,
    health_campaign_activity_status: status,
    health_campaign_activity_priority: priority,
    health_campaign_activity_composition: detailLevel,
    health_campaign_activity_goal: activityProgressDataGoalTotal,
    health_campaign_activity_current_progress: activityProgressDataCurrentProgress
  });
};

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-card-headline.component.tsx
import React2 from "react";
import {
  ActivityCardHeadline,
  CONFIGURABLE_ACTIVITY_PRIORITY
} from "@leagueplatform/health-journey-common";
var MediumPriorityHeadline = ({ tagline }) => {
  if (!tagline) {
    return null;
  }
  return /* @__PURE__ */ React2.createElement(
    ActivityCardHeadline,
    {
      color: "$decorativeBrandPrimaryDark",
      backgroundColor: "$decorativeBrandPrimaryPastel"
    },
    tagline.toUpperCase()
  );
};
var HighPriorityHeadline = ({ tagline }) => {
  if (!tagline) {
    return null;
  }
  return /* @__PURE__ */ React2.createElement(
    ActivityCardHeadline,
    {
      color: "$onSurfaceTextReversed",
      backgroundColor: "$decorativeBrandPrimaryDark"
    },
    tagline.toLocaleUpperCase()
  );
};
var priorityHeadlineMap = {
  [CONFIGURABLE_ACTIVITY_PRIORITY.LOW]: () => null,
  [CONFIGURABLE_ACTIVITY_PRIORITY.MEDIUM]: (tagline) => /* @__PURE__ */ React2.createElement(MediumPriorityHeadline, { tagline }),
  [CONFIGURABLE_ACTIVITY_PRIORITY.HIGH]: (tagline) => /* @__PURE__ */ React2.createElement(HighPriorityHeadline, { tagline })
};

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-card-footer.component.tsx
import React3 from "react";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import {
  StackLayout as StackLayout2,
  queryHelpers,
  useMediaQuery
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import {
  ActivityCardFooterItem,
  useGetUserProfile
} from "@leagueplatform/health-journey-common";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";

// src/types/health-journey-asset-keys.types.ts
var HEALTH_JOURNEY_ASSET_KEYS = /* @__PURE__ */ ((HEALTH_JOURNEY_ASSET_KEYS2) => {
  HEALTH_JOURNEY_ASSET_KEYS2["ALARM_CLOCK"] = "ALARM_CLOCK";
  HEALTH_JOURNEY_ASSET_KEYS2["CALENDAR"] = "CALENDAR";
  HEALTH_JOURNEY_ASSET_KEYS2["CHALLENGE_TOKEN"] = "CHALLENGE_TOKEN";
  HEALTH_JOURNEY_ASSET_KEYS2["CHALLENGE_TOKEN_SUBDUED"] = "CHALLENGE_TOKEN_SUBDUED";
  HEALTH_JOURNEY_ASSET_KEYS2["ARROW_LEFT"] = "ARROW_LEFT";
  HEALTH_JOURNEY_ASSET_KEYS2["ARROW_RIGHT"] = "ARROW_RIGHT";
  HEALTH_JOURNEY_ASSET_KEYS2["HEART_RATE_UP"] = "HEART_RATE_UP";
  HEALTH_JOURNEY_ASSET_KEYS2["HIGH_PRIORITY_ICON"] = "HIGH_PRIORITY_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["LEAGUE_LOGO"] = "LEAGUE_LOGO";
  HEALTH_JOURNEY_ASSET_KEYS2["LEAGUE_LOGO_SUBDUED"] = "LEAGUE_LOGO_SUBDUED";
  HEALTH_JOURNEY_ASSET_KEYS2["MINUS"] = "MINUS";
  HEALTH_JOURNEY_ASSET_KEYS2["MOBILE_ALERT_USER"] = "MOBILE_ALERT_USER";
  HEALTH_JOURNEY_ASSET_KEYS2["PLUS"] = "PLUS";
  HEALTH_JOURNEY_ASSET_KEYS2["SUCCESS_STATUS_ALTERNATIVE"] = "SUCCESS_STATUS_ALTERNATIVE";
  HEALTH_JOURNEY_ASSET_KEYS2["REQUIRED_ICON"] = "REQUIRED_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["COMPLETE_BY_ICON"] = "COMPLETE_BY_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["REWARDS_POINTS_ICON"] = "REWARDS_POINTS_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["REWARDS_PROGRAM_ICON"] = "REWARDS_PROGRAM_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["ACTIVITY_POINTS_ICON"] = "ACTIVITY_POINTS_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["REMOVE_ACTIVITY_IMAGE"] = "REMOVE_ACTIVITY_IMAGE";
  HEALTH_JOURNEY_ASSET_KEYS2["EMPTY_STATE_ACHIEVEMENTS"] = "EMPTY_STATE_ACHIEVEMENTS";
  HEALTH_JOURNEY_ASSET_KEYS2["EMPTY_STATE_PROGRAMS"] = "EMPTY_STATE_PROGRAMS";
  HEALTH_JOURNEY_ASSET_KEYS2["EMPTY_STATE_PROGRESS"] = "EMPTY_STATE_PROGRESS";
  HEALTH_JOURNEY_ASSET_KEYS2["EMPTY_STATE_REST"] = "EMPTY_STATE_REST";
  HEALTH_JOURNEY_ASSET_KEYS2["EMPTY_STATE_HISTORY"] = "EMPTY_STATE_HISTORY";
  HEALTH_JOURNEY_ASSET_KEYS2["HIGH_FIVE"] = "HIGH_FIVE";
  HEALTH_JOURNEY_ASSET_KEYS2["WARNING_ICON"] = "WARNING_ICON";
  HEALTH_JOURNEY_ASSET_KEYS2["WAVE_GOODBYE"] = "WAVE_GOODBYE";
  HEALTH_JOURNEY_ASSET_KEYS2["JOURNEY_HEADER_BACKGROUND_IMAGE"] = "JOURNEY_HEADER_BACKGROUND_IMAGE";
  return HEALTH_JOURNEY_ASSET_KEYS2;
})(HEALTH_JOURNEY_ASSET_KEYS || {});

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-card-footer.component.tsx
import { Badge } from "@leagueplatform/web-common-components";
var {
  REQUIRED_ICON,
  ACTIVITY_POINTS_ICON,
  REWARDS_POINTS_ICON,
  REWARDS_PROGRAM_ICON,
  COMPLETE_BY_ICON
} = HEALTH_JOURNEY_ASSET_KEYS;
var baseIconProps = { css: { minWidth: "$one" }, size: "$one" };
var footerIconMap = {
  [2 /* ACTIVITY_POINTS */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(ACTIVITY_POINTS_ICON)
  }),
  [0 /* REWARD_POINTS */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(REWARDS_POINTS_ICON)
  }),
  [1 /* REWARD_PROGRAM */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(REWARDS_PROGRAM_ICON)
  }),
  [3 /* COMPLETE_BY */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(COMPLETE_BY_ICON)
  }),
  [5 /* REQUIRED */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(REQUIRED_ICON)
  }),
  [4 /* EXPIRES */]: () => __spreadProps(__spreadValues({}, baseIconProps), {
    icon: handleStaticAsset(COMPLETE_BY_ICON)
  })
};
var PriorityActivityCardFooter = ({
  activity
}) => {
  const { formatMessage, formatDate } = useIntl();
  const isBelowMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const {
    activityPoints,
    activityRewardInfo,
    canExpire,
    endDate,
    required,
    campaignInfo
  } = activity;
  const { data: userProfileData } = useGetUserProfile();
  const { defaultTimezone } = userProfileData || {};
  const qualifiesForRewardProgram = campaignInfo == null ? void 0 : campaignInfo.qualifiesForRewardProgram;
  const displayCompleteBy = canExpire && !!endDate && required;
  const displayExpiryDate = canExpire && !!endDate && !required;
  let rewardsPoints;
  if ((activityRewardInfo == null ? void 0 : activityRewardInfo.type) === "reward_points") {
    rewardsPoints = activityRewardInfo.available;
  }
  const displayFooter = qualifiesForRewardProgram || !!rewardsPoints || !!activityPoints || required || displayCompleteBy || displayExpiryDate;
  if (!displayFooter)
    return null;
  return /* @__PURE__ */ React3.createElement(
    StackLayout2,
    {
      orientation: isBelowMobile ? "vertical" : "horizontal",
      verticalAlignment: "center",
      spacing: "$half $oneAndHalf",
      css: { flexWrap: "wrap" }
    },
    qualifiesForRewardProgram && /* @__PURE__ */ React3.createElement(Badge, { css: { backgroundColor: "$decorativeBrandSecondaryPastel" } }, /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[1 /* REWARD_PROGRAM */]()
      },
      formatMessage({ id: "REWARDS_PROGRAM_ELIGIBLE" })
    )),
    !!rewardsPoints && /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[0 /* REWARD_POINTS */]()
      },
      formatMessage({ id: "X_REWARD_POINTS" }, { points: rewardsPoints })
    ),
    !!activityPoints && /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[2 /* ACTIVITY_POINTS */]()
      },
      formatMessage({ id: "X_LEAGUE_POINTS" }, { points: activityPoints })
    ),
    required && /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[5 /* REQUIRED */]()
      },
      formatMessage({ id: "REQUIRED" })
    ),
    displayCompleteBy && /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[3 /* COMPLETE_BY */]()
      },
      formatMessage(
        { id: "COMPLETE_BY_DATE" },
        {
          date: formatDate(endDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
            timeZone: defaultTimezone
          }))
        }
      )
    ),
    displayExpiryDate && /* @__PURE__ */ React3.createElement(
      ActivityCardFooterItem,
      {
        iconProps: footerIconMap[3 /* COMPLETE_BY */]()
      },
      formatMessage(
        { id: "ACTIVITY_EXPIRY_DATE" },
        {
          date: formatDate(endDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
            timeZone: defaultTimezone
          }))
        }
      )
    )
  );
};

// src/components/configurable-journey-experience/priority-activity-card-common/activity-card-utils.utils.ts
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { ACTIVITY_CAMPAIGN_TYPE } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var metricUnits = [
  "count",
  "s",
  "m",
  "min",
  "cal",
  "kcal",
  "bmp",
  "km",
  "mg/dl"
];
var digits = {
  distance: 1,
  steps: 0,
  active_duration: 0,
  mindful_duration: 0,
  floors_climbed: 0,
  energy_burned: 0
};
function useLocaleUnitFormatter() {
  const { $tmap } = useIntl2();
  const getMetricUnit = $tmap({
    steps: "INSIGHT_CARD_UNIT_STEPS",
    floors_climbed: "INSIGHT_CARD_UNIT_FLOORS_CLIMBED"
  });
  const getUnit = $tmap({
    count: "COUNT",
    s: "S",
    m: "M",
    min: "MIN",
    cal: "CAL",
    kcal: "KCAL",
    bmp: "BMP",
    km: "KM",
    "mg/dl": "MG/DL"
  });
  const formatUnit = (type, unit, value = 0) => {
    if (type === "steps" || type === "floors_climbed") {
      return getMetricUnit(type, { count: value });
    }
    if (metricUnits.includes(unit)) {
      return getUnit(unit, { count: value });
    }
    return `${value} ${unit}`;
  };
  return { formatUnit };
}
function useLocaleMetricValueFormatter() {
  const { formatNumber } = useIntl2();
  function formatMetricValue(value, type) {
    const maximumFractionDigits = digits[type];
    if (value === null) {
      return null;
    }
    return formatNumber(value, { maximumFractionDigits });
  }
  return { formatMetricValue };
}
var eyebrowIconMap = {
  [ACTIVITY_CAMPAIGN_TYPE.CHALLENGE]: () => ({
    icon: "tinyStar",
    tint: "$warningBorderDefault",
    css: { minWidth: "$threeQuarters" },
    size: "$threeQuarters"
  }),
  [ACTIVITY_CAMPAIGN_TYPE.OPTIN]: () => ({
    icon: "descriptiveHeartFilled",
    tint: "$decorativeBrandPrimaryDefault",
    css: { minWidth: "$one" },
    size: "$one"
  }),
  [ACTIVITY_CAMPAIGN_TYPE.REWARD]: () => ({
    icon: handleStaticAsset2(
      "REWARDS_PROGRAM_ICON" /* REWARDS_PROGRAM_ICON */
    ),
    size: "$one"
  }),
  [ACTIVITY_CAMPAIGN_TYPE.SUGGESTED]: () => null
};

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-card-activity-body.component.tsx
import React5 from "react";
import { ParagraphText as ParagraphText2, StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
import { CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION } from "@leagueplatform/health-journey-common";

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-progress.component.tsx
import React4 from "react";
import {
  ParagraphText,
  StackItem,
  StackLayout as StackLayout3,
  UtilityText
} from "@leagueplatform/genesis-core";
import { ProgressBar } from "@leagueplatform/web-common-components";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
var styledText = (msg) => /* @__PURE__ */ React4.createElement(
  UtilityText,
  {
    emphasis: "emphasized",
    css: {
      color: "$onSurfaceTextSuccess"
    }
  },
  msg
);
var PriorityActivityProgress = ({
  progress,
  goal,
  unit,
  type
}) => {
  const { formatMessage } = useIntl3();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ React4.createElement(StackLayout3, { spacing: "$none" }, /* @__PURE__ */ React4.createElement(ParagraphText, { as: "span", emphasis: "subtle" }, formatMessage(
    { id: "X_OF_Y_COMPLETED_WITH_UNIT" },
    {
      progress: formatMetricValue(progress, type),
      goal: formatMetricValue(goal, type),
      unit: formatUnit(type, unit, progress),
      span: styledText
    }
  )), /* @__PURE__ */ React4.createElement(
    StackLayout3,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: {
        width: "100%"
      }
    },
    /* @__PURE__ */ React4.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React4.createElement(
      ProgressBar,
      {
        current: progress,
        total: goal,
        customBarBackgroundColor: "interactive.border.disabled",
        customBarFillColor: "success.border.default"
      }
    ))
  ));
};

// src/components/configurable-journey-experience/priority-activity-card-common/components/priority-activity-card-activity-body.component.tsx
function checkActivityProgressData(data) {
  if (data.currentProgress !== void 0 && data.currentProgress !== null && // @ts-ignore
  data.currentProgress !== "" && data.goalTotal !== void 0 && data.goalTotal !== null && // @ts-ignore
  data.goalTotal !== "" && data.dataType !== void 0 && data.dataType !== null && // @ts-ignore
  data.dataType !== "" && data.unit !== void 0 && data.unit !== null && // @ts-ignore
  data.unit !== "") {
    return true;
  }
  return false;
}
var ActivityBody = ({
  activity
}) => {
  const { shortDescription, detailLevel, activityProgressData } = activity;
  const displayShortDescription = detailLevel === CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION.DETAILED;
  if (activityProgressData == null ? void 0 : activityProgressData.length) {
    return /* @__PURE__ */ React5.createElement(StackLayout4, { spacing: "$half", horizontalAlignment: "stretch" }, activityProgressData.filter(checkActivityProgressData).map((progressData) => /* @__PURE__ */ React5.createElement(
      PriorityActivityProgress,
      {
        progress: progressData.currentProgress,
        goal: progressData.goalTotal,
        unit: progressData.unit,
        type: progressData.dataType
      }
    )));
  }
  if (displayShortDescription) {
    return /* @__PURE__ */ React5.createElement(ParagraphText2, { emphasis: "subtle", size: "sm" }, shortDescription);
  }
  return null;
};

// src/components/configurable-journey-experience/priority-activity-card/priority-activity-card.component.tsx
var PriorityActivityCard = ({
  ctaURL,
  onClick,
  activity,
  headingLevel
}) => {
  const {
    id,
    name,
    activityImage,
    detailLevel,
    priority,
    campaignInfo,
    type,
    tagline
  } = activity;
  const displayImage = detailLevel !== CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION2.SIMPLE && activityImage;
  const imageProps = displayImage ? { image: activityImage, altText: "" } : void 0;
  const displayEyebrow = campaignInfo && campaignInfo.campaignType !== ACTIVITY_CAMPAIGN_TYPE2.SUGGESTED;
  const handleClickAnalytics2 = () => selectActivityAnalytics(activity);
  return /* @__PURE__ */ React6.createElement(
    ComposableActivityCard,
    {
      body: /* @__PURE__ */ React6.createElement(ActivityBody, { activity }),
      cta: ctaURL || JOURNEY_ROUTES.getActivityDetails(id, type),
      eyebrow: displayEyebrow ? /* @__PURE__ */ React6.createElement(
        ActivityCardEyebrow,
        {
          iconProps: eyebrowIconMap[campaignInfo.campaignType]()
        },
        campaignInfo.name
      ) : null,
      footer: /* @__PURE__ */ React6.createElement(PriorityActivityCardFooter, { activity }),
      headline: priorityHeadlineMap[priority](tagline),
      title: { text: name, level: headingLevel },
      image: imageProps,
      onClick: () => {
        if (onClick) {
          onClick();
          return;
        }
        handleClickAnalytics2();
      }
    }
  );
};

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-content-v2.component.tsx
var ActivityStackContentV2 = ({
  subheading,
  items,
  orientation = "vertical"
}) => {
  const cardWidth = orientation === "horizontal" ? "calc(50% - $threeQuarters)" : "100%";
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, subheading && /* @__PURE__ */ React7.createElement(StackLayout5, { orientation: "vertical" }, /* @__PURE__ */ React7.createElement(UtilityText2, null, subheading)), /* @__PURE__ */ React7.createElement(
    StackLayout5,
    {
      as: "ul",
      orientation,
      horizontalAlignment: "spaceBetween",
      css: {
        flexWrap: "wrap",
        gap: "$one",
        width: "100%"
      }
    },
    items == null ? void 0 : items.map((item) => {
      var _a;
      return /* @__PURE__ */ React7.createElement(
        Box,
        {
          as: "li",
          key: (_a = item == null ? void 0 : item.attributes) == null ? void 0 : _a.id,
          css: {
            minWidth: cardWidth,
            maxWidth: cardWidth,
            "@mobile": {
              minWidth: "100%"
            }
          }
        },
        /* @__PURE__ */ React7.createElement(PriorityActivityCard, { activity: item.attributes, headingLevel: "4" })
      );
    })
  ));
};

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-widget-v2.component.tsx
var ActivityStackWidgetV2 = ({
  heading = "",
  subheading = "",
  headerButtonLabel,
  headerLinkUrl,
  items,
  traits
}) => {
  const traitItems = useGetTraitsForMedia(traits);
  const activityCardsOrientation = (traitItems == null ? void 0 : traitItems.orientation) === Orientation.HORIZONTAL ? "horizontal" : "vertical";
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  const camelCasedItems = camelcaseKeys(items, {
    deep: true
  });
  const hasHeaderParams = Boolean(
    heading || headerButtonLabel || headerLinkUrl
  );
  return /* @__PURE__ */ React8.createElement(
    StackLayout6,
    {
      orientation: "vertical",
      spacing: "$one",
      css: { width: "100%", marginBottom: "$one" }
    },
    hasHeaderParams && /* @__PURE__ */ React8.createElement(
      ActivityStackHeaderV2,
      {
        heading: heading || "",
        headerButtonLabel: headerButtonLabel || "",
        headerLinkUrl: headerLinkUrl || ""
      }
    ),
    /* @__PURE__ */ React8.createElement(
      ActivityStackContentV2,
      {
        subheading: subheading || "",
        items: camelCasedItems,
        orientation: activityCardsOrientation
      }
    )
  );
};

// src/components/configurable-journey-experience/masonryV2/node-renderers/topic-page/hero-banner-node-renderer-override.tsx
import React9 from "react";
import {
  MasonryHeroBannerRenderer
} from "@leagueplatform/masonry-renderers";
import { Box as Box2 } from "@leagueplatform/genesis-core";
var MasonryHeroBannerRendererOverride = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React9.createElement(
    Box2,
    {
      css: {
        ".masonry-page-header-background::before": {
          display: "none"
        },
        ".masonry-page-header-background": {
          height: "unset",
          marginBlock: "$two"
        }
      }
    },
    /* @__PURE__ */ React9.createElement(
      MasonryHeroBannerRenderer,
      __spreadValues({}, props)
    )
  );
};

// src/components/configurable-journey-experience/priority-activities-widget/priority-activities-widget.component.tsx
import React19 from "react";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { StackLayout as StackLayout8, Box as Box8 } from "@leagueplatform/genesis-core";
import { Flex as Flex3, genesisStyled as genesisStyled4 } from "@leagueplatform/genesis-commons";
import { SkeletonBox, ErrorState } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
import {
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS4,
  HEALTH_JOURNEY_COMMON_ASSET_KEYS,
  JOURNEY_ROUTES as JOURNEY_ROUTES3,
  ENABLE_V3_ACTIVITY_CARDS,
  SCREEN_NAMES as SCREEN_NAMES3
} from "@leagueplatform/health-journey-common";
import {
  EVENT_NAME as EVENT_NAME3,
  PRODUCT_AREA as PRODUCT_AREA3,
  trackAnalyticsEvent as trackAnalyticsEvent3
} from "@leagueplatform/analytics";

// src/components/configurable-journey-experience/configurable-activity-card/configurable-activity-card.component.tsx
import React17 from "react";
import { Flex as Flex2 } from "@leagueplatform/genesis-commons";
import {
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION8,
  JOURNEY_ROUTES as JOURNEY_ROUTES2
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
import { ACHIEVEMENTS_ENABLED as ACHIEVEMENTS_ENABLED3 } from "@leagueplatform/rewards-achievements";

// src/utils/configure-activity-card-progress.util.js
import { HEALTH_JOURNEY_ACTIVITY_STATUS } from "@leagueplatform/health-journey-common";
import camelcaseKeys2 from "camelcase-keys";
var { UPCOMING } = HEALTH_JOURNEY_ACTIVITY_STATUS;
var configureActivityCardProgress = (activity) => {
  const camelcasedActivity = camelcaseKeys2(activity, { deep: true });
  const {
    completionCounter = {},
    activityVerificationProgress = {},
    status,
    frontOfTheLineActivity: isFrontOfLine2 = false
  } = camelcasedActivity;
  const { countProgress: progress = 0 } = activityVerificationProgress;
  const { unit, goal } = completionCounter;
  const isProgressActivity = Boolean(unit && goal && status !== UPCOMING);
  const progressProps = {
    unit,
    goal,
    progress,
    status,
    isFrontOfLine: isFrontOfLine2
  };
  return { isProgressActivity, progressProps };
};

// src/components/configurable-journey-experience/configurable-activity-card/utils/get-configurable-activity-card-details.utils.ts
import {
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE3,
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION3,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS2
} from "@leagueplatform/health-journey-common";
var getInactiveActivityStatusBooleans = (activity) => {
  const { status } = activity;
  const { COMPLETED: COMPLETED11, EXPIRED: EXPIRED7, REMOVED: REMOVED7 } = HEALTH_JOURNEY_ACTIVITY_STATUS2;
  const isCompleted2 = status === COMPLETED11;
  const isMissed2 = status === EXPIRED7 || status === REMOVED7;
  const isCompletedOrMissed = isCompleted2 || isMissed2;
  return {
    isCompleted: isCompleted2,
    isMissed: isMissed2,
    isCompletedOrMissed
  };
};
var getIsActivityForChallenge = (activity) => {
  const { campaignInfo, activityTokens } = activity;
  const { CHALLENGE: CHALLENGE10 } = ACTIVITY_CAMPAIGN_TYPE3;
  return (campaignInfo == null ? void 0 : campaignInfo.campaignType) === CHALLENGE10 || activityTokens > 0;
};
var getReward = (activity) => {
  const { tokensEarned, pointsEarned, activityPoints, activityTokens } = activity;
  const { isCompleted: isCompleted2 } = getInactiveActivityStatusBooleans(activity);
  const isChallenge = getIsActivityForChallenge(activity);
  if (isChallenge) {
    return isCompleted2 ? tokensEarned : activityTokens;
  }
  return isCompleted2 ? pointsEarned : activityPoints;
};
var getContentContainerWidth = (activity) => {
  const { STANDARD: STANDARD3, DETAILED: DETAILED5 } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION3;
  const { activityImage, detailLevel: detail } = activity;
  const { isCompletedOrMissed } = getInactiveActivityStatusBooleans(activity);
  const { isProgressActivity } = configureActivityCardProgress(activity);
  const canDisplayImage = !!activityImage && !isProgressActivity && !isCompletedOrMissed;
  if (detail === DETAILED5 && canDisplayImage)
    return "40%";
  if (detail === STANDARD3 && canDisplayImage)
    return "60%";
  return "100%";
};
var getActivityDisplayValues = (activity, isAchievementsEnabled) => {
  const { SIMPLE: SIMPLE3, STANDARD: STANDARD3, DETAILED: DETAILED5 } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION3;
  const {
    activityImage,
    shortDescription: description,
    detailLevel: detail
  } = activity;
  const { isCompletedOrMissed } = getInactiveActivityStatusBooleans(activity);
  const isChallenge = getIsActivityForChallenge(activity);
  const reward = getReward(activity);
  const { isProgressActivity } = configureActivityCardProgress(activity);
  const isActiveNonProgressActivity = !isProgressActivity && !isCompletedOrMissed;
  const canDisplayImage = !!activityImage && isActiveNonProgressActivity;
  const displayActivityImage = detail !== SIMPLE3 && canDisplayImage;
  const displayMobileStandardActivityImage = detail === STANDARD3 && canDisplayImage;
  const displayActivityDescription = description && detail === DETAILED5 && isActiveNonProgressActivity;
  const displayActivityProgress = isProgressActivity && !isCompletedOrMissed;
  const displayReward = !!reward && reward > 0;
  const displayEarnedOrMissedReward = isCompletedOrMissed && displayReward;
  const displayFooter = !isCompletedOrMissed;
  const displayPointsReward = displayReward && !isChallenge && isAchievementsEnabled;
  const displayChallengeReward = displayReward && isChallenge;
  return {
    displayActivityDescription,
    displayActivityImage,
    displayActivityProgress,
    displayEarnedOrMissedReward,
    displayFooter,
    displayMobileStandardActivityImage,
    displayPointsReward,
    displayChallengeReward,
    activityCardPriorityBannerDisplayValue: isCompletedOrMissed ? "none" : "flex"
  };
};

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-priority-banner.component.tsx
import React10 from "react";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import {
  Box as Box3,
  Overline,
  Image as Image2,
  VisuallyHidden
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
import {
  CONFIGURABLE_ACTIVITY_PRIORITY as CONFIGURABLE_ACTIVITY_PRIORITY3
} from "@leagueplatform/health-journey-common";

// src/components/configurable-journey-experience/configurable-activity-card/utils/get-priority-banner-container-styling-props.util.ts
import {
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION4,
  CONFIGURABLE_ACTIVITY_PRIORITY as CONFIGURABLE_ACTIVITY_PRIORITY2
} from "@leagueplatform/health-journey-common";
var { DETAILED } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION4;
var { HIGH, LOW } = CONFIGURABLE_ACTIVITY_PRIORITY2;
var getBackgroundColor = (activityPriority) => {
  switch (activityPriority) {
    case HIGH:
      return "decorative.brand.primary.dark";
    case LOW:
      return "decorative.brand.primary.brightest";
    default:
      return "decorative.brand.primary.brightest";
  }
};
var getPriorityBannerContainerStylingProps = (detail, priority, display, hasImage, isProgressActivity) => {
  const boxStylingProps = {
    display,
    paddingY: priority === LOW ? "none" : "threeQuarters",
    paddingX: priority === LOW ? "none" : "oneAndHalf",
    width: {
      _: "100%",
      tablet: detail === DETAILED && hasImage && !isProgressActivity ? "40%" : "100%"
    },
    // Min height to accommodate for if there is no tagline text but banner UI should still be there
    minHeight: priority === LOW ? "half" : "twoAndHalf",
    alignSelf: detail === DETAILED ? "flex-end" : "auto",
    borderStartEndRadius: {
      _: detail === DETAILED ? "none" : "large",
      tablet: "large"
    },
    borderStartStartRadius: detail === DETAILED && !isProgressActivity && hasImage ? "none" : "large",
    backgroundColor: getBackgroundColor(priority)
  };
  return {
    boxStylingProps
  };
};

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-priority-banner.component.tsx
var { HIGH_PRIORITY_ICON } = HEALTH_JOURNEY_ASSET_KEYS;
var { LOW: LOW2, HIGH: HIGH2 } = CONFIGURABLE_ACTIVITY_PRIORITY3;
var ActivityCardPriorityBanner = ({
  activityId,
  priority,
  detail,
  tagline,
  hasImage,
  display,
  isProgressActivity
}) => {
  const { formatMessage } = useIntl4();
  const { boxStylingProps } = getPriorityBannerContainerStylingProps(
    detail,
    priority,
    display,
    hasImage,
    isProgressActivity
  );
  const highPriorityIcon2 = handleStaticAsset3(HIGH_PRIORITY_ICON);
  if (priority === LOW2)
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ React10.createElement(Box3, __spreadValues({}, boxStylingProps), /* @__PURE__ */ React10.createElement(VisuallyHidden, { id: activityId }, formatMessage({ id: "LOW_PRIORITY_ACTIVITY_ALT_TEXT" })))
    );
  return /* @__PURE__ */ React10.createElement(
    Box3,
    __spreadValues({
      as: "header"
    }, boxStylingProps),
    priority === HIGH2 ? /* @__PURE__ */ React10.createElement(
      Image2,
      {
        src: highPriorityIcon2,
        alt: formatMessage({
          id: "HIGH_PRIORITY_ACTIVITY_ALT_TEXT"
        }),
        size: "one",
        marginInlineEnd: "half",
        id: activityId
      }
    ) : /* @__PURE__ */ React10.createElement(VisuallyHidden, { id: activityId }, formatMessage({ id: "MEDIUM_PRIORITY_ACTIVITY_ALT_TEXT" })),
    /* @__PURE__ */ React10.createElement(
      Overline,
      {
        as: "p",
        color: priority === HIGH2 ? "highlight.background.secondary" : "highlight.icon"
      },
      tagline
    )
  );
};

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-content.component.tsx
import React15 from "react";
import {
  LinkLegacy as Link
} from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
import { ACHIEVEMENTS_ENABLED as ACHIEVEMENTS_ENABLED2 } from "@leagueplatform/rewards-achievements";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { SHORT_MONTH_FORMAT } from "@leagueplatform/web-common";
import {
  Flex,
  Box as Box6,
  BodyTwo,
  Caption,
  HeadingFour,
  genesisStyled as genesisStyled2,
  css as css2
} from "@leagueplatform/genesis-commons";
import {
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION7,
  CONFIGURABLE_ACTIVITY_PRIORITY as CONFIGURABLE_ACTIVITY_PRIORITY5
} from "@leagueplatform/health-journey-common";
import { ChallengeTokenIcon as ChallengeTokenIcon2, PointsIcon as PointsIcon2 } from "@leagueplatform/rewards-common";
import { Badge as Badge3 } from "@leagueplatform/web-common-components";

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-image.component.tsx
import React11 from "react";
import {
  Box as Box4,
  Image as Image3,
  genesisStyled,
  css
} from "@leagueplatform/genesis-commons";

// src/components/configurable-journey-experience/configurable-activity-card/utils/get-activity-image-styling-props.util.ts
import {
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION6,
  CONFIGURABLE_ACTIVITY_PRIORITY as CONFIGURABLE_ACTIVITY_PRIORITY4
} from "@leagueplatform/health-journey-common";
var { STANDARD, DETAILED: DETAILED2 } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION6;
var { LOW: LOW3 } = CONFIGURABLE_ACTIVITY_PRIORITY4;
var getMarginTop = (detail, priority) => {
  if (detail === STANDARD) {
    if (priority === LOW3)
      return "oneAndHalf";
    return "minusOne";
  }
  if (detail === DETAILED2) {
    if (priority === LOW3)
      return "minusHalf";
    return "minusTwoAndHalf";
  }
  return "none";
};
var getActivityImageStylingProps = (detail, priority, displayMobileStandardComposition) => {
  const boxStylingProps = {
    display: {
      _: detail === STANDARD ? displayMobileStandardComposition : "block",
      tablet: "block"
    },
    width: {
      _: "100%",
      tablet: detail === STANDARD ? "40%" : "60%"
    },
    marginTop: { _: "none", tablet: getMarginTop(detail, priority) },
    marginBottom: detail === STANDARD ? "oneAndHalf" : "none",
    marginInlineEnd: detail === STANDARD ? "oneAndHalf" : "none",
    order: detail === STANDARD ? 2 : 1,
    textAlign: detail === STANDARD ? "end" : "auto"
  };
  const imageStylingProps = {
    width: "100%",
    maxWidth: {
      _: "auto",
      tablet: detail === STANDARD ? "300px" : "auto"
    },
    height: "100%",
    maxHeight: {
      _: "auto",
      tablet: detail === STANDARD ? "187px" : "auto"
    },
    borderStartStartRadius: "large",
    borderEndStartRadius: {
      _: detail === STANDARD ? "large" : "none",
      tablet: "large"
    },
    borderStartEndRadius: {
      _: "large",
      tablet: detail === DETAILED2 ? "none" : "large"
    },
    borderEndEndRadius: {
      _: detail === STANDARD ? "large" : "none",
      tablet: detail === DETAILED2 ? "none" : "large"
    }
  };
  return {
    boxStylingProps,
    imageStylingProps
  };
};

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-image.component.tsx
var StyledImage = genesisStyled(Image3)(
  css({
    objectFit: "cover",
    aspectRatio: "4 / 3"
  })
);
var ActivityCardImage = ({
  priority,
  detail,
  activityImage,
  displayMobileStandardComposition
}) => {
  const { boxStylingProps, imageStylingProps } = getActivityImageStylingProps(
    detail,
    priority,
    displayMobileStandardComposition
  );
  return /* @__PURE__ */ React11.createElement(
    Box4,
    __spreadValues({}, boxStylingProps),
    /* @__PURE__ */ React11.createElement(
      StyledImage,
      __spreadValues({
        src: activityImage,
        alt: ""
      }, imageStylingProps)
    )
  );
};

// src/components/configurable-journey-experience/configurable-activity-card/activity-progress.component.tsx
import React12 from "react";
import {
  Box as Box5,
  HeadingTwo,
  BodyTwoSecondary
} from "@leagueplatform/genesis-commons";
import { ProgressBar as ProgressBar2 } from "@leagueplatform/web-common-components";
var ActivityProgress = ({
  progress,
  goal,
  unit
}) => /* @__PURE__ */ React12.createElement(Box5, { marginTop: "half", marginBottom: "oneAndHalf" }, /* @__PURE__ */ React12.createElement(HeadingTwo, { as: "span", color: "highlight.icon" }, progress), /* @__PURE__ */ React12.createElement(HeadingTwo, { as: "span", color: "onSurface.text.subdued", fontWeight: "regular" }, " ", "/ ", goal), /* @__PURE__ */ React12.createElement(BodyTwoSecondary, { as: "span" }, " ", unit), /* @__PURE__ */ React12.createElement(Box5, { marginTop: "half" }, /* @__PURE__ */ React12.createElement(
  ProgressBar2,
  {
    current: progress,
    total: goal,
    customBarBackgroundColor: "interactive.background.disabled",
    customBarFillColor: "highlight.icon"
  }
)));

// src/components/configurable-journey-experience/configurable-activity-card/earned-or-missed-reward-caption.component.tsx
import React13 from "react";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
import { ACHIEVEMENTS_ENABLED } from "@leagueplatform/rewards-achievements";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
import { PointsIcon, ChallengeTokenIcon } from "@leagueplatform/rewards-common";
import { Badge as Badge2 } from "@leagueplatform/web-common-components";
var getPointsBadgeProps = ({
  isCompleted: isCompleted2,
  isChallenge
}) => {
  const {
    LEAGUE_LOGO: LEAGUE_LOGO2,
    LEAGUE_LOGO_SUBDUED: LEAGUE_LOGO_SUBDUED2,
    CHALLENGE_TOKEN: CHALLENGE_TOKEN2,
    CHALLENGE_TOKEN_SUBDUED: CHALLENGE_TOKEN_SUBDUED2
  } = HEALTH_JOURNEY_ASSET_KEYS;
  const leagueLogo2 = handleStaticAsset4(
    isCompleted2 ? LEAGUE_LOGO2 : LEAGUE_LOGO_SUBDUED2
  );
  const challengeToken2 = handleStaticAsset4(
    isCompleted2 ? CHALLENGE_TOKEN2 : CHALLENGE_TOKEN_SUBDUED2
  );
  switch (true) {
    case (isCompleted2 && isChallenge):
      return {
        pointsIconSrc: challengeToken2,
        backgroundColor: "$surfaceBackgroundSecondary",
        color: "$onSurfaceTextPrimary",
        messageId: "TOKENS_EARNED"
      };
    case (!isCompleted2 && isChallenge):
      return {
        pointsIconSrc: challengeToken2,
        backgroundColor: "$surfaceBackgroundSecondary",
        color: "$onSurfaceTextSubdued",
        messageId: "TOKENS_MISSED"
      };
    case (!isCompleted2 && !isChallenge):
      return {
        pointsIconSrc: leagueLogo2,
        backgroundColor: "$surfaceBackgroundSecondary",
        color: "$onSurfaceTextSubdued",
        messageId: "POINTS_MISSED"
      };
    case (isCompleted2 && !isChallenge):
    default:
      return {
        pointsIconSrc: leagueLogo2,
        backgroundColor: "$successBackgroundSubdued",
        color: "$onSurfaceTextPrimary",
        messageId: "POINTS_EARNED"
      };
  }
};
var EarnedOrMissedRewardCaption = ({
  isCompleted: isCompleted2,
  isChallenge,
  reward
}) => {
  const { data: isAchievementsEnabled } = useFeatureFlagQuery(ACHIEVEMENTS_ENABLED);
  if (!isChallenge && !isAchievementsEnabled) {
    return null;
  }
  const { backgroundColor, color, messageId } = getPointsBadgeProps({
    isCompleted: isCompleted2,
    isChallenge
  });
  return /* @__PURE__ */ React13.createElement(
    Badge2,
    {
      css: { backgroundColor, color, marginTop: "$half" },
      messageId
    },
    isChallenge ? /* @__PURE__ */ React13.createElement(ChallengeTokenIcon, { value: reward, subdued: !isCompleted2 }) : /* @__PURE__ */ React13.createElement(PointsIcon, { value: reward, subdued: !isCompleted2 })
  );
};

// src/components/configurable-journey-experience/activity-completed-badge/activity-completed-badge.tsx
import * as React14 from "react";
import { useIntl as useIntl5 } from "react-intl";
import { Image as Image4 } from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";
function ActivityCompletedBadge() {
  const { formatMessage } = useIntl5();
  const completedIcon = handleStaticAsset5(
    "SUCCESS_STATUS_ALTERNATIVE" /* SUCCESS_STATUS_ALTERNATIVE */
  );
  return /* @__PURE__ */ React14.createElement(
    Image4,
    {
      src: completedIcon,
      alt: formatMessage({ id: "COMPLETED" }),
      size: "oneAndHalf"
    }
  );
}

// src/components/configurable-journey-experience/configurable-activity-card/activity-card-content.component.tsx
var StyledLink = genesisStyled2(HeadingFour)(
  css2({
    "&::after": {
      position: "absolute",
      content: '""',
      top: 0,
      bottom: 0,
      insetInlineStart: 0,
      insetInlineEnd: 0
    },
    "&:focus": {
      outline: "none"
    }
  })
);
var { SIMPLE, STANDARD: STANDARD2, DETAILED: DETAILED3 } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION7;
var ActivityCardContent = ({
  activity,
  activityDetailsPath,
  activityHeadingLevel
}) => {
  const { formatMessage, formatDate } = useIntl6();
  const { data: isAchievementsEnabled } = useFeatureFlagQuery2(ACHIEVEMENTS_ENABLED2);
  const { LOW: LOW4 } = CONFIGURABLE_ACTIVITY_PRIORITY5;
  const {
    activityImage,
    shortDescription: description,
    detailLevel: detail,
    id: activityId,
    name,
    priority,
    tagline,
    canExpire,
    endDate
  } = activity;
  const { isCompleted: isCompleted2, isMissed: isMissed2, isCompletedOrMissed } = getInactiveActivityStatusBooleans(activity);
  const isChallenge = getIsActivityForChallenge(activity);
  const reward = getReward(activity);
  const { isProgressActivity, progressProps } = configureActivityCardProgress(activity);
  const { progress, goal, unit } = progressProps;
  const {
    displayActivityDescription,
    displayActivityProgress,
    displayEarnedOrMissedReward,
    displayFooter,
    displayMobileStandardActivityImage,
    displayPointsReward,
    displayChallengeReward,
    activityCardPriorityBannerDisplayValue
  } = getActivityDisplayValues(activity, isAchievementsEnabled);
  const expiryDate = canExpire ? endDate : "";
  const formattedExpiryDate = formatDate(expiryDate, SHORT_MONTH_FORMAT);
  const isAdditionalTopPadding = priority === LOW4 && !isCompletedOrMissed;
  const isContentFullWidth = detail === STANDARD2 && !isProgressActivity && !isCompletedOrMissed;
  return /* @__PURE__ */ React15.createElement(
    Box6,
    {
      width: { _: "100%", tablet: getContentContainerWidth(activity) },
      order: "2"
    },
    detail === DETAILED3 && /* @__PURE__ */ React15.createElement(
      ActivityCardPriorityBanner,
      {
        activityId,
        priority,
        detail,
        tagline,
        hasImage: !!activityImage,
        display: {
          _: activityCardPriorityBannerDisplayValue,
          tablet: "none"
        },
        isProgressActivity
      }
    ),
    /* @__PURE__ */ React15.createElement(
      Flex,
      {
        flexDirection: "column",
        height: "100%",
        paddingX: "oneAndHalf",
        paddingTop: {
          _: "oneAndHalf",
          tablet: isAdditionalTopPadding ? "oneAndHalf" : "one"
        },
        paddingBottom: "oneAndHalf",
        order: detail === STANDARD2 ? 1 : 2,
        justifyContent: detail === SIMPLE ? "normal" : "space-between"
      },
      isCompleted2 && /* @__PURE__ */ React15.createElement(
        Flex,
        {
          alignSelf: "flex-end",
          marginTop: "minusHalf",
          marginInlineEnd: "minusOne"
        },
        /* @__PURE__ */ React15.createElement(ActivityCompletedBadge, null)
      ),
      /* @__PURE__ */ React15.createElement(Flex, null, /* @__PURE__ */ React15.createElement(
        Box6,
        {
          width: {
            _: !isContentFullWidth ? "70%" : "100%",
            tablet: "100%"
          }
        },
        /* @__PURE__ */ React15.createElement(HeadingFour, { as: activityHeadingLevel }, /* @__PURE__ */ React15.createElement(
          StyledLink,
          {
            as: Link,
            to: activityDetailsPath,
            onClick: () => {
              selectActivityAnalytics(activity);
            },
            "aria-describedby": activityId,
            color: isMissed2 ? "onSurface.text.subdued" : "onSurface.text.primary",
            textDecoration: "none"
          },
          name
        )),
        displayActivityDescription && /* @__PURE__ */ React15.createElement(BodyTwo, { color: "onSurface.text.subdued", marginTop: "half" }, description),
        displayActivityProgress && /* @__PURE__ */ React15.createElement(ActivityProgress, { progress, goal, unit }),
        displayEarnedOrMissedReward && reward && /* @__PURE__ */ React15.createElement(
          EarnedOrMissedRewardCaption,
          {
            isCompleted: isCompleted2,
            isChallenge,
            reward
          }
        )
      ), activityImage && displayMobileStandardActivityImage && /* @__PURE__ */ React15.createElement(
        Box6,
        {
          display: { _: "block", tablet: "none" },
          width: "30%",
          marginInlineStart: "one"
        },
        /* @__PURE__ */ React15.createElement(
          ActivityCardImage,
          {
            priority,
            detail,
            activityImage,
            displayMobileStandardComposition: "block"
          }
        )
      )),
      displayFooter && /* @__PURE__ */ React15.createElement(Box6, { as: "footer", marginTop: "quarter" }, displayPointsReward && reward && /* @__PURE__ */ React15.createElement(Badge3, { css: { marginTop: "$one" } }, /* @__PURE__ */ React15.createElement(PointsIcon2, { value: reward })), displayChallengeReward && reward && /* @__PURE__ */ React15.createElement(
        Badge3,
        {
          css: {
            backgroundColor: "$surfaceBackgroundSecondary",
            marginTop: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(ChallengeTokenIcon2, { value: reward })
      ), expiryDate && /* @__PURE__ */ React15.createElement(
        Caption,
        {
          color: "onSurface.text.subdued",
          paddingTop: ["one", "one", "half"],
          marginTop: ["one", "one", "half"],
          borderTopWidth: "thin"
        },
        formatMessage(
          { id: "ACTIVITY_EXPIRY_DATE" },
          { date: formattedExpiryDate }
        )
      ))
    )
  );
};

// src/components/configurable-journey-experience/card-container/card-container.tsx
import * as React16 from "react";
import { genesisStyled as genesisStyled3, css as css3, Box as Box7 } from "@leagueplatform/genesis-commons";
var StyledCard = genesisStyled3(Box7)(
  () => css3({
    position: "relative",
    "&:hover::before, &:focus-within::before": {
      position: "absolute",
      content: '""',
      top: 0,
      insetInlineStart: 0,
      insetInlineEnd: 0,
      bottom: 0,
      borderWidth: "thick",
      borderStyle: "solid",
      borderColor: "interactive.focus.outer",
      borderRadius: "large"
    }
  })
);
function CardContainer(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React16.createElement(
    StyledCard,
    __spreadValues({
      borderRadius: "large",
      boxShadow: "card",
      backgroundColor: "surface.background.primary"
    }, props),
    children
  );
}

// src/components/configurable-journey-experience/configurable-activity-card/configurable-activity-card.component.tsx
var { SIMPLE: SIMPLE2, DETAILED: DETAILED4 } = CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION8;
var ConfigurableActivityCard = ({
  as = "li",
  activity,
  noBottomMargin,
  height = "auto",
  activityHeadingLevel
}) => {
  const { data: isAchievementsEnabled } = useFeatureFlagQuery3(ACHIEVEMENTS_ENABLED3);
  const {
    activityImage,
    detailLevel: detail,
    id: activityId,
    priority,
    tagline,
    type
  } = activity;
  const { isProgressActivity } = configureActivityCardProgress(activity);
  const { displayActivityImage, activityCardPriorityBannerDisplayValue } = getActivityDisplayValues(activity, isAchievementsEnabled);
  const activityDetailsPath = JOURNEY_ROUTES2.getActivityDetails(
    activityId,
    type
  );
  return /* @__PURE__ */ React17.createElement(
    CardContainer,
    {
      as,
      position: "relative",
      flexDirection: "column",
      marginBottom: noBottomMargin ? "none" : "one",
      height
    },
    /* @__PURE__ */ React17.createElement(
      ActivityCardPriorityBanner,
      {
        activityId,
        priority,
        detail,
        tagline,
        hasImage: !!activityImage,
        display: {
          _: detail === DETAILED4 ? "none" : activityCardPriorityBannerDisplayValue,
          tablet: activityCardPriorityBannerDisplayValue
        },
        isProgressActivity
      }
    ),
    /* @__PURE__ */ React17.createElement(
      Flex2,
      {
        flexDirection: {
          _: "column",
          tablet: detail === SIMPLE2 ? "column" : "row"
        }
      },
      /* @__PURE__ */ React17.createElement(
        ActivityCardContent,
        {
          activity,
          activityDetailsPath,
          activityHeadingLevel
        }
      ),
      activityImage && displayActivityImage && /* @__PURE__ */ React17.createElement(
        ActivityCardImage,
        {
          priority,
          detail,
          activityImage,
          displayMobileStandardComposition: "none"
        }
      )
    )
  );
};

// src/utils/get-activity-statuses-array.util.ts
var getActivityStatusesArray = (statusType) => {
  switch (statusType) {
    case "active":
      return ["active"];
    case "completed":
      return ["completed"];
    case "missed":
      return ["expired", "removed"];
    default:
      return [];
  }
};

// src/components/configurable-journey-experience/priority-activities-widget/priority-activities-widget.component.tsx
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";

// src/hooks/use-activities-by-activity-status.hook.ts
import { useQuery } from "react-query";
import {
  getUserHealthActivities,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import camelcaseKeys3 from "camelcase-keys";

// src/utils/user-health-activities/user-health-activities.utils.js
import { HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS3 } from "@leagueplatform/health-journey-common";
var { ACTIVE, UPCOMING: UPCOMING2, COMPLETED, EXPIRED, REMOVED } = HEALTH_JOURNEY_ACTIVITY_STATUS3;
var normalizeEpochDate = (timestamp) => new Date(timestamp).setHours(0, 0, 0, 0);
var activityStatusByDate = {
  today: [ACTIVE, COMPLETED, REMOVED],
  past: [COMPLETED, EXPIRED, REMOVED],
  future: [UPCOMING2]
};
var getDiffOfDates = (oldDate, newDate, unit = "day") => {
  if (!oldDate || !newDate)
    return void 0;
  const timeDifference = newDate.getTime() - oldDate.getTime();
  const milliseconds = (() => {
    const minute = 1e3 * 60;
    const hour = minute * 60;
    const day3 = hour * 24;
    return { minute, hour, day: day3 };
  })();
  return Math.round(timeDifference / milliseconds[unit]);
};
var deriveActivityStatusFromDate = (currentDate2, todaysDateObj = normalizeEpochDate(Date.now())) => {
  const dateDiff = getDiffOfDates(
    new Date(todaysDateObj),
    new Date(currentDate2)
  );
  if (dateDiff === 0)
    return activityStatusByDate.today;
  return dateDiff > 0 ? activityStatusByDate.future : activityStatusByDate.past;
};
var sortByDate = (array, property, order = "asc") => {
  const newArray = Array.from(array);
  switch (order) {
    case "desc":
      return newArray.sort(
        (a, b) => new Date(b[property]) - new Date(a[property])
      );
    case "asc":
    default:
      return newArray.sort(
        (a, b) => new Date(a[property]) - new Date(b[property])
      );
  }
};

// src/hooks/use-activities-by-activity-status.hook.ts
var WS_ENDPOINT_VERSION_NUMBER = 3;
var useActivitiesByActivityStatus = ({
  activityStatuses,
  campaignId
}) => {
  const normalizedActiveDateTimestamp = normalizeEpochDate(Date.now());
  return useQuery(
    [
      GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
      normalizedActiveDateTimestamp,
      activityStatuses,
      campaignId
    ],
    () => getUserHealthActivities({
      date: normalizedActiveDateTimestamp / 1e3,
      activityStatuses,
      campaignId,
      version: WS_ENDPOINT_VERSION_NUMBER
    }),
    {
      enabled: !!activityStatuses.length,
      select: (data) => camelcaseKeys3(data, { deep: true })
    }
  );
};

// src/components/configurable-journey-experience/configurable-journey-empty-state-card/configurable-journey-empty-state-card.tsx
import React18 from "react";
import { Image as Image5 } from "@leagueplatform/genesis-commons";
import {
  Button,
  Card,
  HeadingText as HeadingText2,
  ParagraphText as ParagraphText3,
  queryHelpers as queryHelpers2,
  Responsive,
  StackLayout as StackLayout7,
  useMediaQuery as useMediaQuery2,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";
import { LinkLegacy as Link2 } from "@leagueplatform/routing";
var EMPTY_STATE_IMAGE_SIZE = "116px";
var ConfigurableJourneyEmptyStateCard = ({
  eyebrow,
  heading,
  description,
  imgSrc,
  ctaLabel,
  ctaHref,
  headingLevel,
  analyticsOnClick
}) => {
  const belowMobileLandscape = useMediaQuery2(
    queryHelpers2.down("mobileLandscape")
  );
  return /* @__PURE__ */ React18.createElement(
    Card.Elevated,
    {
      css: {
        width: "100%",
        backgroundColor: "$surfaceCardSecondary"
      }
    },
    /* @__PURE__ */ React18.createElement(StackLayout7, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React18.createElement(Card.Section, null, /* @__PURE__ */ React18.createElement(UtilityText3, { size: "eyebrow" }, eyebrow), /* @__PURE__ */ React18.createElement(
      HeadingText2,
      {
        level: headingLevel,
        size: belowMobileLandscape ? "sm" : "lg",
        css: {
          marginTop: "$half"
        }
      },
      heading
    ), /* @__PURE__ */ React18.createElement(
      ParagraphText3,
      {
        size: "sm",
        css: { marginTop: "$quarter", marginBottom: "$one" }
      },
      description
    ), ctaLabel && ctaHref && /* @__PURE__ */ React18.createElement(
      Button,
      {
        as: Link2,
        to: ctaHref,
        width: {
          "@initial": "hugContents",
          "@mobile": "fillContainer"
        },
        css: {
          height: "$twoAndHalf",
          fontSize: "$bodyTwo"
        },
        onClick: analyticsOnClick
      },
      ctaLabel
    )), /* @__PURE__ */ React18.createElement(Responsive, { up: "mobileLandscape" }, /* @__PURE__ */ React18.createElement(Card.Section, { css: { maxWidth: "fit-content" } }, imgSrc !== " " && /* @__PURE__ */ React18.createElement(Image5, { src: imgSrc, alt: "", size: EMPTY_STATE_IMAGE_SIZE }))))
  );
};

// src/health-journey.config.ts
import {
  isConfigSettled,
  useConfigProperty,
  useConfigSelection
} from "@leagueplatform/core";
import journeyHeaderBackgroundImage from "./assets/journey-header-background-image.png";
import { useMemo } from "react";
var defaultConfig = {
  tabs: ["activities", "progress", "history", "explore"],
  headerConfig: {
    backgroundImageSrc: journeyHeaderBackgroundImage,
    enableHeaderSubTitle: false
  }
};
var defaultServerConfig = {
  enableMasonryWSForActivities: false,
  enableMasonry2ForActivities: false,
  isCareLibraryEnabled: false
};
var useHealthJourneyConfig = () => {
  const clientConfig = useConfigProperty("healthJourney", defaultConfig);
  const serverDrivenConfig = useConfigSelection(
    (config) => isConfigSettled(config) ? {
      enableMasonryWSForActivities: config.config.flag_journey_enable_masonry_1_5_for_activities,
      enableMasonry2ForActivities: config.config.release_journey_experience_masonry_2_for_activities,
      isCareLibraryEnabled: config.config.config_about_me_care_library
    } : {},
    defaultServerConfig
  );
  const hasExploreTab = useMemo(() => {
    const { tabs } = clientConfig;
    if (Array.isArray(tabs) && tabs.includes("explore")) {
      return true;
    }
    return false;
  }, [clientConfig]);
  return __spreadProps(__spreadValues(__spreadValues({}, clientConfig), serverDrivenConfig), {
    hasExploreTab
  });
};

// src/components/configurable-journey-experience/priority-activities-widget/priority-activities-widget.component.tsx
var ActivityCardGroup = genesisStyled4(Box8)`
  width: 100%;
  li:last-of-type {
    margin-bottom: 0;
  }
`;
var PriorityActivitiesWidget = () => {
  const { formatMessage } = useIntl7();
  const { data: isV3ActivityCardsEnabled } = useFeatureFlagQuery4(
    ENABLE_V3_ACTIVITY_CARDS
  );
  const { ACTIVE: ACTIVE11 } = HEALTH_JOURNEY_ACTIVITY_STATUS4;
  const activityStatuses = getActivityStatusesArray(ACTIVE11);
  const { hasExploreTab } = useHealthJourneyConfig();
  const {
    data: activities,
    isLoading,
    isError,
    error
  } = useActivitiesByActivityStatus({
    activityStatuses
  });
  if (isLoading)
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, Array(4).fill("").map((box, index) => /* @__PURE__ */ React19.createElement(
      SkeletonBox,
      {
        height: "160px",
        backgroundColor: "interactive.background.disabled",
        marginBottom: "one",
        key: index
      }
    )));
  if (isError || !(activities == null ? void 0 : activities.userHealthActivities))
    return /* @__PURE__ */ React19.createElement(ErrorState, { error });
  const activeActivities = activities == null ? void 0 : activities.userHealthActivities;
  const { EMPTY_STATE_CONFIGURABLE_ACTIVITIES } = HEALTH_JOURNEY_COMMON_ASSET_KEYS;
  const emptyStateImgUrl = handleStaticAsset6(
    EMPTY_STATE_CONFIGURABLE_ACTIVITIES
  );
  if (!activeActivities.length) {
    const handleAnalyticsEvent = () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA3.JOURNEY,
      screen_name: SCREEN_NAMES3.PROGRESS_PAGE,
      detail: "explore library"
    });
    return /* @__PURE__ */ React19.createElement(Flex3, { as: "section", alignItems: "start" }, /* @__PURE__ */ React19.createElement(
      ConfigurableJourneyEmptyStateCard,
      {
        eyebrow: formatMessage({
          id: "NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_EYEBROW"
        }),
        heading: formatMessage({
          id: "NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_HEADING"
        }),
        headingLevel: "2",
        description: formatMessage({
          id: "NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_DESCRIPTION"
        }),
        imgSrc: emptyStateImgUrl,
        ctaLabel: hasExploreTab ? formatMessage({ id: "EXPLORE_LIBRARY" }) : void 0,
        ctaHref: hasExploreTab ? JOURNEY_ROUTES3.programsHome() : void 0,
        analyticsOnClick: handleAnalyticsEvent
      }
    ));
  }
  return /* @__PURE__ */ React19.createElement(Flex3, { as: "section", alignItems: "start" }, isV3ActivityCardsEnabled ? /* @__PURE__ */ React19.createElement(StackLayout8, { as: "ul", spacing: "$one", horizontalAlignment: "stretch" }, activeActivities.map((activity) => /* @__PURE__ */ React19.createElement(Box8, { as: "li", key: activity.id }, /* @__PURE__ */ React19.createElement(PriorityActivityCard, { activity, headingLevel: "2" })))) : /* @__PURE__ */ React19.createElement(ActivityCardGroup, { as: "ul" }, activeActivities.map((activity) => /* @__PURE__ */ React19.createElement(
    ConfigurableActivityCard,
    {
      activity,
      key: activity.id,
      activityHeadingLevel: "h2"
    }
  ))));
};

// src/components/configurable-journey-experience/masonryV2/node-renderers/activity-card/activity-card-node-renderer.tsx
import React20 from "react";

// src/utils/map-to-ConfigurableHealthActivityWSCC.util.ts
function mapToConfigurableHealthActivityWSCC(activityCard) {
  var _a, _b;
  return {
    id: activityCard.id,
    name: activityCard.heading,
    tagline: activityCard.tagline,
    shortDescription: activityCard.description,
    type: activityCard.type,
    status: activityCard.status,
    activityPoints: activityCard.points || 0,
    activityTokens: 0,
    required: activityCard.required,
    canExpire: activityCard.canExpire,
    priority: activityCard.priority,
    detailLevel: activityCard.detailLevel,
    activityImage: activityCard.image,
    campaignInfo: activityCard.campaign ? {
      campaignId: activityCard.campaign.id,
      campaignType: activityCard.campaign.type,
      name: activityCard.campaign.name,
      startDate: (_a = activityCard.campaign.startDate) == null ? void 0 : _a.toString(),
      endDate: (_b = activityCard.campaign.endDate) == null ? void 0 : _b.toString(),
      status: activityCard.campaign.status,
      // talk to bernardo
      qualifiesForRewardProgram: activityCard.campaign.qualifiesForRewardProgram
    } : void 0,
    activityProgressData: activityCard.progress ? [
      {
        currentProgress: activityCard.progress.currentProgress,
        goalTotal: activityCard.progress.goalTotal,
        dataType: activityCard.progress.dataType,
        unit: activityCard.progress.unit
      }
    ] : void 0,
    startDate: activityCard.startDate,
    endDate: activityCard.endDate,
    activityRewardInfo: activityCard.reward
  };
}

// src/components/configurable-journey-experience/masonryV2/node-renderers/activity-card/activity-card-node-renderer.tsx
import { useMasonryEngineActionEmitter } from "@leagueplatform/masonry-engine";
import { getLocationWithReferrer } from "@leagueplatform/health-journey-common";
function ActivityCardNodeRenderer(props) {
  const invokeAction = useMasonryEngineActionEmitter();
  const { onClick } = props;
  return /* @__PURE__ */ React20.createElement(
    PriorityActivityCard,
    {
      ctaURL: getLocationWithReferrer({ pathname: onClick == null ? void 0 : onClick.payload.url }),
      onClick: onClick ? (event) => {
        invokeAction(__spreadValues({
          event
        }, onClick));
      } : void 0,
      activity: mapToConfigurableHealthActivityWSCC(props),
      headingLevel: "4"
    }
  );
}
var activity_card_node_renderer_default = ActivityCardNodeRenderer;

// src/components/configurable-journey-experience/masonryV2/node-renderers/view-all-header/view-all-header-renderer.tsx
import { HeadingText as HeadingText3, StackLayout as StackLayout9 } from "@leagueplatform/genesis-core";
import { JOURNEY_ROUTES as JOURNEY_ROUTES4 } from "@leagueplatform/health-journey-common";
import { useNavigateLegacy as useNavigate } from "@leagueplatform/routing";
import { BackButtonArrow } from "@leagueplatform/web-common-components";
import React21 from "react";
function ViewAllHeaderRenderer({ heading }) {
  const navigate = useNavigate();
  return /* @__PURE__ */ React21.createElement(
    StackLayout9,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      css: {
        width: "100%",
        minHeight: "136px",
        backgroundColor: "$surfaceBackgroundTertiary",
        paddingLeft: "$five"
      }
    },
    /* @__PURE__ */ React21.createElement(
      BackButtonArrow,
      {
        justifyContent: "initial",
        marginInlineEnd: "quarter",
        marginY: "half",
        onClick: () => navigate(JOURNEY_ROUTES4.journeyHome()),
        size: "three"
      }
    ),
    heading && /* @__PURE__ */ React21.createElement(HeadingText3, { size: "xxl", level: "1" }, heading)
  );
}

// src/components/configurable-journey-experience/masonryV2/node-renderers/recommended-content/recommended-content-card-node-renderer.tsx
import React22 from "react";
import {
  Card as Card2,
  HeadingText as HeadingText4,
  Icon,
  StackItem as StackItem2,
  StackLayout as StackLayout10,
  TextAction as TextAction2,
  useClickableCard,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { Badge as Badge4 } from "@leagueplatform/web-common-components";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter2
} from "@leagueplatform/masonry-engine";
function RecommendedContentCardNodeRenderer({
  image,
  imageAltText,
  heading,
  eyebrow,
  body,
  subheading,
  badge,
  onClick
}) {
  var _a;
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const invokeAction = useMasonryEngineActionEmitter2();
  return /* @__PURE__ */ React22.createElement(
    Card2.Flat,
    {
      css: {
        border: "$borderWidths$card solid transparent",
        maxWidth: 310
      }
    },
    /* @__PURE__ */ React22.createElement(
      Card2.ClickArea,
      {
        ref: clickAreaRef,
        onCardMouseUp,
        onCardMouseDown,
        css: { border: "$borderWidths$card solid transparent" }
      },
      /* @__PURE__ */ React22.createElement(Card2.Image, { image, imageAlt: imageAltText }),
      /* @__PURE__ */ React22.createElement(
        StackItem2,
        {
          css: {
            position: "absolute",
            top: "$threeQuarters",
            insetInlineEnd: "$threeQuarters"
          }
        },
        badge && /* @__PURE__ */ React22.createElement(
          Badge4,
          {
            css: {
              backgroundColor: badge.backgroundColor,
              borderRadius: "$small"
            }
          },
          /* @__PURE__ */ React22.createElement(React22.Fragment, null, badge.image && /* @__PURE__ */ React22.createElement(Icon, { icon: badge.image, size: "$one" }), /* @__PURE__ */ React22.createElement(UtilityText4, { size: "eyebrow" }, badge.label))
        )
      ),
      /* @__PURE__ */ React22.createElement(
        Card2.Section,
        {
          css: {
            paddingX: "$none",
            paddingTop: "$threeQuarters",
            paddingBottom: "$none"
          }
        },
        /* @__PURE__ */ React22.createElement(
          StackLayout10,
          {
            orientation: "vertical",
            horizontalAlignment: "stretch",
            spacing: "$half"
          },
          eyebrow && /* @__PURE__ */ React22.createElement(UtilityText4, { size: "eyebrow", css: { typography: "$overline" } }, eyebrow),
          /* @__PURE__ */ React22.createElement(
            TextAction2,
            {
              ref: primaryActionRef,
              href: (_a = onClick == null ? void 0 : onClick.payload) == null ? void 0 : _a.url,
              onClick: (event) => {
                if (onClick) {
                  invokeAction(__spreadValues({
                    event
                  }, onClick));
                }
              }
            },
            /* @__PURE__ */ React22.createElement(HeadingText4, { level: "4", size: "md", css: { textWrap: "balance" } }, heading)
          ),
          subheading && /* @__PURE__ */ React22.createElement(UtilityText4, { as: "p", css: { typography: "$bodyTwo" } }, subheading),
          body && /* @__PURE__ */ React22.createElement(
            UtilityText4,
            {
              as: "p",
              css: { typography: "$bodyTwo", color: "$onSurfaceTextSubdued" }
            },
            body
          )
        )
      )
    )
  );
}

// src/components/activity-details-header.component.js
import * as React24 from "react";
import { node, string } from "prop-types";
import {
  Box as Box9,
  css as css4,
  Flex as Flex4,
  genesisStyled as genesisStyled6,
  HeadingOne,
  Overline as Overline2
} from "@leagueplatform/genesis-commons";

// src/components/dynamic-image.component.js
import * as React23 from "react";
import { useEffect, useRef, useState } from "react";
import {
  CoverImage,
  genesisStyled as genesisStyled5,
  Image as Img
} from "@leagueplatform/genesis-commons";
var URL_PARAMS = {
  HEIGHT: "h",
  WIDTH: "w",
  QUALITY: "q",
  FORMAT: "fm"
};
var PreloadImage = genesisStyled5(Img)`
  transition: filter 0.2s ease-out;
  filter: blur(${({ ready }) => ready ? 0 : 5}px)
`;
var PreloadCoverImage = genesisStyled5(CoverImage)`
  transition: filter 0.2s ease-out;
  filter: blur(${({ ready }) => ready ? 0 : 5}px)
`;
var preloadImage = (src, handleSuccess) => {
  const image = new Image();
  image.src = src;
  if (image.complete) {
    handleSuccess(src);
    return;
  }
  const handleImageLoad = () => {
    handleSuccess(src);
    image.removeEventListener("load", handleImageLoad);
  };
  image.addEventListener("load", handleImageLoad);
};
var getImageSrcWithParams = ({ src, width, quality }) => {
  let imageUrl;
  try {
    imageUrl = new URL(src);
    const { searchParams } = imageUrl;
    if (width) {
      if (searchParams.get(URL_PARAMS.HEIGHT)) {
        searchParams.delete(URL_PARAMS.HEIGHT);
      }
      searchParams.set(URL_PARAMS.WIDTH, width);
    }
    if (quality) {
      searchParams.set(URL_PARAMS.FORMAT, "jpg");
      searchParams.set(URL_PARAMS.QUALITY, quality);
    }
  } catch (error) {
    imageUrl = { href: src };
  }
  return imageUrl.href;
};
var useDynamicImageSrc = (imageRef, imageSrc) => {
  const previewSrc = getImageSrcWithParams({ src: imageSrc, quality: 5 });
  const [src, setSrc] = useState(previewSrc);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (imageRef.current) {
      const width = Math.ceil(
        imageRef.current.clientWidth * window.devicePixelRatio
      );
      const scaledSrc = getImageSrcWithParams({ src: imageSrc, width });
      if (!Number.isNaN(width)) {
        preloadImage(scaledSrc, (preloadedSrc) => {
          setSrc(preloadedSrc);
          setReady(true);
        });
      }
    }
  }, [imageRef, imageSrc]);
  return { src, ready };
};
var DynamicImage = (_a) => {
  var _b = _a, { src, ref = null, width = "auto" } = _b, props = __objRest(_b, ["src", "ref", "width"]);
  const imageRef = useRef(ref);
  const dynamicImageSrc = useDynamicImageSrc(imageRef, src);
  return /* @__PURE__ */ React23.createElement(
    PreloadImage,
    __spreadValues({
      ref: imageRef,
      width: width || "100%",
      ready: dynamicImageSrc.ready,
      src: dynamicImageSrc.src
    }, props)
  );
};
DynamicImage.propTypes = Img.propTypes;
DynamicImage.defaultProps = Img.defaultProps;
var DynamicCoverImage = (_a) => {
  var _b = _a, { src, ref = null } = _b, props = __objRest(_b, ["src", "ref"]);
  const imageRef = useRef(ref);
  const dynamicImageSrc = useDynamicImageSrc(imageRef, src);
  return /* @__PURE__ */ React23.createElement(
    PreloadCoverImage,
    __spreadValues({
      ref: imageRef,
      src: dynamicImageSrc.src,
      ready: dynamicImageSrc.ready
    }, props)
  );
};
DynamicCoverImage.propTypes = CoverImage.propTypes;
DynamicCoverImage.defaultProps = CoverImage.defaultProps;

// src/components/activity-details-header.component.js
var ActivityDetailsHeaderGroup = genesisStyled6(Flex4)(
  css4({
    "&&": {
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin"
    }
  })
);
var ActivityDetailsHeader = (props) => {
  const _a = props, { overline, title, iconUrl, children } = _a, rest = __objRest(_a, ["overline", "title", "iconUrl", "children"]);
  return /* @__PURE__ */ React24.createElement(
    ActivityDetailsHeaderGroup,
    __spreadValues({
      flexDirection: { _: "column-reverse", phone: "row" },
      justifyContent: "space-between",
      marginTop: "half",
      marginBottom: "oneAndHalf",
      width: "100%"
    }, rest),
    /* @__PURE__ */ React24.createElement(Box9, null, overline && /* @__PURE__ */ React24.createElement(Overline2, { as: "p", marginBottom: "half", color: "onSurface.text.subdued" }, overline), /* @__PURE__ */ React24.createElement(HeadingOne, { marginBottom: "one" }, title), children),
    iconUrl && /* @__PURE__ */ React24.createElement(
      DynamicCoverImage,
      {
        alt: "",
        backgroundColor: "surface.background.primary",
        borderRadius: "circle",
        marginBottom: { _: "one", phone: "none" },
        minWidth: { _: "48px", phone: "96px" },
        size: { _: 48, phone: 96 },
        src: iconUrl
      }
    )
  );
};
ActivityDetailsHeader.propTypes = {
  overline: string,
  title: string,
  iconUrl: string,
  children: node
};
ActivityDetailsHeader.defaultProps = {
  overline: "",
  title: "",
  iconUrl: "",
  children: []
};

// src/components/activity-details-wrapper.component.js
import React25 from "react";
import { LinkLegacy as Link3 } from "@leagueplatform/routing";
import { node as node2, func, string as string2, oneOfType } from "prop-types";
import { Box as Box10, Flex as Flex5 } from "@leagueplatform/genesis-commons";
import { BackButtonArrow as BackButtonArrow2 } from "@leagueplatform/web-common-components";
var ActivityDetailsWrapper = (_a) => {
  var _b = _a, {
    to,
    onBackClick,
    children
  } = _b, rest = __objRest(_b, [
    "to",
    "onBackClick",
    "children"
  ]);
  return /* @__PURE__ */ React25.createElement(
    Flex5,
    __spreadValues({
      flexDirection: { _: "column", phone: "row" },
      marginX: "auto",
      marginTop: "oneAndHalf",
      paddingBottom: { _: "150px", phone: "120px" },
      width: { _: "90%", tablet: "70%" },
      justifyContent: { _: "unset", phone: "center" }
    }, rest),
    /* @__PURE__ */ React25.createElement(Box10, null, /* @__PURE__ */ React25.createElement(
      BackButtonArrow2,
      {
        as: Link3,
        to,
        onClick: onBackClick,
        marginY: "threeQuarters",
        marginInlineEnd: "two"
      }
    )),
    /* @__PURE__ */ React25.createElement(Box10, { width: "100%" }, children)
  );
};
ActivityDetailsWrapper.propTypes = {
  to: oneOfType([func, string2]).isRequired,
  onBackClick: func,
  children: node2
};
ActivityDetailsWrapper.defaultProps = {
  children: [],
  onBackClick: () => void 0
};

// src/components/complete-activity-modal.component.js
import React26, { useEffect as useEffect2 } from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import PropTypes from "prop-types";
import {
  Box as Box11,
  Flex as Flex6,
  BodyTwo as BodyTwo2,
  HeadingTwo as HeadingTwo2,
  HeadingThree,
  SubtitleOne,
  PrimaryButton
} from "@leagueplatform/genesis-commons";
import { HealthActivityModal } from "@leagueplatform/health-journey-common";
import { BadgeProgress } from "@leagueplatform/rewards-achievements";

// src/hooks/use-health-activity.hook.ts
import { useMemo as useMemo2 } from "react";

// src/utils/process-activity-helpful-tips.util.js
import { getContentUrl } from "@leagueplatform/league-content-api";
import { getContentfulImageUrl } from "@leagueplatform/web-common";
var processActivityHelpfulTips = (helpfulTip) => {
  var _a, _b, _c;
  const contentfulImageAssetUrl = (_c = (_b = (_a = helpfulTip == null ? void 0 : helpfulTip.contentful_image_asset) == null ? void 0 : _a.fields) == null ? void 0 : _b.file) == null ? void 0 : _c.url;
  const getHelpfulTipImageUrl = (helpfulTip == null ? void 0 : helpfulTip.image_content_id) ? getContentUrl(helpfulTip == null ? void 0 : helpfulTip.image_content_id) : helpfulTip == null ? void 0 : helpfulTip.image_url;
  return __spreadProps(__spreadValues({}, helpfulTip), {
    helpfulTipImage: contentfulImageAssetUrl ? getContentfulImageUrl(contentfulImageAssetUrl) : getHelpfulTipImageUrl
  });
};

// src/hooks/use-get-user-health-activity.hook.js
import { useQuery as useQuery2 } from "react-query";
import {
  getUserHealthActivity,
  GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
var getActivityOptions = {
  staleTime: 300
};
var useGetUserHealthActivity = (userActivityId = null, contentActivityId = null, campaignId = null) => useQuery2(
  [
    GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE,
    userActivityId,
    contentActivityId,
    campaignId
  ],
  () => getUserHealthActivity(userActivityId, contentActivityId, campaignId),
  __spreadValues({
    enabled: Boolean(userActivityId) || Boolean(contentActivityId && campaignId)
  }, getActivityOptions)
);

// src/hooks/use-activity-params.hook.ts
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
var useActivityParams = () => {
  const {
    userActivityId,
    campaignId,
    activityId: contentActivityId
  } = useParams();
  return { userActivityId, campaignId, contentActivityId };
};

// src/hooks/use-health-activity.hook.ts
var useHealthActivity = () => {
  const { userActivityId, campaignId, contentActivityId } = useActivityParams();
  const {
    data: activityData = {},
    isLoading,
    isError,
    error
  } = useGetUserHealthActivity(userActivityId, contentActivityId, campaignId);
  const activity = useMemo2(
    () => (activityData == null ? void 0 : activityData.health_activity) || {},
    [activityData == null ? void 0 : activityData.health_activity]
  );
  const redirectLink = activityData == null ? void 0 : activityData.redirect_link;
  const ready = !isLoading;
  const hasError = isError;
  const helpfulTips = useMemo2(
    () => {
      var _a;
      return (_a = activity == null ? void 0 : activity.helpful_tips) == null ? void 0 : _a.map(processActivityHelpfulTips);
    },
    [activity == null ? void 0 : activity.helpful_tips]
  );
  return useMemo2(
    () => {
      var _a, _b;
      return {
        activityId: activity == null ? void 0 : activity.id,
        contentActivityId: activity == null ? void 0 : activity.goal_id,
        activityPoints: activity == null ? void 0 : activity.activity_points,
        activityProgress: (_a = activity == null ? void 0 : activity.activity_verification_progress) != null ? _a : {},
        activityTokens: activity == null ? void 0 : activity.activity_tokens,
        activityType: activity == null ? void 0 : activity.type,
        campaignInfo: activity == null ? void 0 : activity.campaign_info,
        campaignMode: (_b = activity == null ? void 0 : activity.custom_fields) == null ? void 0 : _b.campaign_mode,
        cta: activity == null ? void 0 : activity.cta,
        description: activity == null ? void 0 : activity.description,
        disclaimerBanner: activity == null ? void 0 : activity.disclaimer_banner,
        endDate: activity == null ? void 0 : activity.end_date,
        hasError,
        helpfulTips,
        iconUrl: activity == null ? void 0 : activity.icon_url,
        informationBanner: activity == null ? void 0 : activity.information_banner,
        name: activity == null ? void 0 : activity.name,
        pointsEarned: activity == null ? void 0 : activity.points_earned,
        ready,
        redirectLink,
        references: (activity == null ? void 0 : activity.references) || "",
        richTextDescription: activity == null ? void 0 : activity.rich_text_description,
        startDate: activity == null ? void 0 : activity.start_date,
        status: activity == null ? void 0 : activity.status,
        suggestionBanner: activity == null ? void 0 : activity.suggestion_banner,
        tagline: activity == null ? void 0 : activity.tagline,
        tokensEarned: activity == null ? void 0 : activity.tokens_earned,
        error
      };
    },
    [activity, hasError, helpfulTips, ready, redirectLink, error]
  );
};

// src/components/complete-activity-modal.component.js
import { ChallengeTokenIcon as ChallengeTokenIcon3 } from "@leagueplatform/rewards-common";

// src/hooks/use-activity-details-analytics.hook.js
import {
  trackAnalyticsEvent as trackAnalyticsEvent4,
  PRODUCT_AREA as PRODUCT_AREA4,
  EVENT_NAME as EVENT_NAME4
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES4 } from "@leagueplatform/health-journey-common";
import { useQueryClient } from "react-query";
import { GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE2 } from "@leagueplatform/health-journey-api";
import { useMemo as useMemo3 } from "react";
var { BUTTON_CLICKED, SCREEN_LOADED } = EVENT_NAME4;
var meta = {
  product_area: PRODUCT_AREA4.JOURNEY,
  screen_name: SCREEN_NAMES4.ACTIVITY_DETAILS
};
var useActivityAnalytics = () => {
  const queryClient = useQueryClient();
  const {
    userActivityId,
    campaignId,
    // contentActivityIdParam is nullish when retrieved via url param and is used for deep linking purposes
    contentActivityId: contentActivityIdParam
  } = useActivityParams();
  const activityData = useMemo3(
    () => queryClient.getQueryData([
      GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE2,
      userActivityId,
      contentActivityIdParam,
      campaignId
    ]),
    [campaignId, contentActivityIdParam, queryClient, userActivityId]
  );
  const activity = (activityData == null ? void 0 : activityData.health_activity) || {};
  const {
    cta = {},
    goal_id: contentActivityId,
    name: activityName,
    type: activityType,
    status: activityStatus,
    campaign_info: campaignInfo = {},
    activity_verification_progress: activityProgress = {},
    front_of_the_line_activity: isFotl
  } = activity;
  const counterProgressValue = activityProgress == null ? void 0 : activityProgress.count_progress;
  const completionMethod = (cta == null ? void 0 : cta.completion_method) || {};
  const { counter = {}, type: completionType } = completionMethod;
  const data = {
    health_campaign_activity_id: contentActivityId,
    health_campaign_activity_name: activityName,
    health_campaign_activity_type: activityType,
    health_campaign_activity_ux_type: completionType || null,
    health_campaign_activity_status: activityStatus,
    health_campaign_type: (campaignInfo == null ? void 0 : campaignInfo.campaign_type) || null
  };
  const activityState = {
    health_campaign_activity_goal: (counter == null ? void 0 : counter.goal) || null,
    health_campaign_activity_current_progress: counterProgressValue || null
  };
  return {
    /**
     * View Activity
     * @description Only fire the activity screen view event when the
     * activity id this module is initialized with matches the activity id that api responds with.
     * Without this check, the event is liable to fire for a previously cached activity that the user has visited
     */
    sendViewActivity() {
      trackAnalyticsEvent4(SCREEN_LOADED, __spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState));
    },
    // Activity Removal Analytics
    sendRemoveActivityPrompt() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        detail: "remove health campaign activity"
      }));
    },
    sendViewRemoveActivityModal() {
      trackAnalyticsEvent4(SCREEN_LOADED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        screen_name: SCREEN_NAMES4.REMOVE_MODAL
      }));
    },
    sendConfirmActivityRemove() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.REMOVE_MODAL,
        detail: "confirm health campaign activity removal"
      }));
    },
    sendCancelActivityRemove() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.REMOVE_MODAL,
        detail: "cancel health campaign activity removal"
      }));
    },
    // Complete Activity Analytics
    sendViewCompleteActivityModal() {
      trackAnalyticsEvent4(SCREEN_LOADED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.COMPLETE_MODAL
      }));
    },
    sendCompleteActivity() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        detail: "complete health campaign activity",
        sub_detail: (cta == null ? void 0 : cta.text) || null,
        is_fotl: isFotl
      }));
    },
    sendCloseActivityComplete() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues({}, meta), {
        screen_name: SCREEN_NAMES4.COMPLETE_MODAL,
        detail: "close"
      }));
    },
    // Close Activity Analytics
    sendCloseActivity() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        detail: "close activity"
      }));
    },
    // Close an activity or mark as done from the Progress Save modal
    sendViewSaveProgressModal() {
      trackAnalyticsEvent4(SCREEN_LOADED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.SAVE_PROGRESS_MODAL
      }));
    },
    sendDismissSaveProgressModal() {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.SAVE_PROGRESS_MODAL,
        detail: "dismiss"
      }));
    },
    sendSaveProgressModalAction({ isCompletion, ctaText }) {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        screen_name: SCREEN_NAMES4.SAVE_PROGRESS_MODAL,
        detail: isCompletion ? "complete health campaign activity" : "close",
        sub_detail: ctaText || null
      }));
    },
    // Change Activity Progress Value Analytics Event
    sendEditActivityProgress({ inputMethod, newValue, oldValue }) {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        detail: "edit activity progress",
        health_campaign_activity_current_progress: newValue,
        health_campaign_activity_updated_progress: oldValue,
        health_campaign_activity_config_options: {
          input_methods: [inputMethod]
        }
      }));
    },
    sendOpenEditActivityProgressModal(ctaText) {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), activityState), {
        detail: "manual entry",
        sub_detail: ctaText
      }));
    },
    /**
     * Select Activity Helpful tip
     * @param {string} type link type (ex. audio, video, article)
     * @param {string} title helpful tip title
     * @param {string} url link-out url
     */
    sendSelectHelpfulTip({ type, title, url }) {
      trackAnalyticsEvent4(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta), data), {
        detail: "select content from activity",
        sub_detail: type,
        content_url: url || null,
        link_name: title || null
      }));
    }
  };
};

// src/components/complete-activity-modal.component.js
var CompleteActivityModal = React26.memo(
  ({ onClose, achievementsUpdates, completionData }) => {
    var _a;
    const { formatMessage, $tifelse } = useIntl8();
    const { activityId } = useHealthActivity();
    const activityAnalytics = useActivityAnalytics();
    const {
      isAchievementsFeatureFlagOn,
      completedAchievements,
      inProgressAchievements,
      hasCompletedAchievements
    } = achievementsUpdates != null ? achievementsUpdates : {};
    const achievementsProgress = [
      ...completedAchievements || [],
      ...inProgressAchievements || []
    ];
    const {
      description_one: descriptionOne,
      description_two: descriptionTwo,
      eyebrow_headline: heading,
      image,
      rewards_message: pointsText,
      title,
      activity_reward_tokens: tokens
    } = (_a = completionData == null ? void 0 : completionData.completion_screen) != null ? _a : {};
    const shouldDisplayAchievements = isAchievementsFeatureFlagOn && inProgressAchievements.length;
    const modalLabel = shouldDisplayAchievements ? formatMessage({ id: "ACTIVITY_COMPLETE" }) : title;
    useEffect2(() => {
      if (activityId) {
        activityAnalytics.sendViewCompleteActivityModal();
      }
    }, [activityId]);
    const AchievementsProgress = achievementsProgress == null ? void 0 : achievementsProgress.map((achievement) => {
      var _a2, _b, _c, _d, _e, _f;
      if (achievement.name) {
        return /* @__PURE__ */ React26.createElement(
          BadgeProgress,
          {
            contentUrl: (_a2 = achievement == null ? void 0 : achievement.image) == null ? void 0 : _a2.small,
            title: achievement.name,
            key: achievement.name,
            isLoading: false,
            currentActivity: (_c = (_b = achievement == null ? void 0 : achievement.progress) == null ? void 0 : _b.criteria) == null ? void 0 : _c.current,
            totalActivities: (_e = (_d = achievement == null ? void 0 : achievement.progress) == null ? void 0 : _d.criteria) == null ? void 0 : _e.threshold,
            progressTitle: (_f = achievement == null ? void 0 : achievement.progress) == null ? void 0 : _f.title
          }
        );
      }
      return null;
    });
    const AchievementsContent = /* @__PURE__ */ React26.createElement(Flex6, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React26.createElement(HeadingThree, { as: "h1", marginY: "quarter" }, modalLabel), pointsText && tokens <= 0 && /* @__PURE__ */ React26.createElement(Flex6, { marginBottom: "two" }, /* @__PURE__ */ React26.createElement(SubtitleOne, { as: "span", color: "secondary.text.default" }, pointsText)), tokens > 0 && /* @__PURE__ */ React26.createElement(Flex6, { marginBottom: "two", alignItems: "center" }, /* @__PURE__ */ React26.createElement(BodyTwo2, { marginInlineEnd: 5 }, formatMessage({ id: "YOU_EARNED" })), /* @__PURE__ */ React26.createElement(ChallengeTokenIcon3, { value: tokens })), /* @__PURE__ */ React26.createElement(Box11, { marginInlineStart: "minusTwoAndHalf" }, AchievementsProgress));
    const JourneyContent = /* @__PURE__ */ React26.createElement(Flex6, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React26.createElement(DynamicCoverImage, { src: image, size: 80, marginBottom: "one" }), heading && /* @__PURE__ */ React26.createElement(BodyTwo2, null, heading), modalLabel && /* @__PURE__ */ React26.createElement(HeadingTwo2, { as: "h1", marginY: "quarter" }, modalLabel), pointsText && /* @__PURE__ */ React26.createElement(
      SubtitleOne,
      {
        as: "h2",
        color: "decorative.brand.default",
        fontWeight: "medium"
      },
      pointsText
    ), descriptionOne && /* @__PURE__ */ React26.createElement(BodyTwo2, { marginTop: "one" }, descriptionOne), descriptionTwo && /* @__PURE__ */ React26.createElement(BodyTwo2, { marginTop: "one" }, descriptionTwo));
    return /* @__PURE__ */ React26.createElement(
      HealthActivityModal,
      {
        onClose,
        "aria-label": modalLabel,
        isNarrow: isAchievementsFeatureFlagOn
      },
      shouldDisplayAchievements ? AchievementsContent : JourneyContent,
      /* @__PURE__ */ React26.createElement(Flex6, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React26.createElement(PrimaryButton, { onClick: onClose, marginTop: "oneAndHalf" }, $tifelse(hasCompletedAchievements, "CONTINUE", "BACK_TO_JOURNEY")))
    );
  },
  (prevProps, nextProps) => {
    const nextPropsContainsValidData = nextProps.completionData || nextProps.achievementsUpdates;
    const prevPropsContainsValidData = prevProps.completionData || prevProps.achievementsUpdates;
    return nextPropsContainsValidData || prevPropsContainsValidData;
  }
);
CompleteActivityModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  completionData: PropTypes.shape({ completion_screen: PropTypes.shape({}) }),
  achievementsUpdates: PropTypes.shape({})
};
CompleteActivityModal.defaultProps = {
  completionData: void 0,
  achievementsUpdates: void 0
};

// src/components/health-rewards-sidebar.component.js
import React28 from "react";
import { useNavigateLegacy as useNavigate3 } from "@leagueplatform/routing";
import PropTypes2 from "prop-types";
import { Box as Box12, Flex as Flex7, PrimaryButton as PrimaryButton2 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import {
  AchievementStats,
  RecentAchievements,
  useAchievementsDetail,
  ACHIEVEMENTS_ENABLED as ACHIEVEMENTS_ENABLED4,
  RewardsSidebarCard
} from "@leagueplatform/rewards-achievements";
import { useFeatureFlagQuery as useFeatureFlagQuery6 } from "@leagueplatform/user-profile-api";
import {
  trackAnalyticsEvent as trackAnalyticsEvent5,
  EVENT_NAME as EVENT_NAME5,
  PRODUCT_AREA as PRODUCT_AREA5
} from "@leagueplatform/analytics";
import { JOURNEY_ROUTES as JOURNEY_ROUTES6 } from "@leagueplatform/health-journey-common";
import {
  Sidebar,
  addSidebarSpacing
} from "@leagueplatform/web-common-components";

// src/components/activity-completion-controller.component.js
import React27, { useEffect as useEffect3, useState as useState2, useMemo as useMemo4, useCallback } from "react";
import {
  CelebrationAchievementsModal,
  useAchievementsUpdates
} from "@leagueplatform/rewards-achievements";

// src/hooks/use-activity-completion-data.hook.js
import { useQuery as useQuery3, useQueryClient as useQueryClient2 } from "react-query";
import { COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE } from "@leagueplatform/health-journey-api";
var queryFunctionStub = () => void 0;
var activityCompletionQueryKey = [COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE];
var useActivityCompletionData = () => {
  const queryClient = useQueryClient2();
  const { data: completionData } = useQuery3(
    activityCompletionQueryKey,
    queryFunctionStub,
    {
      staleTime: Infinity
    }
  );
  const setCompletionDataToCache = (updatedCompletionData) => queryClient.setQueryData(
    [COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE],
    updatedCompletionData
  );
  const resetCompletionData = () => queryClient.resetQueries(activityCompletionQueryKey);
  return {
    completionData,
    resetCompletionData,
    setCompletionData: setCompletionDataToCache
  };
};

// src/components/activity-completion-controller.component.js
import {
  useNavigateLegacy as useNavigate2,
  useLocationLegacy as useLocation
} from "@leagueplatform/routing";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES5,
  ViewTransitionController
} from "@leagueplatform/health-journey-common";
import { REWARDS_EVENTS_UPDATES } from "@leagueplatform/rewards-events";
import { useFeatureFlagQuery as useFeatureFlagQuery5 } from "@leagueplatform/user-profile-api";
var COMPLETION_MODAL_TYPES = Object.freeze({
  ACTIVITY_COMPLETE: "activity_complete",
  ACHIEVEMENT_COMPLETE: "achievement_complete",
  NONE: ""
});
var { ACTIVITY_COMPLETE, ACHIEVEMENT_COMPLETE, NONE } = COMPLETION_MODAL_TYPES;
var ActivityCompletionController = () => {
  const navigate = useNavigate2();
  const location = useLocation();
  const { completionData, resetCompletionData } = useActivityCompletionData();
  const achievementsUpdates = useAchievementsUpdates();
  const activityAnalytics = useActivityAnalytics();
  const [activeModal, setActiveModal] = useState2(NONE);
  const { data: isRewardsLayerEnabled } = useFeatureFlagQuery5(
    REWARDS_EVENTS_UPDATES
  );
  const [isAchievementsFetched, setIsAchievementsFetched] = useState2(false);
  const {
    isAchievementUpdatesReady,
    refetchAchievements,
    hasCompletedAchievements,
    inProgressAchievements,
    isAchievementsFeatureFlagOn,
    clearAchievements
  } = achievementsUpdates;
  const hasCompletionData = Boolean(completionData);
  const hasInProgressAchievements = Boolean(inProgressAchievements.length);
  const onActivityCompleteModalClose = useCallback(() => __async(void 0, null, function* () {
    activityAnalytics.sendCloseActivityComplete();
    resetCompletionData();
    if (!hasCompletedAchievements) {
      if (isAchievementsFeatureFlagOn) {
        clearAchievements();
      }
      setActiveModal(NONE);
      navigate(JOURNEY_ROUTES5.journeyHome());
      return;
    }
    setActiveModal(ACHIEVEMENT_COMPLETE);
  }), [hasCompletedAchievements, isAchievementsFeatureFlagOn]);
  const onAchievementCompleteModalClose = useCallback(() => __async(void 0, null, function* () {
    if (isAchievementsFeatureFlagOn) {
      clearAchievements();
    }
    setActiveModal(NONE);
    navigate(JOURNEY_ROUTES5.achievementsHome());
  }), [isAchievementsFeatureFlagOn]);
  const modals = useMemo4(
    () => ({
      [ACTIVITY_COMPLETE]: {
        view: CompleteActivityModal,
        props: {
          onClose: onActivityCompleteModalClose,
          achievementsUpdates,
          completionData
        }
      },
      [ACHIEVEMENT_COMPLETE]: {
        view: CelebrationAchievementsModal,
        props: {
          onClose: onAchievementCompleteModalClose,
          open: activeModal === ACHIEVEMENT_COMPLETE
        }
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inProgressAchievements, hasCompletedAchievements, completionData]
  );
  useEffect3(() => {
    let timeoutId;
    if (location.pathname === JOURNEY_ROUTES5.journeyHome() && isAchievementsFeatureFlagOn && !isRewardsLayerEnabled) {
      timeoutId = setTimeout(
        () => refetchAchievements().then(setIsAchievementsFetched(true)),
        500
      );
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    isAchievementsFeatureFlagOn,
    isRewardsLayerEnabled,
    location.pathname,
    refetchAchievements
  ]);
  useEffect3(() => {
    if (!activeModal && !isRewardsLayerEnabled && (!isAchievementsFeatureFlagOn || isAchievementsFetched && isAchievementUpdatesReady)) {
      if (hasCompletionData || hasInProgressAchievements) {
        setActiveModal(ACTIVITY_COMPLETE);
      } else if (hasCompletedAchievements) {
        setActiveModal(ACHIEVEMENT_COMPLETE);
      } else {
        setActiveModal(NONE);
      }
    }
  }, [
    isAchievementUpdatesReady,
    isAchievementsFeatureFlagOn,
    activeModal,
    hasCompletionData,
    hasInProgressAchievements,
    hasCompletedAchievements,
    isAchievementsFetched,
    isRewardsLayerEnabled
  ]);
  const handleActiveModal = () => activeModal;
  return /* @__PURE__ */ React27.createElement(
    ViewTransitionController,
    {
      views: modals,
      handleActiveView: handleActiveModal
    }
  );
};

// src/components/health-rewards-sidebar.component.js
var AchievementsSidebarView = () => {
  const { completedAchievementStats, recentAchievements } = useAchievementsDetail();
  return /* @__PURE__ */ React28.createElement(
    Box12,
    {
      as: Flex7,
      display: { _: "none", laptop: "flex" },
      css: addSidebarSpacing
    },
    /* @__PURE__ */ React28.createElement(AchievementStats, { completedAchievements: completedAchievementStats }),
    /* @__PURE__ */ React28.createElement(RecentAchievements, { achievements: recentAchievements })
  );
};
var HealthRewardsSidebar = ({
  children,
  isAddProgramButtonShown,
  showAchievements
}) => {
  const { formatMessage } = useIntl9();
  const { data: isAchievementsEnabled } = useFeatureFlagQuery6(ACHIEVEMENTS_ENABLED4);
  const navigate = useNavigate3();
  const screenName = window.location.href.includes("health-progress") ? "health journey progress" : "health journey activities";
  return /* @__PURE__ */ React28.createElement(Sidebar, null, /* @__PURE__ */ React28.createElement(
    Flex7,
    {
      flexGrow: "1",
      marginInlineEnd: { phone: "oneAndHalf", laptop: "initial" },
      css: addSidebarSpacing
    },
    isAchievementsEnabled && showAchievements && /* @__PURE__ */ React28.createElement(AchievementsSidebarView, null),
    /* @__PURE__ */ React28.createElement(RewardsSidebarCard, null)
  ), isAddProgramButtonShown && /* @__PURE__ */ React28.createElement(
    PrimaryButton2,
    {
      marginTop: { _: "half", phone: "initial", laptop: "none" },
      height: "three",
      onClick: () => {
        navigate(JOURNEY_ROUTES6.programsHome());
        trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA5.JOURNEY,
          screen_name: screenName,
          detail: "navigate to health campaign library",
          sub_detail: formatMessage({ id: "ADD_PROGRAM" })
        });
      }
    },
    formatMessage({ id: "ADD_PROGRAM" })
  ), /* @__PURE__ */ React28.createElement(ActivityCompletionController, null), children);
};
HealthRewardsSidebar.propTypes = {
  isAddProgramButtonShown: PropTypes2.bool,
  showAchievements: PropTypes2.bool,
  children: PropTypes2.node
};
HealthRewardsSidebar.defaultProps = {
  isAddProgramButtonShown: false,
  showAchievements: false,
  children: null
};

// src/components/health-activity-card-list/health-activity-card-list.view.js
import React31 from "react";
import { LinkLegacy as Link5 } from "@leagueplatform/routing";
import {
  HeadingThree as HeadingThree2,
  Box as Box15,
  SubtitleOne as SubtitleOne2,
  Flex as Flex10,
  genesisStyled as genesisStyled9
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { arrayOf as arrayOf2, shape as shape2, string as string6, bool as bool3, number as number4 } from "prop-types";
import { JOURNEY_ROUTES as JOURNEY_ROUTES8 } from "@leagueplatform/health-journey-common";

// src/common/health-activities.props.js
import {
  number,
  shape,
  string as string3,
  bool,
  oneOf,
  oneOfType as oneOfType2,
  arrayOf
} from "prop-types";
import { HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS5 } from "@leagueplatform/health-journey-common";
var activityStatusArray = Object.values(HEALTH_JOURNEY_ACTIVITY_STATUS5);
var timestampType = oneOfType2([string3, number]);
var activityShortPropType = {
  activity_points: number.isRequired,
  points_earned: number,
  campaign_info: shape({
    campaign_id: string3.isRequired,
    campaign_type: string3,
    name: string3.isRequired,
    start_date: string3.isRequired,
    assigned: bool,
    assigned_by_title: string3
  }).isRequired,
  can_expire: bool.isRequired,
  suggested: bool.isRequired,
  start_date: timestampType.isRequired,
  icon_url: string3.isRequired,
  id: string3.isRequired,
  name: string3.isRequired,
  type: string3.isRequired,
  status: oneOf(activityStatusArray).isRequired,
  end_date: timestampType,
  completed_date: timestampType,
  removed_date: timestampType,
  activity_tokens: number.isRequired,
  tokens_earned: number
};
var activityShortDefaultProps = {
  points_earned: 0,
  end_date: "",
  completed_date: "",
  removed_date: "",
  tokens_earned: 0
};
var activitiesArrayPropType = arrayOf(shape(activityShortPropType));
var activitiesGroupPropType = arrayOf(
  shape({ title: string3, activities: activitiesArrayPropType })
);
var activitiesGroupsProps = {
  activitiesByCampaign: activitiesGroupPropType,
  activitiesByStatus: activitiesGroupPropType,
  activitiesByAssigned: activitiesArrayPropType,
  activitiesByChallenge: activitiesGroupPropType,
  activitiesByPriority: activitiesArrayPropType
};
var activitiesGroupsDefaultProps = {
  activitiesByCampaign: void 0,
  activitiesByStatus: void 0,
  activitiesByAssigned: void 0,
  activitiesByChallenge: void 0,
  activitiesByPriority: void 0
};
var journeyPageProps = {
  todaysDate: number.isRequired
};
var journeyPageEmptyStateProps = {
  button: string3,
  image: shape({
    alt: string3,
    src: string3
  }),
  text: shape({
    bodyText: string3,
    headingText: string3
  })
};

// src/components/health-activity-card-list/health-activity-card.view.js
import React30 from "react";
import { LinkLegacy as Link4 } from "@leagueplatform/routing";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import { string as string5, instanceOf, number as number3 } from "prop-types";
import {
  Flex as Flex9,
  Box as Box14,
  Overline as Overline3,
  HeadingFour as HeadingFour2,
  Caption as Caption2,
  Image as Image6,
  genesisStyled as genesisStyled8
} from "@leagueplatform/genesis-commons";
import { genesisFocus } from "@leagueplatform/ui-kit";
import { arrayToTag, truncateWithEllipses } from "@leagueplatform/web-common";
import { ChallengeActivityTokenCaption } from "@leagueplatform/challenges";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES7,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS8,
  UserHealthActivityStatus,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE5
} from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";

// src/components/health-activity-card-list/health-activity-card-progress.component.js
import React29 from "react";
import { string as string4, number as number2, oneOf as oneOf2, bool as bool2 } from "prop-types";
import {
  Flex as Flex8,
  Box as Box13,
  useTheme,
  HeadingTwo as HeadingTwo3,
  BodyTwoSecondary as BodyTwoSecondary2,
  genesisStyled as genesisStyled7
} from "@leagueplatform/genesis-commons";
import { CompoundProgressBar } from "@leagueplatform/ui-kit";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS6 } from "@leagueplatform/health-journey-common";
var { COMPLETED: COMPLETED2, ACTIVE: ACTIVE2, UPCOMING: UPCOMING3, EXPIRED: EXPIRED2, REMOVED: REMOVED2 } = HEALTH_JOURNEY_ACTIVITY_STATUS6;
var CounterTitle = genesisStyled7(Flex8)`
  > span:not(:last-child) {
    margin-inline-end: 0.25em;
  }
`;
var getProgressColorsByStatus = ({
  colors: { highlight, success, interactive }
}) => ({
  [ACTIVE2]: {
    // Is front of line activity
    [true]: {
      highlightColor: highlight.icon
    },
    [false]: {
      highlightColor: highlight.icon
    }
  },
  [UPCOMING3]: {
    highlightColor: highlight.icon
  },
  [COMPLETED2]: {
    highlightColor: success.icon
  },
  [EXPIRED2]: {
    highlightColor: interactive.action.subdued
  },
  [REMOVED2]: {
    highlightColor: interactive.action.subdued
  },
  [void 0]: {
    highlightColor: highlight.icon
  }
});
var ActivityCardProgress = ({
  progress,
  goal,
  unit,
  status,
  isFrontOfLine: isFrontOfLine2
}) => {
  const { formatNumber } = useIntl10();
  const theme = useTheme();
  const progressColorsByStatus = getProgressColorsByStatus(theme);
  const { highlightColor } = status === ACTIVE2 ? progressColorsByStatus[status][isFrontOfLine2] : progressColorsByStatus[status];
  const progressBarConfig = [
    {
      key: "activity-progress-count",
      color: highlightColor,
      percent: progress / goal * 100,
      transition: `width 0.5s ease-out`
    }
  ];
  return /* @__PURE__ */ React29.createElement(Box13, { marginTop: "half" }, /* @__PURE__ */ React29.createElement(CounterTitle, { as: "p", marginBottom: "half", alignItems: "baseline" }, /* @__PURE__ */ React29.createElement(HeadingTwo3, { as: "span", color: highlightColor }, formatNumber(progress)), /* @__PURE__ */ React29.createElement(
    HeadingTwo3,
    {
      as: "span",
      color: "onSurface.text.subdued",
      fontWeight: "regular"
    },
    "/"
  ), /* @__PURE__ */ React29.createElement(
    HeadingTwo3,
    {
      as: "span",
      color: "onSurface.text.subdued",
      fontWeight: "regular"
    },
    formatNumber(goal)
  ), /* @__PURE__ */ React29.createElement(BodyTwoSecondary2, { as: "span" }, unit)), /* @__PURE__ */ React29.createElement(
    CompoundProgressBar,
    {
      backgroundColor: "interactive.action.disabled",
      segments: progressBarConfig
    }
  ));
};
ActivityCardProgress.propTypes = {
  progress: number2.isRequired,
  goal: number2.isRequired,
  unit: string4.isRequired,
  status: oneOf2(Object.values(HEALTH_JOURNEY_ACTIVITY_STATUS6)).isRequired,
  isFrontOfLine: bool2.isRequired
};

// src/hooks/use-activities-timeline-analytics/use-activities-timeline-analytics.hook.js
import {
  trackAnalyticsEvent as trackAnalyticsEvent6,
  PRODUCT_AREA as PRODUCT_AREA6,
  EVENT_NAME as EVENT_NAME6
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES5 } from "@leagueplatform/health-journey-common";
import { useLocationLegacy as useLocation2 } from "@leagueplatform/routing";
var useActivitiesTimelineAnalytics = (currentSelectedDate) => {
  const location = useLocation2();
  const baseParams = {
    product_area: PRODUCT_AREA6.JOURNEY,
    current_date: normalizeEpochDate(Date.now())
  };
  const getScreenNameAnalytics = (activity) => {
    if ((activity == null ? void 0 : activity.suggested) && !(activity == null ? void 0 : activity.front_of_the_line_activity)) {
      return SCREEN_NAMES5.SUGGESTED_GROUP;
    }
    if (location.pathname.endsWith("/home")) {
      return SCREEN_NAMES5.HOME_PAGE;
    }
    return SCREEN_NAMES5.ACTIVITY_TIMELINE;
  };
  return {
    // User selects a card from activities list.
    selectActivity: (activity, suggestedActivityGroupName) => {
      var _a, _b, _c, _d, _e;
      trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseParams), {
        screen_name: getScreenNameAnalytics(activity),
        current_selected_date: currentSelectedDate,
        detail: "view health campaign activity",
        is_fotl: activity == null ? void 0 : activity.front_of_the_line_activity,
        health_campaign_activity_composition: activity == null ? void 0 : activity.detail_level,
        health_campaign_activity_id: activity == null ? void 0 : activity.goal_id,
        health_campaign_activity_name: activity == null ? void 0 : activity.name,
        health_campaign_activity_priority: activity == null ? void 0 : activity.priority,
        health_campaign_activity_type: activity == null ? void 0 : activity.type,
        health_campaign_activity_status: activity == null ? void 0 : activity.status,
        health_campaign_type: ((_a = activity == null ? void 0 : activity.campaign_info) == null ? void 0 : _a.campaign_type) || null,
        health_campaign_activity_goal: (_e = (_d = (_c = (_b = activity == null ? void 0 : activity.cta) == null ? void 0 : _b.completion_method) == null ? void 0 : _c.counter) == null ? void 0 : _d.goal) != null ? _e : null,
        suggested_activity_group_name: suggestedActivityGroupName || null
      }));
    },
    // User selects a card from suggested activity groups list.
    selectSuggestedActivityGroup: (groupIndex, groupName) => {
      trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseParams), {
        screen_name: SCREEN_NAMES5.ACTIVITY_TIMELINE,
        current_selected_date: currentSelectedDate,
        detail: "view suggested activity group",
        sub_detail: groupName,
        carousel_name: "Suggested Activity Group",
        carousel_index: groupIndex
      }));
    },
    // User selects back or forward date navigation.
    // Selected date has not been stored as activeDate at time of event,
    // so it must be manually passed in this instance.
    navigateToDate: (selectedDate, subdetail) => {
      trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseParams), {
        current_selected_date: selectedDate,
        detail: "select date",
        sub_detail: subdetail
      }));
    },
    // User selects "back to today" action.
    navigateToToday: () => {
      trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseParams), {
        detail: "navigate to today's date"
      }));
    }
  };
};

// src/hooks/use-health-activity-captions.hook.ts
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { SHORT_MONTH_FORMAT as SHORT_MONTH_FORMAT2 } from "@leagueplatform/web-common";
import { useFeatureFlagQuery as useFeatureFlagQuery7 } from "@leagueplatform/user-profile-api";
import {
  JOURNEY_MANAGER_ENABLED,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS7,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE4,
  useGetUserProfile as useGetUserProfile2
} from "@leagueplatform/health-journey-common";
var { ACTIVE: ACTIVE3, UPCOMING: UPCOMING4, EXPIRED: EXPIRED3, REMOVED: REMOVED3, COMPLETED: COMPLETED3 } = HEALTH_JOURNEY_ACTIVITY_STATUS7;
var { CHALLENGE } = ACTIVITY_CAMPAIGN_TYPE4;
var useHealthActivityCaption = ({
  status,
  end_date,
  todaysDate,
  activity_points: points,
  points_earned: pointsEarned,
  tokens_earned: tokensEarned,
  activity_tokens: activityTokens,
  campaign_info: {
    assigned,
    campaign_type: campaignType,
    assigned_by_title: assignedByTitle
  },
  can_expire: canExpire,
  start_date: startDate
}) => {
  const { formatMessage, $tifelse, formatNumber, formatDate } = useIntl11();
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery7(
    JOURNEY_MANAGER_ENABLED
  );
  const { data: userProfileData } = useGetUserProfile2();
  const { defaultTimezone } = userProfileData || {};
  const endDate = end_date || "";
  const formatPoints = (pts) => formatNumber(pts, { style: "decimal" });
  const isAssignedShown = assigned && isJourneyManagerEnabled;
  const isExpiringToday = new Date(todaysDate).toLocaleDateString("en-US", {
    timeZone: defaultTimezone
  }) === new Date(endDate).toLocaleDateString("en-US", {
    timeZone: defaultTimezone
  });
  const isAssignedToday = new Date(todaysDate).toLocaleDateString("en-US", {
    timeZone: defaultTimezone
  }) === new Date(startDate).toLocaleDateString("en-US", {
    timeZone: defaultTimezone
  });
  const expiresCaption = canExpire ? $tifelse(isExpiringToday, "EXPIRES_TODAY", "EXPIRES_ON_DATE", {
    date: formatDate(endDate, __spreadProps(__spreadValues({}, SHORT_MONTH_FORMAT2), {
      timeZone: defaultTimezone
    }))
  }) : null;
  const assignedOnCaption = isAssignedShown ? $tifelse(isAssignedToday, "ASSIGNED_TODAY", "ASSIGNED_ON", {
    date: formatDate(startDate, __spreadProps(__spreadValues({}, SHORT_MONTH_FORMAT2), {
      timeZone: defaultTimezone
    }))
  }) : "";
  const assignedByTitleCaption = isAssignedShown ? assignedByTitle : "";
  const assignedText = assignedByTitleCaption ? `${assignedByTitleCaption} ${assignedOnCaption}` : null;
  const pointsCaption = (() => {
    let pointsText = null;
    switch (status.toLowerCase()) {
      case ACTIVE3:
      case UPCOMING4:
        if (campaignType === CHALLENGE && activityTokens) {
          pointsText = formatMessage({ id: "EARN" });
        } else if (points) {
          pointsText = formatMessage(
            { id: "EARN_NUMBER_POINTS_FULL" },
            { points: formatPoints(points) }
          );
        }
        break;
      case COMPLETED3:
        if (campaignType === CHALLENGE && tokensEarned) {
          pointsText = formatMessage({ id: "YOU_EARNED" });
        } else if (pointsEarned) {
          pointsText = formatMessage(
            { id: "YOU_EARNED_X_POINTS" },
            { points: formatPoints(pointsEarned) }
          );
        }
        break;
      case EXPIRED3:
      case REMOVED3:
      default:
        break;
    }
    return pointsText;
  })();
  const captions = {
    expires: expiresCaption,
    points: pointsCaption,
    assigned: assignedText
  };
  return captions;
};

// src/components/health-activity-card-list/health-activity-card.view.js
var { ACTIVE: ACTIVE4, UPCOMING: UPCOMING5 } = HEALTH_JOURNEY_ACTIVITY_STATUS8;
var { CHALLENGE: CHALLENGE2 } = ACTIVITY_CAMPAIGN_TYPE5;
var { ALARM_CLOCK } = HEALTH_JOURNEY_ASSET_KEYS;
var ActivityCardCaption = (_a) => {
  var _b = _a, { todaysDate } = _b, activity = __objRest(_b, ["todaysDate"]);
  const clockIcon = handleStaticAsset7(ALARM_CLOCK);
  const { expires, points, assigned } = useHealthActivityCaption(__spreadValues({
    todaysDate
  }, activity));
  const {
    tokens_earned: tokensEarned,
    activity_tokens: activityTokens,
    campaign_info: { campaign_type: campaignType } = {}
  } = activity;
  const fullCaptionText = campaignType === CHALLENGE2 ? arrayToTag([expires], true) : arrayToTag([assigned, expires, points], true);
  return /* @__PURE__ */ React30.createElement(Flex9, { marginTop: "one" }, (assigned || expires) && /* @__PURE__ */ React30.createElement(Image6, { src: clockIcon, alt: "", width: "auto", marginInlineEnd: "quarter" }), /* @__PURE__ */ React30.createElement(Caption2, { as: "span" }, fullCaptionText, campaignType === CHALLENGE2 && points && /* @__PURE__ */ React30.createElement(React30.Fragment, null, fullCaptionText && /* @__PURE__ */ React30.createElement(Box14, { as: "span", marginX: "quarter" }, "\u2219"), /* @__PURE__ */ React30.createElement(
    ChallengeActivityTokenCaption,
    {
      tokens: activityTokens || tokensEarned,
      activityDesc: points
    }
  ))));
};
ActivityCardCaption.propTypes = __spreadProps(__spreadValues({}, activityShortPropType), {
  todaysDate: instanceOf(Date)
});
ActivityCardCaption.defaultProps = __spreadProps(__spreadValues({}, activityShortDefaultProps), {
  todaysDate: /* @__PURE__ */ new Date()
});
var HealthActivityCard = (_a) => {
  var _b = _a, {
    todaysDate,
    activeDate,
    suggestedActivityGroupName
  } = _b, activity = __objRest(_b, [
    "todaysDate",
    "activeDate",
    "suggestedActivityGroupName"
  ]);
  const { $tmap } = useIntl12();
  const {
    campaign_info,
    name,
    status,
    type,
    id: activityId,
    icon_url: image,
    front_of_the_line_activity: isFrontOfLine2
  } = activity;
  const { selectActivity } = useActivitiesTimelineAnalytics(activeDate);
  const { isProgressActivity, progressProps } = configureActivityCardProgress(activity);
  const isActiveUpcoming2 = status === UPCOMING5 || status === ACTIVE4;
  const programName = status !== ACTIVE4 && status !== UPCOMING5 && campaign_info.name;
  const activityPath = JOURNEY_ROUTES7.getActivityDetails(activityId, type);
  const ActivityCardContainer = genesisStyled8(Flex9)`
    &:last-of-type {
      margin-bottom: 0;
    }
  `;
  const activityCardStyles = () => {
    const styles = {
      textDecoration: "none",
      alignItems: "center",
      padding: "oneAndHalf",
      marginBottom: "oneAndHalf",
      borderRadius: "medium",
      borderColor: "onSurface.border.subdued",
      borderWidth: "thin",
      width: "100%",
      backgroundColor: "surface.background.secondary",
      transition: "background-color 150ms"
    };
    if (isActiveUpcoming2) {
      styles.backgroundColor = isFrontOfLine2 ? "highlight.background.subdued" : "surface.background.primary";
    }
    return styles;
  };
  const statusMessage = $tmap({
    [UserHealthActivityStatus.ACTIVE]: "ACTIVE",
    [UserHealthActivityStatus.UPCOMING]: "UPCOMING",
    [UserHealthActivityStatus.COMPLETED]: "COMPLETED",
    [UserHealthActivityStatus.EXPIRED]: "EXPIRED",
    [UserHealthActivityStatus.REMOVED]: "REMOVED",
    [UserHealthActivityStatus.ON_HOLD]: "ON-HOLD",
    suspended: "SUSPENDED",
    completed_today: "COMPLETED_TODAY",
    missed: "MISSED"
  })(status);
  return /* @__PURE__ */ React30.createElement(
    ActivityCardContainer,
    __spreadProps(__spreadValues({
      as: Link4,
      to: activityPath,
      onClick: () => {
        selectActivity(activity, suggestedActivityGroupName);
      }
    }, activityCardStyles()), {
      focusStyle: __spreadProps(__spreadValues({}, genesisFocus), {
        backgroundColor: "interactive.background.disabled"
      }),
      hoverStyle: {
        textDecoration: "none",
        backgroundColor: "interactive.background.disabled"
      }
    }),
    /* @__PURE__ */ React30.createElement(
      DynamicCoverImage,
      {
        alt: statusMessage,
        backgroundColor: "surface.background.primary",
        borderColor: "onSurface.border.subdued",
        borderRadius: "large",
        marginInlineEnd: "oneAndHalf",
        minWidth: "64px",
        size: 64,
        src: image
      }
    ),
    /* @__PURE__ */ React30.createElement(Flex9, { flexDirection: "column", flexGrow: 1 }, programName && /* @__PURE__ */ React30.createElement(Box14, { marginBottom: "half" }, /* @__PURE__ */ React30.createElement(Overline3, { as: "p", color: "onSurface.text.subdued" }, truncateWithEllipses(programName, 50))), name && /* @__PURE__ */ React30.createElement(Box14, null, /* @__PURE__ */ React30.createElement(
      HeadingFour2,
      {
        as: "p",
        fontSize: { _: "subtitle1", phone: "heading4" },
        color: "onSurface.text.primary"
      },
      truncateWithEllipses(name, 70)
    )), isProgressActivity && /* @__PURE__ */ React30.createElement(ActivityCardProgress, __spreadValues({}, progressProps)), /* @__PURE__ */ React30.createElement(ActivityCardCaption, __spreadProps(__spreadValues({}, activity), { todaysDate })))
  );
};
HealthActivityCard.propTypes = __spreadProps(__spreadValues({}, activityShortPropType), {
  todaysDate: instanceOf(Date),
  activeDate: number3,
  suggestedActivityGroupName: string5
  // for segment analytics
});
HealthActivityCard.defaultProps = __spreadProps(__spreadValues({}, activityShortDefaultProps), {
  todaysDate: /* @__PURE__ */ new Date(),
  activeDate: normalizeEpochDate(Date.now()),
  suggestedActivityGroupName: ""
  // for segment analytics
});

// src/components/health-activity-card-list/health-activity-card-list.view.js
var categoryLabelToTestId = (categoryLabel) => `activity-list-${categoryLabel.replaceAll(" ", "-").toLowerCase()}`;
var ActivityCardGroup2 = genesisStyled9(Box15)`
    &:last-of-type {
      margin-bottom: 0;
    }
  `;
var HealthActivityCardList = React31.memo(
  ({
    activityArray,
    activityCategoryLabel,
    hasViewAll,
    activeDate,
    suggestedActivityGroupName
    // for segment analytics
  }) => {
    const { formatMessage } = useIntl13();
    if (!(activityArray == null ? void 0 : activityArray.length))
      return null;
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(Flex10, { justifyContent: "space-between", marginBottom: "two" }, activityCategoryLabel && /* @__PURE__ */ React31.createElement(HeadingThree2, null, activityCategoryLabel), hasViewAll && /* @__PURE__ */ React31.createElement(
      Link5,
      {
        to: JOURNEY_ROUTES8.journeyHome,
        "aria-label": formatMessage({ id: "GO_TO_HEALTH_JOURNEY" })
      },
      /* @__PURE__ */ React31.createElement(SubtitleOne2, { as: "p", color: "interactive.action.primary" }, formatMessage({ id: "VIEW_ALL" }))
    )), /* @__PURE__ */ React31.createElement(
      ActivityCardGroup2,
      {
        marginBottom: "four",
        "data-testid": categoryLabelToTestId(activityCategoryLabel)
      },
      activityArray.map((activity) => /* @__PURE__ */ React31.createElement(
        HealthActivityCard,
        __spreadValues({
          key: activity == null ? void 0 : activity.id,
          activeDate,
          suggestedActivityGroupName
        }, activity)
      ))
    ));
  },
  (prevProps, nextProps) => {
    var _a, _b;
    const isActiveDateSame = prevProps.activeDate === nextProps.activeDate;
    const isSameActivityLength = ((_a = prevProps == null ? void 0 : prevProps.activityArray) == null ? void 0 : _a.length) === ((_b = nextProps == null ? void 0 : nextProps.activityArray) == null ? void 0 : _b.length);
    return isActiveDateSame && isSameActivityLength;
  }
);
HealthActivityCardList.propTypes = {
  activityArray: arrayOf2(shape2(activityShortPropType)),
  activityCategoryLabel: string6,
  hasViewAll: bool3,
  activeDate: number4,
  suggestedActivityGroupName: string6
  // for segment analytics
};
HealthActivityCardList.defaultProps = {
  activityArray: [],
  activityCategoryLabel: "",
  hasViewAll: false,
  activeDate: normalizeEpochDate(Date.now()),
  suggestedActivityGroupName: ""
  // for segment analytics
};

// src/components/health-journey-home/health-journey-home.component.js
import * as React35 from "react";
import PropTypes3 from "prop-types";
import { LinkLegacy as RouterLink2 } from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES10 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
import {
  Box as Box18,
  HeadingText as HeadingText5,
  StackLayout as StackLayout11,
  TextAction as TextAction3
} from "@leagueplatform/genesis-core";

// src/components/health-activities.view.jsx
import React34 from "react";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import {
  JOURNEY_MANAGER_ENABLED as JOURNEY_MANAGER_ENABLED2,
  UserHealthActivityStatus as UserHealthActivityStatus2
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery8 } from "@leagueplatform/user-profile-api";

// src/components/activities-group.view.js
import React32 from "react";
import { node as node3 } from "prop-types";
import { Box as Box16, genesisStyled as genesisStyled10, css as css5 } from "@leagueplatform/genesis-commons";
var ActivitiesGroup = genesisStyled10((props) => /* @__PURE__ */ React32.createElement(
  Box16,
  __spreadValues({
    paddingBottom: { _: "four", laptop: "five" },
    marginBottom: { _: "twoAndHalf", laptop: "four" }
  }, props)
))(
  css5({
    borderBottomWidth: "thick",
    borderBottomColor: "onSurface.border.subdued",
    borderStyle: "solid",
    "&:last-child": {
      paddingBottom: 0,
      marginBottom: 0,
      borderBottom: "none"
    }
  })
);
var ActivitiesGroupSection = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    /* @__PURE__ */ React32.createElement(ActivitiesGroup, __spreadValues({}, props), children)
  );
};
ActivitiesGroupSection.propTypes = { children: node3.isRequired };

// src/components/challenge-activities.view.jsx
import React33 from "react";
import { node as node4, number as number5, string as string7 } from "prop-types";
import {
  BodyOne,
  Box as Box17,
  Flex as Flex11,
  HeadingThree as HeadingThree3
} from "@leagueplatform/genesis-commons";
import { GenesisRouterLink } from "@leagueplatform/web-common-components";
import {
  EVENT_NAME as EVENT_NAME7,
  PRODUCT_AREA as PRODUCT_AREA7,
  trackAnalyticsEvent as trackAnalyticsEvent7
} from "@leagueplatform/analytics";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES9,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE7
} from "@leagueplatform/health-journey-common";

// src/hooks/use-user-campaigns.hook.js
import { useQuery as useQuery4 } from "react-query";
import {
  getUserCampaigns,
  GET_USER_CAMPAIGNS_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import {
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE6,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS9
} from "@leagueplatform/health-journey-common";
var { CHALLENGE: CHALLENGE3 } = ACTIVITY_CAMPAIGN_TYPE6;
var { ACTIVE: ACTIVE5, UPCOMING: UPCOMING6 } = HEALTH_JOURNEY_ACTIVITY_STATUS9;
var useUserCampaigns = () => {
  const campaignTypes = [CHALLENGE3];
  const campaignStatuses = [ACTIVE5, UPCOMING6];
  const {
    data: userCampaignsData = [],
    isError: userCampaignsIsError,
    isLoading: userCampaignsIsLoading
  } = useQuery4(
    [GET_USER_CAMPAIGNS_MESSAGE_TYPE],
    () => getUserCampaigns(campaignTypes, campaignStatuses)
  );
  const filterCampaigns = (data, filter) => {
    var _a, _b;
    return (_b = (_a = data == null ? void 0 : data.campaigns) == null ? void 0 : _a.filter(({ status }) => status === filter)) != null ? _b : [];
  };
  return {
    campaigns: {
      ready: !userCampaignsIsLoading,
      hasError: userCampaignsIsError,
      data: userCampaignsData == null ? void 0 : userCampaignsData.campaigns,
      activeCampaigns: filterCampaigns(userCampaignsData, ACTIVE5),
      upcomingCampaigns: filterCampaigns(userCampaignsData, UPCOMING6)
    }
  };
};

// src/components/challenge-activities.view.jsx
var { CHALLENGE: CHALLENGE4 } = ACTIVITY_CAMPAIGN_TYPE7;
var EmptyStateCard = (_a) => {
  var _b = _a, { children, name } = _b, props = __objRest(_b, ["children", "name"]);
  return /* @__PURE__ */ React33.createElement(Box17, { marginBottom: "four" }, /* @__PURE__ */ React33.createElement(HeadingThree3, { marginBottom: "two" }, name), /* @__PURE__ */ React33.createElement(
    Flex11,
    __spreadValues({
      flexDirection: "column",
      paddingY: "four",
      paddingX: "100px",
      backgroundColor: "decorative.brand.primary.pastel"
    }, props),
    children
  ));
};
EmptyStateCard.propTypes = {
  children: node4.isRequired,
  name: string7.isRequired
};
var RenderCampaigns = ({ activeDate, allActivities }) => {
  var _a;
  const { campaigns } = useUserCampaigns();
  const { formatMessage, formatDate } = useIntl14();
  const hasAnyChallengeActivities = ((_a = allActivities == null ? void 0 : allActivities.filter(
    ({ campaign_info }) => (campaign_info == null ? void 0 : campaign_info.campaign_type) === CHALLENGE4
  )) == null ? void 0 : _a.length) > 0;
  const currentDate2 = normalizeEpochDate(Date.now());
  const strong = (msg) => /* @__PURE__ */ React33.createElement("strong", null, msg);
  const { activeCampaigns, upcomingCampaigns } = campaigns;
  const hasActiveCampaigns = (activeCampaigns == null ? void 0 : activeCampaigns.length) > 0;
  const hasUpcomingCampaigns = (upcomingCampaigns == null ? void 0 : upcomingCampaigns.length) > 0;
  const handleViewChallengeDetails = () => {
    trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA7.JOURNEY,
      screen_name: "Health Journey Activities",
      detail: "View Challenge Details",
      current_date: currentDate2,
      current_selected_date: activeDate
    });
  };
  const UpcomingCampaigns = () => hasUpcomingCampaigns && (upcomingCampaigns == null ? void 0 : upcomingCampaigns.map(({ name, start_date, campaign_id }) => /* @__PURE__ */ React33.createElement(
    EmptyStateCard,
    {
      key: campaign_id,
      name,
      backgroundColor: "surface.background.secondary"
    },
    /* @__PURE__ */ React33.createElement(BodyOne, { fontWeight: "bold" }, formatMessage({ id: "CHALLENGE_ABOUT_TO_START" })),
    /* @__PURE__ */ React33.createElement(BodyOne, null, formatMessage(
      { id: "ACTIVITIES_APPEAR_HERE_WHEN_CHALLENGE_STARTS" },
      {
        date: formatDate(start_date, {
          year: "numeric",
          month: "long",
          day: "numeric"
        }),
        strong
      }
    )),
    /* @__PURE__ */ React33.createElement(
      GenesisRouterLink,
      {
        to: JOURNEY_ROUTES9.getChallengeDetails(campaign_id),
        marginTop: "threeQuarters",
        onClick: () => handleViewChallengeDetails()
      },
      formatMessage({ id: "VIEW_CHALLENGE_DETAILS" })
    )
  )));
  const CampaignInProgressStatus = () => {
    if (hasActiveCampaigns && !hasAnyChallengeActivities) {
      return activeCampaigns == null ? void 0 : activeCampaigns.map(({ name, campaign_id }) => /* @__PURE__ */ React33.createElement(EmptyStateCard, { key: campaign_id, name }, /* @__PURE__ */ React33.createElement(BodyOne, null, formatMessage({ id: "NO_CHALLENGE_ACTIVITIES_TODAY" }))));
    }
    return null;
  };
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(CampaignInProgressStatus, null), /* @__PURE__ */ React33.createElement(UpcomingCampaigns, null));
};
RenderCampaigns.propTypes = {
  activeDate: number5,
  allActivities: activitiesArrayPropType
};
RenderCampaigns.defaultProps = {
  activeDate: normalizeEpochDate(Date.now()),
  allActivities: void 0
};
var ChallengeActivities = ({
  todaysDate,
  activitiesByChallenge,
  activeDate,
  allActivities
}) => {
  const diffOfDates = getDiffOfDates(
    new Date(todaysDate),
    new Date(activeDate)
  );
  const activeDateIsToday = diffOfDates === 0;
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, activitiesByChallenge && (activitiesByChallenge == null ? void 0 : activitiesByChallenge.map(({ title, activities }) => /* @__PURE__ */ React33.createElement(
    HealthActivityCardList,
    {
      key: `activity-list-group-${title}`,
      activityCategoryLabel: title,
      activityArray: activities,
      activeDate
    }
  ))), activeDateIsToday && /* @__PURE__ */ React33.createElement(
    RenderCampaigns,
    {
      allActivities,
      activeDate
    }
  ));
};
ChallengeActivities.propTypes = {
  activitiesByChallenge: activitiesGroupPropType,
  todaysDate: number5,
  activeDate: number5,
  allActivities: activitiesArrayPropType
};
ChallengeActivities.defaultProps = {
  activitiesByChallenge: null,
  todaysDate: normalizeEpochDate(Date.now()),
  activeDate: normalizeEpochDate(Date.now()),
  allActivities: void 0
};

// src/components/health-activities.view.jsx
var HealthActivities = ({
  activitiesByStatus,
  activitiesByAssigned,
  activitiesByCampaign,
  activitiesByPriority,
  activitiesByChallenge,
  allActivities,
  activeDate
}) => {
  const { formatMessage, $tmap } = useIntl15();
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery8(
    JOURNEY_MANAGER_ENABLED2
  );
  const priorityTitle = formatMessage({ id: "SUGGESTED_FOR_YOU" });
  const assignedTitle = formatMessage({ id: "ASSIGNED" });
  const hasActivitiesByCampaign = activitiesByCampaign && activitiesByCampaign.length > 0;
  const hasActivitiesByStatus = activitiesByStatus && activitiesByStatus.some(({ activities }) => activities.length > 0);
  const getCategoryLabel = $tmap({
    [UserHealthActivityStatus2.ACTIVE]: "ACTIVE",
    [UserHealthActivityStatus2.UPCOMING]: "UPCOMING",
    [UserHealthActivityStatus2.COMPLETED]: "COMPLETED",
    [UserHealthActivityStatus2.EXPIRED]: "EXPIRED",
    [UserHealthActivityStatus2.REMOVED]: "REMOVED",
    [UserHealthActivityStatus2.ON_HOLD]: "ON-HOLD",
    suspended: "SUSPENDED",
    completed_today: "COMPLETED_TODAY",
    missed: "MISSED"
  });
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, isJourneyManagerEnabled && /* @__PURE__ */ React34.createElement(
    HealthActivityCardList,
    {
      activityCategoryLabel: assignedTitle,
      activityArray: activitiesByAssigned,
      activeDate
    }
  ), /* @__PURE__ */ React34.createElement(
    HealthActivityCardList,
    {
      activityCategoryLabel: priorityTitle,
      activityArray: activitiesByPriority,
      activeDate
    }
  ), /* @__PURE__ */ React34.createElement(
    ChallengeActivities,
    {
      activitiesByChallenge,
      activeDate,
      allActivities
    }
  ), hasActivitiesByCampaign && /* @__PURE__ */ React34.createElement(ActivitiesGroupSection, null, activitiesByCampaign.map(({ title, activities }) => /* @__PURE__ */ React34.createElement(
    HealthActivityCardList,
    {
      key: `activity-list-group-${title}`,
      activityCategoryLabel: title,
      activityArray: activities,
      activeDate
    }
  ))), hasActivitiesByStatus && /* @__PURE__ */ React34.createElement(ActivitiesGroupSection, null, activitiesByStatus.map(({ title, activities }) => /* @__PURE__ */ React34.createElement(
    HealthActivityCardList,
    {
      key: `activity-list-group-${title}`,
      activityCategoryLabel: getCategoryLabel(title),
      activityArray: activities,
      activeDate
    }
  ))));
};
HealthActivities.propTypes = activitiesGroupsProps;
HealthActivities.defaultProps = activitiesGroupsDefaultProps;

// src/hooks/use-get-user-health-activities.hook.js
import { useQuery as useQuery5 } from "react-query";
import {
  getUserHealthActivities as getUserHealthActivities2,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE2
} from "@leagueplatform/health-journey-api";
import {
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE8,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS10,
  JOURNEY_MANAGER_ENABLED as JOURNEY_MANAGER_ENABLED3
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery9 } from "@leagueplatform/user-profile-api";
var { ACTIVE: ACTIVE6, UPCOMING: UPCOMING7, COMPLETED: COMPLETED4, MISSED, EXPIRED: EXPIRED4, REMOVED: REMOVED4 } = HEALTH_JOURNEY_ACTIVITY_STATUS10;
var { CHALLENGE: CHALLENGE5 } = ACTIVITY_CAMPAIGN_TYPE8;
var isMissed = ({ status }) => status === EXPIRED4 || status === REMOVED4;
var isCompleted = ({ status }) => status === COMPLETED4;
var isActiveUpcoming = ({ status }) => status === ACTIVE6 || status === UPCOMING7;
var isFrontOfLine = ({ front_of_the_line_activity, status }) => isActiveUpcoming({ status }) && front_of_the_line_activity;
var isAssigned = ({ campaign_info, status }) => isActiveUpcoming({ status }) && campaign_info.assigned === true;
var isActiveUpcomingChallengeActivity = ({ campaign_info, status }) => isActiveUpcoming({ status }) && (campaign_info == null ? void 0 : campaign_info.campaign_type) === CHALLENGE5;
var filterByCampaign = (activity) => isActiveUpcoming(activity) && !isFrontOfLine(activity) && !isActiveUpcomingChallengeActivity(activity) && !isAssigned(activity);
var sortByActivityName = (a, b) => a == null ? void 0 : a.name.localeCompare(b == null ? void 0 : b.name);
var sortByActivitySortOrder = (a, b) => (a == null ? void 0 : a.sort_order) - (b == null ? void 0 : b.sort_order);
var sortByCampaignStartDate = ({ activities: [{ campaign_info: campaignInfoA }] }, { activities: [{ campaign_info: campaignInfoB }] }) => new Date(campaignInfoA.start_date) - new Date(campaignInfoB.start_date);
var formatActivityGroup = (activityGroup) => Object.entries(activityGroup).map(([title, activities]) => ({
  title,
  activities
}));
var useGetUserHealthActivities = (activeDate = Date.now(), todaysDate = Date.now()) => {
  const normalizedActiveDateTimestamp = normalizeEpochDate(activeDate);
  const normalizedTodaysDate = normalizeEpochDate(todaysDate);
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery9(
    JOURNEY_MANAGER_ENABLED3
  );
  return useQuery5(
    [GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE2, normalizedActiveDateTimestamp],
    () => getUserHealthActivities2({
      date: normalizedActiveDateTimestamp / 1e3,
      activityStatuses: deriveActivityStatusFromDate(
        normalizedActiveDateTimestamp
      )
    }),
    {
      select: (data) => {
        const { user_health_activities: allActivities } = data;
        let activitiesByAssigned = [];
        if (isJourneyManagerEnabled) {
          activitiesByAssigned = allActivities.filter(isAssigned).sort(sortByActivitySortOrder);
        }
        const activitiesByStatus = formatActivityGroup({
          [COMPLETED4]: sortByDate(
            allActivities.filter(isCompleted),
            "completed_date"
          ),
          [MISSED]: allActivities.filter(isMissed).sort(sortByActivityName)
        });
        const activitiesByPriority = allActivities.filter(isFrontOfLine).sort(sortByActivitySortOrder);
        const activitiesByChallenge = formatActivityGroup(
          allActivities.filter(isActiveUpcomingChallengeActivity).sort(sortByActivitySortOrder).reduce((challenges, activity) => {
            var _a;
            const { campaign_info } = activity;
            const { name: campaignName } = campaign_info;
            const challengeActivities = (_a = challenges == null ? void 0 : challenges[campaignName]) != null ? _a : [];
            return __spreadProps(__spreadValues({}, challenges), {
              [campaignName]: [...challengeActivities, activity]
            });
          }, {})
        );
        const activitiesByCampaign = formatActivityGroup(
          allActivities.filter(filterByCampaign).sort(sortByActivitySortOrder).reduce((campaigns, activity) => {
            var _a;
            const { campaign_info } = activity;
            const { name: campaignName } = campaign_info;
            const campaignActivities = (_a = campaigns == null ? void 0 : campaigns[campaignName]) != null ? _a : [];
            return __spreadProps(__spreadValues({}, campaigns), {
              [campaignName]: [...campaignActivities, activity]
            });
          }, {})
        ).sort(sortByCampaignStartDate);
        const activitiesAllCompletedToday = () => normalizedTodaysDate === normalizedActiveDateTimestamp && allActivities.length > 0 && allActivities.every(
          ({ status }) => status !== ACTIVE6 && status !== UPCOMING7
        );
        return {
          data: allActivities,
          activitiesByStatus,
          activitiesByAssigned,
          activitiesByCampaign,
          activitiesByPriority,
          activitiesByChallenge,
          hasCompletedAllActivities: activitiesAllCompletedToday()
        };
      }
    }
  );
};

// src/components/health-journey-home/hooks/use-health-journey-home.hook.js
var useHealthJourneyHomePage = () => {
  const {
    data: activitiesData,
    isLoading,
    isError
  } = useGetUserHealthActivities();
  const activitiesByAssigned = (activitiesData == null ? void 0 : activitiesData.activitiesByAssigned) || [];
  const activitiesByCampaign = (activitiesData == null ? void 0 : activitiesData.activitiesByCampaign) || [];
  const activitiesByChallenge = (activitiesData == null ? void 0 : activitiesData.activitiesByChallenge) || [];
  const activitiesByPriority = (activitiesData == null ? void 0 : activitiesData.activitiesByPriority) || [];
  const hasActivities = (activitiesByAssigned == null ? void 0 : activitiesByAssigned.length) > 0 || (activitiesByCampaign == null ? void 0 : activitiesByCampaign.length) > 0 || (activitiesByChallenge == null ? void 0 : activitiesByChallenge.length) > 0 || (activitiesByPriority == null ? void 0 : activitiesByPriority.length) > 0;
  return {
    activitiesByAssigned,
    activitiesByCampaign,
    activitiesByChallenge,
    activitiesByPriority,
    allActivities: activitiesData == null ? void 0 : activitiesData.data,
    hasActivities,
    hasError: isError,
    ready: !isLoading
  };
};

// src/components/health-journey-home/health-journey-home.component.js
var HealthJourneyHomeContainer = ({ children }) => /* @__PURE__ */ React35.createElement(
  Box18,
  {
    css: {
      paddingBlock: "$three",
      "@mobileLandscape": { paddingBlock: "$two" },
      "@mobile": { paddingBlock: "$two" }
    },
    className: "health-journey-home-container"
  },
  children
);
HealthJourneyHomeContainer.propTypes = {
  children: PropTypes3.node.isRequired
};
var HealthJourneyHome = () => {
  const { formatMessage } = useIntl16();
  const {
    ready,
    hasError,
    hasActivities,
    activitiesByAssigned,
    activitiesByCampaign,
    activitiesByChallenge,
    activitiesByPriority,
    allActivities
  } = useHealthJourneyHomePage();
  if (!ready) {
    return /* @__PURE__ */ React35.createElement(HealthJourneyHomeContainer, null, /* @__PURE__ */ React35.createElement(SkeletonBox2, { height: "200px", role: "presentation" }));
  }
  if (hasError)
    return null;
  return hasActivities ? /* @__PURE__ */ React35.createElement(HealthJourneyHomeContainer, null, /* @__PURE__ */ React35.createElement(
    StackLayout11,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      horizontalAlignment: "spaceBetween",
      css: {
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React35.createElement(HeadingText5, { level: "2", size: "xl" }, formatMessage({ id: "YOUR_JOURNEY" })),
    /* @__PURE__ */ React35.createElement(
      TextAction3,
      {
        as: RouterLink2,
        to: JOURNEY_ROUTES10.journeyHome(),
        "aria-label": formatMessage({ id: "GO_TO_HEALTH_JOURNEY" })
      },
      formatMessage({ id: "VIEW_ALL" })
    )
  ), /* @__PURE__ */ React35.createElement(
    HealthActivities,
    {
      activitiesByAssigned,
      activitiesByCampaign,
      activitiesByChallenge,
      activitiesByPriority,
      allActivities
    }
  )) : null;
};

// src/components/delete-activity-modal.component.tsx
import React36, { useEffect as useEffect4 } from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import {
  Modal,
  StackLayout as StackLayout12,
  Image as Image7,
  Box as Box19,
  HeadingText as HeadingText6,
  Button as Button2
} from "@leagueplatform/genesis-core";
import { useStaticAsset } from "@leagueplatform/asset-config";
var DeleteActivityModal = ({
  onClose,
  activityId,
  requestSetUserHealthActivityDelete
}) => {
  const { formatMessage } = useIntl17();
  const activityAnalytics = useActivityAnalytics();
  const removeActivityImage2 = useStaticAsset(
    "REMOVE_ACTIVITY_IMAGE" /* REMOVE_ACTIVITY_IMAGE */
  );
  useEffect4(() => {
    if (activityId) {
      activityAnalytics.sendViewRemoveActivityModal();
    }
  }, [activityAnalytics, activityId]);
  const modalLabel = formatMessage({ id: "REMOVE_ACTIVITY" });
  return /* @__PURE__ */ React36.createElement(
    Modal.Root,
    {
      defaultOpen: true,
      onOpenChange: (open) => {
        if (!open && onClose) {
          onClose();
        }
      },
      "aria-label": modalLabel
    },
    /* @__PURE__ */ React36.createElement(Modal.Content, { layout: "standard" }, /* @__PURE__ */ React36.createElement(Modal.Title, { hidden: true }, formatMessage({ id: "REMOVE_ACTIVITY" })), /* @__PURE__ */ React36.createElement(
      StackLayout12,
      {
        css: { padding: "$two" },
        spacing: "$one",
        orientation: "vertical",
        horizontalAlignment: "center"
      },
      /* @__PURE__ */ React36.createElement(Image7, { src: removeActivityImage2 }),
      /* @__PURE__ */ React36.createElement(
        Box19,
        {
          css: { width: "30ch", textAlign: "center", paddingBottom: "$one" }
        },
        /* @__PURE__ */ React36.createElement(HeadingText6, { size: "xl", level: "2" }, formatMessage({ id: "ARE_YOU_SURE_REMOVE_ACTIVITY" }))
      ),
      /* @__PURE__ */ React36.createElement(
        Button2,
        {
          priority: "primary",
          size: "large",
          textAlign: "start",
          type: "button",
          width: "fillContainer",
          destructive: true,
          onClick: () => {
            requestSetUserHealthActivityDelete();
            onClose();
            activityAnalytics.sendConfirmActivityRemove();
          }
        },
        formatMessage({ id: "REMOVE_ACTIVITY_BUTTON" })
      ),
      /* @__PURE__ */ React36.createElement(
        Button2,
        {
          priority: "secondary",
          size: "large",
          textAlign: "start",
          type: "button",
          width: "fillContainer",
          onClick: () => {
            onClose();
            activityAnalytics.sendCancelActivityRemove();
          }
        },
        formatMessage({ id: "CANCEL" })
      )
    ))
  );
};

// src/components/activity-error-message.component.js
import React37 from "react";
import { node as node5 } from "prop-types";
import {
  BodyTwo as BodyTwo3,
  css as css6,
  Flex as Flex12,
  genesisStyled as genesisStyled11,
  useTheme as useTheme2
} from "@leagueplatform/genesis-commons";
var AlertIcon = () => {
  var _a, _b, _c, _d, _e;
  const theme = useTheme2();
  const iconColor = (_e = (_d = (_c = (_b = (_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.primary) == null ? void 0 : _b.background) == null ? void 0 : _c.critical) == null ? void 0 : _d.default) != null ? _e : "#BA1B3B";
  return /* @__PURE__ */ React37.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React37.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99935 15.3337C12.0494 15.3337 15.3327 12.0504 15.3327 8.00033C15.3327 3.95024 12.0494 0.666992 7.99935 0.666992C3.94926 0.666992 0.666016 3.95024 0.666016 8.00033C0.666016 12.0504 3.94926 15.3337 7.99935 15.3337Z",
        stroke: iconColor,
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ React37.createElement(
      "path",
      {
        d: "M8.39961 12.0006C8.39961 12.2215 8.22052 12.4006 7.99961 12.4006C7.7787 12.4006 7.59961 12.2215 7.59961 12.0006C7.59961 11.7797 7.7787 11.6006 7.99961 11.6006C8.22052 11.6006 8.39961 11.7797 8.39961 12.0006Z",
        stroke: iconColor
      }
    ),
    /* @__PURE__ */ React37.createElement(
      "path",
      {
        d: "M8 9.6L8 4",
        stroke: iconColor,
        strokeWidth: "1.5",
        strokeLinecap: "round"
      }
    )
  );
};
var StyledAlertIcon = genesisStyled11(AlertIcon)(
  css6({
    path: {
      stroke: "primary.background.critical.default"
    }
  })
);
var ActivityErrorMessage = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    /* @__PURE__ */ React37.createElement(Flex12, __spreadValues({ justifyContent: "center", alignItems: "center" }, props), /* @__PURE__ */ React37.createElement(StyledAlertIcon, null), /* @__PURE__ */ React37.createElement(BodyTwo3, { color: "onSurface.text.critical", marginInlineStart: "half" }, children))
  );
};
ActivityErrorMessage.propTypes = {
  children: node5.isRequired
};

// src/components/activity-footer.component.js
import React38, { useCallback as useCallback4 } from "react";
import PropTypes4 from "prop-types";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import { isProduction } from "@leagueplatform/app-environment";
import {
  BodyOneSecondary,
  Box as Box20,
  Flex as Flex13,
  HeadingFour as HeadingFour3,
  PrimaryButton as PrimaryButton3
} from "@leagueplatform/genesis-commons";
import { LONG_MONTH_FORMAT } from "@leagueplatform/web-common";
import { VeryQuietButton } from "@leagueplatform/web-common-components";
import { USER_CONNECTED_DEVICE_CAMPAIGN_MODES } from "@leagueplatform/health-journey-api";
import {
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS14,
  COMPLETION_METHOD_TYPES as COMPLETION_METHOD_TYPES3
} from "@leagueplatform/health-journey-common";

// src/hooks/use-health-activity-footer.hook.js
import {
  useNavigateLegacy as useNavigate5,
  useLocationLegacy as useLocation4
} from "@leagueplatform/routing";
import { openInTab, isAbsoluteUrl } from "@leagueplatform/web-common";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES12,
  useApiDelayOverlay,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS12,
  COMPLETION_METHOD_TYPES as COMPLETION_METHOD_TYPES2
} from "@leagueplatform/health-journey-common";

// src/hooks/use-activity-achievements-actions.hook.js
import { useState as useState3 } from "react";
import {
  useCompleteActivity,
  ACHIEVEMENTS_ENABLED as ACHIEVEMENTS_ENABLED5
} from "@leagueplatform/rewards-achievements";
import { useFeatureFlagQuery as useFeatureFlagQuery10 } from "@leagueplatform/user-profile-api";
var useActivityAchievementsActions = (userActivityId) => {
  const [showDeleteActivityModal, toggleDeleteActivityModal] = useState3(false);
  const [shouldFetchAchievementUpdates, toggleAchievementUpdates] = useState3(false);
  const [showCelebrationAchievementModal, toggleCelebrationAchievementModal] = useState3(false);
  const { data: isAchievementsFeatureFlagOn } = useFeatureFlagQuery10(ACHIEVEMENTS_ENABLED5);
  const completeActivityMutation = useCompleteActivity(
    userActivityId,
    toggleAchievementUpdates
  );
  return {
    completeActivityMutation,
    isAchievementsFeatureFlagOn,
    shouldFetchAchievementUpdates,
    showCelebrationAchievementModal,
    showDeleteActivityModal,
    toggleCelebrationAchievementModal,
    toggleDeleteActivityModal
  };
};

// src/hooks/use-activity-steps-analytics.hook.js
import {
  trackAnalyticsEvent as trackAnalyticsEvent8,
  PRODUCT_AREA as PRODUCT_AREA8,
  EVENT_NAME as EVENT_NAME8
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES6 } from "@leagueplatform/health-journey-common";
var { BUTTON_CLICKED: BUTTON_CLICKED2, SCREEN_LOADED: SCREEN_LOADED2 } = EVENT_NAME8;
var useActivityStepsAnalytics = () => {
  const activity = useHealthActivity();
  const {
    activityProgress,
    contentActivityId,
    activityType,
    campaignInfo,
    cta = {},
    name: activityName,
    status: activityStatus
  } = activity;
  const completionMethod = (cta == null ? void 0 : cta.completion_method) || {};
  const { type: completionType, steps, counter } = completionMethod;
  const totalSteps = (steps == null ? void 0 : steps.length) || null;
  const meta2 = {
    product_area: PRODUCT_AREA8.JOURNEY,
    screen_name: SCREEN_NAMES6.ACTIVITY_DETAILS
  };
  const data = {
    health_campaign_activity_id: contentActivityId,
    health_campaign_activity_name: activityName,
    health_campaign_activity_type: activityType,
    health_campaign_activity_ux_type: completionType || null,
    health_campaign_activity_status: activityStatus,
    health_campaign_type: (campaignInfo == null ? void 0 : campaignInfo.campaign_type) || null
  };
  const activityState = {
    health_campaign_activity_goal: (counter == null ? void 0 : counter.goal) || null,
    health_campaign_activity_current_progress: (activityProgress == null ? void 0 : activityProgress.count_progress) || null
  };
  const baseAnalytics = Object.assign(meta2, data, activityState);
  return {
    sendViewStep(currentStep) {
      trackAnalyticsEvent8(SCREEN_LOADED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        current_step: currentStep,
        total_steps: totalSteps
      }));
    },
    sendStartActivity() {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        detail: "start health campaign activity"
      }));
    },
    sendNextStep(currentStep) {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        current_step: currentStep,
        total_steps: totalSteps,
        detail: "next step"
      }));
    },
    sendPreviousStep(currentStep) {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        current_step: currentStep,
        total_steps: totalSteps,
        detail: "previous step"
      }));
    },
    sendViewExitModal(currentStep) {
      trackAnalyticsEvent8(SCREEN_LOADED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        current_step: currentStep,
        total_steps: totalSteps,
        screen_name: SCREEN_NAMES6.EXIT_CONFIRM_MODAL
      }));
    },
    sendCloseActivity(currentStep) {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        current_step: currentStep,
        total_steps: totalSteps,
        detail: "close activity"
      }));
    },
    sendConfirmCloseActivity() {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        detail: "confirm leave activity",
        screen_name: SCREEN_NAMES6.EXIT_CONFIRM_MODAL
      }));
    },
    sendContinueActivity() {
      trackAnalyticsEvent8(BUTTON_CLICKED2, __spreadProps(__spreadValues({}, baseAnalytics), {
        detail: "cancel leave activity",
        screen_name: SCREEN_NAMES6.EXIT_CONFIRM_MODAL
      }));
    }
  };
};

// src/hooks/use-activity-footer-error-message.hook.js
import { useEffect as useEffect5, useMemo as useMemo5, useCallback as useCallback2 } from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { useQuery as useQuery6, useQueryClient as useQueryClient3 } from "react-query";
var ACTIVITY_FOOTER_ERROR_MESSAGE_TYPE = "activity_footer_error_message";
var queryFnStub = () => void 0;
var useActivityFooterErrorMessage = (healthActivity) => {
  const { formatMessage } = useIntl18();
  const queryClient = useQueryClient3();
  const { data: errorMessage } = useQuery6(
    [ACTIVITY_FOOTER_ERROR_MESSAGE_TYPE],
    queryFnStub
  );
  const applyMessage = useCallback2(
    (type) => {
      const message = (
        // eslint-disable-next-line no-nested-ternary
        type === "incomplete" ? formatMessage({ id: "GOAL_INCOMPLETE" }) : type === "error" ? formatMessage({ id: "ACTIVITY_COMPLETE_ERROR" }) : void 0
      );
      queryClient.setQueryData([ACTIVITY_FOOTER_ERROR_MESSAGE_TYPE], message);
      return message;
    },
    [formatMessage, queryClient]
  );
  const applyErrorMessage = useMemo5(
    () => ({
      goalIncomplete: () => applyMessage("incomplete"),
      activityCompleteError: () => applyMessage("error"),
      none: () => applyMessage(void 0)
    }),
    [applyMessage]
  );
  useEffect5(() => {
    applyErrorMessage.none();
    return () => applyErrorMessage.none();
  }, [healthActivity == null ? void 0 : healthActivity.activityProgress, applyErrorMessage]);
  return { errorMessage, applyErrorMessage };
};

// src/hooks/use-complete-user-health-activity.hook.js
import { useQueryClient as useQueryClient4, useMutation } from "react-query";
import {
  CHALLENGES_PATH,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE3,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  completeUserHealthActivity
} from "@leagueplatform/health-journey-api";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import { useApiDelayController } from "@leagueplatform/health-journey-common";

// src/pages/health-activity/hooks/use-activity-link.hook.ts
import { useCallback as useCallback3, useMemo as useMemo6 } from "react";
import {
  useNavigateLegacy as useNavigate4,
  useLocationLegacy as useLocation3
} from "@leagueplatform/routing";
import { isValidUrl } from "@leagueplatform/web-common";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/core";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES11
} from "@leagueplatform/health-journey-common";
var cleanURL = (url) => url == null ? void 0 : url.trim().replace(/^app|^\/app/, "");
var useActivityLink = () => {
  const navigate = useNavigate4();
  const location = useLocation3();
  const { state: locationState } = location;
  const { referrerStack = [] } = locationState || {};
  const entrypointPath = useMemo6(() => {
    const [url = JOURNEY_ROUTES11.journeyHome()] = referrerStack;
    return cleanURL(url);
  }, [referrerStack]);
  const handleLinkCallback = useConfigProperty2("core.customMethods.handleLink");
  const returnToEntrypoint = useCallback3(() => {
    if (!referrerStack) {
      navigate(cleanURL(JOURNEY_ROUTES11.journeyHome()));
    } else {
      const [entryLocation] = referrerStack;
      let returnToIndex = 1;
      if (entryLocation) {
        const entryCount = referrerStack.length || 1;
        returnToIndex = entryLocation.includes("activity") ? entryCount + 1 : entryCount;
      }
      navigate(-returnToIndex);
    }
  }, [navigate, referrerStack]);
  const followDeepLink = useCallback3(
    (pathname) => {
      const pathnameWithoutApp = cleanURL(pathname);
      navigate(pathnameWithoutApp, {
        state: __spreadProps(__spreadValues({}, location.state), {
          referrerStack: [...referrerStack, pathname]
        })
      });
    },
    [navigate, location.state, referrerStack]
  );
  const followLink = useCallback3(
    (link) => isValidUrl(link) ? handleLinkCallback(link) : followDeepLink(link),
    [followDeepLink, handleLinkCallback]
  );
  return { followLink, returnToEntrypoint, entrypointPath };
};

// src/pages/health-activity/utils/activities-sentry.utils.ts
import { addBreadcrumb } from "@leagueplatform/observability";
var TOOLBOX_ACTIVITY_SENTRY_CATEGORY = "web_activities";
var addActivityBreadcrumb = (breadcrumb = {}) => addBreadcrumb(__spreadValues({ category: TOOLBOX_ACTIVITY_SENTRY_CATEGORY }, breadcrumb));

// src/pages/health-activity/hooks/use-get-user-health-activity-by-id.hook.ts
import { useQuery as useQuery7 } from "react-query";
import {
  getUserHealthActivityById
} from "@leagueplatform/health-journey-api";
var GET_USER_HEALTH_ACTIVITY_DATA_KEY = "userHealthActivityData";
var useGetUserHealthActivityByIdData = (campaignId, contentActivityId, userHealthActivityId = "") => useQuery7(
  [
    GET_USER_HEALTH_ACTIVITY_DATA_KEY,
    userHealthActivityId,
    campaignId,
    contentActivityId
  ],
  () => getUserHealthActivityById(
    userHealthActivityId,
    campaignId,
    contentActivityId
  ),
  {
    select(data) {
      const { data: healthActivityData } = data;
      const healthActivityDataObj = Array.isArray(healthActivityData) && healthActivityData.length > 0 ? healthActivityData == null ? void 0 : healthActivityData[0] : healthActivityData;
      return healthActivityDataObj != null ? healthActivityDataObj : {};
    }
  }
);

// src/hooks/use-complete-user-health-activity.hook.js
var COMPLETE_ACTIVITY_DEBUG_MESSAGE = Object.freeze({
  DebugStart: "Attempting to complete Activity",
  DebugError: "Failed to complete Activity",
  DebugSuccess: "Activity successfully completed"
});
var { DebugStart, DebugError, DebugSuccess } = COMPLETE_ACTIVITY_DEBUG_MESSAGE;
var useCompleteUserHealthActivity = (userActivityId, apiDelayConfig) => {
  const queryClient = useQueryClient4();
  const { followLink, returnToEntrypoint, entrypointPath } = useActivityLink();
  const activityCompletionController = useActivityCompletionData();
  const apiDelayController = useApiDelayController(apiDelayConfig);
  const { applyErrorMessage } = useActivityFooterErrorMessage();
  return useMutation(() => completeUserHealthActivity(userActivityId), {
    onMutate: () => {
      applyErrorMessage.none();
      apiDelayController.init();
      addActivityBreadcrumb({ message: DebugStart });
    },
    onSuccess: (_0, ..._1) => __async(void 0, [_0, ..._1], function* (data, variables = {}) {
      const { ctaUrl = "" } = variables;
      yield apiDelayController.finish();
      queryClient.invalidateQueries(GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE);
      queryClient.invalidateQueries(GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE3);
      queryClient.invalidateQueries(CHALLENGES_PATH);
      activityCompletionController.setCompletionData(data);
      const debugData = { ctaUrl, entrypointPath, completionData: data };
      addActivityBreadcrumb({ message: DebugSuccess, data: debugData });
      if (ctaUrl) {
        followLink(ctaUrl);
      } else {
        returnToEntrypoint();
      }
      queryClient.invalidateQueries([
        GET_USER_HEALTH_ACTIVITY_DATA_KEY,
        userActivityId
      ]);
      return data;
    }),
    onError: (error) => __async(void 0, null, function* () {
      yield apiDelayController.finish();
      addActivityBreadcrumb({ message: DebugError, data: error });
      applyErrorMessage.activityCompleteError();
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: "ERROR_STATE_TITLE",
        contentId: "ACTIVITY_COMPLETE_ERROR"
      });
    })
  });
};

// src/hooks/use-dismiss-user-health-activity.hook.js
import { useQueryClient as useQueryClient5, useMutation as useMutation2 } from "react-query";
import {
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE4,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE as GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2,
  dismissUserHealthActivity
} from "@leagueplatform/health-journey-api";
import { toastActions as toastActions2, TOAST_STATUS as TOAST_STATUS2 } from "@leagueplatform/toast-messages";
var useDismissUserHealthActivity = (userActivityId) => {
  const queryClient = useQueryClient5();
  const { returnToEntrypoint } = useActivityLink();
  return useMutation2(() => dismissUserHealthActivity(userActivityId), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2);
      queryClient.invalidateQueries(GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE4);
      returnToEntrypoint();
      return data;
    },
    onError: () => {
      toastActions2.add({
        type: TOAST_STATUS2.ERROR,
        textId: "ERROR_STATE_TITLE",
        contentId: "ACTIVITY_DISMISS_ERROR"
      });
    }
  });
};

// src/utils/user-health-activity/user-health-activity.utils.js
import {
  COMPLETION_METHOD_TYPES,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS11
} from "@leagueplatform/health-journey-common";
var { ACTIVE: ACTIVE7 } = HEALTH_JOURNEY_ACTIVITY_STATUS11;
var { COUNTER } = COMPLETION_METHOD_TYPES;
var hasActivityMetCompletionCriteria = (healthActivity) => {
  var _a, _b, _c;
  const { status, cta, activityProgress: progress } = healthActivity;
  if (status !== ACTIVE7)
    return true;
  switch ((_a = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _a.type) {
    case COUNTER:
      return (progress == null ? void 0 : progress.count_progress) >= ((_c = (_b = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _b.counter) == null ? void 0 : _c.goal);
    default:
      return true;
  }
};
var isOptionValueInCurrentValue = (currentValue, value) => {
  if (Array.isArray(currentValue)) {
    return currentValue == null ? void 0 : currentValue.includes(value);
  }
  return currentValue === value;
};

// src/hooks/use-health-activity-footer.hook.js
var { COMPLETED: COMPLETED5 } = HEALTH_JOURNEY_ACTIVITY_STATUS12;
var { STEP, COUNTER: COUNTER2, BASE } = COMPLETION_METHOD_TYPES2;
var useHealthActivityFooter = (isActivityDetailsView) => {
  const navigate = useNavigate5();
  const location = useLocation4();
  const { formatMessage } = useIntl19();
  const { userActivityId } = useActivityParams();
  const healthActivity = useHealthActivity();
  const {
    campaignMode,
    canExpire,
    cta,
    endDate,
    startDate,
    status,
    activityType
  } = healthActivity;
  const { setDelayOverlayActive } = useApiDelayOverlay();
  const activityHasMetCompletionCriteria = hasActivityMetCompletionCriteria(healthActivity);
  const { errorMessage, applyErrorMessage } = useActivityFooterErrorMessage(healthActivity);
  const activityStepsAnalytics = useActivityStepsAnalytics();
  const activityAnalytics = useActivityAnalytics();
  const { showDeleteActivityModal, toggleDeleteActivityModal } = useActivityAchievementsActions(userActivityId);
  const dismissActivityMutation = useDismissUserHealthActivity(userActivityId);
  const completeActivityMutation = useCompleteUserHealthActivity(userActivityId);
  const isLoadingComplete = completeActivityMutation.isLoading;
  const requestSetUserHealthActivityDelete = () => {
    dismissActivityMutation.mutate();
  };
  const completeActivity = () => {
    if (isLoadingComplete) {
      setDelayOverlayActive(true);
      return;
    }
    const searchParams = new URLSearchParams(location == null ? void 0 : location.search);
    const isFromHome = searchParams.get("b") === "1";
    if (cta == null ? void 0 : cta.mark_as_complete) {
      completeActivityMutation.mutate();
      activityAnalytics.sendCompleteActivity();
    }
    if (cta == null ? void 0 : cta.url) {
      const { url } = cta;
      if (isAbsoluteUrl(url)) {
        openInTab(url);
      } else {
        let urlWithoutApp = url.replace(/^app|^\/app/, "");
        if (isFromHome) {
          const prefix = urlWithoutApp.includes("?") ? "&" : "?";
          urlWithoutApp = `${urlWithoutApp}${prefix}b=1`;
        }
        navigate(urlWithoutApp);
      }
    }
  };
  const onClose = () => {
    var _a, _b;
    activityAnalytics.sendCloseActivity();
    navigate((_b = (_a = location.state) == null ? void 0 : _a.referrer) != null ? _b : JOURNEY_ROUTES12.journeyHome());
  };
  const primaryAction = () => {
    var _a;
    switch ((_a = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _a.type) {
      case STEP:
        if (isActivityDetailsView) {
          activityStepsAnalytics.sendStartActivity();
          return navigate(
            JOURNEY_ROUTES12.getActivitySteps(
              userActivityId,
              activityType,
              location
            )
          );
        }
        return completeActivity();
      case COUNTER2:
        if (!activityHasMetCompletionCriteria) {
          return applyErrorMessage.goalIncomplete();
        }
        return completeActivity();
      case BASE:
      default:
        return completeActivity();
    }
  };
  const secondaryAction = () => {
    activityAnalytics.sendRemoveActivityPrompt();
    toggleDeleteActivityModal(true);
  };
  const primaryCtaText = () => {
    var _a, _b;
    switch ((_a = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _a.type) {
      case STEP:
        if (isActivityDetailsView) {
          return status === COMPLETED5 ? formatMessage({ id: "VIEW_ACTIVITY" }) : (_b = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _b.text;
        }
        return cta == null ? void 0 : cta.text;
      case BASE:
      default:
        return cta == null ? void 0 : cta.text;
    }
  };
  return {
    activityHasMetCompletionCriteria,
    activityId: userActivityId,
    campaignMode,
    canExpire,
    cta,
    endDate,
    errorMessage,
    isActivityDetailsView,
    isLoadingComplete,
    isLoadingDelete: dismissActivityMutation.isLoading || false,
    onClose,
    primaryAction,
    primaryCtaText,
    requestSetUserHealthActivityDelete,
    secondaryAction,
    showDeleteActivityModal,
    startDate,
    status,
    toggleDeleteActivityModal
  };
};

// src/hooks/use-is-mark-as-done-enabled.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery11 } from "@leagueplatform/user-profile-api";
import {
  JOURNEY_MANAGER_ENABLED as JOURNEY_MANAGER_ENABLED4,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS13
} from "@leagueplatform/health-journey-common";
var { ACTIVE: ACTIVE8 } = HEALTH_JOURNEY_ACTIVITY_STATUS13;
var useIsMarkAsDoneEnabled = () => {
  const healthActivity = useHealthActivity();
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery11(
    JOURNEY_MANAGER_ENABLED4
  );
  const isMarkAsDoneInUse = false;
  if (!isMarkAsDoneInUse)
    return true;
  if (!isJourneyManagerEnabled)
    return true;
  const { status, activityProgress } = healthActivity;
  if (status !== ACTIVE8)
    return false;
  const helpfulTips = activityProgress.helpful_tips || [];
  return helpfulTips.some((tip) => tip.opened === true);
};

// src/components/activity-footer.component.js
var { COMPLETED: COMPLETED6, UPCOMING: UPCOMING8, EXPIRED: EXPIRED5, REMOVED: REMOVED5 } = HEALTH_JOURNEY_ACTIVITY_STATUS14;
var { STEP: STEP2, BASE: BASE2 } = COMPLETION_METHOD_TYPES3;
var ActivityFooter = ({ isActivityDetailsView, isRemovable }) => {
  var _a, _b;
  const {
    activityHasMetCompletionCriteria,
    activityId,
    campaignMode,
    canExpire,
    cta,
    endDate,
    errorMessage,
    isLoadingDelete,
    onClose,
    primaryAction,
    primaryCtaText,
    requestSetUserHealthActivityDelete,
    secondaryAction,
    showDeleteActivityModal,
    startDate,
    status,
    toggleDeleteActivityModal
  } = useHealthActivityFooter(isActivityDetailsView);
  const { formatMessage, $tmap, formatDate } = useIntl20();
  const isMarkAsDoneEnabled = useIsMarkAsDoneEnabled();
  const isStepCompletionMethodType = ((_a = cta == null ? void 0 : cta.completion_method) == null ? void 0 : _a.type) === STEP2;
  const isNotActivityWithUserConnectedDevice = campaignMode !== USER_CONNECTED_DEVICE_CAMPAIGN_MODES.AUTOMATIC;
  const { type } = (_b = cta == null ? void 0 : cta.completion_method) != null ? _b : {};
  const primaryCta = primaryCtaText();
  const FooterComponents = ({ isRemovableCta }) => {
    const isDisabled = !isProduction() && type === BASE2 && !activityHasMetCompletionCriteria || primaryCta.toLowerCase() === formatMessage({ id: "MARK_AS_DONE" }).toLowerCase() && !isMarkAsDoneEnabled;
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, isRemovableCta && /* @__PURE__ */ React38.createElement(
      VeryQuietButton,
      {
        marginInlineEnd: "one",
        onClick: secondaryAction,
        isLoading: isLoadingDelete,
        "data-testid": "activity-footer-remove-action"
      },
      formatMessage({ id: "REMOVE_FROM_JOURNEY" })
    ), isNotActivityWithUserConnectedDevice && /* @__PURE__ */ React38.createElement(
      PrimaryButton3,
      {
        onClick: primaryAction,
        disabled: isDisabled,
        transition: "background 0.5s ease-out, color 0.5s ease-out",
        "data-testid": "activity-footer-main-action"
      },
      primaryCta
    ));
  };
  FooterComponents.propTypes = {
    isRemovableCta: PropTypes4.bool
  };
  FooterComponents.defaultProps = {
    isRemovableCta: false
  };
  const DoneFooterComponent = () => /* @__PURE__ */ React38.createElement(PrimaryButton3, { onClick: onClose }, formatMessage({ id: "CLOSE" }));
  const formattedActivityStartDate = formatDate(startDate, LONG_MONTH_FORMAT);
  const formattedActivityEndDate = formatDate(endDate, LONG_MONTH_FORMAT);
  const getFooterText = useCallback4(() => {
    switch (status) {
      case UPCOMING8:
        return {
          heading: "THIS_IS_JUST_A_SNEAK_PEAK",
          body: `COME_BACK_COMPLETE_ACTIVITY_${canExpire ? "ON_DATE" : "LATER"}`,
          date: formattedActivityStartDate
        };
      case EXPIRED5:
        return {
          heading: "LOOKS_LIKE_YOU_MISSED_THIS_ONE",
          body: "THIS_ACTIVITY_EXPIRED_ON_DATE",
          date: formattedActivityEndDate
        };
      case REMOVED5:
        return {
          heading: "LOOKS_LIKE_THIS_WASNT_MEANT_FOR_YOU",
          body: "YOU_SKIPPED_THIS_ACTIVITY"
        };
      default:
        return null;
    }
  }, [canExpire, formattedActivityEndDate, formattedActivityStartDate, status]);
  const TextBasedFooterComponent = useCallback4(() => {
    const headingMessage = $tmap({
      UPCOMING: "THIS_IS_JUST_A_SNEAK_PEAK",
      EXPIRED: "LOOKS_LIKE_YOU_MISSED_THIS_ONE",
      REMOVED: "LOOKS_LIKE_THIS_WASNT_MEANT_FOR_YOU"
    });
    const bodyMessage = $tmap({
      UPCOMING: "COME_BACK_COMPLETE_ACTIVITY_LATER",
      EXPIRED: "THIS_ACTIVITY_EXPIRED_ON_DATE",
      REMOVED: "YOU_SKIPPED_THIS_ACTIVITY"
    });
    const bodyMessageCanExpire = $tmap({
      UPCOMING: "COME_BACK_COMPLETE_ACTIVITY_ON_DATE",
      EXPIRED: "THIS_ACTIVITY_EXPIRED_ON_DATE",
      REMOVED: "YOU_SKIPPED_THIS_ACTIVITY"
    });
    const { heading, body, date } = getFooterText();
    return /* @__PURE__ */ React38.createElement(Box20, { textAlign: "center" }, /* @__PURE__ */ React38.createElement(HeadingFour3, { as: "p", color: "onSurface.text.subdued", marginBottom: "half" }, headingMessage(heading)), /* @__PURE__ */ React38.createElement(BodyOneSecondary, null, canExpire ? bodyMessageCanExpire(body, { date }) : bodyMessage(body, { date })));
  }, [$tmap, canExpire, getFooterText]);
  const FooterView = useCallback4(() => {
    switch (status) {
      case COMPLETED6:
        if (isStepCompletionMethodType && isActivityDetailsView) {
          return /* @__PURE__ */ React38.createElement(FooterComponents, { isRemovableCta: false });
        }
        return /* @__PURE__ */ React38.createElement(DoneFooterComponent, null);
      case UPCOMING8:
      case EXPIRED5:
      case REMOVED5:
        return /* @__PURE__ */ React38.createElement(TextBasedFooterComponent, null);
      default:
        return /* @__PURE__ */ React38.createElement(FooterComponents, { isRemovableCta: isRemovable });
    }
  }, [isActivityDetailsView, isRemovable, isStepCompletionMethodType, status]);
  const deleteActivityOnClose = () => __async(void 0, null, function* () {
    toggleDeleteActivityModal(false);
  });
  return /* @__PURE__ */ React38.createElement(
    Box20,
    {
      position: "sticky",
      bottom: "0",
      width: "100%",
      backgroundColor: "surface.background.secondary",
      padding: "one",
      justifyContent: "center"
    },
    errorMessage && /* @__PURE__ */ React38.createElement(ActivityErrorMessage, { marginBottom: "threeQuarters" }, errorMessage),
    /* @__PURE__ */ React38.createElement(
      Flex13,
      {
        flexDirection: { _: "column", phone: "row" },
        width: "100%",
        marginY: "0",
        marginX: "auto",
        justifyContent: "center"
      },
      /* @__PURE__ */ React38.createElement(FooterView, null),
      showDeleteActivityModal && /* @__PURE__ */ React38.createElement(
        DeleteActivityModal,
        {
          onClose: deleteActivityOnClose,
          activityId,
          requestSetUserHealthActivityDelete
        }
      )
    )
  );
};
ActivityFooter.propTypes = {
  isActivityDetailsView: PropTypes4.bool,
  isRemovable: PropTypes4.bool
};
ActivityFooter.defaultProps = {
  isActivityDetailsView: true,
  isRemovable: true
};

// src/components/navigate-by-date.component.js
import * as React39 from "react";
import PropTypes5 from "prop-types";
import {
  Box as Box21,
  Flex as Flex14,
  HeadingFour as HeadingFour4,
  HeadingOne as HeadingOne2,
  SubtleButton
} from "@leagueplatform/genesis-commons";
import { VeryQuietButton as VeryQuietButton2 } from "@leagueplatform/web-common-components";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import { ICONS, Icon as Icon2 } from "@leagueplatform/ui-kit";
var todayUnix = Date.now();
var buttonStyles = {
  borderRadius: "circle",
  height: "2em",
  paddingInlineStart: "0",
  paddingInlineEnd: "0",
  width: "2em"
};
var iconBoxStyles = {
  as: "span",
  display: "block",
  marginTop: "-0.225em"
};
var NavigateByDate = (_a) => {
  var _b = _a, {
    currentDate: currentDate2,
    disableNext,
    disablePrev,
    onChangeDate,
    todaysDate
  } = _b, props = __objRest(_b, [
    "currentDate",
    "disableNext",
    "disablePrev",
    "onChangeDate",
    "todaysDate"
  ]);
  const { formatDate, formatMessage } = useIntl21();
  const todaysDateObj = new Date(todaysDate);
  const currentDateObj = new Date(currentDate2 || todaysDate);
  const isNotToday = getDiffOfDates(todaysDateObj, currentDateObj) !== 0;
  const formatDateMonthAndDay = () => formatDate(currentDateObj, {
    month: "long",
    day: "numeric"
  });
  const formatDateWeekday = () => {
    switch (getDiffOfDates(todaysDateObj, currentDateObj)) {
      case 0:
        return formatMessage({ id: "TODAY" });
      case 1:
        return formatMessage({ id: "TOMORROW" });
      case -1:
        return formatMessage({ id: "YESTERDAY" });
      default:
        return formatDate(currentDateObj, {
          weekday: "long"
        });
    }
  };
  const selectDate = (incr = 0) => {
    const changeDatePayload = {
      date: todaysDate,
      incr
    };
    if (incr) {
      const requestDate = new Date(currentDate2 || todaysDate);
      requestDate.setDate(currentDateObj.getDate() + incr);
      changeDatePayload.date = requestDate.getTime();
    }
    onChangeDate(changeDatePayload);
  };
  return /* @__PURE__ */ React39.createElement(
    Flex14,
    __spreadValues({
      alignItems: "flex-end",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginX: "auto",
      maxWidth: "40rem",
      textAlign: "center"
    }, props),
    /* @__PURE__ */ React39.createElement(
      Box21,
      {
        as: "header",
        flexGrow: "1",
        flexShrink: "0",
        marginX: "oneAndHalf",
        order: "2"
      },
      /* @__PURE__ */ React39.createElement(HeadingFour4, { as: "p", color: "onSurface.text.subdued", marginBottom: "half" }, formatDateWeekday().toLocaleUpperCase()),
      /* @__PURE__ */ React39.createElement(HeadingOne2, { as: "h2" }, formatDateMonthAndDay())
    ),
    /* @__PURE__ */ React39.createElement(Box21, { order: "1", marginBottom: "quarter" }, /* @__PURE__ */ React39.createElement(
      SubtleButton,
      __spreadValues({
        "aria-label": formatMessage({ id: "PREVIOUS_DAY" }),
        disabled: disablePrev,
        onClick: () => selectDate(-1)
      }, buttonStyles),
      /* @__PURE__ */ React39.createElement(
        Box21,
        __spreadValues({}, iconBoxStyles),
        /* @__PURE__ */ React39.createElement(Icon2, { icon: ICONS.BACK_CHEVRON })
      )
    )),
    /* @__PURE__ */ React39.createElement(Box21, { order: "3", marginBottom: "quarter" }, /* @__PURE__ */ React39.createElement(
      SubtleButton,
      __spreadValues({
        "aria-label": formatMessage({ id: "NEXT_DAY" }),
        disabled: disableNext,
        onClick: () => selectDate(1)
      }, buttonStyles),
      /* @__PURE__ */ React39.createElement(
        Box21,
        __spreadValues({}, iconBoxStyles),
        /* @__PURE__ */ React39.createElement(Icon2, { icon: ICONS.FORWARD_CHEVRON })
      )
    )),
    isNotToday && /* @__PURE__ */ React39.createElement(Box21, { flexBasis: "100%", order: "4" }, /* @__PURE__ */ React39.createElement(
      VeryQuietButton2,
      {
        onClick: () => selectDate(),
        marginTop: "quarter",
        textDecoration: "none",
        darkenBackground: true,
        hideUnderline: true
      },
      formatMessage({ id: "BACK_TO_TODAY" })
    ))
  );
};
NavigateByDate.propTypes = {
  /** Number representing the UNIX epoch time of the currently displayed date */
  currentDate: PropTypes5.number,
  /** Disable the 'Next day' navigation button */
  disableNext: PropTypes5.bool,
  /** Disable the 'Previous day' navigation button */
  disablePrev: PropTypes5.bool,
  /** Returns an object containing the requested date and increment for each navigation button */
  onChangeDate: PropTypes5.func,
  /** Override the reference for "today" for testing and snapshot purposes */
  todaysDate: PropTypes5.number
};
NavigateByDate.defaultProps = {
  currentDate: void 0,
  disableNext: false,
  disablePrev: false,
  onChangeDate: () => {
  },
  todaysDate: todayUnix
};

// src/components/empty-state-card.component.js
import * as React40 from "react";
import PropTypes6 from "prop-types";
import {
  BodyOneSecondary as BodyOneSecondary2,
  Box as Box22,
  HeadingTwo as HeadingTwo4
} from "@leagueplatform/genesis-commons";
var EmptyStateCard2 = (_a) => {
  var _b = _a, {
    bodyText,
    children,
    graphic,
    headingText
  } = _b, props = __objRest(_b, [
    "bodyText",
    "children",
    "graphic",
    "headingText"
  ]);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    /* @__PURE__ */ React40.createElement(Box22, __spreadValues({ textAlign: "center", maxWidth: "60rem", marginX: "auto" }, props), graphic && /* @__PURE__ */ React40.createElement(Box22, { maxWidth: "18.5rem", marginX: "auto", marginBottom: "twoAndHalf" }, graphic), headingText && /* @__PURE__ */ React40.createElement(HeadingTwo4, { fontSize: { _: "heading3", phone: "heading2" } }, headingText), bodyText && /* @__PURE__ */ React40.createElement(BodyOneSecondary2, { marginTop: "one" }, bodyText), children && /* @__PURE__ */ React40.createElement(Box22, { marginTop: "oneAndHalf" }, children))
  );
};
EmptyStateCard2.propTypes = {
  /** Text content to appear under the heading, in the body text */
  bodyText: PropTypes6.string,
  /** Child text, HTML, or components passed will render below the image, heading, and body text */
  children: PropTypes6.node,
  /** Pass an <Image /> component to be rendered above the heading */
  graphic: PropTypes6.element,
  /** Text content to appear within the heading element */
  headingText: PropTypes6.string
};
EmptyStateCard2.defaultProps = {
  bodyText: "",
  children: null,
  graphic: null,
  headingText: ""
};

// src/components/progress-active-program.component.js
import React41 from "react";
import PropTypes7 from "prop-types";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import { arrayToTag as arrayToTag2 } from "@leagueplatform/web-common";
import { GenesisRouterLink as GenesisRouterLink2 } from "@leagueplatform/web-common-components";
import {
  Flex as Flex15,
  HeadingFour as HeadingFour5,
  SubtitleOne as SubtitleOne3
} from "@leagueplatform/genesis-commons";
import { CompoundProgressBar as CompoundProgressBar2 } from "@leagueplatform/ui-kit";
import { programProgressBarSegmentFactory } from "@leagueplatform/health-programs";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES13,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE9
} from "@leagueplatform/health-journey-common";

// src/hooks/use-journey-progress-analytics.hook.js
import {
  trackAnalyticsEvent as trackAnalyticsEvent9,
  EVENT_NAME as EVENT_NAME9,
  PRODUCT_AREA as PRODUCT_AREA9
} from "@leagueplatform/analytics";
import { useActiveCampaignInfo } from "@leagueplatform/health-programs";
import { SCREEN_NAMES as SCREEN_NAMES7 } from "@leagueplatform/health-journey-common";
var { BUTTON_CLICKED: BUTTON_CLICKED3, SCREEN_LOADED: SCREEN_LOADED3, NAVIGATION_TAB_CLICKED } = EVENT_NAME9;
var { PROGRESS_PAGE, PROGRAM_LIMIT_MODAL } = SCREEN_NAMES7;
var useJourneyProgressAnalytics = () => {
  const { data: campaignLimitInfo = {} } = useActiveCampaignInfo();
  const {
    number_of_enrolled_programs: activeCampaigns,
    max_programs_limit: campaignLimit
  } = campaignLimitInfo;
  const meta2 = {
    product_area: PRODUCT_AREA9.JOURNEY,
    screen_name: PROGRESS_PAGE
  };
  const data = {
    num_health_campaign_active: activeCampaigns != null ? activeCampaigns : null,
    num_health_campaign_limit: campaignLimit != null ? campaignLimit : null
  };
  return {
    sendViewProgressPage() {
      trackAnalyticsEvent9(SCREEN_LOADED3, __spreadValues(__spreadValues({}, meta2), data));
    },
    sendPillNavigation({ from, to }) {
      trackAnalyticsEvent9(NAVIGATION_TAB_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, meta2), data), {
        screen_name: from,
        detail: to
      }));
    },
    sendSelectActiveProgram({
      campaignName = null,
      campaignId = null,
      campaignType = null
    }) {
      trackAnalyticsEvent9(BUTTON_CLICKED3, __spreadProps(__spreadValues(__spreadValues({}, meta2), data), {
        detail: "view health campaign",
        health_campaign_name: campaignName,
        health_campaign_id: campaignId,
        health_campaign_type: campaignType,
        is_active_health_campaign: true
      }));
    },
    sendSelectStartProgramsBanner(ctaText) {
      trackAnalyticsEvent9(BUTTON_CLICKED3, __spreadProps(__spreadValues(__spreadValues({}, meta2), data), {
        detail: "start more health campaigns",
        sub_detail: ctaText
      }));
    },
    sendOpenProgramLimitModal() {
      trackAnalyticsEvent9(BUTTON_CLICKED3, __spreadProps(__spreadValues(__spreadValues({}, meta2), data), {
        detail: "view health campaign limit banner"
      }));
    },
    sendCloseProgramLimitModal() {
      trackAnalyticsEvent9(BUTTON_CLICKED3, __spreadProps(__spreadValues(__spreadValues({}, meta2), data), {
        screen_name: PROGRAM_LIMIT_MODAL,
        detail: "close"
      }));
    }
  };
};

// src/components/progress-active-program.component.js
var { CHALLENGE: CHALLENGE6 } = ACTIVITY_CAMPAIGN_TYPE9;
var ProgressActiveProgram = ({
  id,
  image,
  title,
  progressPercentages,
  activityStatusCounts,
  total,
  campaignType
}) => {
  const { formatMessage } = useIntl22();
  const progressAnalytics = useJourneyProgressAnalytics();
  const { completed, expired, removed } = activityStatusCounts != null ? activityStatusCounts : {};
  const missed = expired + removed;
  const progressSegments = programProgressBarSegmentFactory(progressPercentages);
  const progressCaption = arrayToTag2([
    completed !== void 0 ? formatMessage({ id: "X_OF_Y_COMPLETE" }, { completed, total }) : null,
    missed ? formatMessage({ id: "X_MISSED" }, { missed }) : null
  ]);
  const progressCaptionId = `progress-caption-${id}`;
  const ProgressSubtitle = (props) => /* @__PURE__ */ React41.createElement(
    SubtitleOne3,
    __spreadValues({
      id: progressCaptionId,
      color: "onSurface.text.subdued",
      marginTop: "half",
      as: "p"
    }, props)
  );
  const ProgressCardContent = () => /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(
    CompoundProgressBar2,
    {
      role: "progressbar",
      "aria-labelledby": progressCaptionId,
      segments: progressSegments,
      height: "threeQuarters",
      marginTop: { _: "one", phone: "oneAndHalf" }
    }
  ), /* @__PURE__ */ React41.createElement(ProgressSubtitle, null, progressCaption));
  const onClickActions = () => progressAnalytics.sendSelectActiveProgram({
    campaignName: title,
    campaignId: id,
    campaignType
  });
  const getLinkPath = () => campaignType === CHALLENGE6 ? JOURNEY_ROUTES13.getChallengeDetails(id) : `${JOURNEY_ROUTES13.getProgramDetails(id)}?b=progress`;
  return /* @__PURE__ */ React41.createElement(
    GenesisRouterLink2,
    {
      hoverStyle: {
        backgroundColor: "surface.background.secondary",
        textDecoration: "none !important"
      },
      onClick: () => onClickActions(),
      width: "100%",
      to: getLinkPath()
    },
    /* @__PURE__ */ React41.createElement(
      Flex15,
      {
        flexDirection: { _: "column", phone: "row" },
        alignItems: { _: "unset", phone: "center" },
        paddingY: "oneAndHalf"
      },
      image && /* @__PURE__ */ React41.createElement(
        DynamicCoverImage,
        {
          src: image,
          alt: "",
          width: { _: 110, phone: 206 },
          height: { _: 70, phone: 131 },
          marginInlineEnd: { _: "0", phone: "oneAndHalf" },
          marginBottom: { _: "one", phone: "0" },
          borderRadius: "medium"
        }
      ),
      /* @__PURE__ */ React41.createElement(Flex15, { flexDirection: "column", flexGrow: "2" }, title && /* @__PURE__ */ React41.createElement(
        HeadingFour5,
        {
          as: "p",
          fontSize: { _: "heading4", tablet: "heading3" }
        },
        title
      ), /* @__PURE__ */ React41.createElement(ProgressCardContent, null))
    )
  );
};
ProgressActiveProgram.propTypes = {
  total: PropTypes7.number,
  id: PropTypes7.string,
  image: PropTypes7.string,
  title: PropTypes7.string,
  progressPercentages: PropTypes7.shape({
    missed: PropTypes7.number,
    completed: PropTypes7.number
  }),
  activityStatusCounts: PropTypes7.shape({
    active: PropTypes7.number,
    upcoming: PropTypes7.number,
    completed: PropTypes7.number,
    expired: PropTypes7.number,
    removed: PropTypes7.number
  }),
  campaignType: PropTypes7.oneOf(["opt-in", "challenge"])
};
ProgressActiveProgram.defaultProps = {
  total: 0,
  id: "",
  image: "",
  title: "",
  progressPercentages: {
    completed: 0,
    missed: 0
  },
  activityStatusCounts: {
    active: 0,
    upcoming: 0,
    completed: 0,
    expired: 0,
    removed: 0
  },
  campaignType: "opt-in"
};

// src/components/active-campaigns.component.js
import * as React42 from "react";
import PropTypes8 from "prop-types";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import {
  Box as Box23,
  HeadingTwo as HeadingTwo5,
  genesisStyled as genesisStyled12,
  css as css7
} from "@leagueplatform/genesis-commons";
import { ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE10 } from "@leagueplatform/health-journey-common";
var { OPTIN, CHALLENGE: CHALLENGE7 } = ACTIVITY_CAMPAIGN_TYPE10;
var ActiveCampaignListItem = genesisStyled12("li")(
  css7({
    borderBottomWidth: "thin",
    borderBottomStyle: "solid",
    borderBottomColor: "onSurface.border.subdued",
    "&:last-child": {
      borderStyle: "none"
    }
  })
);
var CampaignBlock = genesisStyled12(Box23)(
  css7({
    marginBottom: "two",
    "&:last-of-type": {
      marginBottom: "none",
      borderStyle: "none"
    }
  })
);
var CampaignList = genesisStyled12(Box23)(
  css7({
    marginBottom: "two",
    "&:last-of-type": {
      marginBottom: "none"
    }
  })
);
var ActiveCampaignViewContainer = ({ programs }) => {
  css7({
    "&:last-of-type": {
      marginBottom: "two",
      borderStyle: "none"
    }
  });
  return /* @__PURE__ */ React42.createElement(Box23, { flexDirection: "column", as: "ul" }, programs == null ? void 0 : programs.map(
    ({
      image_url: imageUrl,
      name,
      program_id: programId,
      activity_status_counts: activityStatusCounts,
      total_activities_count: totalActivitiesCount,
      completed_activity_progress_percentage: completed,
      missed_activity_progress_percentage: missed,
      campaign_type: campaignType
    }) => /* @__PURE__ */ React42.createElement(ActiveCampaignListItem, { key: programId }, /* @__PURE__ */ React42.createElement(
      ProgressActiveProgram,
      {
        id: programId,
        image: imageUrl,
        title: name,
        total: totalActivitiesCount,
        progressPercentages: { completed, missed },
        activityStatusCounts,
        campaignType
      }
    ))
  ));
};
ActiveCampaignViewContainer.propTypes = {
  programs: PropTypes8.arrayOf(
    PropTypes8.shape({
      image_url: PropTypes8.string,
      program_id: PropTypes8.string,
      progress_percentage: PropTypes8.number,
      name: PropTypes8.string
    })
  ).isRequired
};
var ActiveCampaignList = ({ programs, heading }) => /* @__PURE__ */ React42.createElement(CampaignBlock, null, /* @__PURE__ */ React42.createElement(HeadingTwo5, null, heading), /* @__PURE__ */ React42.createElement(ActiveCampaignViewContainer, { programs }));
ActiveCampaignList.propTypes = {
  programs: PropTypes8.arrayOf(
    PropTypes8.shape({
      image_url: PropTypes8.string,
      program_id: PropTypes8.string,
      progress_percentage: PropTypes8.number,
      name: PropTypes8.string
    })
  ).isRequired,
  heading: PropTypes8.string
};
ActiveCampaignList.defaultProps = {
  heading: ""
};
var ActiveCampaigns = ({ programs }) => {
  const { formatMessage } = useIntl23();
  const filterCampaignData = (data, filter) => {
    var _a;
    return (_a = data == null ? void 0 : data.filter(
      ({ campaign_type: campaignType }) => campaignType === filter
    )) != null ? _a : [];
  };
  const activeChallenges = filterCampaignData(programs, CHALLENGE7);
  const activePrograms = filterCampaignData(programs, OPTIN);
  const isChallengesEmpty = (activeChallenges == null ? void 0 : activeChallenges.length) === 0;
  const isProgramsEmpty = (activePrograms == null ? void 0 : activePrograms.length) === 0;
  return /* @__PURE__ */ React42.createElement(CampaignList, null, !isChallengesEmpty && /* @__PURE__ */ React42.createElement(
    ActiveCampaignList,
    {
      programs: activeChallenges,
      heading: formatMessage(
        { id: "ACTIVE_CHALLENGE" },
        { length: activeChallenges.length }
      )
    }
  ), !isProgramsEmpty && /* @__PURE__ */ React42.createElement(
    ActiveCampaignList,
    {
      programs: activePrograms,
      heading: formatMessage(
        { id: "ACTIVE_PROGRAM" },
        { length: activePrograms.length }
      )
    }
  ));
};
ActiveCampaigns.propTypes = {
  programs: PropTypes8.arrayOf(
    PropTypes8.shape({
      image_url: PropTypes8.string,
      program_id: PropTypes8.string,
      progress_percentage: PropTypes8.number,
      name: PropTypes8.string
    })
  ).isRequired
};

// src/components/journey-page-layout.component.js
import * as React43 from "react";
import PropTypes9 from "prop-types";
import { Flex as Flex16, Box as Box24, HeadingOne as HeadingOne3 } from "@leagueplatform/genesis-commons";
import {
  PageHeaderBackground,
  SIDEBAR_MIN_WIDTH
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
var PAGE_LAYOUT_SPACING = {
  _: "oneAndHalf",
  phone: "oneAndHalf",
  tablet: "three",
  laptop: "five",
  desktop: "120px"
};
var JourneyPageLayout = ({ children }) => {
  const { formatMessage } = useIntl24();
  return /* @__PURE__ */ React43.createElement(Flex16, { maxWidth: "1400px" }, /* @__PURE__ */ React43.createElement(PageHeaderBackground, null), /* @__PURE__ */ React43.createElement(Flex16, { flexDirection: { _: "column", laptop: "row" }, width: 1 }, /* @__PURE__ */ React43.createElement(
    Box24,
    {
      width: 1,
      marginBottom: { _: "230px", phone: "140px" },
      paddingTop: "twoAndHalf",
      paddingX: PAGE_LAYOUT_SPACING,
      paddingInlineEnd: { laptop: "twoAndHalf", desktop: "twoAndHalf" }
    },
    /* @__PURE__ */ React43.createElement(
      HeadingOne3,
      {
        marginBottom: "twoAndHalf",
        textAlign: { _: "center", phone: "initial" }
      },
      formatMessage({ id: "HEALTH_JOURNEY" })
    ),
    children
  ), /* @__PURE__ */ React43.createElement(
    Box24,
    {
      height: 1,
      marginInlineEnd: PAGE_LAYOUT_SPACING,
      minWidth: SIDEBAR_MIN_WIDTH,
      paddingY: "twoAndHalf",
      flex: "0"
    },
    /* @__PURE__ */ React43.createElement(HealthRewardsSidebar, { showAchievements: true, isAddProgramButtonShown: true })
  )));
};
JourneyPageLayout.propTypes = {
  children: PropTypes9.node.isRequired
};

// src/components/campaign-progress-content.component.js
import * as React45 from "react";
import { Box as Box25, CoverImage as CoverImage3 } from "@leagueplatform/genesis-commons";
import {
  ErrorState as ErrorState2,
  LoadingIndicator
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
import {
  RecentAchievements as RecentAchievements2,
  AchievementStats as AchievementStats2,
  useAchievementsDetail as useAchievementsDetail2
} from "@leagueplatform/rewards-achievements";
import { useFeatureFlagQuery as useFeatureFlagQuery12 } from "@leagueplatform/user-profile-api";
import { ACHIEVEMENTS_ENABLED as ACHIEVEMENTS_ENABLED6 } from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";

// src/hooks/use-health-journey-progress.hook.js
import { useQuery as useQuery8 } from "react-query";
import {
  getUserHealthGoalPrograms,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE as GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE3
} from "@leagueplatform/health-journey-api";
var useHealthJourneyProgress = () => {
  var _a;
  const {
    data: userHealthGoalProgramsData,
    isError: userHealthGoalProgramsIsError,
    isLoading: userHealthGoalProgramsIsLoading,
    error
  } = useQuery8(
    [GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE3],
    getUserHealthGoalPrograms,
    { staleTime: 3e3 }
  );
  const activePrograms = (userHealthGoalProgramsData == null ? void 0 : userHealthGoalProgramsData.programs) || [];
  const numberOfAvailablePrograms = (userHealthGoalProgramsData == null ? void 0 : userHealthGoalProgramsData.number_of_available_programs) || 0;
  return {
    hasError: userHealthGoalProgramsIsError,
    activePrograms,
    isProgramLimitReached: numberOfAvailablePrograms === 0,
    isProgramsEmpty: ((_a = userHealthGoalProgramsData == null ? void 0 : userHealthGoalProgramsData.programs) == null ? void 0 : _a.length) === 0,
    numberOfAvailablePrograms,
    programLimitModal: userHealthGoalProgramsData == null ? void 0 : userHealthGoalProgramsData.program_limit_modal,
    ready: !userHealthGoalProgramsIsLoading,
    error
  };
};

// src/components/campaign-limit-banner.component.js
import * as React44 from "react";
import { useState as useState4 } from "react";
import { useNavigateLegacy as useNavigate6 } from "@leagueplatform/routing";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import {
  Flex as Flex17,
  Link as Link6,
  CoverImage as CoverImage2,
  SubtitleOne as SubtitleOne4
} from "@leagueplatform/genesis-commons";
import {
  ProgramLimitModal,
  JOURNEY_ROUTES as JOURNEY_ROUTES14
} from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
var { HEART_RATE_UP, MOBILE_ALERT_USER } = HEALTH_JOURNEY_ASSET_KEYS;
var CampaignLimitBanner = () => {
  const availablePrograms = handleStaticAsset8(HEART_RATE_UP);
  const noAvailablePrograms = handleStaticAsset8(MOBILE_ALERT_USER);
  const navigate = useNavigate6();
  const { formatMessage } = useIntl25();
  const [showProgramLimitModel, setShowProgramLimitModel] = useState4(false);
  const {
    isProgramLimitReached,
    numberOfAvailablePrograms,
    programLimitModal
  } = useHealthJourneyProgress();
  const progressAnalytics = useJourneyProgressAnalytics();
  const onClickActions = (e) => {
    e.preventDefault();
    if (!programLimitModal)
      return;
    if (isProgramLimitReached) {
      progressAnalytics.sendOpenProgramLimitModal();
      setShowProgramLimitModel(true);
    } else {
      progressAnalytics.sendSelectStartProgramsBanner("Browse Programs");
      navigate(JOURNEY_ROUTES14.programsHome());
    }
  };
  const handleProgramLimitModalClose = () => {
    progressAnalytics.sendCloseProgramLimitModal();
    setShowProgramLimitModel(false);
  };
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(
    Flex17,
    {
      as: Link6,
      href: "#",
      cursor: "pointer",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      borderRadius: "medium",
      borderWidth: "thin",
      borderColor: "highlight.background.subdued",
      backgroundColor: "highlight.background.subdued",
      padding: "oneAndHalf",
      marginTop: "oneAndHalf",
      onClick: onClickActions,
      hoverStyle: {
        textDecoration: "none"
      }
    },
    /* @__PURE__ */ React44.createElement(Flex17, { marginInlineEnd: "one" }, /* @__PURE__ */ React44.createElement(
      CoverImage2,
      {
        src: isProgramLimitReached ? noAvailablePrograms : availablePrograms,
        alt: "",
        size: 25
      }
    ), /* @__PURE__ */ React44.createElement(SubtitleOne4, { marginInlineStart: "one" }, isProgramLimitReached ? formatMessage({ id: "YOUVE_REACHED_PROGRAM_LIMIT" }) : formatMessage(
      { id: "START_X_MORE_PROGRAMS" },
      { duration: numberOfAvailablePrograms }
    ))),
    /* @__PURE__ */ React44.createElement(SubtitleOne4, { color: "interactive.action.primary" }, isProgramLimitReached ? formatMessage({ id: "LEARN_MORE" }) : formatMessage({ id: "BROWSE_PROGRAMS" }))
  ), showProgramLimitModel && /* @__PURE__ */ React44.createElement(
    ProgramLimitModal,
    {
      title: programLimitModal.title,
      description: programLimitModal.description,
      onClose: handleProgramLimitModalClose
    }
  ));
};

// src/components/campaign-progress-content.component.js
var { EMPTY_STATE_PROGRESS } = HEALTH_JOURNEY_ASSET_KEYS;
var EmptyStateProgress = () => handleStaticAsset9(EMPTY_STATE_PROGRESS, {
  isComponent: true,
  props: {
    as: CoverImage3,
    backgroundSize: "contain",
    borderRadius: "large",
    marginBottom: "minusOne",
    size: 96
  }
});
var NoActivePrograms = () => {
  const { formatMessage } = useIntl26();
  return /* @__PURE__ */ React45.createElement(
    EmptyStateCard2,
    {
      bodyText: formatMessage({ id: "TAP_ADD_PROGRAM_BUTTON" }),
      graphic: /* @__PURE__ */ React45.createElement(EmptyStateProgress, null),
      headingText: formatMessage({ id: "YOU_HAVENT_STARTED_PROGRAMS" })
    }
  );
};
var RecentAchievementsView = () => {
  const { completedAchievementStats, recentAchievements } = useAchievementsDetail2();
  return /* @__PURE__ */ React45.createElement(Box25, { display: { _: "block", laptop: "none" } }, /* @__PURE__ */ React45.createElement(AchievementStats2, { completedAchievements: completedAchievementStats }), /* @__PURE__ */ React45.createElement(RecentAchievements2, { achievements: recentAchievements }));
};
var CampaignProgressContent = () => {
  const { activePrograms, hasError, isProgramsEmpty, ready, error } = useHealthJourneyProgress();
  const { data: isAchievementsEnabled } = useFeatureFlagQuery12(ACHIEVEMENTS_ENABLED6);
  const progressAnalytics = useJourneyProgressAnalytics();
  React45.useEffect(() => {
    if (ready) {
      progressAnalytics.sendViewProgressPage();
    }
  }, [progressAnalytics, ready]);
  if (!ready)
    return /* @__PURE__ */ React45.createElement(
      Box25,
      {
        position: "relative",
        minHeight: "30vh",
        height: "auto",
        width: "100%",
        "data-testid": "loading-indicator"
      },
      /* @__PURE__ */ React45.createElement(LoadingIndicator, null)
    );
  if (hasError)
    return /* @__PURE__ */ React45.createElement(ErrorState2, { error });
  return isProgramsEmpty ? /* @__PURE__ */ React45.createElement(React45.Fragment, null, isAchievementsEnabled && /* @__PURE__ */ React45.createElement(RecentAchievementsView, null), /* @__PURE__ */ React45.createElement(NoActivePrograms, null)) : /* @__PURE__ */ React45.createElement(React45.Fragment, null, isAchievementsEnabled && /* @__PURE__ */ React45.createElement(RecentAchievementsView, null), /* @__PURE__ */ React45.createElement(ActiveCampaigns, { programs: activePrograms }), /* @__PURE__ */ React45.createElement(CampaignLimitBanner, null));
};

// src/pages/activity-steps/components/arrow-button.component.js
import React46 from "react";
import PropTypes10 from "prop-types";
import {
  Image as Image8,
  Flex as Flex18,
  BodyOneSecondary as BodyOneSecondary3,
  genesisStyled as genesisStyled13,
  css as css8
} from "@leagueplatform/genesis-commons";
import { genesisFocus as genesisFocus2 } from "@leagueplatform/ui-kit";
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";

// src/pages/activity-steps/constants/activity-steps.constants.ts
var BTN_SIZE = "56px";
var LEFT = "left";
var RIGHT = "right";

// src/pages/activity-steps/components/arrow-button.component.js
var { ARROW_LEFT, ARROW_RIGHT } = HEALTH_JOURNEY_ASSET_KEYS;
var SingleLineCaption = genesisStyled13(BodyOneSecondary3)(
  css8({ whiteSpace: "nowrap" })
);
var ArrowButton = (_a) => {
  var _b = _a, { disabled, orientation, focusRef } = _b, rest = __objRest(_b, ["disabled", "orientation", "focusRef"]);
  const arrowRight2 = handleStaticAsset10(ARROW_RIGHT);
  const arrowLeft2 = handleStaticAsset10(ARROW_LEFT);
  const { formatMessage, $tifelse } = useIntl27();
  const rightOrientation = orientation === RIGHT;
  const accessibilityText = $tifelse(orientation === LEFT, "PREVIOUS", "NEXT");
  const leftStyles = {
    backgroundColor: "decorative.brand.primary.pastel",
    hoverStyle: {
      backgroundColor: "decorative.brand.primary.brightest"
    }
  };
  const rightStyles = {
    backgroundColor: "primary.background.default",
    hoverStyle: {
      backgroundColor: "primary.background.hovered"
    }
  };
  const derivedStyles = orientation === RIGHT ? rightStyles : leftStyles;
  return /* @__PURE__ */ React46.createElement(
    Flex18,
    __spreadValues(__spreadProps(__spreadValues({
      as: "button",
      "aria-label": accessibilityText,
      alignItems: "center",
      justifyContent: "center",
      minWidth: BTN_SIZE,
      minHeight: BTN_SIZE,
      disabled,
      border: "none",
      borderRadius: "circle"
    }, derivedStyles), {
      disabledStyle: {
        backgroundColor: "decorative.brand.primary.pastel",
        cursor: "not-allowed"
      },
      transition: "background 0.3s ease-out",
      focusStyle: genesisFocus2,
      transform: "rotateY(calc(180deg * var(--league-is-rtl)))",
      ref: focusRef
    }), rest),
    /* @__PURE__ */ React46.createElement(
      Image8,
      {
        src: orientation === RIGHT && !disabled ? arrowRight2 : arrowLeft2,
        alt: accessibilityText,
        width: "initial",
        display: "block",
        transform: `scaleX(${orientation === LEFT ? "-1" : "1"})`
      }
    ),
    rightOrientation && /* @__PURE__ */ React46.createElement(SingleLineCaption, { marginTop: "one", position: "absolute", top: "100%" }, formatMessage({ id: "PRESS_ENTER" }))
  );
};
ArrowButton.propTypes = {
  disabled: PropTypes10.bool.isRequired,
  orientation: PropTypes10.oneOf([LEFT, RIGHT]).isRequired,
  focusRef: PropTypes10.func
};
ArrowButton.defaultProps = {
  focusRef: null
};

// src/components/configurable-journey-experience/rewards-program-card-carousel-widget/rewards-program-card-carousel-widget.component.tsx
import { HEALTH_JOURNEY_MASONRY_VERSION } from "@leagueplatform/health-journey-common";
import {
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import { SkeletonBox as SkeletonBox3 } from "@leagueplatform/web-common-components";
import React49 from "react";

// src/components/configurable-journey-experience/rewards-program-card-carousel-widget/rewards-program-card-carousel-widget-v2.component.tsx
import React48 from "react";
import { HeadingText as HeadingText8, StackLayout as StackLayout14 } from "@leagueplatform/genesis-core";
import { Carousel } from "@leagueplatform/web-common-components";
import {
  EVENT_NAME as EVENT_NAME10,
  PRODUCT_AREA as PRODUCT_AREA10,
  SCREEN_NAMES as SCREEN_NAMES8,
  trackAnalyticsEvent as trackAnalyticsEvent10
} from "@leagueplatform/analytics";

// src/components/configurable-journey-experience/rewards-program-card/rewards-program-card.component.tsx
import React47 from "react";
import {
  HeadingText as HeadingText7,
  StackLayout as StackLayout13,
  UtilityText as UtilityText5,
  Icon as Icon3,
  StackItem as StackItem3,
  Card as Card3,
  useClickableCard as useClickableCard2
} from "@leagueplatform/genesis-core";
import {
  Badge as Badge5,
  ConditionalLink,
  ProgressBar as ProgressBar3
} from "@leagueplatform/web-common-components";
var ItemContent = ({
  itemContent
}) => {
  if (!itemContent.currentText && !itemContent.prefixText) {
    return null;
  }
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(Icon3, { icon: itemContent.image, size: "$one" }), itemContent.prefixText && /* @__PURE__ */ React47.createElement(
    UtilityText5,
    {
      size: "sm",
      emphasis: "emphasized",
      css: { color: "$onSurfaceTextSuccess" }
    },
    itemContent.prefixText
  ), itemContent.currentText && /* @__PURE__ */ React47.createElement(UtilityText5, { size: "sm" }, itemContent.currentText));
};
var RewardsProgramProgressCard = ({
  badge,
  cta,
  heading,
  image,
  imageAltText,
  items,
  imagePosition,
  contentTextAlign = "center",
  onClick
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard2();
  const cardImageCss = imagePosition === "top" ? void 0 : {
    "&&": {
      maxWidth: "50%"
    },
    "@mobile": {
      "&&": {
        maxWidth: "unset"
      }
    }
  };
  return /* @__PURE__ */ React47.createElement(
    Card3.Elevated,
    {
      css: { position: "relative", height: "100%" },
      backgroundColor: "secondary"
    },
    /* @__PURE__ */ React47.createElement(
      Card3.ClickArea,
      {
        ref: clickAreaRef,
        onCardMouseUp,
        onCardMouseDown,
        imagePosition: imagePosition ? { "@initial": imagePosition } : {
          "@initial": "start",
          "@mobile": "top",
          "@desktop": "start"
        }
      },
      /* @__PURE__ */ React47.createElement(Card3.Image, { image, imageAlt: imageAltText, css: cardImageCss }),
      /* @__PURE__ */ React47.createElement(
        StackItem3,
        {
          css: {
            position: "absolute",
            top: "$one",
            insetInlineStart: "$one"
          }
        },
        /* @__PURE__ */ React47.createElement(
          Badge5,
          {
            css: {
              backgroundColor: badge.badgeBackgroundColor || "$decorativeBrandSecondaryBrightest",
              borderRadius: "$small"
            }
          },
          /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(Icon3, { icon: badge.image, size: "$one" }), /* @__PURE__ */ React47.createElement(UtilityText5, { size: "eyebrow", emphasis: "emphasized" }, badge.body))
        )
      ),
      /* @__PURE__ */ React47.createElement(Card3.Section, null, /* @__PURE__ */ React47.createElement(
        StackLayout13,
        {
          verticalAlignment: contentTextAlign,
          spacing: "$threeQuarters",
          horizontalAlignment: "stretch",
          css: { paddingInlineEnd: "$oneAndHalf" }
        },
        /* @__PURE__ */ React47.createElement(StackItem3, null, /* @__PURE__ */ React47.createElement(
          ConditionalLink,
          {
            ref: primaryActionRef,
            url: cta,
            onClick
          },
          /* @__PURE__ */ React47.createElement(HeadingText7, { level: "3", size: "lg", css: { textWrap: "balance" } }, heading)
        )),
        /* @__PURE__ */ React47.createElement(StackItem3, null, /* @__PURE__ */ React47.createElement(
          StackLayout13,
          {
            orientation: "vertical",
            spacing: "$threeQuarters",
            horizontalAlignment: "stretch"
          },
          items.map((item) => /* @__PURE__ */ React47.createElement(StackLayout13, { horizontalAlignment: "stretch" }, item.heading && /* @__PURE__ */ React47.createElement(StackItem3, null, /* @__PURE__ */ React47.createElement(HeadingText7, { size: "xs", level: "4" }, item.heading)), /* @__PURE__ */ React47.createElement(
            StackLayout13,
            {
              orientation: "vertical",
              horizontalAlignment: "stretch",
              spacing: "$threeQuarters"
            },
            /* @__PURE__ */ React47.createElement(
              StackLayout13,
              {
                verticalAlignment: "center",
                orientation: "horizontal",
                spacing: "$quarter"
              },
              item.content && /* @__PURE__ */ React47.createElement(ItemContent, { itemContent: item.content })
            ),
            item.progressContent && /* @__PURE__ */ React47.createElement(
              StackLayout13,
              {
                spacing: "$half",
                horizontalAlignment: "stretch"
              },
              /* @__PURE__ */ React47.createElement(
                StackLayout13,
                {
                  verticalAlignment: "center",
                  orientation: "horizontal",
                  spacing: "$quarter"
                },
                /* @__PURE__ */ React47.createElement(React47.Fragment, null, item.progressContent.image !== "" && /* @__PURE__ */ React47.createElement(
                  Icon3,
                  {
                    icon: item.progressContent.image,
                    size: "$one"
                  }
                ), /* @__PURE__ */ React47.createElement(
                  UtilityText5,
                  {
                    size: "xs",
                    css: { color: "$onSurfaceTextSuccess" }
                  },
                  item.progressContent.prefixText
                ), /* @__PURE__ */ React47.createElement(UtilityText5, { size: "xs" }, " ", item.progressContent.currentText))
              ),
              item.progressValue !== void 0 && /* @__PURE__ */ React47.createElement(
                StackLayout13,
                {
                  orientation: "horizontal",
                  horizontalAlignment: "stretch",
                  verticalAlignment: "center",
                  css: {
                    width: "100%"
                  }
                },
                /* @__PURE__ */ React47.createElement(
                  ProgressBar3,
                  {
                    total: 100,
                    current: item.progressValue,
                    customBarFillColor: "success.border.default",
                    customBarBackgroundColor: "interactive.action.disabled"
                  }
                )
              )
            )
          )))
        ))
      ))
    )
  );
};

// src/components/configurable-journey-experience/rewards-program-card-carousel-widget/rewards-program-card-carousel-widget-v2.component.tsx
var handleClickAnalytics = (eventProps) => {
  trackAnalyticsEvent10(EVENT_NAME10.BUTTON_CLICKED, __spreadValues({
    product_area: PRODUCT_AREA10.JOURNEY,
    screen_name: SCREEN_NAMES8.PROGRAM_WITH_PROGRESS_CAROUSEL_WIDGET,
    detail: "view health campaign"
  }, eventProps));
};
var RewardsProgramCardCarouselWidgetV2 = ({
  heading,
  items
}) => {
  const WidgetHeader = /* @__PURE__ */ React48.createElement(
    HeadingText8,
    {
      level: "2",
      size: {
        "@initial": "xl",
        "@mobile": "lg"
      },
      css: { textWrap: "balance" }
    },
    heading
  );
  return /* @__PURE__ */ React48.createElement(React48.Fragment, null, items.length >= 2 && /* @__PURE__ */ React48.createElement(
    Carousel,
    {
      heading: WidgetHeader,
      name: heading || "RewardsProgramCarousel",
      spaceBetweenCards: "oneAndHalf",
      titleMarginBottom: "one"
    },
    items.map(
      ({
        attributes: {
          badge,
          cta,
          image,
          imageAltText,
          items: cardItems,
          heading: cardHeading,
          id,
          category
        }
      }, index) => /* @__PURE__ */ React48.createElement(
        StackLayout14,
        {
          css: {
            width: "384px",
            "@mobile": {
              width: "320px"
            }
          }
        },
        /* @__PURE__ */ React48.createElement(
          RewardsProgramProgressCard,
          {
            contentTextAlign: "top",
            imagePosition: "top",
            badge,
            cta,
            heading: cardHeading,
            image,
            imageAltText,
            items: cardItems,
            onClick: () => {
              var _a;
              return handleClickAnalytics({
                sub_product_area: (_a = badge == null ? void 0 : badge.body) == null ? void 0 : _a.toLowerCase(),
                sub_detail: cardHeading,
                carousel_name: heading,
                carousel_index: index,
                health_campaign_name: cardHeading,
                health_campaign_id: id,
                health_campaign_type: category
              });
            }
          }
        )
      )
    )
  ), items.length === 1 && /* @__PURE__ */ React48.createElement(StackLayout14, { spacing: "$one" }, WidgetHeader, items.map((item, index) => /* @__PURE__ */ React48.createElement(
    RewardsProgramProgressCard,
    {
      badge: item.attributes.badge,
      cta: item.attributes.cta,
      heading: item.attributes.heading,
      image: item.attributes.image,
      imageAltText: item.attributes.imageAltText,
      items: item.attributes.items,
      onClick: () => {
        var _a, _b, _c, _d;
        return handleClickAnalytics({
          sub_product_area: (_c = (_b = (_a = item.attributes) == null ? void 0 : _a.badge) == null ? void 0 : _b.body) == null ? void 0 : _c.toLowerCase(),
          sub_detail: (_d = item.attributes) == null ? void 0 : _d.heading,
          carousel_name: heading,
          carousel_index: index,
          health_campaign_name: item.attributes.heading,
          health_campaign_id: item.attributes.id,
          health_campaign_type: item.attributes.category
        });
      }
    }
  ))));
};

// src/components/configurable-journey-experience/rewards-program-card-carousel-widget/rewards-program-card-carousel-widget.component.tsx
var RewardsProgramCardCarouselWidget = ({
  widget
}) => {
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(
    widget,
    HEALTH_JOURNEY_MASONRY_VERSION
  );
  if (isLoading)
    return /* @__PURE__ */ React49.createElement(SkeletonBox3, { width: "100%", height: "120px" });
  if (error || !widgetData || !(widgetData == null ? void 0 : widgetData.attributes)) {
    return null;
  }
  const props = widgetData.attributes;
  return /* @__PURE__ */ React49.createElement(RewardsProgramCardCarouselWidgetV2, __spreadValues({}, props));
};

// src/components/configurable-journey-experience/activities-stack-widget/activity-stack-widget.component.tsx
import React52 from "react";
import { StackLayout as StackLayout17 } from "@leagueplatform/genesis-core";
import { SkeletonBox as SkeletonBox4 } from "@leagueplatform/web-common-components";
import { captureError } from "@leagueplatform/observability";

// src/constants/configurable-journey-experience.constants.ts
var CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT = {
  _: "125px",
  phone: "200px",
  tablet: "256px"
};
var STANDALONE_ACTIVITIES_LIMIT_ONE = 1;
var STANDALONE_ACTIVITIES_LIMIT_VIEW_ALL = 50;
var API_VERSION = 2;

// src/hooks/use-actitivity-stack-widget.hook.ts
import { useGetWidgetData as useGetWidgetData2 } from "@leagueplatform/masonry-api";
var useActivityStackWidgetData = (widget, apiVersion) => useGetWidgetData2(widget, apiVersion);

// src/components/configurable-journey-experience/activities-stack-widget/activity-stack-header.component.tsx
import React50 from "react";
import {
  HeadingText as HeadingText9,
  StackLayout as StackLayout15,
  TextAction as TextAction4
} from "@leagueplatform/genesis-core";
import { LinkLegacy as RouterLink3 } from "@leagueplatform/routing";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import {
  PRODUCT_AREA as PRODUCT_AREA11,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA2,
  SCREEN_NAMES as SCREEN_NAMES9,
  trackAnalyticsEvent as trackAnalyticsEvent11,
  EVENT_NAME as EVENT_NAME11
} from "@leagueplatform/analytics";
import { useIntl as useIntl28 } from "@leagueplatform/locales";
var ActivityStackHeader = ({
  heading
}) => {
  const { formatMessage } = useIntl28();
  const trackViewAllClick = () => {
    trackAnalyticsEvent11(EVENT_NAME11.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA11.JOURNEY,
      sub_product_area: SUB_PRODUCT_AREA2.ACTIVITY_STACK_WIDGET,
      screen_name: SCREEN_NAMES9.HOMEPAGE,
      detail: "view all"
    });
  };
  return /* @__PURE__ */ React50.createElement(
    StackLayout15,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: {
        width: "100%"
      }
    },
    /* @__PURE__ */ React50.createElement(HeadingText9, { level: "3", size: "xl" }, heading),
    /* @__PURE__ */ React50.createElement(
      TextAction4,
      {
        as: RouterLink3,
        to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
        css: { textDecoration: "none" },
        onClick: trackViewAllClick
      },
      formatMessage({ id: "VIEW_ALL" })
    )
  );
};

// src/components/configurable-journey-experience/activities-stack-widget/activity-stack-content.component.tsx
import React51 from "react";
import { StackLayout as StackLayout16, UtilityText as UtilityText6 } from "@leagueplatform/genesis-core";
var ActivityStackContent = ({
  subheading,
  items
}) => /* @__PURE__ */ React51.createElement(React51.Fragment, null, /* @__PURE__ */ React51.createElement(StackLayout16, { orientation: "vertical" }, subheading && /* @__PURE__ */ React51.createElement(UtilityText6, null, subheading)), items == null ? void 0 : items.map((item) => /* @__PURE__ */ React51.createElement(
  PriorityActivityCard,
  {
    key: item.attributes.id,
    activity: item.attributes,
    headingLevel: "4"
  }
)));

// src/components/configurable-journey-experience/activities-stack-widget/activity-stack-widget.component.tsx
var ActivityStackWidget = ({ widget }) => {
  const {
    data: widgetData,
    isLoading,
    error
  } = useActivityStackWidgetData(widget, API_VERSION);
  if (isLoading)
    return /* @__PURE__ */ React52.createElement(SkeletonBox4, { "data-testid": "skeleton-loader", width: "100%", height: "120px" });
  if (error) {
    captureError(
      new Error(
        `Unable to fetch widget data for the activity stack widget: ${error}`
      )
    );
    return null;
  }
  if (!widgetData || !widgetData.attributes) {
    return null;
  }
  const { heading = "", subheading = "", items = [] } = widgetData.attributes;
  return /* @__PURE__ */ React52.createElement(StackLayout17, { orientation: "vertical", spacing: "$one" }, /* @__PURE__ */ React52.createElement(ActivityStackHeader, { heading }), /* @__PURE__ */ React52.createElement(ActivityStackContent, { subheading, items }));
};

// src/components/configurable-journey-experience/priority-activity-cta-card/priority-activity-cta-card.component.tsx
import React53 from "react";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES15,
  CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION9,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE11,
  ActivityCardEyebrow as ActivityCardEyebrow2,
  ComposableActivityCTACard
} from "@leagueplatform/health-journey-common";
var PriorityActivityCTACard = ({
  activity,
  headingLevel,
  ctaComponent,
  ctaText
}) => {
  const {
    id,
    name,
    activityImage,
    detailLevel,
    priority,
    campaignInfo,
    type,
    tagline
  } = activity;
  const displayImage = detailLevel !== CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION9.SIMPLE && activityImage;
  const imageProps = displayImage ? { image: activityImage, altText: "" } : void 0;
  const displayEyebrow = campaignInfo && campaignInfo.campaignType !== ACTIVITY_CAMPAIGN_TYPE11.SUGGESTED;
  const handleClickAnalytics2 = () => selectActivityAnalytics(activity);
  const ctaProps = {
    href: JOURNEY_ROUTES15.getActivityDetails(id, type),
    text: ctaText,
    component: ctaComponent,
    onClick: handleClickAnalytics2
  };
  return /* @__PURE__ */ React53.createElement(
    ComposableActivityCTACard,
    {
      id,
      body: /* @__PURE__ */ React53.createElement(ActivityBody, { activity }),
      cta: ctaProps,
      eyebrow: displayEyebrow ? /* @__PURE__ */ React53.createElement(
        ActivityCardEyebrow2,
        {
          iconProps: eyebrowIconMap[campaignInfo.campaignType]()
        },
        campaignInfo.name
      ) : null,
      footer: /* @__PURE__ */ React53.createElement(PriorityActivityCardFooter, { activity }),
      headline: priorityHeadlineMap[priority](tagline),
      title: { text: name, level: headingLevel },
      image: imageProps
    }
  );
};

// src/components/masonry/program-overview/program-overview-masonry-register.tsx
import { MasonryDriverNodeRenderersRegistry } from "@leagueplatform/masonry";

// src/components/masonry/program-overview/program-header-renderer/program-header-renderer.component.tsx
import {
  Box as Box26,
  HeadingText as HeadingText10,
  Image as Image9,
  queryHelpers as queryHelpers3,
  StackLayout as StackLayout18,
  useMediaQuery as useMediaQuery3,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import { Badge as Badge6 } from "@leagueplatform/web-common-components";
import React54 from "react";

// src/components/masonry/program-overview/program-overview.constants.ts
var HEADER_MAX_WIDTH = "792px";
var HEADER_IMAGE_MAX_HEIGHT = "445px";
var PROGRAM_OVERVIEW_PAGE_LAYOUT_MAX_WIDTH = "1200px";

// src/components/masonry/program-overview/program-header-renderer/program-header-renderer.component.tsx
function ProgramHeaderRenderer({
  heading,
  image,
  imageAltText,
  badge
}) {
  const isMobile = useMediaQuery3(queryHelpers3.down("tablet"));
  return /* @__PURE__ */ React54.createElement(
    StackLayout18,
    {
      horizontalAlignment: isMobile ? "center" : "start",
      css: { maxWidth: HEADER_MAX_WIDTH, textAlign: "center" },
      spacing: "$one"
    },
    /* @__PURE__ */ React54.createElement(Box26, { css: { maxHeight: HEADER_IMAGE_MAX_HEIGHT, marginBottom: "$half" } }, /* @__PURE__ */ React54.createElement(
      Image9,
      {
        src: image,
        alt: imageAltText,
        css: { height: "100%", width: "100%" }
      }
    )),
    badge && /* @__PURE__ */ React54.createElement(
      Badge6,
      {
        css: {
          borderRadius: "$small",
          backgroundColor: `$${badge.badgeBackgroundColor}`
        },
        iconTextProps: {
          iconProps: {
            icon: badge.image,
            label: badge.imageAltText
          },
          text: /* @__PURE__ */ React54.createElement(UtilityText7, { emphasis: "emphasized", size: "eyebrow" }, badge.body)
        }
      }
    ),
    /* @__PURE__ */ React54.createElement(HeadingText10, { size: isMobile ? "xl" : "xxl", level: isMobile ? "2" : "1" }, heading)
  );
}

// src/components/masonry/program-overview/program-sidebar-renderer/program-sidebar-renderer.component.tsx
import { Box as Box27, queryHelpers as queryHelpers4, useMediaQuery as useMediaQuery4 } from "@leagueplatform/genesis-core";
import { MasonryVerticalLayoutRenderer } from "@leagueplatform/masonry-renderers";
import React55 from "react";
function ProgramSidebarRenderer({
  isVisible,
  items,
  nodeId,
  nodeData,
  rootElementRef
}) {
  const isMobile = useMediaQuery4(queryHelpers4.down("tablet"));
  if (isMobile)
    return null;
  return /* @__PURE__ */ React55.createElement(
    Box27,
    {
      css: {
        borderRadius: "$card",
        border: "1px",
        borderColor: "$onSurfaceBorderSubdued",
        padding: "$oneAndHalf",
        borderStyle: "solid"
      }
    },
    /* @__PURE__ */ React55.createElement(
      MasonryVerticalLayoutRenderer,
      {
        isVisible,
        items,
        nodeId,
        nodeData,
        rootElementRef
      }
    )
  );
}

// src/components/masonry/program-overview/program-footer-renderer/program-footer-renderer.component.tsx
import { queryHelpers as queryHelpers5, useMediaQuery as useMediaQuery5 } from "@leagueplatform/genesis-core";
import { MasonryVerticalLayoutRenderer as MasonryVerticalLayoutRenderer2 } from "@leagueplatform/masonry-renderers";
import React56 from "react";
function ProgramFooterRenderer({
  isVisible,
  items,
  nodeId,
  nodeData,
  rootElementRef
}) {
  const isMobile = useMediaQuery5(queryHelpers5.down("tablet"));
  if (!isMobile)
    return null;
  return /* @__PURE__ */ React56.createElement(
    MasonryVerticalLayoutRenderer2,
    {
      isVisible,
      items,
      nodeId,
      nodeData,
      rootElementRef
    }
  );
}

// src/components/masonry/program-overview/program-progress-renderer/program-progress-renderer.component.tsx
import {
  Box as Box28,
  queryHelpers as queryHelpers6,
  StackLayout as StackLayout19,
  useMediaQuery as useMediaQuery6,
  UtilityText as UtilityText8
} from "@leagueplatform/genesis-core";
import { ProgressBar as ProgressBar4 } from "@leagueplatform/web-common-components";
import React57 from "react";
function ProgramProgressRenderer({
  type,
  activityAndPointsDetails,
  progressBar
}) {
  const isMobile = useMediaQuery6(queryHelpers6.down("tablet"));
  if (!isMobile)
    return null;
  return /* @__PURE__ */ React57.createElement(
    StackLayout19,
    {
      css: {
        paddingBottom: "$oneAndHalf",
        paddingX: "$two",
        height: "fit-content",
        width: "100%"
      },
      spacing: "$one"
    },
    type === "activityAndPointsDetails" && activityAndPointsDetails && /* @__PURE__ */ React57.createElement(
      StackLayout19,
      {
        horizontalAlignment: "center",
        orientation: "horizontal",
        spacing: "$none",
        css: { width: "100%" }
      },
      /* @__PURE__ */ React57.createElement(UtilityText8, { emphasis: "base", size: "xs" }, activityAndPointsDetails.map((details) => details.body).join(" \u2022 "))
    ),
    type === "progressBar" && progressBar && /* @__PURE__ */ React57.createElement(
      StackLayout19,
      {
        horizontalAlignment: "center",
        spacing: "$half",
        css: { width: "100%" }
      },
      /* @__PURE__ */ React57.createElement(UtilityText8, { emphasis: "base", size: "xs" }, progressBar.currentText),
      /* @__PURE__ */ React57.createElement(Box28, { css: { width: "100%" } }, /* @__PURE__ */ React57.createElement(
        ProgressBar4,
        {
          customBarFillColor: "input.border.success",
          current: progressBar.progress || 0
        }
      ))
    )
  );
}

// src/components/masonry/program-overview/program-progress-sidebar-renderer/program-progress-sidebar-renderer.component.tsx
import {
  Box as Box29,
  Icon as Icon4,
  StackLayout as StackLayout20,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";
import { ProgressBar as ProgressBar5 } from "@leagueplatform/web-common-components";
import React58 from "react";
function ProgramProgressSidebarRenderer({
  type,
  activityAndPointsDetails,
  progressBar
}) {
  return /* @__PURE__ */ React58.createElement(
    StackLayout20,
    {
      css: {
        height: "fit-content",
        width: "100%"
      },
      spacing: "$one"
    },
    type === "activityAndPointsDetails" && activityAndPointsDetails && /* @__PURE__ */ React58.createElement(
      StackLayout20,
      {
        horizontalAlignment: "start",
        orientation: "vertical",
        spacing: "$one",
        css: { width: "100%" }
      },
      activityAndPointsDetails.map((details) => /* @__PURE__ */ React58.createElement(
        StackLayout20,
        {
          horizontalAlignment: "start",
          orientation: "horizontal",
          spacing: "$half",
          css: { width: "100%" }
        },
        /* @__PURE__ */ React58.createElement(Icon4, { icon: details.image, label: details.imageAltText }),
        /* @__PURE__ */ React58.createElement(UtilityText9, null, details.body)
      ))
    ),
    type === "progressBar" && progressBar && /* @__PURE__ */ React58.createElement(StackLayout20, { spacing: "$half", css: { width: "100%" } }, /* @__PURE__ */ React58.createElement(UtilityText9, { emphasis: "base", size: "xs" }, progressBar.currentText), /* @__PURE__ */ React58.createElement(Box29, { css: { width: "100%" } }, /* @__PURE__ */ React58.createElement(
      ProgressBar5,
      {
        customBarFillColor: "input.border.success",
        current: progressBar.progress || 0
      }
    )))
  );
}

// src/components/masonry/program-overview/program-overview-masonry-register.tsx
function ProgramOverviewMasonryRegister() {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journey",
    "programProgress",
    ProgramProgressRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journey",
    "programProgressSidebar",
    ProgramProgressSidebarRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journey",
    "programHeader",
    ProgramHeaderRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journey_program_overview_sidebar",
    "verticalLayout",
    ProgramSidebarRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journey_program_overview_footer",
    "verticalLayout",
    ProgramFooterRenderer
  );
}

// src/init-masonry-registry.ts
var HEALTH_JOURNEY_NAMESPACE = "health_journey";
var NODE_TYPE_RECOMMENDED_CONTENT = "recommendedContentCard";
var NODE_TYPE_HERO_BANNER = "heroBanner";
var CARE_LIBRARY_TOPIC_NAMESPACE = "care_library_topic";
var HEALTH_JOURNEY_NODE_TYPES = {
  HEALTH_JOURNEY: "health_journey",
  ACTIVITIES_WIDGET: "activity_stack",
  PRIORITY_ACTIVITY_CTA_CARD: "priority-activity-cta-card",
  PRIORITY_ACTIVITIES_LIST_WIDGET: "get_active_user_health_activities_by_priority",
  ACTIVITY_CARD: "activityCard"
};
var initMasonryRegistry = () => {
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.HEALTH_JOURNEY,
    HealthJourneyHome
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITIES_WIDGET,
    ActivityStackWidgetV2
  );
  MasonryDriverNodeRenderersRegistry2.registerRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.PRIORITY_ACTIVITY_CTA_CARD,
    PriorityActivityCTACard
  );
  MasonryDriverNodeRenderersRegistry2.registerRenderer(
    "default",
    NODE_TYPE_RECOMMENDED_CONTENT,
    RecommendedContentCardNodeRenderer
  );
  MasonryDriverNodeRenderersRegistry2.overrideRenderer(
    CARE_LIBRARY_TOPIC_NAMESPACE,
    NODE_TYPE_HERO_BANNER,
    MasonryHeroBannerRendererOverride
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.PRIORITY_ACTIVITIES_LIST_WIDGET,
    PriorityActivitiesWidget
  );
  MasonryDriverNodeRenderersRegistry2.registerRenderer(
    "default",
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITY_CARD,
    activity_card_node_renderer_default
  );
  MasonryDriverNodeRenderersRegistry2.registerRenderer(
    "journeyActivitiesHeader",
    "heroBanner",
    ViewAllHeaderRenderer
  );
  MasonryDriverActionController.registerHandler(
    "deeplink",
    "journey_activities",
    () => {
    }
  );
  ProgramOverviewMasonryRegister();
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/common/asset-map.ts
import alarmClock from "./assets/clock-alarm.svg";
import alertUser from "./assets/alert-user.png";
import alternativeSuccessStatus from "./assets/checkmark-circle-icon-alternative.svg";
import arrowLeft from "./assets/arrow-right-dark.svg";
import arrowRight from "./assets/arrow-right.svg";
import calendar from "./assets/calendar.svg";
import challengeToken from "./assets/challenge-token.svg";
import challengeTokenSubdued from "./assets/challenge-token-subdued.svg";
import heartRateUp from "./assets/monitor-heart-rate-up.png";
import highPriorityIcon from "./assets/high-priority-icon.svg";
import leagueLogo from "./assets/league-logo.svg";
import leagueLogoSubdued from "./assets/league-logo-subdued.svg";
import requiredIcon from "./assets/requiredIcon.svg";
import completeByIcon from "./assets/completeByIcon.svg";
import rewardsPointsIcon from "./assets/rewardPointsIcon.svg";
import rewardsProgramIcon from "./assets/rewardsProgramIcon.svg";
import activityPointsIcon from "./assets/activityPointsIcon.svg";
import removeActivityImage from "./assets/remove-activity.png";
import emptyStateAchievements from "./assets/trophyIcon.png";
import emptyStatePrograms from "./assets/empty-state-programs.svg";
import emptyStateRest from "./assets/empty-state-rest.svg";
import emptyStateProgress from "./assets/emptyStateHJ.png";
import emptyStateHistory from "./assets/emptyStateHistory.png";
import highFive from "./assets/high-five-hands.svg";
import journeyHeaderBackgroundImage2 from "./assets/journey-header-background-image.png";
import waveGoodbye from "./assets/leave-activity.svg";
import warningIcon from "./assets/warning-icon-orange.svg";

// src/components/minus-icon.js
import React59 from "react";
import { genesisStyled as genesisStyled14 } from "@leagueplatform/genesis-commons";

// src/common/plus-minus-icon-styles.js
import { css as css9 } from "@leagueplatform/genesis-commons";
var transitionTempo = "0.2s ease-out";
var plusMinusDisabledStyles = ({ disabled, theme: { colors } }) => css9({
  path: {
    fill: disabled ? `${colors.onSurface.text.subdued}` : `${colors.primary.text.default}`,
    transition: `fill ${transitionTempo}`
  }
});

// src/components/minus-icon.js
var Minus = (props) => /* @__PURE__ */ React59.createElement(
  "svg",
  __spreadValues({
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React59.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0002 6.60012C15.8286 6.60011 16.5002 7.27168 16.5002 8.10011C16.5001 8.92855 15.8286 9.60014 15.0001 9.60015L1.99999 9.60034C1.17156 9.60035 0.499987 8.92878 0.499999 8.10035C0.500011 7.27191 1.1716 6.60032 2.00004 6.60031L15.0002 6.60012Z",
      fill: "white"
    }
  )
);
var MinusIcon = genesisStyled14(Minus)(plusMinusDisabledStyles);

// src/components/plus-icon.js
import React60 from "react";
import { genesisStyled as genesisStyled15 } from "@leagueplatform/genesis-commons";
var Plus = (props) => /* @__PURE__ */ React60.createElement(
  "svg",
  __spreadValues({
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React60.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00004 1.50002C7.00005 0.671581 7.67164 -9.8648e-06 8.50008 -2.20337e-05C9.32851 -3.42025e-05 10.0001 0.671536 10.0001 1.49997L9.99988 14.5038C9.99987 15.3323 9.32828 16.0039 8.49984 16.0039C7.67141 16.0039 6.99984 15.3323 6.99985 14.5039L7.00004 1.50002Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React60.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0002 6.60012C15.8286 6.60011 16.5002 7.27168 16.5002 8.10011C16.5001 8.92855 15.8286 9.60014 15.0001 9.60015L1.99999 9.60034C1.17156 9.60035 0.499987 8.92878 0.499999 8.10035C0.500011 7.27191 1.1716 6.60032 2.00004 6.60031L15.0002 6.60012Z",
      fill: "white"
    }
  )
);
var PlusIcon = genesisStyled15(Plus)(plusMinusDisabledStyles);

// src/common/asset-map.ts
var {
  ALARM_CLOCK: ALARM_CLOCK2,
  ARROW_LEFT: ARROW_LEFT2,
  ARROW_RIGHT: ARROW_RIGHT2,
  CALENDAR,
  CHALLENGE_TOKEN,
  CHALLENGE_TOKEN_SUBDUED,
  HEART_RATE_UP: HEART_RATE_UP2,
  HIGH_PRIORITY_ICON: HIGH_PRIORITY_ICON2,
  JOURNEY_HEADER_BACKGROUND_IMAGE,
  LEAGUE_LOGO,
  LEAGUE_LOGO_SUBDUED,
  MINUS,
  MOBILE_ALERT_USER: MOBILE_ALERT_USER2,
  PLUS,
  SUCCESS_STATUS_ALTERNATIVE,
  REQUIRED_ICON: REQUIRED_ICON2,
  COMPLETE_BY_ICON: COMPLETE_BY_ICON2,
  REWARDS_POINTS_ICON: REWARDS_POINTS_ICON2,
  REWARDS_PROGRAM_ICON: REWARDS_PROGRAM_ICON2,
  ACTIVITY_POINTS_ICON: ACTIVITY_POINTS_ICON2,
  REMOVE_ACTIVITY_IMAGE,
  // TODO – JRNY – Update tokens to reflect the source-of-truth when they become available
  EMPTY_STATE_ACHIEVEMENTS,
  EMPTY_STATE_PROGRAMS,
  EMPTY_STATE_PROGRESS: EMPTY_STATE_PROGRESS2,
  EMPTY_STATE_REST,
  EMPTY_STATE_HISTORY,
  HIGH_FIVE,
  WARNING_ICON,
  WAVE_GOODBYE
} = HEALTH_JOURNEY_ASSET_KEYS;
var HEALTH_JOURNEY_ASSET_MAP = {
  [ALARM_CLOCK2]: alarmClock,
  [ARROW_LEFT2]: arrowLeft,
  [ARROW_RIGHT2]: arrowRight,
  [CALENDAR]: calendar,
  [CHALLENGE_TOKEN]: challengeToken,
  [CHALLENGE_TOKEN_SUBDUED]: challengeTokenSubdued,
  [HEART_RATE_UP2]: heartRateUp,
  [HIGH_PRIORITY_ICON2]: highPriorityIcon,
  [LEAGUE_LOGO]: leagueLogo,
  [LEAGUE_LOGO_SUBDUED]: leagueLogoSubdued,
  [MINUS]: MinusIcon,
  [MOBILE_ALERT_USER2]: alertUser,
  [PLUS]: PlusIcon,
  [SUCCESS_STATUS_ALTERNATIVE]: alternativeSuccessStatus,
  [REQUIRED_ICON2]: requiredIcon,
  [COMPLETE_BY_ICON2]: completeByIcon,
  [REWARDS_POINTS_ICON2]: rewardsPointsIcon,
  [REWARDS_PROGRAM_ICON2]: rewardsProgramIcon,
  [ACTIVITY_POINTS_ICON2]: activityPointsIcon,
  [REMOVE_ACTIVITY_IMAGE]: removeActivityImage,
  // TODO – JRNY – Update tokens to reflect the source-of-truth when they become available
  [EMPTY_STATE_ACHIEVEMENTS]: emptyStateAchievements,
  [EMPTY_STATE_PROGRAMS]: emptyStatePrograms,
  [EMPTY_STATE_PROGRESS2]: emptyStateProgress,
  [EMPTY_STATE_REST]: emptyStateRest,
  [EMPTY_STATE_HISTORY]: emptyStateHistory,
  [HIGH_FIVE]: highFive,
  [JOURNEY_HEADER_BACKGROUND_IMAGE]: journeyHeaderBackgroundImage2,
  [WARNING_ICON]: warningIcon,
  [WAVE_GOODBYE]: waveGoodbye
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(HEALTH_JOURNEY_ASSET_MAP);
};

// src/health-journey-routes.tsx
import * as React166 from "react";
import { Routes as Routes3, Route as Route3, useNestedAbsoluteRoute } from "@leagueplatform/routing";
import { getModulePath as getModulePath6, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES6 } from "@leagueplatform/core";
import { useFeatureFlagQuery as useFeatureFlagQuery21 } from "@leagueplatform/user-profile-api";
import { ENABLE_NEW_JOURNEY_EXPERIENCE as ENABLE_NEW_JOURNEY_EXPERIENCE2 } from "@leagueplatform/health-journey-common";
import { LoadingIndicator as LoadingIndicator6 } from "@leagueplatform/web-common-components";
import { HealthProgramsRoutes } from "@leagueplatform/health-programs";

// src/components/configurable-journey-experience/configurable-journey-experience.component.tsx
import React81, { useEffect as useEffect8, useMemo as useMemo7, useState as useState6 } from "react";
import {
  useLocationLegacy as useLocation5,
  useNavigateLegacy as useNavigate7
} from "@leagueplatform/routing";

// src/components/configurable-journey-experience/progress-tab/progress-tab.component.tsx
import React70 from "react";
import Masonry from "@leagueplatform/masonry";
import { PRODUCT_AREA as PRODUCT_AREA17 } from "@leagueplatform/analytics";
import {
  ACHIEVEMENTS_WIDGET,
  CHALLENGES_LIST_WIDGET,
  COMPLETED_ACTIVITIES_CAROUSEL_WIDGET,
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION5,
  HEALTH_JOURNEY_MODULE_KEY,
  JOURNEY_PROGRESS_TAB_APP_ID,
  MISSED_ACTIVITIES_CAROUSEL_WIDGET,
  PROGRAMS_LIST_WIDGET,
  SCREEN_NAMES as SCREEN_NAMES15,
  STANDALONE_ACTIVITIES_WIDGET,
  CHALLENGES_AND_PROGRAMS_LIST_WIDGET,
  REWARD_PROGRAM_CAROUSEL
} from "@leagueplatform/health-journey-common";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { useIntl as useIntl36 } from "@leagueplatform/locales";

// src/components/configurable-journey-experience/activities-by-status/activities-by-status.component.tsx
import React61 from "react";
import {
  HeadingThree as HeadingThree4,
  Box as Box30,
  genesisStyled as genesisStyled16
} from "@leagueplatform/genesis-commons";
import { SkeletonBox as SkeletonBox5, Carousel as Carousel2 } from "@leagueplatform/web-common-components";
import { CAROUSEL_CONTENT_CARD_WIDTH } from "@leagueplatform/masonry-widgets";
import { JOURNEY_ROUTES as JOURNEY_ROUTES16 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl29 } from "@leagueplatform/locales";

// src/utils/view-all-activities-analytics.util.ts
import {
  EVENT_NAME as EVENT_NAME12,
  PRODUCT_AREA as PRODUCT_AREA12,
  trackAnalyticsEvent as trackAnalyticsEvent12
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES10 } from "@leagueplatform/health-journey-common";
var viewAllActivitiesAnalytics = (sub_detail) => trackAnalyticsEvent12(EVENT_NAME12.BUTTON_CLICKED, {
  product_area: PRODUCT_AREA12.JOURNEY,
  screen_name: SCREEN_NAMES10.PROGRESS_PAGE,
  sub_detail,
  detail: "view all"
});

// src/components/configurable-journey-experience/activities-by-status/activities-by-status.component.tsx
var CarouselWrapper = genesisStyled16(Box30)`
  li {
    width: 100%;
    min-width: ${CAROUSEL_CONTENT_CARD_WIDTH};
    width: ${CAROUSEL_CONTENT_CARD_WIDTH};
  }
`;
var ActivitiesByStatus = ({ statusType }) => {
  const { formatMessage, $tmap } = useIntl29();
  const activityStatuses = getActivityStatusesArray(statusType);
  const {
    data: activities,
    isLoading,
    isError
  } = useActivitiesByActivityStatus({ activityStatuses });
  if (isLoading)
    return /* @__PURE__ */ React61.createElement(
      SkeletonBox5,
      {
        backgroundColor: "interactive.background.disabled",
        height: "200px",
        marginBottom: "one"
      }
    );
  const activitiesByStatus = activities == null ? void 0 : activities.userHealthActivities;
  const sectionTitle = $tmap({
    completed: "COMPLETED_ACTIVITIES",
    missed: "MISSED_ACTIVITIES"
  })(statusType);
  const linkAriaLabel = $tmap({
    completed: "SEE_MORE_COMPLETED_ACTIVITIES_ARIA_LABEL",
    missed: "SEE_MORE_MISSED_ACTIVITIES_ARIA_LABEL"
  })(statusType);
  if (isError || !(activitiesByStatus == null ? void 0 : activitiesByStatus.length)) {
    return null;
  }
  const linkUrl = statusType === "completed" ? JOURNEY_ROUTES16.getCompletedActivityHistory() : JOURNEY_ROUTES16.getMissedActivityHistory();
  const displaySeeMoreLink = activitiesByStatus.length > 3;
  return /* @__PURE__ */ React61.createElement(CarouselWrapper, null, /* @__PURE__ */ React61.createElement(
    Carousel2,
    __spreadValues({
      heading: /* @__PURE__ */ React61.createElement(HeadingThree4, { as: "h2" }, sectionTitle),
      name: sectionTitle,
      spaceBetweenCards: "oneAndHalf"
    }, displaySeeMoreLink && {
      linkAriaLabel,
      linkCta: formatMessage({ id: "SEE_MORE_ACTIVITIES" }),
      linkUrl,
      linkOnClick: () => viewAllActivitiesAnalytics(statusType)
    }),
    activitiesByStatus.slice(0, 3).map((activity) => /* @__PURE__ */ React61.createElement(
      ConfigurableActivityCard,
      {
        as: "div",
        activity,
        key: activity.id,
        height: "100%",
        activityHeadingLevel: "h3"
      }
    ))
  ));
};

// src/components/configurable-journey-experience/achievements-widget/achievements-widget.component.tsx
import React62 from "react";
import { BadgeImage } from "@leagueplatform/rewards-achievements";
import { useIntl as useIntl30 } from "@leagueplatform/locales";
import {
  Flex as Flex19,
  Caption as Caption3,
  Box as Box31,
  HeadingThree as HeadingThree5,
  SubtitleTwo,
  BodyOne as BodyOne2,
  HeadingFour as HeadingFour6
} from "@leagueplatform/genesis-commons";
import { HeadingText as HeadingText11, StackLayout as StackLayout21 } from "@leagueplatform/genesis-core";
import {
  EVENT_NAME as EVENT_NAME13,
  PRODUCT_AREA as PRODUCT_AREA13,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA3,
  trackAnalyticsEvent as trackAnalyticsEvent13
} from "@leagueplatform/analytics";
import {
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION2,
  JOURNEY_ROUTES as JOURNEY_ROUTES17,
  SCREEN_NAMES as SCREEN_NAMES11
} from "@leagueplatform/health-journey-common";
import {
  useGetWidgetData as useGetWidgetData3
} from "@leagueplatform/masonry-api";
import {
  GenesisRouterLink as GenesisRouterLink3,
  SkeletonBox as SkeletonBox6
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset11 } from "@leagueplatform/asset-config";
var AchievementsWidget = ({ widget }) => {
  var _a;
  const { formatMessage, $tifelse } = useIntl30();
  const {
    data: achievementsData,
    isLoading,
    error
  } = useGetWidgetData3(
    widget,
    HEALTH_JOURNEY_MASONRY_VERSION2
  );
  const { EMPTY_STATE_ACHIEVEMENTS: EMPTY_STATE_ACHIEVEMENTS2 } = HEALTH_JOURNEY_ASSET_KEYS;
  const emptyStateImgUrl = handleStaticAsset11(
    EMPTY_STATE_ACHIEVEMENTS2
  );
  if (isLoading) {
    return /* @__PURE__ */ React62.createElement(
      SkeletonBox6,
      {
        backgroundColor: "interactive.background.disabled",
        height: "100px",
        "data-testid": "skeleton-loader"
      }
    );
  }
  const isError = error || !((_a = achievementsData == null ? void 0 : achievementsData.attributes) == null ? void 0 : _a.items);
  if (isError)
    return null;
  const { items: recentAchievements } = achievementsData.attributes;
  const multipleAchievements = recentAchievements.length > 1;
  const isEmptyState = !recentAchievements.length;
  if (isEmptyState)
    return /* @__PURE__ */ React62.createElement(StackLayout21, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React62.createElement(HeadingText11, { size: "xl", level: "2" }, formatMessage({
      id: "RECENT_ACHIEVEMENTS"
    })), /* @__PURE__ */ React62.createElement(
      ConfigurableJourneyEmptyStateCard,
      {
        heading: formatMessage({
          id: "ACHIEVEMENTS_EMPTY_STATE_HEADER"
        }),
        description: formatMessage({
          id: "ACHIEVEMENTS_EMPTY_STATE_DESCRIPTION"
        }),
        imgSrc: emptyStateImgUrl,
        headingLevel: "2"
      }
    ));
  const viewAllAchievementsOnClick = () => trackAnalyticsEvent13(EVENT_NAME13.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA13.REWARDS,
    sub_product_area: SUB_PRODUCT_AREA3.ACHIEVEMENTS,
    screen_name: SCREEN_NAMES11.PROGRESS_PAGE,
    detail: "view all achievements"
  });
  return /* @__PURE__ */ React62.createElement(React62.Fragment, null, /* @__PURE__ */ React62.createElement(Flex19, { justifyContent: "space-between" }, /* @__PURE__ */ React62.createElement(HeadingThree5, { as: "h2", marginBottom: "one" }, formatMessage({
    id: "RECENT_ACHIEVEMENTS"
  })), /* @__PURE__ */ React62.createElement(
    SubtitleTwo,
    {
      as: GenesisRouterLink3,
      to: JOURNEY_ROUTES17.achievementsHome(),
      onClick: viewAllAchievementsOnClick,
      color: "interactive.action.primary",
      display: ["flex", "flex", "none"],
      "aria-label": formatMessage({ id: "VIEW_ALL_ACHIEVEMENTS" })
    },
    formatMessage({
      id: "VIEW_ALL"
    })
  )), /* @__PURE__ */ React62.createElement(
    Flex19,
    {
      borderRadius: "large",
      boxShadow: "card",
      marginBottom: "one",
      width: "100%"
    },
    /* @__PURE__ */ React62.createElement(
      Flex19,
      {
        alignItems: "center",
        textAlign: "center",
        justifyContent: "space-evenly",
        padding: {
          phone: "none",
          tablet: "oneAndHalf"
        },
        minWidth: "50%",
        flexGrow: 1
      },
      /* @__PURE__ */ React62.createElement(
        Flex19,
        {
          backgroundColor: "highlight.background.subdued",
          borderRadius: "large",
          height: "100%",
          width: "100%",
          padding: "one",
          flexDirection: { _: "column", tablet: "row" },
          justifyContent: "center",
          alignItems: "center"
        },
        /* @__PURE__ */ React62.createElement(
          SubtitleTwo,
          {
            as: "h3",
            width: "100%",
            color: "onSurface.text.primary",
            display: { _: "block", tablet: "none" },
            justifyContent: "center",
            marginBottom: "one"
          },
          formatMessage({
            id: "ACHIEVEMENTS_BANNER_HEADER"
          })
        ),
        /* @__PURE__ */ React62.createElement(
          StackLayout21,
          {
            orientation: "horizontal",
            horizontalAlignment: "stretch",
            spacing: "$oneAndHalf"
          },
          recentAchievements.map((recentAchievement) => /* @__PURE__ */ React62.createElement(Box31, { key: recentAchievement.title }, /* @__PURE__ */ React62.createElement(
            BadgeImage,
            {
              imageUrl: recentAchievement.image,
              isDisabled: false,
              label: recentAchievement.image_alt_text
            }
          ), /* @__PURE__ */ React62.createElement(
            Caption3,
            {
              color: "onSurface.text.primary",
              alignSelf: "flex-start",
              width: "100%"
            },
            recentAchievement.title
          )))
        )
      )
    ),
    /* @__PURE__ */ React62.createElement(
      Box31,
      {
        minWidth: "50%",
        display: { _: "none", tablet: "block" },
        padding: { phone: "none", tablet: "oneAndHalf" }
      },
      /* @__PURE__ */ React62.createElement(HeadingFour6, { as: "h3", color: "onSurface.text.primary" }, formatMessage({
        id: "ACHIEVEMENTS_BANNER_HEADER"
      })),
      /* @__PURE__ */ React62.createElement(
        BodyOne2,
        {
          marginTop: "half",
          marginBottom: "oneAndHalf",
          color: "onSurface.text.subdued"
        },
        $tifelse(
          multipleAchievements,
          "MULTIPLE_ACHIEVEMENT_DESCRIPTION",
          "SINGLE_ACHIEVEMENT_DESCRIPTION"
        )
      ),
      /* @__PURE__ */ React62.createElement(
        SubtitleTwo,
        {
          as: GenesisRouterLink3,
          to: JOURNEY_ROUTES17.achievementsHome(),
          color: "interactive.action.primary",
          minWidth: "fit-content",
          onClick: viewAllAchievementsOnClick,
          "aria-label": formatMessage({ id: "VIEW_ALL_ACHIEVEMENTS" })
        },
        formatMessage({
          id: "VIEW_ALL_ACHIEVEMENTS"
        })
      )
    )
  ));
};

// src/components/configurable-journey-experience/campaigns-list-widget/campaigns-list-widget.component.tsx
import React65 from "react";
import { useIntl as useIntl33 } from "@leagueplatform/locales";
import { Box as Box33, HeadingThree as HeadingThree7 } from "@leagueplatform/genesis-commons";
import {
  HEALTH_JOURNEY_COMMON_ASSET_KEYS as HEALTH_JOURNEY_COMMON_ASSET_KEYS2,
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION3,
  JOURNEY_ROUTES as JOURNEY_ROUTES19,
  ENABLE_NEW_JOURNEY_PROGRESS
} from "@leagueplatform/health-journey-common";
import {
  useGetWidgetData as useGetWidgetData4
} from "@leagueplatform/masonry-api";
import { SkeletonBox as SkeletonBox7 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset12 } from "@leagueplatform/asset-config";
import { useFeatureFlagQuery as useFeatureFlagQuery13 } from "@leagueplatform/user-profile-api";

// src/components/configurable-journey-experience/campaign-progress-card/campaign-progress-card.component.tsx
import React64 from "react";
import { useIntl as useIntl32 } from "@leagueplatform/locales";
import { Flex as Flex21, Box as Box32, SubtitleTwo as SubtitleTwo3 } from "@leagueplatform/genesis-commons";

// src/types/configurable-health-program.types.ts
import camelcaseKeys4 from "camelcase-keys";
function camelcaseCampaign(campaign) {
  return camelcaseKeys4(campaign, { deep: true });
}

// src/components/configurable-journey-experience/campaign-progress/campaign-progress.component.tsx
import React63 from "react";
import { useIntl as useIntl31 } from "@leagueplatform/locales";
import {
  Flex as Flex20,
  HeadingThree as HeadingThree6,
  BodyOne as BodyOne3,
  SubtitleTwo as SubtitleTwo2,
  BodyOneSecondary as BodyOneSecondary4
} from "@leagueplatform/genesis-commons";
import {
  EVENT_NAME as EVENT_NAME14,
  PRODUCT_AREA as PRODUCT_AREA14,
  trackAnalyticsEvent as trackAnalyticsEvent14
} from "@leagueplatform/analytics";
import {
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE12,
  JOURNEY_ROUTES as JOURNEY_ROUTES18,
  SCREEN_NAMES as SCREEN_NAMES12
} from "@leagueplatform/health-journey-common";
import {
  GenesisRouterLink as GenesisRouterLink4,
  ProgressBar as ProgressBar6
} from "@leagueplatform/web-common-components";
var { CHALLENGE: CHALLENGE8 } = ACTIVITY_CAMPAIGN_TYPE12;
function CampaignProgress({ program }) {
  const {
    activityStatusCounts: { completed: completedActivitiesCount },
    campaignType,
    completedActivityProgressPercentage,
    programId,
    name: programName,
    totalActivitiesCount
  } = program;
  const { formatMessage } = useIntl31();
  const VIEW_DETAILS_ID = `${programId}_view_details`;
  const VIEW_DETAILS_LABELLEDBY = `${VIEW_DETAILS_ID} ${programId}`;
  const viewDetailsOnClick = () => trackAnalyticsEvent14(EVENT_NAME14.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA14.JOURNEY,
    screen_name: SCREEN_NAMES12.PROGRESS_PAGE,
    detail: "view health campaign",
    health_campaign_name: programName,
    health_campaign_id: programId,
    health_campaign_type: campaignType
  });
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    Flex20,
    {
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: "half"
    },
    /* @__PURE__ */ React63.createElement(HeadingThree6, { marginInlineEnd: "one", id: programId }, programName),
    /* @__PURE__ */ React63.createElement(
      SubtitleTwo2,
      {
        as: GenesisRouterLink4,
        to: campaignType === CHALLENGE8 ? JOURNEY_ROUTES18.getChallengeDetails(programId) : JOURNEY_ROUTES18.getProgramDetails(programId),
        id: VIEW_DETAILS_ID,
        "aria-labelledby": VIEW_DETAILS_LABELLEDBY,
        color: "interactive.action.primary",
        minWidth: "fit-content",
        onClick: viewDetailsOnClick
      },
      formatMessage({ id: "VIEW_DETAILS" })
    )
  ), /* @__PURE__ */ React63.createElement(
    BodyOne3,
    {
      as: "span",
      color: "onSurface.text.success",
      fontWeight: "bold",
      marginInlineEnd: "quarter"
    },
    formatMessage(
      { id: "X_PERCENTAGE" },
      { percent: completedActivityProgressPercentage }
    )
  ), /* @__PURE__ */ React63.createElement(BodyOneSecondary4, { as: "span", marginBottom: "quarter" }, formatMessage(
    { id: "X_OF_Y_ACTIVITIES" },
    {
      completed: completedActivitiesCount,
      total: totalActivitiesCount
    }
  )), /* @__PURE__ */ React63.createElement(
    ProgressBar6,
    {
      current: completedActivitiesCount,
      total: totalActivitiesCount,
      customBarBackgroundColor: "success.background.subdued",
      customBarFillColor: "success.icon"
    }
  ));
}

// src/components/configurable-journey-experience/campaign-progress-card/campaign-progress-card.component.tsx
var CampaignProgressCard = ({
  campaign
}) => {
  const { formatMessage } = useIntl32();
  const camelcasedCampaign = camelcaseCampaign(campaign);
  const { program, nextActivity } = camelcasedCampaign;
  return (
    // TODO: switch to elevated card genesis core component
    /* @__PURE__ */ React64.createElement(
      Flex21,
      {
        as: "li",
        flexDirection: { _: "column", tablet: "row" },
        borderRadius: "large",
        boxShadow: "card",
        padding: "oneAndHalf",
        marginBottom: "one"
      },
      /* @__PURE__ */ React64.createElement(
        Box32,
        {
          width: { _: "100%", tablet: "50%", laptop: "40%" },
          paddingInlineEnd: { _: "none", tablet: "oneAndHalf" },
          borderInlineEndStyle: { tablet: "solid" },
          borderInlineEndColor: { tablet: "onSurface.border.subdued" },
          borderInlineEndWidth: { tablet: "thin" }
        },
        /* @__PURE__ */ React64.createElement(CampaignProgress, { program })
      ),
      /* @__PURE__ */ React64.createElement(
        Box32,
        {
          width: { _: "100%", tablet: "50%", laptop: "60%" },
          paddingInlineStart: { _: "none", tablet: "oneAndHalf" }
        },
        /* @__PURE__ */ React64.createElement(
          SubtitleTwo3,
          {
            as: "h4",
            color: "onSurface.text.subdued",
            fontWeight: "semibold",
            marginTop: { _: "one", tablet: "quarter" },
            marginBottom: { _: "half", tablet: "one" }
          },
          formatMessage({ id: "NEXT_ACTIVITY" })
        ),
        nextActivity && /* @__PURE__ */ React64.createElement(
          ConfigurableActivityCard,
          {
            as: "div",
            activity: nextActivity,
            noBottomMargin: true,
            activityHeadingLevel: "h5"
          }
        )
      )
    )
  );
};

// src/components/configurable-journey-experience/campaigns-list-widget/campaigns-list-widget.component.tsx
var CampaignsListWidget = ({
  widget,
  campaignType
}) => {
  var _a, _b;
  const { formatMessage, $tifelse } = useIntl33();
  const { hasExploreTab } = useHealthJourneyConfig();
  const { isLoading, error, data } = useGetWidgetData4(
    widget,
    HEALTH_JOURNEY_MASONRY_VERSION3
  );
  const { EMPTY_STATE_CONFIGURABLE_ACTIVITIES } = HEALTH_JOURNEY_COMMON_ASSET_KEYS2;
  const emptyStateImgUrl = handleStaticAsset12(
    EMPTY_STATE_CONFIGURABLE_ACTIVITIES
  );
  const { data: isNewJourneyProgressEnabled } = useFeatureFlagQuery13(
    ENABLE_NEW_JOURNEY_PROGRESS
  );
  if (isNewJourneyProgressEnabled) {
    return null;
  }
  if (isLoading)
    return /* @__PURE__ */ React65.createElement(
      SkeletonBox7,
      {
        backgroundColor: "interactive.background.disabled",
        height: "200px",
        marginBottom: "one",
        "data-testid": "skeleton-loader"
      }
    );
  const isErrorState = error || !(data == null ? void 0 : data.attributes) || // If there are no challenges, don't display anything. Don't want to display empty state, since there may be no challenges to sign up for.
  campaignType === "challenge" && !((_b = (_a = data == null ? void 0 : data.attributes) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  if (isErrorState)
    return null;
  const { items: campaignList } = data.attributes;
  const isEmptyState = campaignType === "opt-in" && !(campaignList == null ? void 0 : campaignList.length);
  if (isEmptyState)
    return /* @__PURE__ */ React65.createElement(
      ConfigurableJourneyEmptyStateCard,
      {
        eyebrow: formatMessage({
          id: "NO_CONFIGURABLE_PROGRESS_EMPTY_STATE_EYEBROW"
        }),
        heading: formatMessage({
          id: "NO_CONFIGURABLE_PROGRESS_EMPTY_STATE_HEADING"
        }),
        headingLevel: "2",
        description: formatMessage({
          id: "NO_CONFIGURABLE_PROGRESS_EMPTY_STATE_DESCRIPTION"
        }),
        imgSrc: emptyStateImgUrl,
        ctaLabel: hasExploreTab ? formatMessage({ id: "EXPLORE_LIBRARY" }) : void 0,
        ctaHref: hasExploreTab ? JOURNEY_ROUTES19.programsHome() : void 0
      }
    );
  return /* @__PURE__ */ React65.createElement(React65.Fragment, null, /* @__PURE__ */ React65.createElement(HeadingThree7, { as: "h2" }, $tifelse(campaignType === "challenge", "CHALLENGES", "PROGRAMS")), /* @__PURE__ */ React65.createElement(Box33, { as: "ul", paddingTop: "threeQuarters" }, campaignList == null ? void 0 : campaignList.map((campaign) => /* @__PURE__ */ React65.createElement(
    CampaignProgressCard,
    {
      campaign,
      key: campaign.program.program_id
    }
  ))));
};

// src/components/configurable-journey-experience/standalone-activities-widget/standalone-activities-widget.component.tsx
import React66 from "react";
import {
  GenesisRouterLink as GenesisRouterLink5,
  SkeletonBox as SkeletonBox8
} from "@leagueplatform/web-common-components";
import {
  BodyOneSecondary as BodyOneSecondary5,
  BodyTwoSecondary as BodyTwoSecondary3,
  Box as Box34,
  HeadingThree as HeadingThree8,
  Flex as Flex22
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl34 } from "@leagueplatform/locales";

// src/hooks/use-get-user-standalone-activities.hook.tsx
import { useQuery as useQuery9 } from "react-query";
import {
  getUserStandaloneActivities,
  GET_USER_STANDALONE_ACTIVITIES_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import camelcaseKeys5 from "camelcase-keys";
var useGetUserStandaloneActivities = ({ limit }) => useQuery9(
  [GET_USER_STANDALONE_ACTIVITIES_MESSAGE_TYPE, limit],
  () => getUserStandaloneActivities(limit),
  {
    select: (data) => camelcaseKeys5(data, { deep: true })
  }
);

// src/components/configurable-journey-experience/standalone-activities-widget/standalone-activities-widget.component.tsx
import {
  ENABLE_V3_ACTIVITY_CARDS as ENABLE_V3_ACTIVITY_CARDS2,
  JOURNEY_ROUTES as JOURNEY_ROUTES20
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery14 } from "@leagueplatform/user-profile-api";
var StandaloneActivitiesWidget = () => {
  const { formatMessage } = useIntl34();
  const { data: isV3ActivityCardsEnabled } = useFeatureFlagQuery14(
    ENABLE_V3_ACTIVITY_CARDS2
  );
  const { data, isError, isLoading } = useGetUserStandaloneActivities({
    limit: STANDALONE_ACTIVITIES_LIMIT_ONE
  });
  if (isLoading) {
    return /* @__PURE__ */ React66.createElement(
      SkeletonBox8,
      {
        backgroundColor: "interactive.background.disabled",
        height: "100px",
        "data-testid": "skeleton-loader"
      }
    );
  }
  const isErrorState = isError || !(data == null ? void 0 : data.userHealthActivities) || // If there are no standalone activity, don't display anything. We don't want to display empty state here.
  (data == null ? void 0 : data.userHealthActivities.length) <= 0;
  if (isErrorState)
    return null;
  const standaloneActivity = data == null ? void 0 : data.userHealthActivities[0];
  return /* @__PURE__ */ React66.createElement(Box34, { width: "100%" }, /* @__PURE__ */ React66.createElement(Box34, { marginBottom: "oneAndHalf" }, /* @__PURE__ */ React66.createElement(Flex22, { alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ React66.createElement(HeadingThree8, { as: "h2" }, formatMessage({
    id: "STANDALONE_ACTIVITIES"
  })), /* @__PURE__ */ React66.createElement(
    GenesisRouterLink5,
    {
      to: JOURNEY_ROUTES20.getStandaloneActivities(),
      "aria-label": formatMessage({ id: "VIEW_ALL_STANDALONE_ACTIVITIES" }),
      onClick: () => viewAllActivitiesAnalytics("standalone")
    },
    formatMessage({ id: "VIEW_ALL" })
  )), /* @__PURE__ */ React66.createElement(BodyOneSecondary5, null, formatMessage({
    id: "STANDALONE_ACTIVITIES_DESCRIPTION"
  }))), /* @__PURE__ */ React66.createElement(BodyTwoSecondary3, { as: "h3", marginBottom: "one" }, formatMessage({ id: "NEXT_ACTIVITY" })), /* @__PURE__ */ React66.createElement(Box34, { marginBottom: "three", marginTop: "one" }, isV3ActivityCardsEnabled ? /* @__PURE__ */ React66.createElement(
    PriorityActivityCard,
    {
      activity: standaloneActivity,
      headingLevel: "4"
    }
  ) : /* @__PURE__ */ React66.createElement(
    ConfigurableActivityCard,
    {
      as: "div",
      activity: standaloneActivity,
      activityHeadingLevel: "h4"
    }
  )));
};

// src/components/configurable-journey-experience/custom-widget-container.component.tsx
import React67 from "react";
import { StackLayout as StackLayout22 } from "@leagueplatform/genesis-core";
var CustomWidgetContainer = ({
  children
}) => /* @__PURE__ */ React67.createElement(StackLayout22, { horizontalAlignment: "stretch" }, children);

// src/components/configurable-journey-experience/programs-and-challenges-widget/programs-and-challenges-widget.component.tsx
import * as React69 from "react";
import {
  useGetWidgetData as useGetWidgetData5
} from "@leagueplatform/masonry-api";
import { useIntl as useIntl35 } from "@leagueplatform/locales";
import {
  ENABLE_NEW_JOURNEY_PROGRESS as ENABLE_NEW_JOURNEY_PROGRESS2,
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION4,
  JOURNEY_ROUTES as JOURNEY_ROUTES21,
  SCREEN_NAMES as SCREEN_NAMES14
} from "@leagueplatform/health-journey-common";
import { SkeletonBox as SkeletonBox9 } from "@leagueplatform/web-common-components";
import {
  Button as Button3,
  Card as Card4,
  HeadingText as HeadingText12,
  StackLayout as StackLayout24,
  UtilityText as UtilityText11,
  queryHelpers as queryHelpers7,
  useMediaQuery as useMediaQuery7
} from "@leagueplatform/genesis-core";
import { useFeatureFlagQuery as useFeatureFlagQuery15 } from "@leagueplatform/user-profile-api";
import {
  EVENT_NAME as EVENT_NAME16,
  PRODUCT_AREA as PRODUCT_AREA16,
  trackAnalyticsEvent as trackAnalyticsEvent16
} from "@leagueplatform/analytics";
import { LinkLegacy as Link7 } from "@leagueplatform/routing";

// src/components/configurable-journey-experience/programs-and-challenges-progress-card/programs-and-challenges-progress-card.component.tsx
import React68 from "react";
import {
  ParagraphText as ParagraphText4,
  StackItem as StackItem4,
  StackLayout as StackLayout23,
  UtilityText as UtilityText10
} from "@leagueplatform/genesis-core";
import { ProgressBar as ProgressBar7 } from "@leagueplatform/web-common-components";
import {
  ComposableActivityCard as ComposableActivityCard2,
  SCREEN_NAMES as SCREEN_NAMES13
} from "@leagueplatform/health-journey-common";
import {
  EVENT_NAME as EVENT_NAME15,
  PRODUCT_AREA as PRODUCT_AREA15,
  trackAnalyticsEvent as trackAnalyticsEvent15
} from "@leagueplatform/analytics";
function ProgramsAndChallengesProgressCard({
  badge,
  content,
  cta,
  heading,
  percentageProgress,
  id
}) {
  const handleClickAnalytics2 = () => {
    trackAnalyticsEvent15(EVENT_NAME15.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA15.JOURNEY,
      screen_name: SCREEN_NAMES13.PROGRESS_PAGE,
      detail: "view health campaign",
      health_campaign_name: heading,
      health_campaign_id: id,
      health_campaign_type: badge.type
    });
  };
  return /* @__PURE__ */ React68.createElement(
    ComposableActivityCard2,
    {
      title: { text: heading, level: "3", size: "sm" },
      badge: {
        body: badge.body,
        image: badge.image,
        imageTint: badge.type === "challenge" ? "$warningBorderDefault" : "$decorativeBrandPrimaryDark",
        backgroundColor: badge.type === "challenge" ? "$warningBackgroundSubdued" : "$decorativeBrandPrimaryPastel"
      },
      body: /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(StackLayout23, { orientation: "horizontal", spacing: "$quarter" }, /* @__PURE__ */ React68.createElement(
        UtilityText10,
        {
          emphasis: "emphasized",
          css: {
            color: "$onSurfaceTextSuccess"
          }
        },
        content.currentText
      ), /* @__PURE__ */ React68.createElement(ParagraphText4, { as: "span", emphasis: "subtle" }, content.suffixText)), /* @__PURE__ */ React68.createElement(
        StackLayout23,
        {
          orientation: "horizontal",
          horizontalAlignment: "stretch",
          verticalAlignment: "center",
          css: {
            width: "100%"
          }
        },
        /* @__PURE__ */ React68.createElement(StackItem4, { growFactor: 1 }, /* @__PURE__ */ React68.createElement(
          ProgressBar7,
          {
            current: percentageProgress,
            total: 100,
            customBarBackgroundColor: "interactive.border.disabled",
            customBarFillColor: "success.border.default"
          }
        ))
      )),
      cta,
      onClick: handleClickAnalytics2
    }
  );
}

// src/components/configurable-journey-experience/programs-and-challenges-widget/programs-and-challenges-widget.component.tsx
function WidgetContent({ items }) {
  const { formatMessage } = useIntl35();
  const belowMobileLandscape = useMediaQuery7(
    queryHelpers7.down("mobileLandscape")
  );
  const isEmptyState = !(items == null ? void 0 : items.length);
  const handleAnalyticsEvent = () => trackAnalyticsEvent16(EVENT_NAME16.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA16.JOURNEY,
    screen_name: SCREEN_NAMES14.PROGRESS_PAGE,
    detail: "explore library"
  });
  const { hasExploreTab, isCareLibraryEnabled } = useHealthJourneyConfig();
  if (isEmptyState) {
    return /* @__PURE__ */ React69.createElement(Card4.Elevated, { backgroundColor: "highlight", css: { width: "100%" } }, /* @__PURE__ */ React69.createElement(StackLayout24, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React69.createElement(Card4.Section, null, /* @__PURE__ */ React69.createElement(HeadingText12, { level: "2", size: belowMobileLandscape ? "sm" : "md" }, formatMessage({
      id: "NO_CHALLENGES_PROGRAMS_EMPTY_STATE_HEADING"
    })), /* @__PURE__ */ React69.createElement(
      UtilityText11,
      {
        size: "sm",
        as: "p",
        css: { marginTop: "$quarter", marginBottom: "$one" }
      },
      formatMessage({
        id: "NO_CHALLENGES_PROGRAMS_EMPTY_STATE_BODY"
      })
    ), hasExploreTab && /* @__PURE__ */ React69.createElement(
      Button3,
      {
        as: Link7,
        to: isCareLibraryEnabled ? JOURNEY_ROUTES21.getCareLibrary() : JOURNEY_ROUTES21.programsHome(),
        onClick: handleAnalyticsEvent,
        width: {
          "@initial": "hugContents",
          "@mobile": "fillContainer"
        },
        css: {
          height: "$twoAndHalf",
          fontSize: "$bodyTwo",
          padding: "$half $one"
        }
      },
      formatMessage({ id: "EXPLORE_LIBRARY" })
    ))));
  }
  return /* @__PURE__ */ React69.createElement(StackLayout24, { spacing: "$one", horizontalAlignment: "stretch" }, items.map(({ badge, content, cta, heading, percentageProgress, id }) => /* @__PURE__ */ React69.createElement(
    ProgramsAndChallengesProgressCard,
    {
      key: id,
      badge,
      content,
      cta,
      heading,
      percentageProgress,
      id
    }
  )));
}
function ProgramsAndChallengesWidget({
  widget
}) {
  const { data: isNewJourneyProgressEnabled } = useFeatureFlagQuery15(
    ENABLE_NEW_JOURNEY_PROGRESS2
  );
  const { data, isLoading, error } = useGetWidgetData5(
    widget,
    HEALTH_JOURNEY_MASONRY_VERSION4
  );
  if (isLoading)
    return /* @__PURE__ */ React69.createElement(SkeletonBox9, { width: "100%", height: "120px" });
  if (error || !data || !(data == null ? void 0 : data.attributes) || !isNewJourneyProgressEnabled) {
    return null;
  }
  const { heading: widgetTitle, items } = data.attributes;
  return /* @__PURE__ */ React69.createElement(StackLayout24, { spacing: "$one", horizontalAlignment: "stretch" }, /* @__PURE__ */ React69.createElement(HeadingText12, { level: "2", size: "xl" }, widgetTitle), /* @__PURE__ */ React69.createElement(WidgetContent, { items }));
}

// src/components/configurable-journey-experience/progress-tab/progress-tab.component.tsx
var ProgressTabContent = Masonry.init({
  appId: JOURNEY_PROGRESS_TAB_APP_ID,
  apiVersion: HEALTH_JOURNEY_MASONRY_VERSION5,
  analytics: {
    productArea: PRODUCT_AREA17.JOURNEY,
    screenName: SCREEN_NAMES15.PROGRESS_PAGE
  },
  // Add custom widget configs here
  customWidgetModules: [
    {
      moduleKey: HEALTH_JOURNEY_MODULE_KEY,
      customWidgetsUI: [
        {
          type: REWARD_PROGRAM_CAROUSEL,
          widget: ({ widget }) => /* @__PURE__ */ React70.createElement(RewardsProgramCardCarouselWidget, { widget })
        },
        {
          type: CHALLENGES_AND_PROGRAMS_LIST_WIDGET,
          widget: ({ widget }) => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(ProgramsAndChallengesWidget, { widget }))
        },
        {
          type: ACHIEVEMENTS_WIDGET,
          widget: ({ widget }) => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(AchievementsWidget, { widget }))
        },
        {
          type: CHALLENGES_LIST_WIDGET,
          widget: ({ widget }) => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(CampaignsListWidget, { widget, campaignType: "challenge" }))
        },
        {
          type: COMPLETED_ACTIVITIES_CAROUSEL_WIDGET,
          widget: () => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(ActivitiesByStatus, { statusType: "completed" }))
        },
        {
          type: MISSED_ACTIVITIES_CAROUSEL_WIDGET,
          widget: () => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(ActivitiesByStatus, { statusType: "missed" }))
        },
        {
          type: PROGRAMS_LIST_WIDGET,
          widget: ({ widget }) => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(CampaignsListWidget, { widget, campaignType: "opt-in" }))
        },
        {
          type: STANDALONE_ACTIVITIES_WIDGET,
          widget: () => /* @__PURE__ */ React70.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React70.createElement(StandaloneActivitiesWidget, null))
        }
      ]
    }
  ]
});
var ProgressTab = () => {
  const { formatMessage } = useIntl36();
  useDocumentTitle(formatMessage({ id: "PROGRESS" }));
  return /* @__PURE__ */ React70.createElement(ProgressTabContent.Provider, null);
};

// src/components/configurable-journey-experience/history-tab/history-tab.component.tsx
import * as React73 from "react";
import compareDesc from "date-fns/compareDesc";
import parseISO from "date-fns/parseISO";
import {
  HeadingText as HeadingText14,
  StackItem as StackItem6,
  StackLayout as StackLayout27,
  Button as Button4
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset13 } from "@leagueplatform/asset-config";
import { useIntl as useIntl37 } from "@leagueplatform/locales";
import {
  DATE_FORMAT,
  MONTH_YEAR,
  useDocumentTitle as useDocumentTitle2
} from "@leagueplatform/web-common";
import { ErrorState as ErrorState3, SkeletonBox as SkeletonBox10 } from "@leagueplatform/web-common-components";
import {
  SCREEN_NAMES as SCREEN_NAMES16,
  useGetUserProfile as useGetUserProfile3
} from "@leagueplatform/health-journey-common";
import {
  EVENT_NAME as EVENT_NAME17,
  PRODUCT_AREA as PRODUCT_AREA18,
  trackAnalyticsEvent as trackAnalyticsEvent17
} from "@leagueplatform/analytics";

// src/pages/health-activity/hooks/use-get-user-health-journey-history.hook.ts
import { useInfiniteQuery } from "react-query";
import {
  getUserHealthJourneyHistory,
  getUserHealthJourneyHistoryByPaginationLink
} from "@leagueplatform/health-journey-api";
import { captureError as captureError2 } from "@leagueplatform/observability";
var GET_USER_HEALTH_JOURNEY_HISTORY_DATA_KEY = "userHealthJourneyHistory";
var useGetUserHealthJourneyHistory = (params) => useInfiniteQuery(
  [GET_USER_HEALTH_JOURNEY_HISTORY_DATA_KEY, params],
  ({ pageParam }) => {
    if (pageParam) {
      return getUserHealthJourneyHistoryByPaginationLink(pageParam);
    }
    return getUserHealthJourneyHistory(params);
  },
  {
    getNextPageParam(lastPage) {
      var _a;
      if (!((_a = lastPage == null ? void 0 : lastPage.links) == null ? void 0 : _a.next)) {
        return void 0;
      }
      const { next } = lastPage.links;
      return next.slice(next.indexOf("/v2/"));
    },
    onError(error) {
      captureError2(
        new Error(
          `Unable to fetch paginated user health journey history: ${error}`
        ),
        {
          context: {
            parameters: {
              api: JSON.stringify(params)
            }
          }
        }
      );
    }
  }
);

// src/components/configurable-journey-experience/history-activity/history-activity-card.tsx
import * as React72 from "react";
import {
  HeadingText as HeadingText13,
  ParagraphText as ParagraphText5,
  StackLayout as StackLayout26,
  UtilityText as UtilityText13,
  Icon as Icon6
} from "@leagueplatform/genesis-core";
import {
  Badge as Badge7,
  ConditionalLink as ConditionalLink2,
  ConditionalLinkCard
} from "@leagueplatform/web-common-components";

// src/components/configurable-journey-experience/program-progress/program-progress.component.tsx
import React71 from "react";
import { ProgressBar as ProgressBar8 } from "@leagueplatform/web-common-components";
import {
  StackLayout as StackLayout25,
  UtilityText as UtilityText12,
  Icon as Icon5,
  StackItem as StackItem5
} from "@leagueplatform/genesis-core";
var ProgramProgress = ({
  currentProgress,
  currentText,
  progressImage,
  pointsIcon,
  suffixText
}) => {
  const showProgressBar = currentProgress !== void 0;
  const StyledPrefix = /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(
    UtilityText12,
    {
      size: "sm",
      emphasis: "emphasized",
      css: { color: "$onSurfaceTextSuccess" }
    },
    currentText
  ), /* @__PURE__ */ React71.createElement(UtilityText12, { size: "sm" }, suffixText));
  const StandardText = /* @__PURE__ */ React71.createElement(UtilityText12, { size: "sm" }, currentText);
  const displayText = suffixText ? StyledPrefix : StandardText;
  return /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(
    StackLayout25,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter"
    },
    pointsIcon ? /* @__PURE__ */ React71.createElement(StackItem5, { horizontalAlignment: "center", verticalAlignment: "center" }, /* @__PURE__ */ React71.createElement(Icon5, { icon: pointsIcon, size: "$one" })) : null,
    displayText
  ), /* @__PURE__ */ React71.createElement(
    StackLayout25,
    {
      orientation: "horizontal",
      horizontalAlignment: "stretch",
      verticalAlignment: "center",
      css: {
        width: "100%"
      }
    },
    showProgressBar ? /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(StackItem5, { growFactor: 1 }, /* @__PURE__ */ React71.createElement(
      ProgressBar8,
      {
        total: 100,
        current: currentProgress,
        customBarFillColor: "success.border.default",
        customBarBackgroundColor: "interactive.border.disabled"
      }
    )), progressImage ? /* @__PURE__ */ React71.createElement(StackItem5, { growFactor: 0, baseWidth: "$one" }, /* @__PURE__ */ React71.createElement(Icon5, { icon: progressImage, size: "$one" })) : null) : null
  ));
};

// src/components/configurable-journey-experience/history-activity/history-activity-card.tsx
function HistoryActivityCard({
  status,
  eyebrow,
  heading,
  badge,
  image,
  imageAltText,
  imageTint,
  body,
  content,
  cta,
  onClick
}) {
  const linkRef = React72.useRef(null);
  return /* @__PURE__ */ React72.createElement(
    ConditionalLinkCard,
    {
      linkRef,
      hasLink: Boolean(cta),
      cardStyle: {
        paddingY: "one",
        paddingInlineStart: "oneAndHalf",
        paddingInlineEnd: "one",
        backgroundColor: "surface.card.secondary"
      },
      onClick
    },
    /* @__PURE__ */ React72.createElement(StackLayout26, { orientation: "horizontal", spacing: "$half" }, /* @__PURE__ */ React72.createElement(StackLayout26, { spacing: "$threeQuarters" }, badge ? /* @__PURE__ */ React72.createElement(
      Badge7,
      {
        css: { backgroundColor: badge.color, borderRadius: "$small" }
      },
      /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(
        Icon6,
        {
          icon: badge.image,
          tint: badge.imageTint,
          size: "$threeQuarters"
        }
      ), /* @__PURE__ */ React72.createElement(UtilityText13, { size: "eyebrow", emphasis: "emphasized" }, badge.body))
    ) : null, eyebrow ? /* @__PURE__ */ React72.createElement(UtilityText13, { size: "xs" }, eyebrow) : null, /* @__PURE__ */ React72.createElement(
      HeadingText13,
      {
        size: "sm",
        level: "2",
        emphasis: status === "missed" ? "subtle" : void 0,
        css: {
          a: {
            all: "inherit"
          }
        }
      },
      /* @__PURE__ */ React72.createElement(ConditionalLink2, { ref: linkRef, url: cta }, heading)
    ), body ? /* @__PURE__ */ React72.createElement(ParagraphText5, { emphasis: "subtle", size: "sm" }, body) : null, content ? /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(
      ProgramProgress,
      {
        suffixText: content.suffixText,
        currentText: content.currentText,
        pointsIcon: content.image
      }
    )) : null), image ? /* @__PURE__ */ React72.createElement(Icon6, { icon: image, tint: imageTint, label: imageAltText }) : null)
  );
}

// src/components/configurable-journey-experience/history-tab/history-tab.component.tsx
var badgeTypeColorMap = {
  challenge: "$warningBackgroundSubdued",
  "opt-in": "$decorativeBrandPrimaryBrightest",
  reward: "$decorativeBrandSecondaryBrightest"
};
function consolidatePageData(pages) {
  const consolidatedHistoryItems = pages == null ? void 0 : pages.reduce(
    (items, page) => items.concat(page.data),
    []
  );
  return consolidatedHistoryItems != null ? consolidatedHistoryItems : [];
}
function groupByDate(getDate, items) {
  const groupedByDate = items == null ? void 0 : items.reduce((acc, item) => {
    var _a;
    const date = getDate(item);
    return __spreadProps(__spreadValues({}, acc), {
      // Append the item to the date group, if doesn't already exist create a new array.
      [date]: [...(_a = acc[date]) != null ? _a : [], item]
    });
  }, {});
  return groupedByDate;
}
function normalizeItems(value) {
  const normalizedItems = Object.entries(value).map(([keyValue, items]) => ({
    groupedBy: keyValue,
    items
  }));
  return normalizedItems;
}
function useGroupHistoryItems(historyItems, timeZone) {
  const { formatDate } = useIntl37();
  const sortedHistoryItems = historyItems.sort(
    (itemA, itemB) => compareDesc(parseISO(itemA.timestamp), parseISO(itemB.timestamp))
  );
  const groupedHistoryItemsByKey = groupByDate(
    (item) => formatDate(item.timestamp, __spreadProps(__spreadValues({}, MONTH_YEAR), {
      timeZone
    })),
    sortedHistoryItems
  );
  const historyItemsGroupedByMonth = (
    // Group all items by month.
    normalizeItems(groupedHistoryItemsByKey).map((month3) => {
      const historyItemsGroupedByDate = groupByDate(
        (item) => formatDate(item.timestamp, __spreadProps(__spreadValues({}, DATE_FORMAT), {
          timeZone
        })),
        month3.items
      );
      return __spreadProps(__spreadValues({}, month3), {
        items: normalizeItems(historyItemsGroupedByDate)
      });
    })
  );
  return historyItemsGroupedByMonth;
}
function HistoryTab() {
  var _a;
  const { formatMessage } = useIntl37();
  const query = useGetUserHealthJourneyHistory();
  const { data: userProfileData } = useGetUserProfile3();
  useDocumentTitle2(formatMessage({ id: "HISTORY" }));
  const { defaultTimezone } = userProfileData || {};
  const historyItems = consolidatePageData((_a = query.data) == null ? void 0 : _a.pages);
  const groupedHistoryItems = useGroupHistoryItems(
    historyItems,
    defaultTimezone
  );
  const hasHistoryItems = historyItems.length > 0;
  function handleAnalytics(historyItem) {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    switch (historyItem.itemType) {
      case "activity":
        trackAnalyticsEvent17(EVENT_NAME17.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA18.JOURNEY,
          screen_name: SCREEN_NAMES16.HISTORY_PAGE,
          detail: "view health campaign activity",
          health_campaign_name: (_c = (_b = (_a2 = historyItem.meta) == null ? void 0 : _a2.content) == null ? void 0 : _b[0]) == null ? void 0 : _c.name,
          health_campaign_id: (_f = (_e = (_d = historyItem.meta) == null ? void 0 : _d.content) == null ? void 0 : _e[0]) == null ? void 0 : _f.contentfulId,
          health_campaign_type: (_g = historyItem.badge) == null ? void 0 : _g.type,
          health_campaign_activity_name: historyItem.heading,
          health_campaign_activity_id: historyItem.contentfulId
        });
        break;
      case "campaign":
        trackAnalyticsEvent17(EVENT_NAME17.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA18.JOURNEY,
          screen_name: SCREEN_NAMES16.HISTORY_PAGE,
          detail: "view health campaign",
          health_campaign_name: historyItem.heading,
          health_campaign_id: historyItem.contentfulId,
          health_campaign_type: (_h = historyItem.badge) == null ? void 0 : _h.type
        });
        break;
      default:
        break;
    }
  }
  if (query.isError) {
    return /* @__PURE__ */ React73.createElement(
      ErrorState3,
      {
        error: query.error,
        onButtonClick: () => {
          query.refetch();
        }
      }
    );
  }
  if (query.isLoading) {
    return /* @__PURE__ */ React73.createElement(StackLayout27, { spacing: "$one" }, /* @__PURE__ */ React73.createElement(SkeletonBox10, { width: "10%", height: "1.5rem" }), /* @__PURE__ */ React73.createElement(SkeletonBox10, { width: "100%", height: "150px" }), /* @__PURE__ */ React73.createElement(SkeletonBox10, { width: "100%", height: "150px" }), /* @__PURE__ */ React73.createElement(SkeletonBox10, { width: "100%", height: "150px" }));
  }
  if (!hasHistoryItems) {
    const { EMPTY_STATE_HISTORY: EMPTY_STATE_HISTORY2 } = HEALTH_JOURNEY_ASSET_KEYS;
    const emptyStateImgUrl = handleStaticAsset13(EMPTY_STATE_HISTORY2);
    return /* @__PURE__ */ React73.createElement(StackLayout27, { spacing: "$two", horizontalAlignment: "stretch" }, /* @__PURE__ */ React73.createElement(StackItem6, null, /* @__PURE__ */ React73.createElement(
      ConfigurableJourneyEmptyStateCard,
      {
        heading: formatMessage({
          id: "HISTORY_EMPTY_STATE_HEADER"
        }),
        description: formatMessage({
          id: "HISTORY_EMPTY_STATE_DESCRIPTION"
        }),
        imgSrc: emptyStateImgUrl,
        headingLevel: "2"
      }
    )));
  }
  return /* @__PURE__ */ React73.createElement(StackLayout27, { spacing: "$two", horizontalAlignment: "stretch" }, groupedHistoryItems == null ? void 0 : groupedHistoryItems.map((month3) => /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(StackItem6, { key: month3.groupedBy }, /* @__PURE__ */ React73.createElement(HeadingText14, { size: "lg", level: "3" }, month3.groupedBy)), month3.items.map((historyItem) => /* @__PURE__ */ React73.createElement(StackItem6, { key: historyItem.groupedBy }, /* @__PURE__ */ React73.createElement(
    HeadingText14,
    {
      size: "sm",
      level: "4",
      css: { typography: "$overline", marginBottom: "$one" }
    },
    historyItem.groupedBy
  ), /* @__PURE__ */ React73.createElement(StackLayout27, { spacing: "$one", horizontalAlignment: "stretch" }, historyItem.items.map((item) => /* @__PURE__ */ React73.createElement(StackItem6, null, /* @__PURE__ */ React73.createElement(
    HistoryActivityCard,
    {
      key: item.id,
      status: item.status,
      eyebrow: item.eyebrow,
      heading: item.heading,
      badge: item.badge ? {
        body: item.badge.body,
        image: item.badge.image,
        color: badgeTypeColorMap[item.badge.type]
      } : void 0,
      image: item.image,
      imageAltText: item.imageAltText,
      body: item.body,
      content: item.content,
      cta: item.cta,
      onClick: () => {
        handleAnalytics(item);
      }
    }
  )))))))), query.hasNextPage ? /* @__PURE__ */ React73.createElement(StackItem6, { horizontalAlignment: "center" }, /* @__PURE__ */ React73.createElement(
    Button4,
    {
      disabled: query.isFetchingNextPage,
      onClick: () => {
        query.fetchNextPage();
      }
    },
    formatMessage({ id: "LOAD_MORE" }).toLocaleUpperCase()
  )) : null);
}

// src/components/configurable-journey-experience/configurable-journey-experience.component.tsx
import { Tabs as Tabs2, Box as Box38 } from "@leagueplatform/genesis-core";
import {
  EVENT_NAME as EVENT_NAME19,
  PRODUCT_AREA as PRODUCT_AREA21,
  trackAnalyticsEvent as trackAnalyticsEvent19
} from "@leagueplatform/analytics";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES22,
  TAB_PANEL_ANALYTICS_NAMES as TAB_PANEL_ANALYTICS_NAMES2,
  TAB_DISPLAY_NAMES
} from "@leagueplatform/health-journey-common";
import {
  HealthProgramsPage,
  useActiveCampaignInfo as useActiveCampaignInfo2
} from "@leagueplatform/health-programs";
import { getModulePath as getModulePath3, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES3 } from "@leagueplatform/core";

// src/components/configurable-journey-experience/priority-activities-tab/priority-activities-tab.component.tsx
import React75, { useEffect as useEffect7, useState as useState5 } from "react";
import Masonry2, {
  getMasonryDriver,
  getMasonryWSDriver
} from "@leagueplatform/masonry";
import { PRODUCT_AREA as PRODUCT_AREA19 } from "@leagueplatform/analytics";
import {
  SCREEN_NAMES as SCREEN_NAMES17,
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION7,
  HEALTH_JOURNEY_MODULE_KEY as HEALTH_JOURNEY_MODULE_KEY2,
  JOURNEY_TO_DO_TAB_APP_ID,
  PRIORITY_ACTIVITIES_ACTIVITY_STACK_WIDGET,
  PRIORITY_ACTIVITIES_LIST_WIDGET
} from "@leagueplatform/health-journey-common";
import { isProduction as isProduction2 } from "@leagueplatform/app-environment";

// src/components/configurable-journey-experience/activity-stack-widget-v2/activity-stack-widget-V2-wrapper.component.tsx
import React74 from "react";
import { SkeletonBox as SkeletonBox11 } from "@leagueplatform/web-common-components";
import { captureError as captureError3 } from "@leagueplatform/observability";
import {
  useGetWidgetData as useGetWidgetData6
} from "@leagueplatform/masonry-api";
import { HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION6 } from "@leagueplatform/health-journey-common";
var ActivityStackWidgetV2Wrapper = ({
  widget
}) => {
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData6(
    widget,
    HEALTH_JOURNEY_MASONRY_VERSION6
  );
  if (isLoading)
    return /* @__PURE__ */ React74.createElement(SkeletonBox11, { width: "100%", height: "120px" });
  if (error) {
    captureError3(
      new Error(
        `Unable to fetch widget data for the activity stack widget: ${error}`
      )
    );
    return null;
  }
  if (!widgetData || !widgetData.attributes) {
    return null;
  }
  return /* @__PURE__ */ React74.createElement(ActivityStackWidgetV2, __spreadValues({}, widgetData.attributes));
};

// src/components/configurable-journey-experience/priority-activities-tab/priority-activities-tab.component.tsx
import { MasonryEngine } from "@leagueplatform/masonry-engine";
import { useDocumentTitle as useDocumentTitle3 } from "@leagueplatform/web-common";
import { useIntl as useIntl38 } from "@leagueplatform/locales";
var PriorityActivitiesTabContent = Masonry2.init({
  // TODO: update const name of first tab app id once we have an official name
  appId: JOURNEY_TO_DO_TAB_APP_ID,
  apiVersion: HEALTH_JOURNEY_MASONRY_VERSION7,
  analytics: {
    productArea: PRODUCT_AREA19.JOURNEY,
    screenName: SCREEN_NAMES17.ACTIVITY_TIMELINE
  },
  // Add custom widget configs here
  customWidgetModules: [
    {
      moduleKey: HEALTH_JOURNEY_MODULE_KEY2,
      customWidgetsUI: [
        {
          type: PRIORITY_ACTIVITIES_LIST_WIDGET,
          widget: () => /* @__PURE__ */ React75.createElement(CustomWidgetContainer, null, /* @__PURE__ */ React75.createElement(PriorityActivitiesWidget, null))
        },
        {
          type: PRIORITY_ACTIVITIES_ACTIVITY_STACK_WIDGET,
          widget: ({ widget }) => /* @__PURE__ */ React75.createElement(ActivityStackWidgetV2Wrapper, { widget })
        }
      ]
    }
  ]
});
var MasonryJourneyActivitiesDriver = getMasonryWSDriver({
  appId: JOURNEY_TO_DO_TAB_APP_ID,
  screenName: SCREEN_NAMES17.ACTIVITY_TIMELINE,
  productArea: PRODUCT_AREA19.JOURNEY
});
var MasonryActivitiesDriver = getMasonryDriver({
  rootNodeId: "journeyActivities$root"
});
function useEnableActivitiesMasonry() {
  const [isEnabled, setIsEnabled] = useState5(false);
  useEffect7(() => {
    const value = localStorage.getItem("enableActivitiesMasonry2");
    setIsEnabled(value === "true");
  }, []);
  return isEnabled && !isProduction2();
}
var PriorityActivitiesTab = () => {
  const { enableMasonryWSForActivities, enableMasonry2ForActivities } = useHealthJourneyConfig();
  const { formatMessage } = useIntl38();
  useDocumentTitle3(formatMessage({ id: "ACTIVITIES" }));
  const enableMasonryLocally = useEnableActivitiesMasonry();
  if (enableMasonry2ForActivities || enableMasonryLocally) {
    return /* @__PURE__ */ React75.createElement(MasonryEngine, { driver: MasonryActivitiesDriver });
  }
  if (enableMasonryWSForActivities) {
    return /* @__PURE__ */ React75.createElement(MasonryEngine, { driver: MasonryJourneyActivitiesDriver });
  }
  return /* @__PURE__ */ React75.createElement(PriorityActivitiesTabContent.Provider, null);
};

// src/components/configurable-journey-experience/configurable-journey-experience-header/configurable-journey-experience-header.component.tsx
import React77 from "react";
import {
  CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH,
  useGetUserProfile as useGetUserProfile4
} from "@leagueplatform/health-journey-common";
import { useIntl as useIntl40 } from "@leagueplatform/locales";
import {
  Box as Box35,
  HeadingText as HeadingText15,
  VisuallyHidden as VisuallyHidden2,
  ParagraphText as ParagraphText6
} from "@leagueplatform/genesis-core";
import { useStaticAsset as useStaticAsset2 } from "@leagueplatform/asset-config";

// src/components/configurable-journey-experience/configurable-journey-experience-button/configurable-journey-experience-button.component.tsx
import { useIntl as useIntl39 } from "@leagueplatform/locales";
import { useRewardsSidebar } from "@leagueplatform/rewards-achievements";
import {
  EVENT_NAME as EVENT_NAME18,
  PRODUCT_AREA as PRODUCT_AREA20,
  trackAnalyticsEvent as trackAnalyticsEvent18
} from "@leagueplatform/analytics";
import React76 from "react";
import { Badge as Badge8 } from "@leagueplatform/web-common-components";
import { LinkLegacy as Link8 } from "@leagueplatform/routing";
import { PointsIcon as PointsIcon3 } from "@leagueplatform/rewards-common";
import { Button as Button5 } from "@leagueplatform/genesis-core";
import { getModulePath as getModulePath2, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2 } from "@leagueplatform/core";
import { ViewMyHealthDashboardButton } from "@leagueplatform/about-me";

// src/components/configurable-journey-experience/configurable-journey-experience-button/use-configurable-journey-experience-button.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery16 } from "@leagueplatform/user-profile-api";
import {
  ENABLE_JOURNEY_POINTS_COUNTER_BUTTON,
  ENABLE_JOURNEY_VIEW_MY_PROFILE_BUTTON,
  ENABLE_JOURNEY_VIEW_MY_PROGRESS_BUTTON
} from "@leagueplatform/health-journey-common";
var useConfigurableJourneyExperienceButton = () => {
  const { data: isPointsCounterButtonEnabled } = useFeatureFlagQuery16(
    ENABLE_JOURNEY_POINTS_COUNTER_BUTTON
  );
  const { data: isViewMyProgressButtonEnabled } = useFeatureFlagQuery16(
    ENABLE_JOURNEY_VIEW_MY_PROGRESS_BUTTON
  );
  const { data: isViewMyProfileButtonEnabled } = useFeatureFlagQuery16(
    ENABLE_JOURNEY_VIEW_MY_PROFILE_BUTTON
  );
  if (isPointsCounterButtonEnabled) {
    return 1 /* POINTS_COUNTER */;
  }
  if (isViewMyProgressButtonEnabled) {
    return 2 /* VIEW_MY_PROGRESS */;
  }
  if (isViewMyProfileButtonEnabled) {
    return 3 /* VIEW_MY_PROFILE */;
  }
  return 0 /* NONE */;
};

// src/components/configurable-journey-experience/configurable-journey-experience-button/configurable-journey-experience-button.component.tsx
var HealthJourneyButton = ({
  analyticsScreenName
}) => {
  const { formatMessage } = useIntl39();
  const enabledButton = useConfigurableJourneyExperienceButton();
  const { userRewardPoints } = useRewardsSidebar();
  const handleClickAnalytics2 = (detail) => trackAnalyticsEvent18(EVENT_NAME18.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA20.JOURNEY,
    screen_name: analyticsScreenName,
    detail
  });
  switch (enabledButton) {
    case 1 /* POINTS_COUNTER */:
      if (userRewardPoints === void 0)
        return null;
      return /* @__PURE__ */ React76.createElement(
        Badge8,
        {
          as: Link8,
          to: "/member/get-rewarded",
          css: {
            backgroundColor: "$surfaceBackgroundPrimary",
            "&:hover": { textDecoration: "underline" }
          },
          onClick: () => handleClickAnalytics2(userRewardPoints.toString())
        },
        /* @__PURE__ */ React76.createElement(PointsIcon3, { value: userRewardPoints })
      );
    case 2 /* VIEW_MY_PROGRESS */:
      return /* @__PURE__ */ React76.createElement(
        ViewMyHealthDashboardButton,
        {
          handleClickAnalytics: handleClickAnalytics2
        }
      );
    case 3 /* VIEW_MY_PROFILE */:
      return /* @__PURE__ */ React76.createElement(
        Button5,
        {
          as: Link8,
          to: getModulePath2(LEAGUE_MODULE_NAMES2.healthProfile),
          size: "medium",
          onClick: () => handleClickAnalytics2("view my profile")
        },
        formatMessage({ id: "VIEW_MY_PROFILE" })
      );
    default:
      return null;
  }
};

// src/components/configurable-journey-experience/configurable-journey-experience-header/configurable-journey-experience-header.component.tsx
var ConfigurableJourneyExperienceHeader = ({
  analyticsScreenName
}) => {
  const { formatMessage, $tifelse } = useIntl40();
  const {
    data: userProfileData,
    isLoading: isUserNameLoading,
    isError: isUserProfileError
  } = useGetUserProfile4();
  const { headerConfig } = useHealthJourneyConfig();
  const { firstName, preferredFirstName } = (userProfileData == null ? void 0 : userProfileData.userProfile) || {};
  const displayName = preferredFirstName || firstName;
  const displayFallbackGreeting = isUserProfileError || isUserNameLoading || !displayName;
  const JourneyHeaderContainerStyles = {
    display: "flex",
    flexWrap: "wrap",
    marginX: "auto",
    backgroundColor: "$surfaceScreenHeaderBackground",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50%",
    borderRadius: "$medium",
    marginTop: "$twoAndHalf",
    flexDirection: "column",
    maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH,
    minHeight: CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT._,
    padding: "$two $one",
    width: "auto"
  };
  return /* @__PURE__ */ React77.createElement(
    Box35,
    {
      as: "header",
      className: "journey-header-container",
      css: __spreadValues(__spreadProps(__spreadValues({}, JourneyHeaderContainerStyles), {
        "@laptop": {
          flexWrap: "nowrap",
          minHeight: CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT.tablet
        },
        "@mobile": {
          minHeight: CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT._,
          marginTop: "$none"
        },
        "@tablet": {
          minHeight: CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT.phone
        },
        "@desktop": {
          minHeight: CONFIGURABLE_JOURNEY_HEADER_BACKGROUND_IMAGE_HEIGHT.tablet,
          flexWrap: "nowrap"
        }
      }), headerConfig.backgroundImageSrc ? {
        backgroundImage: `url(${headerConfig.backgroundImageSrc})`
      } : {
        backgroundImage: `url(${// eslint-disable-next-line react-hooks/rules-of-hooks
        useStaticAsset2(
          "JOURNEY_HEADER_BACKGROUND_IMAGE" /* JOURNEY_HEADER_BACKGROUND_IMAGE */
        )})`
      }),
      "data-testid": "background-image"
    },
    /* @__PURE__ */ React77.createElement(VisuallyHidden2, null, /* @__PURE__ */ React77.createElement(HeadingText15, { level: "1", size: "xxl" }, formatMessage({ id: "HEALTH_JOURNEY_PAGE" }))),
    /* @__PURE__ */ React77.createElement(
      Box35,
      {
        className: "journey-header-content-wrapper",
        css: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          gap: "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React77.createElement(HeadingText15, { level: "2", size: "xl", as: "p" }, $tifelse(
        displayFallbackGreeting,
        "YOUVE_GOT_THIS",
        "YOUVE_GOT_THIS_NAME",
        { firstName: displayName }
      )),
      headerConfig.enableHeaderSubTitle && /* @__PURE__ */ React77.createElement(ParagraphText6, { size: "base", as: "p" }, formatMessage({
        id: "CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE"
      })),
      /* @__PURE__ */ React77.createElement(HealthJourneyButton, { analyticsScreenName })
    )
  );
};

// src/components/configurable-journey-experience/configurable-journey-page-layout.component.tsx
import * as React78 from "react";
import { Box as Box36 } from "@leagueplatform/genesis-core";
import { CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH as CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH2 } from "@leagueplatform/health-journey-common";
var ConfigurableJourneyPageLayout = ({
  children
}) => /* @__PURE__ */ React78.createElement(
  Box36,
  {
    css: {
      display: "flex",
      maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH2,
      margin: "auto",
      width: "100%"
    }
  },
  children
);

// src/components/configurable-journey-experience/configurable-journey-experience-tabs/configurable-journey-experience-tabs.component.tsx
import React79 from "react";
import { useIntl as useIntl41 } from "@leagueplatform/locales";
import { Tabs, Box as Box37 } from "@leagueplatform/genesis-core";
var ConfigurableJourneyExperienceTabs = ({
  tabRoutes,
  tabDisplayNames
}) => {
  const { $tmap } = useIntl41();
  const getTabName = $tmap({
    activities: "ACTIVITIES",
    progress: "PROGRESS",
    history: "HISTORY",
    explore: "EXPLORE"
  });
  return /* @__PURE__ */ React79.createElement(
    Box37,
    {
      css: {
        marginBottom: "$oneAndHalf",
        ".GDS-tab-list-wrapper": {
          width: "100%"
        },
        marginTop: "$half",
        "@mobile": {
          marginTop: "$one"
        },
        "@tablet": {
          marginTop: "$oneAndHalf"
        }
      }
    },
    /* @__PURE__ */ React79.createElement(Tabs.TabList, { css: { width: "100%" }, divider: true }, /* @__PURE__ */ React79.createElement(ConfigurableJourneyPageLayout, null, tabDisplayNames.map((tab, index) => /* @__PURE__ */ React79.createElement(
      Tabs.Tab,
      {
        key: tab,
        css: { padding: "$threeQuarters $oneAndHalf" },
        value: tabRoutes[index]
      },
      getTabName(tab)
    ))))
  );
};

// src/components/configurable-journey-experience/masonryV2/explore-tab.tsx
import { useIntl as useIntl42 } from "@leagueplatform/locales";
import { getMasonryDriver as getMasonryDriver2 } from "@leagueplatform/masonry";
import { MasonryEngine as MasonryEngine2 } from "@leagueplatform/masonry-engine";
import { useDocumentTitle as useDocumentTitle4 } from "@leagueplatform/web-common";
import React80 from "react";
var MasonryCareLibraryDriver = getMasonryDriver2({
  rootNodeId: "careLibrary$root"
});
function ExploreTab() {
  const { formatMessage } = useIntl42();
  useDocumentTitle4(formatMessage({ id: "EXPLORE" }));
  return /* @__PURE__ */ React80.createElement(MasonryEngine2, { driver: MasonryCareLibraryDriver });
}

// src/components/configurable-journey-experience/configurable-journey-experience.component.tsx
var ConfigurableJourneyExperience = () => {
  const { data: activeCampaignInfo } = useActiveCampaignInfo2();
  const { tabs: healthJourneyConfigTabs, isCareLibraryEnabled } = useHealthJourneyConfig();
  const ExploreComponent = isCareLibraryEnabled ? ExploreTab : HealthProgramsPage;
  const LegacyProgramsTab = {
    route: JOURNEY_ROUTES22.programsHome(),
    component: HealthProgramsPage
  };
  const CareLibrary = {
    route: getModulePath3(LEAGUE_MODULE_NAMES3.careLibrary),
    component: ExploreComponent
  };
  const Explore = isCareLibraryEnabled ? CareLibrary : LegacyProgramsTab;
  const configuredTabs = useMemo7(() => {
    const JOURNEY_TAB_MAP = {
      activities: {
        route: JOURNEY_ROUTES22.journeyHome(),
        component: PriorityActivitiesTab
      },
      progress: {
        route: JOURNEY_ROUTES22.progressHome(),
        component: ProgressTab
      },
      history: {
        route: JOURNEY_ROUTES22.journeyHistoryHome(),
        component: HistoryTab
      },
      explore: Explore
    };
    const filteredConfigTabs = healthJourneyConfigTabs.filter(
      (tab) => TAB_DISPLAY_NAMES.includes(tab)
    );
    const tabs = filteredConfigTabs.length === 0 ? TAB_DISPLAY_NAMES : filteredConfigTabs;
    return {
      names: tabs,
      routes: tabs.map((tab) => JOURNEY_TAB_MAP[tab].route),
      content: tabs.map((tab) => JOURNEY_TAB_MAP[tab].component)
    };
  }, [healthJourneyConfigTabs, Explore]);
  const {
    names: tabNames,
    routes: tabRoutes,
    content: tabContent
  } = configuredTabs;
  const navigate = useNavigate7();
  const { pathname: currentTab } = useLocation5();
  const [tabIndex, setTabIndex] = useState6(tabRoutes.indexOf(currentTab));
  const analyticsScreenName = TAB_PANEL_ANALYTICS_NAMES2[tabIndex];
  const handleTabsChange = (index) => {
    trackAnalyticsEvent19(EVENT_NAME19.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA21.JOURNEY,
      screen_name: analyticsScreenName,
      detail: tabNames[index]
    });
    navigate(tabRoutes[index]);
  };
  useEffect8(() => {
    if (tabIndex !== tabRoutes.indexOf(currentTab)) {
      setTabIndex(tabRoutes.indexOf(currentTab));
    }
  }, [currentTab, tabIndex, tabRoutes]);
  useEffect8(() => {
    if (!activeCampaignInfo)
      return;
    const isProgramsLibraryPage = tabRoutes[tabIndex] === JOURNEY_ROUTES22.programsHome();
    trackAnalyticsEvent19(EVENT_NAME19.SCREEN_LOADED, __spreadValues({
      product_area: PRODUCT_AREA21.JOURNEY,
      screen_name: analyticsScreenName
    }, isProgramsLibraryPage && {
      num_health_campaign_active: activeCampaignInfo == null ? void 0 : activeCampaignInfo.number_of_enrolled_programs,
      num_health_campaign_limit: activeCampaignInfo == null ? void 0 : activeCampaignInfo.max_programs_limit
    }));
  }, [tabRoutes, activeCampaignInfo, tabIndex, analyticsScreenName]);
  return /* @__PURE__ */ React81.createElement(
    Box38,
    {
      css: {
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    },
    /* @__PURE__ */ React81.createElement(
      Box38,
      {
        css: {
          padding: "$none $oneAndHalf",
          "@mobile": {
            padding: "$none"
          }
        }
      },
      /* @__PURE__ */ React81.createElement(
        ConfigurableJourneyExperienceHeader,
        {
          analyticsScreenName
        }
      )
    ),
    /* @__PURE__ */ React81.createElement(
      Box38,
      {
        css: {
          padding: "$none $oneAndHalf"
        }
      },
      /* @__PURE__ */ React81.createElement(
        Tabs2.Root,
        {
          value: tabRoutes[tabIndex],
          onValueChange: (value) => handleTabsChange(tabRoutes.findIndex((tab) => tab === value))
        },
        /* @__PURE__ */ React81.createElement(
          ConfigurableJourneyExperienceTabs,
          {
            tabRoutes,
            tabDisplayNames: tabNames
          }
        ),
        /* @__PURE__ */ React81.createElement(ConfigurableJourneyPageLayout, null, /* @__PURE__ */ React81.createElement(Box38, { css: { width: "100%", paddingBottom: "$twoAndHalf" } }, tabContent.map((Tab, index) => /* @__PURE__ */ React81.createElement(
          Tabs2.TabPanel,
          {
            value: tabRoutes[index],
            key: `${tabRoutes[index]}`
          },
          /* @__PURE__ */ React81.createElement(Tab, null)
        ))))
      ),
      /* @__PURE__ */ React81.createElement(ActivityCompletionController, null)
    )
  );
};

// src/components/configurable-journey-experience/masonryV2/topic-page.tsx
import React82 from "react";
import { getMasonryDriver as getMasonryDriver3 } from "@leagueplatform/masonry";
import { getModulePath as getModulePath4, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES4 } from "@leagueplatform/core";
import { MasonryEngine as MasonryEngine3 } from "@leagueplatform/masonry-engine";
import { useGoBack } from "@leagueplatform/web-common";
import { BackButtonArrow as BackButtonArrow3 } from "@leagueplatform/web-common-components";
import { Box as Box39 } from "@leagueplatform/genesis-core";
import { CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH as CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH3 } from "@leagueplatform/health-journey-common";
import { useParamsLegacy as useParams2 } from "@leagueplatform/routing";
function TopicPage() {
  const { tag } = useParams2();
  const MasonryTopicLibraryDriver = React82.useMemo(
    () => getMasonryDriver3({
      rootNodeId: "careLibrary$topicPage",
      queryParams: {
        tag
      }
    }),
    [tag]
  );
  const goBack = useGoBack(getModulePath4(LEAGUE_MODULE_NAMES4.careLibrary));
  return /* @__PURE__ */ React82.createElement(
    Box39,
    {
      css: {
        maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH3,
        margin: "auto",
        width: "100%"
      }
    },
    /* @__PURE__ */ React82.createElement(BackButtonArrow3, { onClick: goBack }),
    /* @__PURE__ */ React82.createElement(MasonryEngine3, { driver: MasonryTopicLibraryDriver })
  );
}

// src/components/configurable-journey-experience/masonryV2/care-collections-page.tsx
import React83 from "react";
import { getMasonryDriver as getMasonryDriver4 } from "@leagueplatform/masonry";
import { getModulePath as getModulePath5, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES5 } from "@leagueplatform/core";
import { MasonryEngine as MasonryEngine4 } from "@leagueplatform/masonry-engine";
import { useGoBack as useGoBack2 } from "@leagueplatform/web-common";
import { BackButtonArrow as BackButtonArrow4 } from "@leagueplatform/web-common-components";
import { Box as Box40 } from "@leagueplatform/genesis-core";
import { CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH as CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH4 } from "@leagueplatform/health-journey-common";
import { useParamsLegacy as useParams3 } from "@leagueplatform/routing";
function CareCollectionsPage() {
  const { tag } = useParams3();
  const MasonryCareCollectionsLibraryDriver = React83.useMemo(
    () => getMasonryDriver4({
      rootNodeId: "core$careLibrary$viewAllCareCollections",
      queryParams: {
        tag
      }
    }),
    [tag]
  );
  const goBack = useGoBack2(getModulePath5(LEAGUE_MODULE_NAMES5.careLibrary));
  return /* @__PURE__ */ React83.createElement(
    Box40,
    {
      css: {
        maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH4,
        margin: "auto",
        width: "100%"
      }
    },
    /* @__PURE__ */ React83.createElement(BackButtonArrow4, { onClick: goBack }),
    /* @__PURE__ */ React83.createElement(MasonryEngine4, { driver: MasonryCareCollectionsLibraryDriver })
  );
}

// src/health-progress-subroutes.tsx
import * as React94 from "react";
import { Routes, Route } from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery18 } from "@leagueplatform/user-profile-api";
import { ENABLE_NEW_JOURNEY_EXPERIENCE } from "@leagueplatform/health-journey-common";

// src/components/configurable-journey-experience/all-activities-by-status/all-activities-by-status.component.tsx
import React85 from "react";
import { useIntl as useIntl44 } from "@leagueplatform/locales";
import { LinkLegacy as Link9 } from "@leagueplatform/routing";
import {
  BackButtonArrow as BackButtonArrow5,
  SkeletonBox as SkeletonBox12
} from "@leagueplatform/web-common-components";
import { DATE_FORMAT as DATE_FORMAT3 } from "@leagueplatform/web-common";
import {
  Flex as Flex23,
  HeadingThree as HeadingThree9,
  Box as Box42,
  BodyTwo as BodyTwo4,
  BodyOneSecondary as BodyOneSecondary6
} from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout28, Box as CoreBox } from "@leagueplatform/genesis-core";
import {
  CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH as CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH5,
  ENABLE_V3_ACTIVITY_CARDS as ENABLE_V3_ACTIVITY_CARDS3,
  JOURNEY_ROUTES as JOURNEY_ROUTES23
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery17 } from "@leagueplatform/user-profile-api";

// src/hooks/use-all-activities-by-activity-status.hook.ts
var useAllActivitiesByActivityStatus = (statusType) => {
  var _a, _b;
  const isStandalone = statusType === "standalone";
  const activityStatuses = getActivityStatusesArray(statusType);
  const allActivitiesQuery = useActivitiesByActivityStatus({
    activityStatuses
  });
  const standaloneActivitiesQuery = useGetUserStandaloneActivities({
    limit: STANDALONE_ACTIVITIES_LIMIT_VIEW_ALL
  });
  if (isStandalone) {
    return __spreadProps(__spreadValues({}, standaloneActivitiesQuery), {
      activities: (_a = standaloneActivitiesQuery == null ? void 0 : standaloneActivitiesQuery.data) == null ? void 0 : _a.userHealthActivities
    });
  }
  return __spreadProps(__spreadValues({}, allActivitiesQuery), {
    activities: (_b = allActivitiesQuery == null ? void 0 : allActivitiesQuery.data) == null ? void 0 : _b.userHealthActivities
  });
};

// src/components/configurable-journey-experience/all-activities-by-status/group-activities-by-date.util.ts
var groupActivitiesByDate = (statusType, activities) => {
  const groupedByDate = activities.reduce(
    (result, activity) => {
      const date = statusType === "completed" ? (
        // Using non-null assertion operator here, as a completed_date must exist for completed activities
        new Date(activity.completedDate).toDateString()
      ) : new Date(activity.endDate).toDateString();
      const existingDateGrouping = result.find(
        (grouping) => grouping.date === date
      );
      if (!existingDateGrouping) {
        result.push({ date, activities: [activity] });
      } else {
        existingDateGrouping.activities.push(activity);
      }
      return result;
    },
    // Setting the initial value as an empty array
    []
  );
  groupedByDate.sort(
    (a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf()
  );
  return groupedByDate;
};

// src/components/configurable-journey-experience/all-activities-by-status/activities-by-date-list.component.tsx
import React84 from "react";
import { useIntl as useIntl43 } from "@leagueplatform/locales";
import { DATE_FORMAT as DATE_FORMAT2 } from "@leagueplatform/web-common";
import { Box as Box41, Overline as Overline4 } from "@leagueplatform/genesis-commons";
var ActivitiesByDateList = ({
  grouping
}) => {
  const { formatDate } = useIntl43();
  return /* @__PURE__ */ React84.createElement(Box41, { as: "li" }, /* @__PURE__ */ React84.createElement(Overline4, { as: "h2", color: "onSurface.text.subdued", marginBottom: "one" }, formatDate(grouping.date, DATE_FORMAT2)), /* @__PURE__ */ React84.createElement(Box41, { as: "ul", marginBottom: "two" }, grouping.activities.map((activity) => /* @__PURE__ */ React84.createElement(
    ConfigurableActivityCard,
    {
      activity,
      key: activity.id,
      activityHeadingLevel: "h3"
    }
  ))));
};

// src/components/configurable-journey-experience/all-activities-by-status/all-activities-by-status.component.tsx
var noopFunction = () => {
};
var StandaloneActivityCard = ({
  activity
}) => {
  const { data: isV3ActivityCardsEnabled } = useFeatureFlagQuery17(
    ENABLE_V3_ACTIVITY_CARDS3
  );
  if (isV3ActivityCardsEnabled) {
    return /* @__PURE__ */ React85.createElement(CoreBox, { as: "li" }, /* @__PURE__ */ React85.createElement(PriorityActivityCard, { activity, headingLevel: "2" }));
  }
  return /* @__PURE__ */ React85.createElement(
    ConfigurableActivityCard,
    {
      activity,
      key: activity.id,
      activityHeadingLevel: "h2"
    }
  );
};
var AllActivitiesByStatusContents = ({
  statusType
}) => {
  const { $tmap } = useIntl44();
  const { activities, isLoading, isError } = useAllActivitiesByActivityStatus(statusType);
  if (isLoading) {
    return /* @__PURE__ */ React85.createElement(Box42, { marginTop: "two" }, Array(4).fill("").map((el, idx) => /* @__PURE__ */ React85.createElement(
      SkeletonBox12,
      {
        backgroundColor: "interactive.background.disabled",
        height: "100px",
        marginBottom: "one",
        key: idx
      }
    )));
  }
  const isStandalone = statusType === "standalone";
  const errorDescription = $tmap({
    completed: "COMPLETED_ACTIVITIES_EMPTY_STATE",
    missed: "MISSED_ACTIVITIES_EMPTY_STATE",
    standalone: "STANDALONE_ACTIVITIES_EMPTY_STATE"
  })(statusType);
  if (isError || !(activities == null ? void 0 : activities.length)) {
    return /* @__PURE__ */ React85.createElement(
      Flex23,
      {
        backgroundColor: "surface.background.secondary",
        borderRadius: "large",
        justifyContent: "center",
        marginTop: "two",
        paddingX: "one",
        paddingY: ["oneAndHalf", "three", "four"],
        textAlign: "center"
      },
      /* @__PURE__ */ React85.createElement(BodyOneSecondary6, null, errorDescription)
    );
  }
  let activitiesGroupedByDate = [];
  if (!isStandalone) {
    activitiesGroupedByDate = groupActivitiesByDate(statusType, activities);
  }
  return isStandalone ? /* @__PURE__ */ React85.createElement(StackLayout28, { as: "ul", spacing: "$one", horizontalAlignment: "stretch" }, activities.map((activity) => /* @__PURE__ */ React85.createElement(StandaloneActivityCard, { key: activity.id, activity }))) : /* @__PURE__ */ React85.createElement(Box42, { as: "ul", width: "100%" }, activitiesGroupedByDate.map((grouping) => /* @__PURE__ */ React85.createElement(ActivitiesByDateList, { grouping, key: grouping.date })));
};
var AllActivitiesByStatus = ({
  statusType
}) => {
  const { formatMessage, $tmap, formatDate } = useIntl44();
  const sectionTitle = $tmap({
    completed: "COMPLETED_ACTIVITIES",
    missed: "MISSED_ACTIVITIES",
    standalone: "STANDALONE_ACTIVITIES"
  })(statusType);
  const lastYear = new Date(
    (/* @__PURE__ */ new Date()).setFullYear((/* @__PURE__ */ new Date()).getFullYear() - 1)
  );
  const isStandalone = statusType === "standalone";
  return /* @__PURE__ */ React85.createElement(
    Flex23,
    {
      width: "100%",
      maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH5,
      margin: "auto",
      paddingX: "one",
      paddingTop: { _: "two", laptop: "four" },
      paddingBottom: "one"
    },
    /* @__PURE__ */ React85.createElement(
      BackButtonArrow5,
      {
        as: Link9,
        marginInlineEnd: "one",
        marginTop: "quarter",
        onClick: noopFunction,
        to: JOURNEY_ROUTES23.progressHome
      }
    ),
    /* @__PURE__ */ React85.createElement(StackLayout28, { spacing: "$two", css: { width: "100%" } }, /* @__PURE__ */ React85.createElement(StackLayout28, { spacing: "$half" }, /* @__PURE__ */ React85.createElement(HeadingThree9, { as: "h1" }, sectionTitle), !isStandalone && /* @__PURE__ */ React85.createElement(BodyTwo4, null, formatMessage(
      {
        id: "DISPLAYING_ACTIVITIES_FROM_DATE"
      },
      {
        date: formatDate(lastYear, DATE_FORMAT3)
      }
    ))), /* @__PURE__ */ React85.createElement(AllActivitiesByStatusContents, { statusType }))
  );
};

// src/pages/main/health-journey-page.component.js
import React93 from "react";
import PropTypes13 from "prop-types";
import { Flex as Flex24 } from "@leagueplatform/genesis-commons";
import {
  PillTabs,
  PillTab,
  PillTabList
} from "@leagueplatform/web-common-components";
import { Tabs as Tabs3 } from "@leagueplatform/genesis-core";
import {
  useLeaveProgramModal,
  LeaveProgramPulseCheckModal
} from "@leagueplatform/health-programs";

// src/hooks/use-health-pills.hook.js
import { useState as useState7, useEffect as useEffect9 } from "react";
import {
  useNavigateLegacy as useNavigate8,
  useLocationLegacy as useLocation6
} from "@leagueplatform/routing";
import { useIntl as useIntl45 } from "@leagueplatform/locales";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES24,
  SCREEN_NAMES as SCREEN_NAMES18
} from "@leagueplatform/health-journey-common";
import { useDocumentTitle as useDocumentTitle5 } from "@leagueplatform/web-common";
var { ACTIVITY_TIMELINE, PROGRESS_PAGE: PROGRESS_PAGE2 } = SCREEN_NAMES18;
var { journeyHome, progressHome } = JOURNEY_ROUTES24;
var useHealthPills = () => {
  const location = useLocation6();
  const navigate = useNavigate8();
  const { formatMessage } = useIntl45();
  const progressAnalytics = useJourneyProgressAnalytics();
  const [activeIndex, setActiveIndex] = useState7(0);
  const tabs = [
    {
      label: formatMessage({ id: "ACTIVITIES_PILL" }),
      onClick: () => {
        progressAnalytics.sendPillNavigation({
          from: PROGRESS_PAGE2,
          to: "activities"
        });
        navigate(journeyHome());
      },
      index: 0,
      page: "activities",
      documentTitle: formatMessage({ id: "HEALTH_JOURNEY" }),
      isCurrentPage: location.pathname.includes(journeyHome())
    },
    {
      label: formatMessage({ id: "PROGRESS" }),
      onClick: () => {
        progressAnalytics.sendPillNavigation({
          from: ACTIVITY_TIMELINE,
          to: "progress"
        });
        navigate(progressHome());
      },
      index: 1,
      page: "progress",
      documentTitle: formatMessage({ id: "PROGRESS" }),
      isCurrentPage: location.pathname.includes(progressHome())
    }
  ];
  const { documentTitle } = tabs[activeIndex];
  useDocumentTitle5(documentTitle);
  useEffect9(() => {
    var _a;
    const currentIndex = (_a = tabs.find((tab) => tab.isCurrentPage)) == null ? void 0 : _a.index;
    setActiveIndex(currentIndex != null ? currentIndex : activeIndex);
  }, []);
  const handleIndexChange = (index) => {
    setActiveIndex(index);
    tabs[index].onClick();
  };
  return {
    tabs,
    activeIndex,
    handleIndexChange
  };
};

// src/pages/main/components/journey-page-content.component.jsx
import React92, { useMemo as useMemo8, useState as useState8 } from "react";
import { Box as Box45, VisuallyHidden as VisuallyHidden3 } from "@leagueplatform/genesis-commons";
import {
  ErrorState as ErrorState4,
  LoadingIndicator as LoadingIndicator2
} from "@leagueplatform/web-common-components";
import {
  ViewTransitionController as ViewTransitionController2,
  SCREEN_NAMES as SCREEN_NAMES19
} from "@leagueplatform/health-journey-common";
import { useIntl as useIntl47 } from "@leagueplatform/locales";

// src/hooks/use-empty-activities-state.hook.js
import { handleStaticAsset as handleStaticAsset14 } from "@leagueplatform/asset-config";
import { useIntl as useIntl46 } from "@leagueplatform/locales";
var { EMPTY_STATE_PROGRAMS: EMPTY_STATE_PROGRAMS2, EMPTY_STATE_REST: EMPTY_STATE_REST2, HIGH_FIVE: HIGH_FIVE2 } = HEALTH_JOURNEY_ASSET_KEYS;
var defaultEmptyStateInfo = {
  diffOfDates: 0,
  hasActivities: false,
  hasCompletedAllActivities: false
};
var useEmptyActivitiesState = ({
  diffOfDates,
  hasActivities,
  hasCompletedAllActivities
} = defaultEmptyStateInfo) => {
  const { formatMessage } = useIntl46();
  if (hasCompletedAllActivities)
    return emptyStateTodayCompleted(formatMessage);
  if (hasActivities)
    return null;
  if (diffOfDates > 0)
    return emptyStateFuture(formatMessage);
  if (diffOfDates < 0)
    return emptyStatePast(formatMessage);
  return emptyStateToday(formatMessage);
};
var emptyStateFuture = (formatMessage) => {
  const emptyStatePrograms2 = handleStaticAsset14(EMPTY_STATE_PROGRAMS2);
  return {
    button: null,
    image: {
      alt: formatMessage({ id: "IMG_ALT_EMPTY_STATE_PROGRAMS" }),
      src: emptyStatePrograms2
    },
    text: {
      bodyText: formatMessage({
        id: "NO_ACTIVITIES_FUTURE_DESCRIPTION"
      }),
      headingText: formatMessage({
        id: "NO_ACTIVITIES_HAS_PROGRAMS_TODAY_OR_FUTURE_HEADING"
      })
    }
  };
};
var emptyStatePast = (formatMessage) => {
  const emptyStateRest2 = handleStaticAsset14(EMPTY_STATE_REST2);
  return {
    button: null,
    image: {
      alt: formatMessage({ id: "IMG_ALT_EMPTY_STATE_REST" }),
      src: emptyStateRest2
    },
    text: {
      bodyText: formatMessage({
        id: "NO_ACTIVITIES_PAST_DESCRIPTION"
      }),
      headingText: formatMessage({
        id: "NO_ACTIVITIES_PAST_HEADING"
      })
    }
  };
};
var emptyStateToday = (formatMessage) => {
  const emptyStatePrograms2 = handleStaticAsset14(EMPTY_STATE_PROGRAMS2);
  return {
    button: formatMessage({ id: "BUTTON_BROWSE_PROGRAMS" }),
    image: {
      alt: formatMessage({ id: "IMG_ALT_EMPTY_STATE_PROGRAMS" }),
      src: emptyStatePrograms2
    },
    text: {
      bodyText: formatMessage({
        id: "NO_ACTIVITIES_HAS_PROGRAMS_TODAY_DESCRIPTION"
      }),
      headingText: formatMessage({
        id: "NO_ACTIVITIES_HAS_PROGRAMS_TODAY_OR_FUTURE_HEADING"
      })
    }
  };
};
var emptyStateTodayCompleted = (formatMessage) => {
  const highFiveHands = handleStaticAsset14(HIGH_FIVE2);
  return {
    button: null,
    image: {
      alt: formatMessage({ id: "IMG_ALT_HIGH_FIVE_HANDS" }),
      src: highFiveHands
    },
    text: {
      bodyText: formatMessage({
        id: "NO_ACTIVITIES_COMPLETED_TODAY_DESCRIPTION"
      }),
      headingText: formatMessage({
        id: "NO_ACTIVITIES_COMPLETED_TODAY_HEADING"
      })
    }
  };
};

// src/hooks/use-health-journey-page.hook.js
import { useQuery as useQuery10 } from "react-query";
import {
  getSuggestedUserActivityGroups,
  GET_SUGGESTED_ACTIVITY_GROUPS
} from "@leagueplatform/health-journey-api";
var useHealthJourneyPage = (activeDate, todaysDate) => {
  var _a, _b;
  const {
    data: healthActivitiesData,
    isLoading: healthActivitiesDataLoading,
    isError: healthActivitiesDataError
  } = useGetUserHealthActivities(activeDate, todaysDate);
  const { data, isError, isLoading } = useQuery10(
    GET_SUGGESTED_ACTIVITY_GROUPS,
    () => getSuggestedUserActivityGroups()
  );
  const suggestedGroups = (_a = data == null ? void 0 : data.suggested_activities_groups) != null ? _a : [];
  return {
    activities: {
      ready: !healthActivitiesDataLoading,
      hasError: healthActivitiesDataError,
      hasActivities: ((_b = healthActivitiesData == null ? void 0 : healthActivitiesData.data) == null ? void 0 : _b.length) > 0,
      allActivities: healthActivitiesData == null ? void 0 : healthActivitiesData.data,
      activitiesByCampaign: healthActivitiesData == null ? void 0 : healthActivitiesData.activitiesByCampaign,
      activitiesByStatus: healthActivitiesData == null ? void 0 : healthActivitiesData.activitiesByStatus,
      activitiesByAssigned: healthActivitiesData == null ? void 0 : healthActivitiesData.activitiesByAssigned,
      activitiesByPriority: healthActivitiesData == null ? void 0 : healthActivitiesData.activitiesByPriority,
      activitiesByChallenge: healthActivitiesData == null ? void 0 : healthActivitiesData.activitiesByChallenge,
      hasCompletedAllActivities: healthActivitiesData == null ? void 0 : healthActivitiesData.hasCompletedAllActivities
    },
    suggestedActivities: {
      ready: !isLoading,
      hasError: isError,
      groups: suggestedGroups
    }
  };
};

// src/pages/main/components/journey-page-content.component.jsx
import { usePageViewAnalytics, PRODUCT_AREA as PRODUCT_AREA22 } from "@leagueplatform/analytics";

// src/components/suggested-activities.component.js
import * as React87 from "react";
import PropTypes12 from "prop-types";
import {
  HeadingTwo as HeadingTwo6,
  BodyOneSecondary as BodyOneSecondary7,
  Box as Box43,
  genesisStyled as genesisStyled18
} from "@leagueplatform/genesis-commons";
import { JOURNEY_ROUTES as JOURNEY_ROUTES25 } from "@leagueplatform/health-journey-common";

// src/components/suggested-activities-card.component.js
import * as React86 from "react";
import PropTypes11 from "prop-types";
import { LinkLegacy as RouterLink4 } from "@leagueplatform/routing";
import {
  genesisStyled as genesisStyled17,
  Image as Image10,
  Link as Link10,
  SubtitleOne as SubtitleOne5
} from "@leagueplatform/genesis-commons";
var ActivityLink = genesisStyled17(Link10)(
  ({ theme: { shadows, space, radii, colors } }) => `
  &:after {
    border: solid 1px transparent;
    border-radius: ${radii.large}px;
    bottom: -${space.half}px;
    box-shadow: none;
    content: "";
    display: block;
    inset-inline-start: -${space.half}px;
    position: absolute;
    inset-inline-end: -${space.half}px;
    top: -${space.quarter}px;
    transition: border-color 150ms, box-shadow 150ms;
    z-index: -1;
  }
  &:hover {
    text-decoration: none;
    &:after {
      border-color: ${colors.onSurface.border.subdued};
      box-shadow: ${shadows.card};
    }
  }
`
);
var SuggestedActivitiesCard = ({ name, image, path, onClick }) => /* @__PURE__ */ React86.createElement(
  ActivityLink,
  {
    as: RouterLink4,
    display: "block",
    height: "100%",
    paddingY: "quarter",
    position: "relative",
    to: path,
    onClick
  },
  /* @__PURE__ */ React86.createElement(
    Image10,
    {
      alt: "",
      borderRadius: "medium",
      marginBottom: "half",
      maxWidth: "100%",
      src: image
    }
  ),
  /* @__PURE__ */ React86.createElement(SubtitleOne5, { as: "p" }, name)
);
SuggestedActivitiesCard.propTypes = {
  name: PropTypes11.string,
  image: PropTypes11.string,
  path: PropTypes11.string,
  onClick: PropTypes11.func
};
SuggestedActivitiesCard.defaultProps = {
  name: "",
  path: "",
  image: "",
  onClick: null
};

// src/components/suggested-activities.component.js
var ActivityContainer = genesisStyled18(Box43)(
  ({ theme: { space, breakpoints } }) => `
  display: grid;
  grid-column-gap: ${space.two}px;
  grid-row-gap: ${space.oneAndHalf}px;
  grid-template-columns: repeat(2, minmax(0, 42rem));
  @media screen and (max-width: ${breakpoints.tablet}) {
    grid-column-gap: ${space.oneAndHalf}px;
  }
  @media screen and (max-width: ${breakpoints.phone}) {
    grid-column-gap: ${space.one}px;
  }
`
);
var SuggestedActivities = (_a) => {
  var _b = _a, {
    description,
    suggestedActivities,
    title,
    activeDate
  } = _b, props = __objRest(_b, [
    "description",
    "suggestedActivities",
    "title",
    "activeDate"
  ]);
  const { selectSuggestedActivityGroup } = useActivitiesTimelineAnalytics(activeDate);
  const orderedActivities = (suggestedActivities == null ? void 0 : suggestedActivities.sort(
    (a, b) => (a == null ? void 0 : a.activity_count) > (b == null ? void 0 : b.activity_count) ? -1 : 1
  )) || [];
  return /* @__PURE__ */ React87.createElement(
    Box43,
    __spreadValues({
      borderTopColor: "onSurface.border.subdued",
      borderTopWidth: "thick",
      paddingTop: "twoAndHalf"
    }, props),
    title && /* @__PURE__ */ React87.createElement(HeadingTwo6, null, title),
    description && /* @__PURE__ */ React87.createElement(BodyOneSecondary7, { marginTop: "half" }, description),
    orderedActivities.length > 0 && /* @__PURE__ */ React87.createElement(ActivityContainer, { as: "ul", marginY: "two" }, orderedActivities == null ? void 0 : orderedActivities.map(
      ({ name, icon_url, suggested_activity_group_id }, index) => /* @__PURE__ */ React87.createElement("li", { key: suggested_activity_group_id }, /* @__PURE__ */ React87.createElement(
        SuggestedActivitiesCard,
        {
          name,
          image: icon_url,
          path: JOURNEY_ROUTES25.getSuggestedActivity(
            suggested_activity_group_id
          ),
          onClick: () => selectSuggestedActivityGroup(index + 1, name)
        }
      ))
    ))
  );
};
SuggestedActivities.propTypes = {
  description: PropTypes12.string,
  suggestedActivities: PropTypes12.arrayOf(
    PropTypes12.shape({
      name: PropTypes12.string,
      icon_url: PropTypes12.string,
      suggested_activity_group_id: PropTypes12.string
    })
  ),
  title: PropTypes12.string,
  activeDate: PropTypes12.number.isRequired
};
SuggestedActivities.defaultProps = {
  description: "",
  suggestedActivities: [],
  title: ""
};

// src/pages/main/components/journey-page-content.component.jsx
import { useQueryClient as useQueryClient6 } from "react-query";
import { GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE5 } from "@leagueplatform/health-journey-api";

// src/pages/main/components/journey-timeline-activities-list.component.jsx
import React89 from "react";
import { bool as bool4, number as number6 } from "prop-types";

// src/pages/main/components/journey-timeline-empty-state.component.jsx
import React88 from "react";
import { Image as Image11, PrimaryButton as PrimaryButton4 } from "@leagueplatform/genesis-commons";
import { JOURNEY_ROUTES as JOURNEY_ROUTES26 } from "@leagueplatform/health-journey-common";
import { LinkLegacy as Link11 } from "@leagueplatform/routing";
var JourneyTimelineEmptyState = (_a) => {
  var _b = _a, { emptyStateContent } = _b, props = __objRest(_b, ["emptyStateContent"]);
  var _a2, _b2, _c, _d;
  return /* @__PURE__ */ React88.createElement(
    EmptyStateCard2,
    __spreadValues({
      graphic: /* @__PURE__ */ React88.createElement(
        Image11,
        {
          src: (_a2 = emptyStateContent == null ? void 0 : emptyStateContent.image) == null ? void 0 : _a2.src,
          alt: (_b2 = emptyStateContent == null ? void 0 : emptyStateContent.image) == null ? void 0 : _b2.alt
        }
      ),
      bodyText: (_c = emptyStateContent == null ? void 0 : emptyStateContent.text) == null ? void 0 : _c.bodyText,
      headingText: (_d = emptyStateContent == null ? void 0 : emptyStateContent.text) == null ? void 0 : _d.headingText
    }, props),
    (emptyStateContent == null ? void 0 : emptyStateContent.button) && /* @__PURE__ */ React88.createElement(
      PrimaryButton4,
      {
        as: Link11,
        textDecoration: "none",
        to: JOURNEY_ROUTES26.programsHome
      },
      emptyStateContent.button
    )
  );
};
JourneyTimelineEmptyState.propTypes = journeyPageEmptyStateProps;
JourneyTimelineEmptyState.defaultProps = {
  button: null
};

// src/pages/main/components/journey-timeline-activities-list.component.jsx
var JourneyTimelineActivitiesList = ({
  hasCompletedAllActivities,
  emptyStateContent,
  activitiesByCampaign,
  activitiesByStatus,
  activitiesByAssigned,
  activitiesByPriority,
  activitiesByChallenge,
  allActivities,
  activeDate
}) => /* @__PURE__ */ React89.createElement(React89.Fragment, null, hasCompletedAllActivities && emptyStateContent && /* @__PURE__ */ React89.createElement(
  JourneyTimelineEmptyState,
  {
    marginBottom: "four",
    emptyStateContent
  }
), /* @__PURE__ */ React89.createElement(
  HealthActivities,
  {
    activitiesByCampaign,
    activitiesByStatus,
    activitiesByAssigned,
    activitiesByPriority,
    activitiesByChallenge,
    allActivities,
    activeDate
  }
));
JourneyTimelineActivitiesList.propTypes = __spreadProps(__spreadValues(__spreadValues({}, activitiesGroupsProps), journeyPageEmptyStateProps), {
  hasCompletedAllActivities: bool4.isRequired,
  activeDate: number6.isRequired
});
JourneyTimelineActivitiesList.defaultProps = __spreadValues({}, activitiesGroupsDefaultProps);

// src/pages/main/components/journey-timeline-empty-with-challenges.component.jsx
import React90 from "react";
import { number as number7 } from "prop-types";
var EmptyStateWithChallenges = ({
  emptyStateContent,
  activeDate,
  allActivities
}) => /* @__PURE__ */ React90.createElement(React90.Fragment, null, /* @__PURE__ */ React90.createElement(
  JourneyTimelineEmptyState,
  {
    marginBottom: "four",
    emptyStateContent
  }
), /* @__PURE__ */ React90.createElement(
  ChallengeActivities,
  {
    activeDate,
    allActivities
  }
));
EmptyStateWithChallenges.propTypes = __spreadProps(__spreadValues(__spreadValues({}, activitiesGroupsProps), journeyPageEmptyStateProps), {
  activeDate: number7.isRequired
});
EmptyStateWithChallenges.defaultProps = __spreadValues({}, activitiesGroupsDefaultProps);

// src/pages/main/components/journey-page-header.component.jsx
import React91 from "react";
import { func as func2, number as number8 } from "prop-types";
import { Box as Box44 } from "@leagueplatform/genesis-commons";
var JourneyPageHeader = ({
  activeDate,
  setActiveDate,
  todaysDate
}) => {
  const { navigateToToday, navigateToDate } = useActivitiesTimelineAnalytics(activeDate);
  const onChangeDateNavigation = ({ date, incr }) => {
    if (incr === 0) {
      navigateToToday();
    } else {
      const direction = incr === -1 ? "backward" : "forward";
      navigateToDate(date, direction);
    }
    setActiveDate(date);
  };
  return /* @__PURE__ */ React91.createElement(Box44, null, activeDate && todaysDate && /* @__PURE__ */ React91.createElement(
    NavigateByDate,
    {
      currentDate: activeDate,
      onChangeDate: onChangeDateNavigation,
      paddingBottom: "two",
      todaysDate
    }
  ));
};
JourneyPageHeader.propTypes = {
  todaysDate: number8.isRequired,
  activeDate: number8.isRequired,
  setActiveDate: func2.isRequired
};

// src/pages/main/components/journey-page-content.component.jsx
var { ACTIVITIES, EMPTY, LOADING, ERROR } = Object.freeze({
  ACTIVITIES: "activities",
  EMPTY: "empty",
  ERROR: "error",
  LOADING: "loading"
});
var Loader = () => /* @__PURE__ */ React92.createElement(
  Box45,
  {
    position: "relative",
    minHeight: "30vh",
    height: "auto",
    width: "100%",
    "data-testid": "loading-indicator"
  },
  /* @__PURE__ */ React92.createElement(LoadingIndicator2, null)
);
var JourneyPageContent = ({ todaysDate }) => {
  var _a;
  const [activeDate, setActiveDate] = useState8(todaysDate);
  const { activities, suggestedActivities } = useHealthJourneyPage(
    activeDate,
    todaysDate
  );
  const {
    ready,
    hasError,
    hasActivities,
    allActivities,
    activitiesByCampaign,
    activitiesByStatus,
    activitiesByAssigned,
    activitiesByPriority,
    activitiesByChallenge,
    hasCompletedAllActivities
  } = activities;
  usePageViewAnalytics(
    {
      product_area: PRODUCT_AREA22.JOURNEY,
      screen_name: SCREEN_NAMES19.ACTIVITY_TIMELINE
    },
    [ready]
  );
  const { formatMessage, formatDate } = useIntl47();
  const queryClient = useQueryClient6();
  const refetchQueries = () => {
    queryClient.invalidateQueries([
      GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE5,
      activeDate
    ]);
  };
  const diffOfDates = getDiffOfDates(
    new Date(todaysDate),
    new Date(activeDate)
  );
  const emptyStateContent = useEmptyActivitiesState({
    diffOfDates,
    hasActivities,
    hasCompletedAllActivities
  });
  const statusMessage = useMemo8(() => {
    if (!ready) {
      return formatMessage({
        id: "LOADING"
      });
    }
    if (ready && activeDate) {
      return formatDate(activeDate, {
        month: "long",
        day: "numeric"
      });
    }
    return "";
  }, [activeDate, formatDate, formatMessage, ready]);
  const isEmptyWithNoActivities = emptyStateContent && !hasCompletedAllActivities;
  const showSuggestedActivities = (suggestedActivities == null ? void 0 : suggestedActivities.ready) && ((_a = suggestedActivities == null ? void 0 : suggestedActivities.groups) == null ? void 0 : _a.length) > 0 && diffOfDates === 0;
  const handleActiveView = () => {
    if (!ready)
      return LOADING;
    if (hasError)
      return ERROR;
    if (isEmptyWithNoActivities)
      return EMPTY;
    return ACTIVITIES;
  };
  const activityViews = {
    [ACTIVITIES]: {
      view: JourneyTimelineActivitiesList,
      props: {
        hasCompletedAllActivities,
        emptyStateContent,
        activitiesByCampaign,
        activitiesByStatus,
        activitiesByAssigned,
        activitiesByPriority,
        activitiesByChallenge,
        allActivities,
        activeDate
      }
    },
    [EMPTY]: {
      view: EmptyStateWithChallenges,
      props: {
        emptyStateContent,
        activeDate,
        allActivities
      }
    },
    [ERROR]: {
      view: ErrorState4,
      props: {
        onButtonClick: refetchQueries
      }
    },
    [LOADING]: Loader
  };
  return /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(VisuallyHidden3, { "aria-live": "polite", role: "status" }, statusMessage), /* @__PURE__ */ React92.createElement(
    JourneyPageHeader,
    {
      todaysDate,
      activeDate,
      setActiveDate
    }
  ), /* @__PURE__ */ React92.createElement(Box45, { paddingY: "two" }, /* @__PURE__ */ React92.createElement(
    ViewTransitionController2,
    {
      handleActiveView,
      views: activityViews
    }
  )), showSuggestedActivities && /* @__PURE__ */ React92.createElement(
    SuggestedActivities,
    {
      description: formatMessage({
        id: "DISCOVER_ACTIVITIES_CAPTION"
      }),
      suggestedActivities: suggestedActivities == null ? void 0 : suggestedActivities.groups,
      title: formatMessage({ id: "DISCOVER_ACTIVITIES" }),
      todaysDate,
      activeDate
    }
  ));
};
JourneyPageContent.propTypes = journeyPageProps;

// src/pages/main/health-journey-page.component.js
var HealthJourneyPage = ({ todaysDate }) => {
  const { activeIndex, handleIndexChange, tabs } = useHealthPills();
  const {
    showLeaveProgramPulseCheck,
    setShowLeaveProgramPulseCheck,
    leaveProgramPulseCheckState
  } = useLeaveProgramModal();
  const tabContent = {
    activities: /* @__PURE__ */ React93.createElement(JourneyPageContent, { todaysDate }),
    progress: /* @__PURE__ */ React93.createElement(CampaignProgressContent, null)
  };
  return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(JourneyPageLayout, null, /* @__PURE__ */ React93.createElement(
    PillTabs,
    {
      defaultValue: tabs[activeIndex].label,
      onValueChange: (value) => handleIndexChange(tabs.findIndex((tab) => tab.label === value))
    },
    /* @__PURE__ */ React93.createElement(
      Flex24,
      {
        marginBottom: "twoAndHalf",
        justifyContent: { _: "center", phone: "initial" }
      },
      /* @__PURE__ */ React93.createElement(PillTabList, null, tabs.map((tab) => /* @__PURE__ */ React93.createElement(PillTab, { key: tab.index, value: tab.label }, tab.label)))
    ),
    tabs.map((tab) => /* @__PURE__ */ React93.createElement(Tabs3.TabPanel, { key: tab.index, value: tab.label }, tabContent[tab.page]))
  )), showLeaveProgramPulseCheck && /* @__PURE__ */ React93.createElement(
    LeaveProgramPulseCheckModal,
    {
      onClose: () => setShowLeaveProgramPulseCheck(false),
      programId: leaveProgramPulseCheckState == null ? void 0 : leaveProgramPulseCheckState.programId
    }
  ));
};
HealthJourneyPage.propTypes = {
  todaysDate: PropTypes13.number
};
HealthJourneyPage.defaultProps = {
  todaysDate: normalizeEpochDate(Date.now())
};

// src/health-progress-subroutes.tsx
var HealthJourneyProgressSubroutes = () => {
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery18(
    ENABLE_NEW_JOURNEY_EXPERIENCE
  );
  return /* @__PURE__ */ React94.createElement(Routes, null, isNewJourneyExperienceEnabled && /* @__PURE__ */ React94.createElement(React94.Fragment, null, /* @__PURE__ */ React94.createElement(
    Route,
    {
      path: "standalone/*",
      element: /* @__PURE__ */ React94.createElement(AllActivitiesByStatus, { statusType: "standalone" })
    }
  ), /* @__PURE__ */ React94.createElement(
    Route,
    {
      path: "completed-history/*",
      element: /* @__PURE__ */ React94.createElement(AllActivitiesByStatus, { statusType: "completed" })
    }
  ), /* @__PURE__ */ React94.createElement(
    Route,
    {
      path: "missed-history/*",
      element: /* @__PURE__ */ React94.createElement(AllActivitiesByStatus, { statusType: "missed" })
    }
  )), /* @__PURE__ */ React94.createElement(Route, { index: true, element: /* @__PURE__ */ React94.createElement(HealthJourneyPage, null) }));
};

// src/health-journey-subroutes.tsx
import * as React165 from "react";
import { Routes as Routes2, Route as Route2 } from "@leagueplatform/routing";
import {
  ChallengeRoutes,
  useIsChallengesEnabled
} from "@leagueplatform/challenges";
import {
  HEALTH_ASSESSMENT_REPORT as HEALTH_ASSESSMENT_REPORT2,
  JOURNEY_WELLNESS_AND_REWARDS,
  REWARDS_PROGRAMS_ENABLED
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery20 } from "@leagueplatform/user-profile-api";
import { RewardProgramLandingPage } from "@leagueplatform/rewards-programs";

// src/pages/health-assessment-report/health-assessment-report-page.tsx
import * as React95 from "react";
import Masonry3 from "@leagueplatform/masonry";
import {
  SCREEN_NAMES as SCREEN_NAMES20,
  HEALTH_JOURNEY_MASONRY_VERSION as HEALTH_JOURNEY_MASONRY_VERSION8,
  HEALTH_ASSESSMENT_REPORT
} from "@leagueplatform/health-journey-common";
import { PRODUCT_AREA as PRODUCT_AREA23 } from "@leagueplatform/analytics";
var MasonryComposer = Masonry3.init({
  appId: HEALTH_ASSESSMENT_REPORT,
  apiVersion: HEALTH_JOURNEY_MASONRY_VERSION8,
  analytics: {
    productArea: PRODUCT_AREA23.JOURNEY,
    screenName: SCREEN_NAMES20.HEALTH_ASSESSMENT_REPORT
  }
});
function HealthAssessmentReport() {
  return /* @__PURE__ */ React95.createElement(MasonryComposer.Provider, null);
}

// src/components/configurable-journey-experience/masonryV2/view-all-page-wrapper/view-all-page-wrapper.component.tsx
import { StackLayout as StackLayout29 } from "@leagueplatform/genesis-core";
import { GenericMasonryPage } from "@leagueplatform/masonry";
import React96 from "react";
var PageWrapperComponent = ({ children }) => /* @__PURE__ */ React96.createElement(StackLayout29, { horizontalAlignment: "stretch" }, children);
function ViewAllPageWrapper(props) {
  return /* @__PURE__ */ React96.createElement(
    GenericMasonryPage,
    __spreadValues({
      pageWrapperComponent: PageWrapperComponent
    }, props)
  );
}

// src/pages/suggested-activities-page/suggested-activities-page.component.js
import React97 from "react";
import { usePageViewAnalytics as usePageViewAnalytics2, PRODUCT_AREA as PRODUCT_AREA24 } from "@leagueplatform/analytics";
import { Box as Box46, SubtitleTwo as SubtitleTwo4 } from "@leagueplatform/genesis-commons";
import {
  LoadingIndicator as LoadingIndicator3,
  ErrorState as ErrorState5
} from "@leagueplatform/web-common-components";
import { JOURNEY_ROUTES as JOURNEY_ROUTES27 } from "@leagueplatform/health-journey-common";

// src/pages/suggested-activities-page/use-suggested-activities.hook.js
import { useQuery as useQuery11 } from "react-query";
import { useParamsLegacy as useParams4 } from "@leagueplatform/routing";
import {
  getSuggestedUserActivities,
  GET_SUGGESTED_ACTIVITIES
} from "@leagueplatform/health-journey-api";
var useSuggestedActivities = () => {
  var _a;
  const { groupId } = useParams4();
  const { data, isLoading, isError, error } = useQuery11(
    [GET_SUGGESTED_ACTIVITIES, groupId],
    () => getSuggestedUserActivities(groupId)
  );
  const {
    name: title,
    icon_url: iconUrl,
    description,
    suggested_activity_group_id: suggestedActivityGroupId
  } = (_a = data == null ? void 0 : data.suggested_activity_group) != null ? _a : {};
  const activities = data == null ? void 0 : data.user_health_activities;
  return {
    ready: !isLoading,
    hasError: isError,
    activityArray: activities,
    error,
    suggestedGroup: {
      title,
      iconUrl,
      description,
      suggestedActivityGroupId
    }
  };
};

// src/pages/suggested-activities-page/suggested-activities-page.component.js
var SuggestedActivitiesPage = (props) => {
  const { ready, hasError, activityArray, suggestedGroup, error } = useSuggestedActivities();
  const SuggestedActivitiesWrapper = (wrapperProps) => /* @__PURE__ */ React97.createElement(
    ActivityDetailsWrapper,
    __spreadValues({
      to: JOURNEY_ROUTES27.journeyHome(),
      "data-testid": "suggested-activities-page-wrapper"
    }, wrapperProps)
  );
  usePageViewAnalytics2(
    {
      product_area: PRODUCT_AREA24.JOURNEY,
      screen_name: "health journey activities suggested group",
      suggested_activity_group_name: suggestedGroup == null ? void 0 : suggestedGroup.suggestedActivityGroupId
    },
    [suggestedGroup.suggestedActivityGroupId]
  );
  if (!ready) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
      /* @__PURE__ */ React97.createElement(SuggestedActivitiesWrapper, __spreadValues({}, props), /* @__PURE__ */ React97.createElement(LoadingIndicator3, null))
    );
  }
  if (hasError) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
      /* @__PURE__ */ React97.createElement(SuggestedActivitiesWrapper, __spreadValues({}, props), /* @__PURE__ */ React97.createElement(Box46, { marginTop: "three" }, /* @__PURE__ */ React97.createElement(ErrorState5, { error })))
    );
  }
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    /* @__PURE__ */ React97.createElement(SuggestedActivitiesWrapper, __spreadValues({}, props), /* @__PURE__ */ React97.createElement(ActivityDetailsHeader, __spreadProps(__spreadValues({}, suggestedGroup), { iconUrl: "" }), /* @__PURE__ */ React97.createElement(
      SubtitleTwo4,
      {
        as: "h2",
        color: "onSurface.text.subdued",
        fontWeight: "regular",
        marginBottom: "oneAndHalf"
      },
      suggestedGroup == null ? void 0 : suggestedGroup.description
    )), /* @__PURE__ */ React97.createElement(
      HealthActivityCardList,
      {
        activityArray,
        suggestedActivityGroupName: suggestedGroup == null ? void 0 : suggestedGroup.title
      }
    ))
  );
};

// src/pages/health-activity/health-activity-page.component.tsx
import React149 from "react";

// src/pages/health-activity/hooks/use-health-activity-toolbox.hook.ts
var useHealthActivityToolbox = () => {
  const { userActivityId, campaignId, contentActivityId } = useActivityParams();
  const {
    isLoading,
    isRefetching,
    isError,
    data: healthActivityData
  } = useGetUserHealthActivityByIdData(
    campaignId,
    contentActivityId,
    userActivityId
  );
  return {
    hasError: isError,
    healthActivityData,
    ready: !isLoading && !isRefetching
  };
};

// src/pages/health-activity/hooks/use-health-activity-analytics.hook.ts
import { useMemo as useMemo9 } from "react";
import {
  trackAnalyticsEvent as trackAnalyticsEvent20,
  PRODUCT_AREA as PRODUCT_AREA25,
  EVENT_NAME as EVENT_NAME20
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES21 } from "@leagueplatform/health-journey-common";
var { BUTTON_CLICKED: BUTTON_CLICKED4, SCREEN_LOADED: SCREEN_LOADED4 } = EVENT_NAME20;
var useHealthActivityAnalytics = () => {
  const { healthActivityData } = useHealthActivityToolbox();
  const {
    id,
    name,
    status,
    userHealthCampaign,
    frontOfTheLineActivity,
    pages = []
  } = healthActivityData != null ? healthActivityData : {};
  const totalPages = pages.length;
  const userHealthCampaignData = userHealthCampaign == null ? void 0 : userHealthCampaign.data;
  const baseAnalytics = useMemo9(() => {
    const meta2 = {
      product_area: PRODUCT_AREA25.JOURNEY,
      screen_name: SCREEN_NAMES21.ACTIVITY_DETAILS
    };
    const data = {
      health_campaign_activity_name: name,
      health_campaign_activity_type: "healthJourney_toolboxActivity",
      // TODO: wait BE send the correct value
      health_campaign_activity_id: id,
      health_campaign_activity_status: status,
      health_campaign_type: (userHealthCampaignData == null ? void 0 : userHealthCampaignData.campaignType) || null,
      // Once we handle other types of activities, like manual multi-step, etc,
      // that has ux_types like step or counter, then we can consider changing
      // it to a value other than null.
      health_campaign_activity_ux_type: null
    };
    return Object.assign(meta2, data);
  }, [id, name, status, userHealthCampaignData == null ? void 0 : userHealthCampaignData.campaignType]);
  return useMemo9(
    () => ({
      sendCompleteActivity(ctaText) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "complete health campaign activity",
          sub_detail: ctaText || null,
          health_campaign_activity_goal: null,
          health_campaign_activity_current_progress: null,
          is_fotl: frontOfTheLineActivity || null
        }));
      },
      sendNextPage(currentPage) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          current_step: currentPage,
          total_steps: totalPages,
          detail: "next step",
          health_campaign_activity_goal: null,
          health_campaign_activity_current_progress: null
        }));
      },
      sendPreviousPage(currentPage) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          current_step: currentPage,
          total_steps: totalPages,
          detail: "previous step",
          health_campaign_activity_goal: null,
          health_campaign_activity_current_progress: null
        }));
      },
      sendCloseActivity(currentPage) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          current_step: currentPage,
          total_steps: totalPages,
          detail: "close activity",
          health_campaign_activity_goal: null,
          health_campaign_activity_current_progress: null
        }));
      },
      sendViewExitModal(currentPage) {
        trackAnalyticsEvent20(SCREEN_LOADED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          current_step: currentPage,
          total_steps: totalPages,
          screen_name: SCREEN_NAMES21.EXIT_CONFIRM_MODAL,
          health_campaign_activity_goal: null,
          health_campaign_activity_current_progress: null
        }));
      },
      sendConfirmCloseActivity() {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "confirm leave activity",
          screen_name: SCREEN_NAMES21.EXIT_CONFIRM_MODAL
        }));
      },
      sendContinueActivity() {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "cancel leave activity",
          screen_name: SCREEN_NAMES21.EXIT_CONFIRM_MODAL
        }));
      },
      sendViewPage(currentPage) {
        trackAnalyticsEvent20(SCREEN_LOADED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          current_step: currentPage,
          total_steps: totalPages
        }));
      },
      sendLinkOutClick({
        title,
        url,
        detail = "linkout clicked"
      }) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: detail || null,
          content_url: url || null,
          link_name: title || null
        }));
      },
      sendVideoPlay(videoURL, videoDuration, currentPosition) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "video play button clicked",
          video_url: videoURL,
          video_position: currentPosition,
          video_duration: videoDuration
        }));
      },
      sendVideoPause(videoURL, videoDuration, currentPosition) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "video pause button clicked",
          video_url: videoURL,
          video_position: currentPosition,
          video_duration: videoDuration
        }));
      },
      sendVideoEnd(videoURL, videoDuration) {
        trackAnalyticsEvent20(BUTTON_CLICKED4, __spreadProps(__spreadValues({}, baseAnalytics), {
          detail: "video ended",
          video_url: videoURL,
          video_duration: videoDuration
        }));
      }
    }),
    [baseAnalytics, frontOfTheLineActivity, totalPages]
  );
};

// src/pages/health-activity/contexts/health-activity-provider.component.tsx
import React100, { useMemo as useMemo13, useState as useState10, createContext as createContext2 } from "react";

// src/pages/health-activity/contexts/toolbox-component-provider.component.tsx
import React98, {
  useCallback as useCallback5,
  useMemo as useMemo10,
  createContext,
  useRef as useRef3,
  useContext
} from "react";
import { ComponentTypes } from "@leagueplatform/health-journey-common";
var ComponentKeys = Object.values(ComponentTypes);
var DefaultComponentActions = Object.freeze(
  Object.fromEntries(ComponentKeys.map((componentKey) => [componentKey]))
);
var ToolboxComponentContext = createContext({
  actions: DefaultComponentActions,
  registerToolboxComponent: null,
  toolboxComponentMap: {}
});
var ToolboxComponentProvider = ({ children, actions = DefaultComponentActions }) => {
  const toolboxComponentMapRef = useRef3({});
  const registerToolboxComponent = useCallback5(
    (componentId, component) => {
      const currentComponent = toolboxComponentMapRef.current[componentId];
      if (!currentComponent) {
        toolboxComponentMapRef.current[componentId] = component;
        return component;
      }
      return currentComponent;
    },
    []
  );
  const contextValue = useMemo10(
    () => ({
      actions: __spreadValues(__spreadValues({}, DefaultComponentActions), actions),
      registerToolboxComponent,
      toolboxComponentMap: toolboxComponentMapRef.current
    }),
    [actions, registerToolboxComponent]
  );
  return /* @__PURE__ */ React98.createElement(ToolboxComponentContext.Provider, { value: contextValue }, children);
};
var useToolboxComponentContext = (componentType) => {
  const { actions: actionMap } = useContext(ToolboxComponentContext);
  const actions = actionMap == null ? void 0 : actionMap[componentType];
  return { actions };
};

// src/pages/health-activity/hooks/use-activity-form-manager.hook.ts
import { useRef as useRef4, useCallback as useCallback6, useState as useState9 } from "react";
var useActivityFormManager = () => {
  const { current: paginatedForms } = useRef4([]);
  const [isValidating, setIsValidating] = useState9(false);
  const registerForm = useCallback6(
    (pageIndex) => (formMethods) => {
      paginatedForms[pageIndex] = formMethods;
    },
    [paginatedForms]
  );
  const manageValidationState = useCallback6(
    (validationPromise, fallbackValue = true) => __async(void 0, null, function* () {
      var _a;
      setIsValidating(true);
      const isValid = (_a = yield validationPromise) != null ? _a : fallbackValue;
      setIsValidating(false);
      return isValid;
    }),
    []
  );
  const validateAllPages = useCallback6(
    () => manageValidationState(
      Promise.all(
        paginatedForms.map(
          (formMethods) => formMethods == null ? void 0 : formMethods.trigger()
        )
      ).then(
        (pageValidationArr) => pageValidationArr.every((isPageValid) => isPageValid != null ? isPageValid : true)
      )
    ),
    [manageValidationState, paginatedForms]
  );
  const validatePage = useCallback6(
    (pageIndex) => {
      var _a;
      return manageValidationState(
        (_a = paginatedForms[pageIndex]) == null ? void 0 : _a.trigger(void 0, { shouldFocus: true })
      );
    },
    [manageValidationState, paginatedForms]
  );
  const validatePages = useCallback6(
    (pageIndices) => manageValidationState(
      Promise.all(pageIndices.map(validatePage)).then(
        (pageValidationArr) => pageValidationArr.every(Boolean)
      )
    ),
    [manageValidationState, validatePage]
  );
  const getQuestionsForPage = useCallback6(
    (pageIndex, options2 = {}) => {
      var _a;
      return (_a = paginatedForms[pageIndex]) == null ? void 0 : _a.getInputComponents(options2);
    },
    [paginatedForms]
  );
  const getAllQuestions = useCallback6(
    (options2 = {}) => (
      // Flatten paginated questions
      paginatedForms.flatMap(
        (formMethods) => formMethods.getInputComponents(options2)
      )
    ),
    [paginatedForms]
  );
  const getQuestionsForPages = useCallback6(
    (pageIndices, options2 = {}) => (
      // Flatten paginated questions, filter out pages with no questions
      pageIndices.flatMap((pageIndex) => getQuestionsForPage(pageIndex, options2)).filter(Boolean)
    ),
    [getQuestionsForPage]
  );
  return {
    isValidating,
    paginatedForms,
    registerForm,
    validateAllPages,
    validatePage,
    validatePages,
    getQuestionsForPage,
    getQuestionsForPages,
    getAllQuestions
  };
};

// src/pages/health-activity/hooks/use-activity-toolbox-component-actions.hook.ts
import { useMemo as useMemo12 } from "react";
import { ComponentTypes as ComponentTypes3 } from "@leagueplatform/health-journey-common";
import { isProduction as isProduction3, useConfigProperty as useConfigProperty3 } from "@leagueplatform/core";
import { addBreadcrumb as addBreadcrumb2 } from "@leagueplatform/observability";

// src/pages/health-activity/components/page-components/activity-toolbox-video.component.tsx
import React99, { useCallback as useCallback7, useMemo as useMemo11 } from "react";
import { Box as Box47 } from "@leagueplatform/genesis-core";
import { Video } from "@leagueplatform/genesis-core-alpha";
import { ComponentTypes as ComponentTypes2 } from "@leagueplatform/health-journey-common";
import { captureError as captureError4 } from "@leagueplatform/observability";
var getVideoState = (player) => ({
  src: player == null ? void 0 : player.src(),
  duration: player.duration(),
  currentTime: player.currentTime(),
  remainingTime: player.remainingTime()
});
var formatTextTracks = (...textTracks) => textTracks == null ? void 0 : textTracks.flatMap(({ url: src, label }) => ({
  src,
  label,
  kind: "subtitles"
  // Toolbox only accepts subtitle tracks as of Oct/2024
}));
var ActivityToolboxVideo = ({
  videoUrl: src,
  thumbnailUrl: poster,
  subtitles = [],
  altText,
  css: css14,
  componentId
}) => {
  const { actions } = useToolboxComponentContext(ComponentTypes2.Video);
  const tracks = useMemo11(() => formatTextTracks(...subtitles), [subtitles]);
  const attachListenersOnReady = useCallback7(
    (player) => {
      player == null ? void 0 : player.on("play", (event) => {
        var _a;
        return (_a = actions == null ? void 0 : actions.onPlay) == null ? void 0 : _a.call(actions, player, event);
      });
      player == null ? void 0 : player.on("pause", (event) => {
        var _a;
        return (_a = actions == null ? void 0 : actions.onPause) == null ? void 0 : _a.call(actions, player, event);
      });
      player == null ? void 0 : player.on("ended", (event) => {
        var _a;
        return (_a = actions == null ? void 0 : actions.onEnd) == null ? void 0 : _a.call(actions, player, event);
      });
      player == null ? void 0 : player.on("error", (error) => captureError4(error));
    },
    [actions]
  );
  return /* @__PURE__ */ React99.createElement(Box47, { css: css14, "data-testid": componentId, "aria-label": altText }, /* @__PURE__ */ React99.createElement(
    Video,
    {
      src,
      poster,
      tracks,
      onReady: attachListenersOnReady
    }
  ));
};

// src/pages/health-activity/hooks/use-activity-toolbox-component-actions.hook.ts
var useActivityToolboxComponentActions = (healthActivityAnalytics) => {
  const handleLinkCallback = useConfigProperty3("core.customMethods.handleLink");
  const actionMap = useMemo12(
    () => ({
      [ComponentTypes3.Link]: {
        onLinkOut(event, actionAttributes) {
          var _a;
          (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendLinkOutClick) == null ? void 0 : _a.call(healthActivityAnalytics, actionAttributes);
          const { currentTarget } = event;
          const { href } = currentTarget;
          if (handleLinkCallback) {
            event.preventDefault();
            handleLinkCallback(href);
          }
        },
        onDeepLink(event, actionAttributes) {
          var _a;
          (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendLinkOutClick) == null ? void 0 : _a.call(healthActivityAnalytics, __spreadProps(__spreadValues({}, actionAttributes), {
            detail: "deep link clicked"
          }));
        }
      },
      [ComponentTypes3.Biometric]: {
        onLinkOut(event, actionAttributes) {
          var _a;
          (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendLinkOutClick) == null ? void 0 : _a.call(healthActivityAnalytics, __spreadProps(__spreadValues({}, actionAttributes), {
            detail: "biometric linkout clicked"
          }));
          const { currentTarget } = event;
          const { href } = currentTarget;
          if (handleLinkCallback) {
            event.preventDefault();
            handleLinkCallback(href);
          }
        },
        onDeepLink(event, actionAttributes) {
          var _a;
          (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendLinkOutClick) == null ? void 0 : _a.call(healthActivityAnalytics, __spreadProps(__spreadValues({}, actionAttributes), {
            detail: "biometric deep link clicked"
          }));
        }
      },
      [ComponentTypes3.RichText]: {
        onLinkOut(event) {
          var _a;
          const { currentTarget } = event;
          const { href, innerText } = currentTarget;
          (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendLinkOutClick) == null ? void 0 : _a.call(healthActivityAnalytics, {
            url: href,
            title: innerText == null ? void 0 : innerText.trim(),
            detail: "richtext linkout clicked"
          });
          if (handleLinkCallback) {
            event.preventDefault();
            handleLinkCallback(href);
          }
        }
      },
      [ComponentTypes3.Video]: {
        onPlay(videoPlayer) {
          const videoState = getVideoState(videoPlayer);
          const { src, duration, currentTime } = videoState;
          if (isProduction3()) {
            healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendVideoPlay(src, duration, currentTime);
          } else {
            console.log("Toolbox Video Play \u25B6\uFE0F", videoState);
            addBreadcrumb2({
              message: "Toolbox Video Play \u25B6\uFE0F",
              data: videoState
            });
          }
        },
        onPause(videoPlayer) {
          const videoState = getVideoState(videoPlayer);
          const { src, duration, currentTime } = videoState;
          if (isProduction3()) {
            healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendVideoPause(src, duration, currentTime);
          } else {
            console.log("Toolbox Video Pause \u23F8\uFE0F", videoState);
            addBreadcrumb2({
              message: "Toolbox Video Pause \u23F8\uFE0F",
              data: videoState
            });
          }
        },
        onEnd(videoPlayer) {
          const videoState = getVideoState(videoPlayer);
          const { src, currentTime } = videoState;
          if (isProduction3()) {
            healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendVideoEnd(src, currentTime);
          } else {
            console.log("Toolbox Video End \u23F9\uFE0F", videoState);
            addBreadcrumb2({
              message: "Toolbox Video End \u23F9\uFE0F",
              data: videoState
            });
          }
        }
      }
    }),
    [handleLinkCallback, healthActivityAnalytics]
  );
  return actionMap;
};

// src/pages/health-activity/contexts/health-activity-provider.component.tsx
var HealthActivityContext = createContext2(
  null
);
var HealthActivityProvider = ({
  children,
  currentPage: initialPage = 0,
  healthActivityAnalytics
}) => {
  const toolboxActions = useActivityToolboxComponentActions(
    healthActivityAnalytics
  );
  const [currentPage, setCurrentPage] = useState10(initialPage);
  const healthAssessmentManager = useActivityFormManager();
  const healthActivityContextValue = useMemo13(
    () => ({
      currentPage,
      setCurrentPage,
      healthActivityAnalytics,
      healthAssessmentManager
    }),
    [currentPage, healthActivityAnalytics, healthAssessmentManager]
  );
  return /* @__PURE__ */ React100.createElement(HealthActivityContext.Provider, { value: healthActivityContextValue }, /* @__PURE__ */ React100.createElement(ToolboxComponentProvider, { actions: toolboxActions }, children));
};

// src/pages/health-activity/components/health-activity-loading.component.tsx
import React101 from "react";
import { LoadingIndicator as LoadingIndicator4 } from "@leagueplatform/web-common-components";
import { Box as Box48 } from "@leagueplatform/genesis-core";
var HealthActivityLoading = () => /* @__PURE__ */ React101.createElement(Box48, { "data-testid": "health-activity-loading" }, /* @__PURE__ */ React101.createElement(LoadingIndicator4, null));

// src/pages/health-activity/components/health-activity-error.component.tsx
import React102 from "react";
import {
  BackButtonArrow as BackButtonArrow6,
  ErrorState as ErrorState6
} from "@leagueplatform/web-common-components";
import { Box as Box49 } from "@leagueplatform/genesis-core";
var HealthActivityError = () => {
  const { returnToEntrypoint } = useActivityLink();
  return /* @__PURE__ */ React102.createElement(
    Box49,
    {
      css: {
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
        padding: "$twoAndHalf",
        flexDirection: "column",
        textAlign: "center",
        "@mobile": {
          padding: "$oneAndHalf"
        }
      },
      "data-testid": "health-activity-error"
    },
    /* @__PURE__ */ React102.createElement(
      BackButtonArrow6,
      {
        fontSize: "heading3",
        color: "onSurface.text.primary",
        marginInlineEnd: "one",
        marginY: "half",
        justifyContent: "initial",
        onClick: returnToEntrypoint
      }
    ),
    /* @__PURE__ */ React102.createElement(
      Box49,
      {
        css: {
          marginTop: "$three"
        }
      },
      /* @__PURE__ */ React102.createElement(ErrorState6, { error: null })
    )
  );
};

// src/pages/health-activity/health-activity.component.tsx
import React148, {
  useCallback as useCallback27,
  useContext as useContext8,
  useEffect as useEffect27,
  useMemo as useMemo40,
  useState as useState21
} from "react";
import { debounce } from "lodash";
import { useDocumentTitle as useDocumentTitle6 } from "@leagueplatform/web-common";
import { useIntl as useIntl73 } from "@leagueplatform/locales";
import { toastActions as toastActions3, TOAST_STATUS as TOAST_STATUS3 } from "@leagueplatform/toast-messages";
import { UserHealthActivityStatus as UserHealthActivityStatus4 } from "@leagueplatform/health-journey-common";
import { isProduction as isProduction5 } from "@leagueplatform/app-environment";

// src/pages/health-activity/hooks/use-activity-modals.hook.ts
import { useCallback as useCallback8, useState as useState11, useEffect as useEffect10, useMemo as useMemo14 } from "react";
import {
  useQueryClient as useQueryClient7,
  QueryObserver
} from "react-query";

// src/pages/health-activity/types/health-activity.types.ts
var HealthActivityModalTypes = /* @__PURE__ */ ((HealthActivityModalTypes2) => {
  HealthActivityModalTypes2["Remove"] = "remove";
  HealthActivityModalTypes2["Exit"] = "exit";
  HealthActivityModalTypes2["ApiDelay"] = "api-delay";
  HealthActivityModalTypes2["Warning"] = "warning";
  HealthActivityModalTypes2["None"] = "";
  return HealthActivityModalTypes2;
})(HealthActivityModalTypes || {});

// src/pages/health-activity/hooks/use-activity-modals.hook.ts
var SET_ACTIVITY_MODAL_QUERY = "set-activity-modal";
var setActivityModalQueryKey = [SET_ACTIVITY_MODAL_QUERY];
var queryObserverOptions = {
  queryKey: setActivityModalQueryKey,
  initialData: { type: "" /* None */, props: {} },
  enabled: false
};
var useActivityModals = () => {
  const queryClient = useQueryClient7();
  const observer = useMemo14(
    () => new QueryObserver(queryClient, queryObserverOptions),
    [queryClient]
  );
  const [activeModal, updateActiveModal] = useState11(
    observer.getCurrentResult().data
  );
  useEffect10(() => {
    const unsubscribe = observer.subscribe(
      (result) => updateActiveModal(result.data)
    );
    return unsubscribe;
  }, [observer, updateActiveModal]);
  const setActiveModal = useCallback8(
    (type, props = {}) => queryClient.setQueryData(setActivityModalQueryKey, { type, props }),
    [queryClient]
  );
  return { activeModal, setActiveModal };
};

// src/pages/health-activity/hooks/use-set-toolbox-interaction-hub.ts
import { useMutation as useMutation3 } from "react-query";
import {
  postToolboxInteractionHub
} from "@leagueplatform/health-journey-api";
import { isProduction as isProduction4 } from "@leagueplatform/app-environment";
var useSetToolboxInteractionHub = (userActivityId, userHealthCampaignId) => {
  const isProd = isProduction4();
  return useMutation3(
    ({ components, skippedComponents, completedActivity = false }) => postToolboxInteractionHub({
      userActivityId,
      userHealthCampaignId,
      components,
      skippedComponents,
      completedActivity
    }),
    {
      onSuccess: (data) => {
        if (!isProd)
          console.log("Success on persisting hub api responses", data);
      },
      onError: (error) => {
        if (!isProd)
          console.error("Error persisting hub api user responses", error);
      }
    }
  );
};

// src/pages/health-activity/hooks/use-activity-navigation.hook.ts
import {
  useMemo as useMemo15,
  useReducer,
  useCallback as useCallback9,
  useContext as useContext2,
  useEffect as useEffect11
} from "react";
import jsonLogic from "json-logic-js";

// src/pages/health-activity/utils/toolbox-json.util.ts
var safeJsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return void 0;
  }
};

// src/pages/health-activity/hooks/use-activity-navigation.hook.ts
var HealthActivityNavigationActions = /* @__PURE__ */ ((HealthActivityNavigationActions2) => {
  HealthActivityNavigationActions2["Next"] = "next";
  HealthActivityNavigationActions2["Prev"] = "prev";
  HealthActivityNavigationActions2["Last"] = "last";
  return HealthActivityNavigationActions2;
})(HealthActivityNavigationActions || {});
var ROOT_PAGE_INDEX = 0;
var { Next, Prev, Last } = HealthActivityNavigationActions;
var buildNavigationStack = (currentNavigationStack, currentPageIndex) => {
  const updatedNavigationStack = [...currentNavigationStack, currentPageIndex];
  const stackLength = updatedNavigationStack.indexOf(currentPageIndex) + 1;
  const amendedNavigationStack = updatedNavigationStack.slice(0, stackLength);
  const nextNavigationStack = Array.from(new Set(amendedNavigationStack));
  return nextNavigationStack;
};
var reducer = (state, action) => {
  const { type } = action;
  const { pageHistory } = state;
  switch (type) {
    case Next:
    case Prev:
      return __spreadProps(__spreadValues({}, state), {
        isLastPage: Boolean(action == null ? void 0 : action.isLastPage),
        pageHistory: buildNavigationStack(pageHistory, action.nextPage)
      });
    case Last:
      return __spreadProps(__spreadValues({}, state), {
        isLastPage: action.isLastPage
      });
    default:
      return state;
  }
};
var useActivityNavigation = ({
  healthActivityData
}) => {
  const {
    healthAssessmentManager,
    currentPage: initialPageIndex,
    setCurrentPage
  } = useContext2(HealthActivityContext);
  const { getQuestionsForPages } = healthAssessmentManager;
  const { pages } = healthActivityData != null ? healthActivityData : {};
  const totalPages = ((pages == null ? void 0 : pages.length) || 1) - 1;
  const allPageIndices = useMemo15(
    () => Array(pages == null ? void 0 : pages.length).fill(void 0).map((_, pageIndex) => pageIndex),
    [pages == null ? void 0 : pages.length]
  );
  const [navigationState, dispatch] = useReducer(reducer, {
    pageHistory: buildNavigationStack([ROOT_PAGE_INDEX], initialPageIndex),
    isLastPage: initialPageIndex >= totalPages
  });
  const { pageHistory, isLastPage } = navigationState;
  const [currentPage = ROOT_PAGE_INDEX] = useMemo15(
    () => navigationState == null ? void 0 : navigationState.pageHistory.slice(-1),
    [navigationState == null ? void 0 : navigationState.pageHistory]
  );
  const skippedPages = useMemo15(
    () => allPageIndices.filter((pageIndex) => !pageHistory.includes(pageIndex)),
    [allPageIndices, pageHistory]
  );
  useEffect11(() => {
    setCurrentPage(currentPage);
  }, [currentPage, setCurrentPage]);
  const getNextPageIndex = useCallback9(() => {
    var _a, _b;
    if (!pages)
      return currentPage + 1;
    const { branchingLogic } = pages[currentPage];
    const nextPageIndexDefault = Math.min(currentPage + 1, totalPages);
    if (!branchingLogic)
      return nextPageIndexDefault;
    const { rule, ruleString, data, dataString } = branchingLogic;
    const branchingLogicRules = rule != null ? rule : safeJsonParse(ruleString);
    const branchingLogicData = (_a = data != null ? data : safeJsonParse(dataString)) != null ? _a : {};
    const components = Object.fromEntries(
      getQuestionsForPages(pageHistory, {
        includeCleanFields: true
      }).map((component) => [component.id, component])
    );
    const jsonLogicData = __spreadValues({ components }, branchingLogicData);
    const nextPageIndex = (_b = jsonLogic.apply(branchingLogicRules, jsonLogicData)) != null ? _b : nextPageIndexDefault;
    return nextPageIndex;
  }, [currentPage, getQuestionsForPages, pageHistory, pages, totalPages]);
  const navigateActivity = useMemo15(
    () => ({
      next: (nextOptions = {}) => {
        const { onNextPage, onLastPage } = nextOptions;
        const nextPage = getNextPageIndex();
        const isCurrentPageLast = nextPage === -1 || currentPage >= totalPages;
        if (isCurrentPageLast) {
          dispatch({ type: Last, isLastPage: true });
          onLastPage == null ? void 0 : onLastPage(currentPage);
          return currentPage;
        }
        const goToNextPage = () => dispatch({
          type: Next,
          nextPage,
          isLastPage: nextPage >= totalPages
        });
        if (onNextPage) {
          onNextPage({ nextPage, goToNextPage });
          return nextPage;
        }
        goToNextPage();
        return nextPage;
      },
      previous: () => {
        const [previousPage = ROOT_PAGE_INDEX] = pageHistory.slice(-2);
        dispatch({ type: Prev, nextPage: previousPage });
        return previousPage;
      }
    }),
    [getNextPageIndex, currentPage, totalPages, pageHistory]
  );
  return {
    currentPage,
    pageHistory,
    skippedPages,
    isLastPage,
    navigateActivity
  };
};

// src/pages/health-activity/components/health-activity-layout.component.tsx
import React103 from "react";
import { Box as Box50, StackLayout as StackLayout30, styled } from "@leagueplatform/genesis-core";

// src/pages/health-activity/constants/health-activity-design.constants.ts
import { useUnknownConfigProperty } from "@leagueplatform/core";
var useShouldApplyActivityLayoutFixes = () => useUnknownConfigProperty("__internal.shouldApplyActivityLayoutFixes");
var ACTIVITY_CONTENT_BASE_WIDTH_NARROW = 484;
var ACTIVITY_CONTENT_BASE_WIDTH_WIDE = 800;
var useActivityContentWidth = () => {
  const shouldApplyActivityLayoutFixes = useShouldApplyActivityLayoutFixes();
  return shouldApplyActivityLayoutFixes ? ACTIVITY_CONTENT_BASE_WIDTH_WIDE : ACTIVITY_CONTENT_BASE_WIDTH_NARROW;
};
var ACTIVITY_MODAL_MAX_WIDTH = 588;
var EASING = Object.freeze({
  IN_OUT_QUAD: `cubic-bezier(0.45, 0, 0.55, 1)`
});
var baseDurationMs = 150;
var TRANSITION_DURATION_MS = Object.freeze({
  SHORT: baseDurationMs,
  MEDIUM: baseDurationMs * 2,
  LONG: baseDurationMs * 3,
  XLONG: baseDurationMs * 4
});
var TRANSITION_DELAY_MS = 200;
var { SHORT, MEDIUM, XLONG } = TRANSITION_DURATION_MS;
var { IN_OUT_QUAD } = EASING;
var TRANSITIONS = Object.freeze({
  PAGE: `${XLONG}ms ${IN_OUT_QUAD}`,
  HALF_PAGE: `${MEDIUM}ms ${IN_OUT_QUAD}`,
  QUARTER_PAGE: `${SHORT}ms ${IN_OUT_QUAD}`
});

// src/pages/health-activity/hooks/use-activity-toolbox-theme.hook.ts
import { useCallback as useCallback10, useEffect as useEffect12, useState as useState12, useMemo as useMemo16 } from "react";
import {
  QueryObserver as QueryObserver2,
  useQueryClient as useQueryClient8
} from "react-query";
var ACTIVITY_TOOLBOX_THEME = "activity-toolbox-theme";
var activityToolboxDefaultTheme = {
  backgroundColor: "$surfaceBackgroundSecondary"
};
var queryObserverOptions2 = {
  queryKey: [ACTIVITY_TOOLBOX_THEME],
  initialData: activityToolboxDefaultTheme,
  staleTime: Infinity
};
var useActivityToolboxTheme = () => {
  const queryClient = useQueryClient8();
  const observer = useMemo16(
    () => new QueryObserver2(queryClient, queryObserverOptions2),
    [queryClient]
  );
  const [activityToolboxTheme, updateActivityToolboxTheme] = useState12(
    observer.getCurrentResult().data
  );
  useEffect12(() => {
    const unsubscribe = observer.subscribe(
      (result) => updateActivityToolboxTheme(result.data)
    );
    return unsubscribe;
  }, [observer, updateActivityToolboxTheme]);
  const setActivityToolboxTheme = useCallback10(
    (newThemeOptions) => queryClient.setQueryData(
      [ACTIVITY_TOOLBOX_THEME],
      (currentThemeOptions = {}) => __spreadValues(__spreadValues({}, currentThemeOptions), newThemeOptions)
    ),
    [queryClient]
  );
  return { activityToolboxTheme, setActivityToolboxTheme };
};

// src/pages/health-activity/components/health-activity-layout.component.tsx
var FullPageHeight = styled(Box50, {
  height: "100%",
  inset: 0,
  position: "absolute"
});
var ContentPosition = styled(StackLayout30, {
  padding: "$oneAndHalf 0",
  transition: `all ${TRANSITIONS.PAGE}`,
  overflowX: "hidden",
  overflowY: "auto"
});
ContentPosition.defaultProps = { horizontalAlignment: "center" };
var ContentWrapper = styled(StackLayout30, {
  position: "relative",
  maxWidth: "100%"
});
ContentWrapper.defaultProps = {
  orientation: "vertical",
  horizontalAlignment: "center"
};
var HealthActivityLayout = ({
  children
}) => {
  const { activityToolboxTheme = {} } = useActivityToolboxTheme();
  const { backgroundColor = "$surfaceBackgroundSecondary" } = activityToolboxTheme;
  const width = useActivityContentWidth();
  const shouldApplyActivityLayoutFixes = useShouldApplyActivityLayoutFixes();
  const inner = /* @__PURE__ */ React103.createElement(
    ContentPosition,
    {
      css: { backgroundColor },
      "data-testid": "health-activity-layout",
      className: "health-activity-layout"
    },
    /* @__PURE__ */ React103.createElement(
      ContentWrapper,
      {
        css: {
          width,
          minHeight: !shouldApplyActivityLayoutFixes ? ACTIVITY_CONTENT_BASE_WIDTH_NARROW : void 0,
          maxWidth: "100%"
        },
        "data-testid": "health-activity-content-wrapper",
        className: "health-activity-content-wrapper"
      },
      children
    )
  );
  return !shouldApplyActivityLayoutFixes ? /* @__PURE__ */ React103.createElement(
    FullPageHeight,
    {
      "data-testid": "health-activity-page",
      className: "health-activity-page",
      "aria-live": "polite"
    },
    inner
  ) : /* @__PURE__ */ React103.createElement(Box50, { css: { backgroundColor, minHeight: "100%" } }, inner);
};

// src/pages/health-activity/components/health-activity-slider.component.tsx
import React104, { useMemo as useMemo17 } from "react";
import { Transition } from "react-transition-group";
import { Box as Box51, StackLayout as StackLayout31, css as css10 } from "@leagueplatform/genesis-core";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
var slideTransition = `transform ${TRANSITIONS.PAGE}, opacity ${TRANSITIONS.PAGE}, visibility ${TRANSITIONS.PAGE}`;
var reducedMotionSlideTransition = `opacity ${TRANSITIONS.PAGE}, visibility ${TRANSITIONS.PAGE}`;
var reducedMotionSlideStyles = css10({
  insetInlineStart: 0,
  transform: "none",
  transition: reducedMotionSlideTransition
});
var useSlideTransitionStyles = ({
  slideIndex,
  gap,
  activeIndex
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const slideStyles = useMemo17(
    () => ({
      insetInlineStart: `calc(${slideIndex} * ${gap})`,
      "&:dir(ltr)": {
        transform: `translateX(calc(-${gap} * ${activeIndex}))`
      },
      "&:dir(rtl)": {
        transform: `translateX(calc(${gap} * ${activeIndex}))`
      },
      transition: slideTransition
    }),
    [activeIndex, gap, slideIndex]
  );
  return useMemo17(
    () => prefersReducedMotion ? reducedMotionSlideStyles : slideStyles,
    [prefersReducedMotion, slideStyles]
  );
};
var HealthActivitySlide = ({
  children,
  gap = "100%",
  slideIndex,
  activeIndex,
  onTransition
}) => {
  const slideTransitionStyles = useSlideTransitionStyles({
    gap,
    slideIndex,
    activeIndex
  });
  const isActive = activeIndex === slideIndex;
  return /* @__PURE__ */ React104.createElement(
    Box51,
    {
      "aria-hidden": !isActive,
      css: __spreadProps(__spreadValues({}, slideTransitionStyles), {
        visibility: isActive ? "visible" : "hidden",
        height: "100%",
        opacity: Number(isActive),
        position: "absolute",
        top: 0,
        width: "100%"
      })
    },
    /* @__PURE__ */ React104.createElement(
      Transition,
      {
        in: isActive,
        timeout: TRANSITION_DURATION_MS.XLONG,
        onEnter: () => onTransition == null ? void 0 : onTransition(true),
        onExited: () => onTransition == null ? void 0 : onTransition(false)
      },
      children
    )
  );
};
var HealthActivitySlider = ({ children }) => /* @__PURE__ */ React104.createElement(StackLayout31, { css: { height: "100%", width: "100%", position: "relative" } }, children);

// src/pages/health-activity/components/health-activity-slider-v2.component.tsx
import React105, {
  Children,
  useCallback as useCallback11,
  useEffect as useEffect13,
  useRef as useRef5,
  useState as useState13
} from "react";
import { CSSTransition } from "react-transition-group";
import { Box as Box52, StackLayout as StackLayout32 } from "@leagueplatform/genesis-core";
var slideTransition2 = `transform ${TRANSITIONS.PAGE}, opacity ${TRANSITIONS.PAGE}, visibility ${TRANSITIONS.PAGE}`;
var HealthActivitySlideV2 = (_a) => {
  var _b = _a, {
    children,
    gap = "100%",
    slideIndex,
    activeIndex,
    onTransition
  } = _b, rest = __objRest(_b, [
    "children",
    "gap",
    "slideIndex",
    "activeIndex",
    "onTransition"
  ]);
  const setHeight = (
    /**
     * the `HealthActivitySlider` will be injecting one more prop here: a `SetHeightCallback` callback.
     * we keep this prop out of the `ActivitySlideProps` type because we don't want to give
     * consumers of this component the impression that THEY can (or need) to pass this prop in;
     * it's an "hidden internal" prop.
     */
    `setHeight` in rest ? rest.setHeight : void 0
  );
  const prevActiveIndex = useRef5(activeIndex);
  const direction = useRef5("forward");
  if (activeIndex < prevActiveIndex.current) {
    direction.current = "back";
  } else if (activeIndex > prevActiveIndex.current) {
    direction.current = "forward";
  }
  const isActive = slideIndex === activeIndex;
  const [isIn, setIsIn] = useState13(isActive);
  useEffect13(() => {
    if (isActive && prevActiveIndex.current !== activeIndex) {
      onTransition == null ? void 0 : onTransition(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setTimeout(() => {
      setIsIn(isActive);
      prevActiveIndex.current = activeIndex;
    }, TRANSITION_DELAY_MS);
  }, [activeIndex, isActive, onTransition]);
  return /* @__PURE__ */ React105.createElement(
    CSSTransition,
    {
      in: isIn,
      timeout: TRANSITION_DURATION_MS.XLONG,
      onExit: (element) => {
        setHeight == null ? void 0 : setHeight(element.clientHeight, "exit");
      },
      onEnter: (element) => {
        setHeight == null ? void 0 : setHeight(element.clientHeight, "enter");
      },
      onEntered: (element) => {
        setHeight == null ? void 0 : setHeight(element.clientHeight, "entered");
      },
      onExited: () => onTransition == null ? void 0 : onTransition(false),
      classNames: `slide-${direction.current}`,
      unmountOnExit: true
    },
    /* @__PURE__ */ React105.createElement(
      Box52,
      {
        css: {
          transform: "translateX(0)",
          top: 0,
          opacity: 1,
          width: "100%",
          "@media (prefers-reduced-motion)": {
            transform: "none"
          },
          "&.slide-forward-enter": {
            transform: `translateX(${gap})`,
            opacity: 0
          },
          "&.slide-forward-enter-active": {
            transform: `translateX(0)`,
            opacity: 1,
            transition: slideTransition2
          },
          "&.slide-forward-exit": {
            position: "absolute",
            transform: `translateX(-${gap})`,
            opacity: 0,
            transition: slideTransition2
          },
          "&.slide-back-enter": {
            transform: `translateX(-${gap})`,
            opacity: 0
          },
          "&.slide-back-enter-active": {
            transform: `translateX(0)`,
            opacity: 1,
            transition: slideTransition2
          },
          "&.slide-back-exit": {
            position: "absolute",
            transform: `translateX(${gap})`,
            opacity: 0,
            transition: slideTransition2
          }
        }
      },
      children
    )
  );
};
var HealthActivitySliderV2 = ({ children }) => {
  const containerRef = useRef5(null);
  const currentHeight = useRef5(0);
  useEffect13(() => {
    var _a;
    currentHeight.current = ((_a = containerRef.current) == null ? void 0 : _a.clientHeight) || 0;
  }, []);
  const setHeight = useCallback11((height, status) => {
    if (!containerRef.current) {
      return;
    }
    if (status === "entered") {
      containerRef.current.style.setProperty("height", "auto");
      currentHeight.current = height;
    } else {
      containerRef.current.style.setProperty(
        "height",
        `${currentHeight.current}px`
      );
      if (status === "enter" && height > currentHeight.current) {
        setTimeout(() => {
          containerRef.current.style.setProperty("height", `${height}px`);
        }, TRANSITION_DELAY_MS);
      }
    }
  }, []);
  return /* @__PURE__ */ React105.createElement(
    StackLayout32,
    {
      ref: containerRef,
      css: {
        height: "auto",
        flex: "0 1 auto",
        width: "100%",
        position: "relative"
      }
    },
    Children.map(
      children,
      (child) => React105.cloneElement(child, {
        // inject `setHeight` into the props of each child `HealthActivitySlide`.
        setHeight
      })
    )
  );
};

// src/pages/health-activity/components/health-activity-content.component.tsx
import React106 from "react";
import { Box as Box53 } from "@leagueplatform/genesis-core";
var HealthActivityContent = ({
  children
}) => {
  const shouldApplyActivityLayoutFixes = useShouldApplyActivityLayoutFixes();
  return /* @__PURE__ */ React106.createElement(
    Box53,
    {
      className: "health-activity-content",
      "data-testid": "health-activity-content",
      css: {
        display: "flex",
        backgroundColor: "$surfaceBackgroundPrimary",
        borderRadius: "$large",
        boxShadow: "dropdown",
        flexDirection: "column",
        minHeight: shouldApplyActivityLayoutFixes ? "400px" : void 0,
        height: "100%",
        minWidth: "100%",
        overflowY: "auto",
        position: "relative",
        width: "100%",
        gap: "$one"
      }
    },
    children
  );
};

// src/pages/health-activity/components/activity-footer/health-activity-footer.component.tsx
import React110 from "react";
import { useIntl as useIntl48 } from "@leagueplatform/locales";
import { Box as Box56, styled as styled2, UtilityText as UtilityText14 } from "@leagueplatform/genesis-core";

// src/pages/health-activity/components/activity-footer/health-activity-footer-buttons.component.tsx
import React108, { useMemo as useMemo18 } from "react";
import {
  Box as Box54,
  Button as Button7
} from "@leagueplatform/genesis-core";
import { isString } from "lodash";
import { ViewTransitionController as ViewTransitionController3 } from "@leagueplatform/health-journey-common";

// src/pages/health-activity/components/buttons/activity-circle-button.component.tsx
import React107 from "react";
import {
  Button as Button6
} from "@leagueplatform/genesis-core";
var { QUARTER_PAGE } = TRANSITIONS;
var baseStyles = {
  zIndex: `calc($sticky - $default)`,
  borderRadius: "circle",
  padding: "$threeQuarters",
  transition: `background ${QUARTER_PAGE}, color ${QUARTER_PAGE}`
};
var ActivityCircleButton = (_a) => {
  var _b = _a, {
    children,
    css: css14,
    hideLabel,
    icon
  } = _b, props = __objRest(_b, [
    "children",
    "css",
    "hideLabel",
    "icon"
  ]);
  return /* @__PURE__ */ React107.createElement(
    Button6,
    __spreadValues({
      type: "button",
      css: __spreadValues(__spreadValues({}, baseStyles), css14),
      icon,
      hideLabel: hideLabel || !children
    }, props),
    children
  );
};

// src/pages/health-activity/components/activity-footer/health-activity-footer-buttons.component.tsx
var { SHORT: SHORT2 } = TRANSITION_DURATION_MS;
var { QUARTER_PAGE: QUARTER_PAGE2 } = TRANSITIONS;
var FooterButtonTypes = /* @__PURE__ */ ((FooterButtonTypes2) => {
  FooterButtonTypes2["PrimaryCta"] = "PrimaryCta";
  FooterButtonTypes2["SecondaryCta"] = "SecondaryCta";
  FooterButtonTypes2["Check"] = "Check";
  FooterButtonTypes2["ArrowBack"] = "ArrowBack";
  FooterButtonTypes2["ArrowForward"] = "ArrowForward";
  return FooterButtonTypes2;
})(FooterButtonTypes || {});
var { PrimaryCta, SecondaryCta, Check, ArrowBack, ArrowForward } = FooterButtonTypes;
var BUTTON_TRANSITION = `background ${QUARTER_PAGE2}, color ${QUARTER_PAGE2}, border ${QUARTER_PAGE2}`;
var buttonProps = {
  primary: { priority: "primary", css: { transition: BUTTON_TRANSITION } },
  secondary: { priority: "secondary", css: { transition: BUTTON_TRANSITION } }
};
var ButtonTransition = ({
  views,
  handleActiveView,
  css: css14
}) => (
  // TODO – ACTV-X: Refactor ViewTransitionController and remove the `Box` wrapping this component
  /* @__PURE__ */ React108.createElement(Box54, { css: css14 }, /* @__PURE__ */ React108.createElement(
    ViewTransitionController3,
    {
      views,
      handleActiveView,
      duration: SHORT2,
      transitionType: "fade"
    }
  ))
);
var PrevButton = ({
  "aria-label": ariaLabel,
  currentPage,
  disabled,
  onClick,
  css: css14
}) => {
  const buttons = {
    [ArrowBack]: {
      view: ActivityCircleButton,
      props: __spreadProps(__spreadValues({}, buttonProps.secondary), {
        quiet: true,
        icon: "interfaceArrowBack",
        "aria-label": ariaLabel,
        disabled,
        onClick
      })
    }
  };
  const handleActiveButton = () => {
    if (currentPage)
      return ArrowBack;
    return "";
  };
  return /* @__PURE__ */ React108.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css14
    }
  );
};
var NextButton = ({
  "aria-label": defaultAriaLabel,
  disabled,
  onClick,
  isLastPage,
  children,
  loading,
  css: css14
}) => {
  const buttons = useMemo18(() => {
    const { primary, secondary } = buttonProps;
    const ariaLabel = [children, defaultAriaLabel].filter(isString).join(" - ");
    const commonProps = { onClick, disabled, "aria-label": ariaLabel };
    const ctaProps = __spreadProps(__spreadValues({}, commonProps), { children });
    const iconProps = __spreadProps(__spreadValues({}, commonProps), { quiet: true });
    const primaryCtaProps = __spreadProps(__spreadValues({}, primary), { loading });
    return {
      [PrimaryCta]: {
        view: Button7,
        props: __spreadValues(__spreadValues({}, primaryCtaProps), ctaProps)
      },
      [SecondaryCta]: {
        view: Button7,
        props: __spreadValues(__spreadValues({}, secondary), ctaProps)
      },
      [ArrowForward]: {
        view: ActivityCircleButton,
        props: __spreadProps(__spreadValues(__spreadValues({}, iconProps), secondary), { icon: "interfaceArrowForward" })
      },
      [Check]: {
        view: ActivityCircleButton,
        props: __spreadProps(__spreadValues(__spreadValues({}, iconProps), primaryCtaProps), { icon: "interfaceCheckmark" })
      }
    };
  }, [children, defaultAriaLabel, disabled, loading, onClick]);
  const handleActiveButton = () => {
    if (children)
      return isLastPage ? PrimaryCta : SecondaryCta;
    if (isLastPage)
      return Check;
    return ArrowForward;
  };
  return /* @__PURE__ */ React108.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css14
    }
  );
};

// src/pages/health-activity/components/activity-footer/health-activity-page-progress.component.tsx
import React109 from "react";
import { Box as Box55 } from "@leagueplatform/genesis-core";
var progressBarStyles = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  padding: " 0 25%",
  marginBottom: "$oneAndHalf",
  gap: "$quarter"
};
var PageIndicator = ({ isActive }) => /* @__PURE__ */ React109.createElement(
  Box55,
  {
    css: {
      position: "relative",
      overflow: "hidden",
      backgroundColor: "$interactiveActionDisabled",
      borderRadius: "$medium",
      border: "none",
      height: "$quarter",
      width: "100%",
      "&:before": {
        content: "",
        position: "absolute",
        inset: 0,
        transform: `scaleX(${Number(isActive)})`,
        transformOrigin: "left",
        "&:dir(rtl)": {
          transformOrigin: "right"
        },
        backgroundColor: "$interactiveActionPrimary",
        transition: `transform ${TRANSITIONS.PAGE}`
      }
    }
  }
);
var HealthActivityPageProgress = ({ css: css14 = {}, totalPages, currentPage }) => {
  const pageIndices = [...Array(totalPages).keys()];
  return /* @__PURE__ */ React109.createElement(Box55, { css: __spreadValues(__spreadValues({}, progressBarStyles), css14) }, pageIndices.map((pageIndex) => /* @__PURE__ */ React109.createElement(
    PageIndicator,
    {
      key: `page-progress-${pageIndex}`,
      isActive: currentPage >= pageIndex
    }
  )));
};

// src/pages/health-activity/constants/health-activity-footer.constants.ts
var ActivityFooterAreas = /* @__PURE__ */ ((ActivityFooterAreas2) => {
  ActivityFooterAreas2["Top"] = "top";
  ActivityFooterAreas2["Start"] = "start";
  ActivityFooterAreas2["Center"] = "center";
  ActivityFooterAreas2["End"] = "end";
  ActivityFooterAreas2["Bottom"] = "bottom";
  return ActivityFooterAreas2;
})(ActivityFooterAreas || {});

// src/pages/health-activity/components/activity-footer/health-activity-footer.component.tsx
var { Top, Start, Center, End, Bottom } = ActivityFooterAreas;
var footerPlacement = {
  [Top]: { gridArea: Top, justifySelf: "center" },
  [Start]: { gridArea: Start, justifySelf: "start" },
  [Center]: { gridArea: Center, justifySelf: "center" },
  [End]: { gridArea: End, justifySelf: "end" },
  [Bottom]: { gridArea: Bottom, justifySelf: "center" }
};
var FooterLayout = styled2(Box56, {
  alignItems: "center",
  display: "grid",
  gridTemplateAreas: `
    'top top top'
    'start center end'
    'bottom bottom bottom'`,
  gridTemplateColumns: "[start] 1fr [center] auto [end] 1fr",
  gridTemplateRows: "auto",
  width: "100%",
  gap: "1rem",
  "> *:only-child": { gridArea: "bottom" },
  "&:last-child": { marginTop: "16px" }
});
var HealthActivityFooter = ({
  totalPages,
  currentPage,
  ctaText,
  disabled,
  onNext,
  onPrev,
  isLastPage,
  loading
}) => {
  const { formatMessage } = useIntl48();
  const isMultiPage = totalPages > 1;
  const copy = {
    nextStepLabel: isLastPage ? formatMessage({ id: "COMPLETE_ACTIVITY" }) : formatMessage({ id: "ACTIVITY_NEXT_STEP" }),
    prevStepLabel: formatMessage({ id: "ACTIVITY_PREV_STEP" }),
    pageProgress: formatMessage(
      { id: "X_OF_Y" },
      { current: currentPage + 1, total: totalPages }
    )
  };
  return /* @__PURE__ */ React110.createElement(FooterLayout, null, isMultiPage && /* @__PURE__ */ React110.createElement(
    HealthActivityPageProgress,
    {
      css: footerPlacement[Top],
      currentPage,
      totalPages
    }
  ), isMultiPage && /* @__PURE__ */ React110.createElement(
    PrevButton,
    {
      currentPage,
      disabled,
      onClick: onPrev,
      css: footerPlacement[Start],
      "aria-label": copy.prevStepLabel
    }
  ), isMultiPage && /* @__PURE__ */ React110.createElement(
    UtilityText14,
    {
      as: "p",
      emphasis: "subtle",
      css: __spreadValues({}, footerPlacement[Center])
    },
    copy.pageProgress
  ), /* @__PURE__ */ React110.createElement(
    NextButton,
    {
      css: footerPlacement[End],
      currentPage,
      isLastPage,
      disabled,
      onClick: onNext,
      loading,
      "aria-label": copy.nextStepLabel
    },
    ctaText
  ));
};

// src/pages/health-activity/components/activity-footer/health-activity-footer-v2.component.tsx
import React111, { useEffect as useEffect14, useState as useState14 } from "react";
import { useIntl as useIntl49 } from "@leagueplatform/locales";
import { Box as Box57, styled as styled3, UtilityText as UtilityText15 } from "@leagueplatform/genesis-core";
var { Top: Top2, Start: Start2, Center: Center2, End: End2, Bottom: Bottom2 } = ActivityFooterAreas;
var footerPlacement2 = {
  [Top2]: { gridArea: Top2, justifySelf: "center" },
  [Start2]: { gridArea: Start2, justifySelf: "start" },
  [Center2]: { gridArea: Center2, justifySelf: "center" },
  [End2]: { gridArea: End2, justifySelf: "end" },
  [Bottom2]: { gridArea: Bottom2, justifySelf: "center" }
};
var FooterLayout2 = styled3(Box57, {
  alignItems: "center",
  display: "grid",
  gridTemplateAreas: `
    'top top top'
    'start center end'
    'bottom bottom bottom'`,
  gridTemplateColumns: "[start] 1fr [center] auto [end] 1fr",
  gridTemplateRows: "auto",
  width: "100%",
  gap: "1rem",
  "> *:only-child": { gridArea: "bottom" },
  "&:last-child": { marginTop: "16px" }
});
var HealthActivityFooterV2 = ({
  totalPages,
  currentPage,
  ctaText,
  disabled,
  onNext,
  onPrev,
  isLastPage,
  loading,
  transitioning
}) => {
  const { formatMessage } = useIntl49();
  const isMultiPage = totalPages > 1;
  const copy = {
    nextStepLabel: isLastPage ? formatMessage({ id: "COMPLETE_ACTIVITY" }) : formatMessage({ id: "ACTIVITY_NEXT_STEP" }),
    prevStepLabel: formatMessage({ id: "ACTIVITY_PREV_STEP" }),
    pageProgress: formatMessage(
      { id: "X_OF_Y" },
      { current: currentPage + 1, total: totalPages }
    )
  };
  const [delayedCtaText, setDelayedCtaText] = useState14(ctaText);
  useEffect14(() => {
    setTimeout(() => {
      setDelayedCtaText(ctaText);
    }, TRANSITION_DELAY_MS);
  }, [ctaText]);
  return /* @__PURE__ */ React111.createElement(
    FooterLayout2,
    {
      css: {
        transition: "opacity 0.2s ease-in-out",
        opacity: transitioning ? 0 : 1
      }
    },
    isMultiPage && /* @__PURE__ */ React111.createElement(
      HealthActivityPageProgress,
      {
        css: footerPlacement2[Top2],
        currentPage,
        totalPages
      }
    ),
    isMultiPage && /* @__PURE__ */ React111.createElement(
      PrevButton,
      {
        currentPage,
        disabled,
        onClick: onPrev,
        css: footerPlacement2[Start2],
        "aria-label": copy.prevStepLabel
      }
    ),
    isMultiPage && /* @__PURE__ */ React111.createElement(
      UtilityText15,
      {
        as: "p",
        emphasis: "subtle",
        css: __spreadValues({}, footerPlacement2[Center2])
      },
      copy.pageProgress
    ),
    /* @__PURE__ */ React111.createElement(
      NextButton,
      {
        css: footerPlacement2[End2],
        currentPage,
        isLastPage,
        disabled,
        onClick: onNext,
        loading,
        "aria-label": copy.nextStepLabel
      },
      delayedCtaText
    )
  );
};

// src/pages/health-activity/components/toolbox-component-resolver.component.tsx
import React141, { createElement as createElement22, useContext as useContext5 } from "react";
import { ComponentTypes as ComponentTypes9 } from "@leagueplatform/health-journey-common";

// src/pages/health-activity/components/page-components/activity-toolbox-badge.component.tsx
import React112 from "react";
import { Badge as Badge9 } from "@leagueplatform/web-common-components";
import {
  StyleBackgroundColorType as StyleBackgroundColorType2,
  StyleBorderRadiusType as StyleBorderRadiusType2,
  StyleHorizontalAlignmentType as StyleHorizontalAlignmentType2
} from "@leagueplatform/health-journey-api";
import { StackLayout as StackLayout33, UtilityText as UtilityText16 } from "@leagueplatform/genesis-core";

// src/pages/health-activity/hooks/use-get-dynamic-component-styles.component.ts
import {
  StyleBackgroundColorType,
  StyleBorderRadiusType,
  StyleHorizontalAlignmentType
} from "@leagueplatform/health-journey-api";
var useGetDynamicComponentStyles = (style, defaultStyle) => {
  var _a, _b, _c;
  const {
    borderRadius = (_a = defaultStyle == null ? void 0 : defaultStyle.borderRadius) != null ? _a : StyleBorderRadiusType.medium,
    horizontalAlignment = (_b = defaultStyle == null ? void 0 : defaultStyle.horizontalAlignment) != null ? _b : StyleHorizontalAlignmentType.center,
    backgroundColor = (_c = defaultStyle == null ? void 0 : defaultStyle.backgroundColor) != null ? _c : StyleBackgroundColorType.decorativeBrandPrimaryPastel
  } = style != null ? style : {};
  const borderRadiusStyles = {
    [StyleBorderRadiusType.pill]: { borderRadius: "$pill" },
    [StyleBorderRadiusType.medium]: { borderRadius: "$medium" }
  };
  const borderRadiusStyle = borderRadiusStyles == null ? void 0 : borderRadiusStyles[borderRadius];
  const horizontalAlignmentStyles = {
    [StyleHorizontalAlignmentType.start]: {
      justifyContent: "start"
    },
    [StyleHorizontalAlignmentType.center]: {
      justifyContent: "center"
    },
    [StyleHorizontalAlignmentType.end]: {
      justifyContent: "end"
    }
  };
  const horizontalAlignmentStyle = horizontalAlignmentStyles == null ? void 0 : horizontalAlignmentStyles[horizontalAlignment];
  const backgroundColorStyles = {
    [StyleBackgroundColorType.decorativeBrandPrimaryPastel]: {
      backgroundColor: "$decorativeBrandPrimaryPastel"
    },
    [StyleBackgroundColorType.decorativeBrandSecondaryPastel]: {
      backgroundColor: "$decorativeBrandSecondaryPastel"
    },
    [StyleBackgroundColorType.decorativeBrandTertiaryPastel]: {
      backgroundColor: "$decorativeBrandTertiaryPastel"
    }
  };
  const backgroundColorStyle = backgroundColorStyles == null ? void 0 : backgroundColorStyles[backgroundColor];
  return { borderRadiusStyle, horizontalAlignmentStyle, backgroundColorStyle };
};

// src/pages/health-activity/components/page-components/activity-toolbox-badge.component.tsx
var ActivityToolboxBadge = ({
  styleModifiers,
  text,
  iconUrl,
  altText,
  css: css14,
  componentId
}) => {
  const defaultStyleModifier = {
    borderRadius: StyleBorderRadiusType2.medium,
    horizontalAlignment: StyleHorizontalAlignmentType2.center,
    backgroundColor: StyleBackgroundColorType2.decorativeBrandPrimaryPastel
  };
  const { borderRadiusStyle, horizontalAlignmentStyle, backgroundColorStyle } = useGetDynamicComponentStyles(styleModifiers, defaultStyleModifier);
  return /* @__PURE__ */ React112.createElement(
    StackLayout33,
    {
      css: __spreadValues(__spreadValues({ flex: "initial" }, horizontalAlignmentStyle), css14),
      "data-testid": componentId,
      orientation: "horizontal"
    },
    /* @__PURE__ */ React112.createElement(
      Badge9,
      {
        css: __spreadValues(__spreadValues({}, borderRadiusStyle), backgroundColorStyle),
        className: "toolbox-badge"
      },
      iconUrl && /* @__PURE__ */ React112.createElement("img", { width: "12", src: iconUrl, alt: altText }),
      /* @__PURE__ */ React112.createElement(UtilityText16, { size: "xs", emphasis: "base" }, text)
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-full-page-highlight.component.tsx
import React115, { useEffect as useEffect16, useMemo as useMemo21 } from "react";
import { Box as Box59, HeadingText as HeadingText16, StackLayout as StackLayout34 } from "@leagueplatform/genesis-core";
import { WaveAnimation } from "@leagueplatform/health-journey-common";

// src/pages/health-activity/hooks/use-is-toolbox-component-visible.hook.ts
import { useEffect as useEffect15, useMemo as useMemo19, useCallback as useCallback12, useState as useState15 } from "react";
var useIsToolboxComponentVisible = (options2) => {
  const [ref, setRef] = useState15(null);
  const componentRef = useCallback12(setRef, [setRef]);
  const [isVisible, setIsVisible] = useState15(false);
  const observer = useMemo19(
    () => new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      __spreadValues({
        threshold: 0.6,
        root: ref == null ? void 0 : ref.parentElement
      }, options2)
    ),
    [options2, ref]
  );
  useEffect15(() => {
    if (ref) {
      observer.observe(ref);
    }
    return () => observer.disconnect();
  }, [observer, ref]);
  return { isVisible, componentRef };
};

// src/pages/health-activity/components/page-components/activity-toolbox-rich-text.component.tsx
import React114, { useMemo as useMemo20 } from "react";

// src/utils/wrap-orphan-text-node.util.ts
var inlineTextElements = [
  "a",
  "b",
  "em",
  "i",
  "mark",
  "s",
  "span",
  "strong",
  "sub",
  "sup",
  "u",
  "#text"
];
var groupInlineTextNodes = (container) => {
  container.childNodes.forEach((node7) => {
    var _a;
    const { parentElement, nodeName, previousSibling, textContent } = node7;
    const precedingNodeTag = previousSibling == null ? void 0 : previousSibling.nodeName.toLowerCase();
    const currentNodeTag = nodeName.toLowerCase();
    const isWhitespace = !(textContent == null ? void 0 : textContent.trim());
    const isOrphanText = inlineTextElements.includes(currentNodeTag) && parentElement === container;
    const isNotInlineAnchor = currentNodeTag === "a" && ((_a = previousSibling == null ? void 0 : previousSibling.textContent) == null ? void 0 : _a.endsWith("\n"));
    if (isWhitespace || !isOrphanText || isNotInlineAnchor)
      return;
    const isNewParagraph = precedingNodeTag !== "p" || (textContent == null ? void 0 : textContent.startsWith("\n"));
    if (isNewParagraph) {
      const wrapper = document.createElement("p");
      node7.replaceWith(wrapper);
      wrapper.append(node7);
      groupInlineTextNodes(container);
    } else if (previousSibling instanceof Element) {
      previousSibling == null ? void 0 : previousSibling.append(node7);
      groupInlineTextNodes(container);
    }
  });
};
var wrapOrphanTextNode = (htmlString) => {
  const richTextContainer = document.createElement("div");
  richTextContainer.innerHTML = htmlString;
  groupInlineTextNodes(richTextContainer);
  return richTextContainer.innerHTML;
};

// src/pages/health-activity/components/page-components/activity-toolbox-rich-text.component.tsx
import {
  Box as Box58,
  HtmlToReact
} from "@leagueplatform/genesis-core";

// src/pages/health-activity/common/activity-toolbox-rich-text-options.tsx
import { Fragment as Fragment6 } from "react";

// src/pages/health-activity/components/page-components/activity-toolbox-building-blocks.component.tsx
import React113 from "react";
import {
  styled as styled4,
  UtilityText as UtilityText17,
  TextAction as TextAction5
} from "@leagueplatform/genesis-core";
import { ComponentTypes as ComponentTypes4 } from "@leagueplatform/health-journey-common";
var Mark = (_a) => {
  var _b = _a, {
    as = "mark",
    css: css14
  } = _b, props = __objRest(_b, [
    "as",
    "css"
  ]);
  return /* @__PURE__ */ React113.createElement(
    UtilityText17,
    __spreadValues({
      as,
      css: __spreadValues({
        font: "inherit",
        fontWeight: "$subtitleOne",
        backgroundColor: "$decorativeBrandPrimaryPastel"
      }, css14)
    }, props)
  );
};
var Bold = (_a) => {
  var _b = _a, { as = "b", css: css14 } = _b, props = __objRest(_b, ["as", "css"]);
  return /* @__PURE__ */ React113.createElement(
    UtilityText17,
    __spreadValues({
      as,
      css: __spreadValues({ font: "inherit", fontWeight: "$subtitleOne" }, css14)
    }, props)
  );
};
var Italic = (_a) => {
  var _b = _a, {
    as = "i",
    css: css14
  } = _b, props = __objRest(_b, [
    "as",
    "css"
  ]);
  return /* @__PURE__ */ React113.createElement(
    UtilityText17,
    __spreadValues({
      as,
      css: __spreadValues({ font: "inherit", fontStyle: "italic" }, css14)
    }, props)
  );
};
var Link12 = (_a) => {
  var _b = _a, {
    onClick,
    css: css14 = {}
  } = _b, props = __objRest(_b, [
    "onClick",
    "css"
  ]);
  const { actions } = useToolboxComponentContext(ComponentTypes4.RichText);
  const handleClick = (event) => {
    var _a2;
    onClick == null ? void 0 : onClick(event);
    (_a2 = actions == null ? void 0 : actions.onLinkOut) == null ? void 0 : _a2.call(actions, event);
  };
  return /* @__PURE__ */ React113.createElement(
    TextAction5,
    __spreadProps(__spreadValues({}, props), {
      css: __spreadValues({ font: "inherit" }, css14),
      target: "_blank",
      onClick: handleClick
    })
  );
};
var Blockquote = styled4("blockquote", {
  display: "flex",
  typography: "$bodyOne",
  "&::before": {
    flexShrink: 0,
    marginInlineEnd: "$oneAndHalf",
    content: "",
    width: "10px",
    borderRadius: "$extraLarge",
    backgroundColor: "$decorativeBrandPrimaryBrightest"
  }
});
var Image12 = styled4("img", {
  maxWidth: "100%",
  maxHeight: "66vh",
  width: "fit-content"
});

// src/pages/health-activity/common/activity-toolbox-rich-text-options.tsx
var STATIC_TOOLBOX_RICH_TEXT_STYLES = Object.freeze({
  display: "flex",
  flexDirection: "column",
  gap: "$one",
  overflowWrap: "anywhere",
  whiteSpace: "pre-wrap",
  "p *": { lineHeight: "inherit", fontSize: "inherit" },
  "p > a": { display: "inline" }
});
var activityToolboxRichTextOptions = {
  blockquote: { component: Blockquote },
  br: { component: Fragment6 },
  b: { component: Bold },
  i: { component: Italic },
  mark: { component: Mark },
  img: { component: Image12 },
  a: { component: Link12 }
};

// src/pages/health-activity/components/page-components/activity-toolbox-rich-text.component.tsx
var ActivityToolboxRichText = ({
  as,
  componentId,
  css: cssOverrides = {},
  options: options2 = {},
  richText
}) => {
  const formattedRichText = useMemo20(
    () => wrapOrphanTextNode(richText.trim()),
    [richText]
  );
  const consolidatedOptions = __spreadValues(__spreadValues({}, activityToolboxRichTextOptions), options2);
  return /* @__PURE__ */ React114.createElement(
    Box58,
    {
      className: "toolbox-richtext",
      as,
      css: __spreadValues(__spreadValues({}, STATIC_TOOLBOX_RICH_TEXT_STYLES), cssOverrides),
      "data-testid": componentId
    },
    /* @__PURE__ */ React114.createElement(
      HtmlToReact,
      {
        htmlString: formattedRichText,
        options: consolidatedOptions
      }
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-full-page-highlight.component.tsx
var ActivityToolboxFullPageHighlight = ({
  title,
  subtitle,
  highlightImage,
  highlightText,
  backgroundColor,
  componentId,
  isVisible,
  css: css14
}) => {
  const derivedBackgroundColor = backgroundColor || "$decorativeBrandSecondaryPastel";
  const { setActivityToolboxTheme } = useActivityToolboxTheme();
  const { componentRef, isVisible: isInFrame } = useIsToolboxComponentVisible({
    threshold: 0.75
  });
  const shouldApplyTheme = useMemo21(
    () => isVisible && isInFrame,
    [isInFrame, isVisible]
  );
  useEffect16(() => {
    if (shouldApplyTheme) {
      setActivityToolboxTheme({ backgroundColor: derivedBackgroundColor });
    } else {
      setActivityToolboxTheme(activityToolboxDefaultTheme);
    }
  }, [derivedBackgroundColor, setActivityToolboxTheme, shouldApplyTheme]);
  return /* @__PURE__ */ React115.createElement(
    StackLayout34,
    {
      ref: componentRef,
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: __spreadValues({
        backgroundColor: derivedBackgroundColor,
        position: "relative",
        minHeight: "100%"
      }, css14),
      "data-testid": componentId
    },
    /* @__PURE__ */ React115.createElement(
      StackLayout34,
      {
        orientation: "vertical",
        horizontalAlignment: "center",
        verticalAlignment: "center",
        spacing: "$threeQuarters",
        css: {
          padding: "0 $oneAndHalf",
          textAlign: "center",
          zIndex: "$sticky"
        }
      },
      highlightImage && /* @__PURE__ */ React115.createElement(
        Box59,
        {
          as: "img",
          src: highlightImage,
          alt: "",
          css: { maxWidth: "120px", maxHeight: "120px" }
        }
      ),
      title && /* @__PURE__ */ React115.createElement(HeadingText16, { level: "2", size: "xxl" }, title),
      subtitle && /* @__PURE__ */ React115.createElement(HeadingText16, { level: "display", size: "md", as: "p" }, subtitle),
      highlightText && /* @__PURE__ */ React115.createElement(ActivityToolboxRichText, { richText: highlightText })
    ),
    /* @__PURE__ */ React115.createElement(React115.Suspense, { fallback: null }, /* @__PURE__ */ React115.createElement(WaveAnimation, null))
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-blockquote.component.tsx
import React116 from "react";
import { ParagraphText as ParagraphText7 } from "@leagueplatform/genesis-core";
var ActivityToolboxBlockquote = ({
  text,
  css: cssOverrides,
  componentId
}) => /* @__PURE__ */ React116.createElement(Blockquote, { css: cssOverrides, "data-testid": componentId }, /* @__PURE__ */ React116.createElement(
  ParagraphText7,
  {
    htmlStringOptions: activityToolboxRichTextOptions,
    css: STATIC_TOOLBOX_RICH_TEXT_STYLES
  },
  text
));

// src/pages/health-activity/components/page-components/activity-toolbox-header.component.tsx
import React118 from "react";
import { styled as styled6, Box as Box61, UtilityText as UtilityText18 } from "@leagueplatform/genesis-core";

// src/pages/health-activity/components/progress/circle-progress.component.tsx
import React117 from "react";
import { Box as Box60, styled as styled5 } from "@leagueplatform/genesis-core";
var SvgCircle = styled5("circle", {
  transform: "rotate(-90deg)",
  transformOrigin: "center",
  transition: `stroke-dashoffset ${TRANSITIONS.PAGE}`,
  width: "100%"
});
var Svg = styled5("svg", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
var calcPercentOfCircumference = (percent, circumference) => {
  const clampedPercent = Math.min(Math.max(percent, 0), 100);
  const percentOfCircumference = (100 - clampedPercent) / 100 * circumference;
  return percentOfCircumference;
};
var CircleProgress = ({
  children,
  lineCap = "butt",
  percent,
  size,
  strokeColor,
  strokeWidth = 3,
  trackColor,
  css: css14
}) => {
  const trueRadius = size / 2;
  const normalizedRadius = trueRadius - strokeWidth / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const circumferencePercent = calcPercentOfCircumference(
    percent,
    circumference
  );
  const derivedStrokeColor = strokeColor != null ? strokeColor : "$successIcon";
  const derivedTrackColor = trackColor != null ? trackColor : "$surfaceBackgroundPrimary";
  return /* @__PURE__ */ React117.createElement(
    Box60,
    {
      css: __spreadValues({
        display: "flex",
        width: size,
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      }, css14)
    },
    children,
    /* @__PURE__ */ React117.createElement(
      Svg,
      {
        viewBox: `0 0 ${size} ${size}`,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React117.createElement(
        SvgCircle,
        {
          r: normalizedRadius,
          cx: trueRadius,
          cy: trueRadius,
          strokeDashoffset: "0",
          css: {
            stroke: `${derivedTrackColor}`,
            fill: "transparent",
            strokeWidth: `${strokeWidth}`,
            strokeDasharray: `${circumference}`
          }
        }
      ),
      /* @__PURE__ */ React117.createElement(
        SvgCircle,
        {
          id: "bar",
          r: normalizedRadius,
          cx: trueRadius,
          cy: trueRadius,
          strokeLinecap: lineCap,
          strokeDashoffset: circumferencePercent,
          css: {
            stroke: `${derivedStrokeColor}`,
            fill: "transparent",
            strokeWidth: `${strokeWidth}`,
            strokeDasharray: `${circumference}`
          }
        }
      )
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-header.component.tsx
var ImageContainer = styled6(Box61, {
  "& + *": {
    zIndex: 1,
    backgroundColor: "$surfaceBackgroundPrimary !important",
    borderStartStartRadius: "$large !important",
    borderStartEndRadius: "$large !important",
    marginTop: "$minusTwoAndHalf !important",
    paddingTop: "$two !important"
  }
});
var HeaderImage = styled6(Box61, {
  position: "relative",
  padding: "$two",
  "&:after": {
    content: "",
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to top, rgba(0,0,0,.8) , rgba(0,0,0,0))"
  }
});
var ActivityToolboxHeader = ({
  imageUrl,
  alt = "",
  campaignName,
  progressPercentage,
  componentId,
  css: css14
}) => /* @__PURE__ */ React118.createElement(ImageContainer, { "data-testid": componentId, css: { css: css14 } }, /* @__PURE__ */ React118.createElement(
  HeaderImage,
  {
    role: "img",
    "aria-label": alt,
    css: {
      ariaLabel: alt,
      background: `url(${imageUrl})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "50% center",
      aspectRatio: " 480 / 212",
      display: "flex",
      alignItems: "flex-end"
    }
  },
  /* @__PURE__ */ React118.createElement(
    Box61,
    {
      css: {
        display: "flex",
        alignItems: "center",
        gap: "$one",
        paddingBottom: "$threeQuarters",
        zIndex: "1"
      }
    },
    progressPercentage >= 0 && progressPercentage !== null && /* @__PURE__ */ React118.createElement(CircleProgress, { size: 50, percent: progressPercentage }, /* @__PURE__ */ React118.createElement(
      UtilityText18,
      {
        css: {
          typography: "$overline",
          position: "absolute",
          color: "$onSurfaceTextReversed"
        }
      },
      progressPercentage,
      "%"
    )),
    campaignName && /* @__PURE__ */ React118.createElement(
      UtilityText18,
      {
        css: {
          typography: "$overline",
          textTransform: "uppercase",
          color: "$onSurfaceTextReversed"
        }
      },
      campaignName
    )
  )
));

// src/pages/health-activity/components/page-components/activity-toolbox-image.component.tsx
import React119 from "react";
import {
  ParagraphText as ParagraphText8,
  ImageMessage,
  Box as Box62
} from "@leagueplatform/genesis-core";
var ActivityToolboxImage = ({
  imageUrl,
  alt = "",
  caption,
  height = "auto",
  width = "100%",
  borderRadius = "$large",
  css: css14,
  componentId
}) => /* @__PURE__ */ React119.createElement(Box62, { as: "figure", css: __spreadValues({ display: "flex" }, css14) }, /* @__PURE__ */ React119.createElement(
  ImageMessage,
  {
    image: imageUrl,
    imageAlt: alt,
    imageGap: "$none",
    imagePosition: "top",
    css: {
      img: { borderRadius, height, width }
    },
    "data-testid": componentId
  },
  caption && /* @__PURE__ */ React119.createElement(
    ParagraphText8,
    {
      size: "xs",
      emphasis: "subtle",
      as: "figcaption",
      css: { marginTop: "$one" }
    },
    caption
  )
));

// src/pages/health-activity/components/page-components/activity-toolbox-link.component.tsx
import React120, { useMemo as useMemo23 } from "react";
import {
  Icon as Icon7,
  styled as styled7,
  Box as Box63,
  ImageMessage as ImageMessage2,
  ParagraphText as ParagraphText9
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl50 } from "@leagueplatform/locales";
import { ComponentTypes as ComponentTypes5 } from "@leagueplatform/health-journey-common";

// src/pages/health-activity/hooks/use-toolbox-link.hook.ts
import { useMemo as useMemo22 } from "react";
import { isValidUrl as isValidUrl2, normalizeUrl } from "@leagueplatform/web-common";
import { LinkLegacy as RouterLink5 } from "@leagueplatform/routing";
var cleanURL2 = (url) => normalizeUrl(url == null ? void 0 : url.trim().replace(/^app|^\/app/, ""));
var StaticDeepLinkProps = Object.freeze({
  target: "_blank",
  rel: "noopener noreferrer"
});
var useToolboxLink = (url = "") => {
  const linkUrl = url == null ? void 0 : url.trim();
  const isLinkOut = isValidUrl2(linkUrl, { protocol: "http" });
  const linkProps = useMemo22(() => {
    if (!linkUrl)
      return void 0;
    return isLinkOut ? __spreadProps(__spreadValues({}, StaticDeepLinkProps), { as: "a", href: linkUrl }) : { as: RouterLink5, to: cleanURL2(linkUrl) };
  }, [isLinkOut, linkUrl]);
  return { isLinkOut, linkProps };
};

// src/pages/health-activity/hooks/use-read-link.hook.ts
import { useCallback as useCallback13 } from "react";
import { useQuery as useQuery12, useQueryClient as useQueryClient9 } from "react-query";
var IS_TOOLBOX_LINK_READ_QUERY = "is-toolbox-link-read";
var useToolboxLinkState = (linkId = "") => {
  const queryClient = useQueryClient9();
  const { data: isLinkRead } = useQuery12(
    [IS_TOOLBOX_LINK_READ_QUERY, linkId],
    () => void 0,
    {
      initialData: false,
      staleTime: Infinity
    }
  );
  const setIsLinkRead = useCallback13(
    (isRead = false) => queryClient.setQueryData([IS_TOOLBOX_LINK_READ_QUERY, linkId], isRead),
    [queryClient, linkId]
  );
  return { isLinkRead, setIsLinkRead };
};

// src/pages/health-activity/components/page-components/activity-toolbox-link.component.tsx
var CardContainer2 = styled7("a", {
  display: "flex",
  textDecoration: "none",
  flexDirection: "column",
  alignItems: "center",
  gap: "$half",
  borderColor: "$onSurfaceBorderSubdued",
  borderRadius: "$large",
  backgroundColor: "$surfaceBackgroundPrimary",
  borderStyle: "solid",
  borderWidth: "$thin",
  padding: "$one $oneAndHalf",
  transition: "box-shadow 0.2s ease-out",
  "&:hover": {
    borderColor: "$interactiveBorderHovered"
  },
  "&:focus": {
    outline: "none",
    boxShadow: "0 0 0 $borderWidths$thick  $colors$interactiveBorderHovered"
  }
});
var LinkCta = ({
  copy,
  iconColor,
  textColor,
  iconToken
}) => /* @__PURE__ */ React120.createElement(
  ParagraphText9,
  {
    size: "xs",
    css: {
      fontWeight: "$overline",
      textTransform: "uppercase",
      color: textColor,
      display: "inline-flex",
      alignItems: "center",
      gap: "$quarter"
    }
  },
  /* @__PURE__ */ React120.createElement(Icon7, { label: "", icon: iconToken, size: "16px", tint: iconColor }),
  copy
);
var ActivityToolboxLink = ({
  url,
  iconUrl = "",
  title,
  css: css14,
  componentId,
  ctaText = ""
}) => {
  const { formatMessage } = useIntl50();
  const { isLinkRead, setIsLinkRead } = useToolboxLinkState(componentId);
  const { isLinkOut, linkProps } = useToolboxLink(url);
  const { actions } = useToolboxComponentContext(ComponentTypes5.Link);
  const handleLinkClick = (event) => {
    var _a, _b;
    const actionAttributes = { title, url };
    if (isLinkOut) {
      (_a = actions == null ? void 0 : actions.onLinkOut) == null ? void 0 : _a.call(actions, event, actionAttributes);
    } else {
      (_b = actions == null ? void 0 : actions.onDeepLink) == null ? void 0 : _b.call(actions, event, actionAttributes);
    }
    setIsLinkRead(true);
  };
  const ctaProps = useMemo23(
    () => isLinkRead ? {
      copy: formatMessage({ id: "COMPLETED_STATE_TITLE" }),
      iconColor: "$onSurfaceTextSuccess",
      textColor: "$onSurfaceTextSuccess",
      iconToken: "interfaceCheckmark"
    } : {
      copy: ctaText || formatMessage({ id: "LINK_OUT_MESSAGE" }),
      iconColor: "$secondaryTextDefault",
      textColor: "$secondaryTextDefault",
      iconToken: "tinyExternalLink"
    },
    [ctaText, formatMessage, isLinkRead]
  );
  return /* @__PURE__ */ React120.createElement(Box63, { css: css14 }, /* @__PURE__ */ React120.createElement(
    CardContainer2,
    __spreadValues({
      onClick: handleLinkClick,
      "data-testid": componentId,
      "aria-label": `${title}: ${ctaProps.copy}`
    }, linkProps),
    /* @__PURE__ */ React120.createElement(
      ImageMessage2,
      {
        imageAlt: "",
        imageGap: "$none",
        css: { borderRadius: "$circle", img: { width: "$four" } },
        image: iconUrl
      },
      /* @__PURE__ */ React120.createElement(ParagraphText9, { css: { typography: "$headingFour" } }, title)
    ),
    /* @__PURE__ */ React120.createElement(LinkCta, __spreadValues({}, ctaProps))
  ));
};

// src/pages/health-activity/components/page-components/activity-toolbox-banner.component.tsx
import React121 from "react";
import {
  UtilityText as UtilityText19,
  Box as Box64,
  Icon as Icon8,
  StackLayout as StackLayout35
} from "@leagueplatform/genesis-core";
import {
  BannerTypes
} from "@leagueplatform/health-journey-api";
var options = {
  [BannerTypes.primary]: {
    "p, &": {
      textAlign: "center",
      typography: "$subtitleOne"
    }
  },
  [BannerTypes.secondary]: {
    "p, &": {
      textAlign: "center",
      typography: "$subtitleOne"
    }
  },
  [BannerTypes.subtle]: {
    "p, &": {
      textAlign: "start",
      typography: "$caption"
    }
  }
};
var backgroundColorContainer = {
  [BannerTypes.primary]: {
    background: "$decorativeBrandPrimaryPastel",
    titleColor: "$onSurfaceTextPrimary"
  },
  [BannerTypes.secondary]: {
    background: "$decorativeBrandSecondaryPastel",
    titleColor: "$onSurfaceTextPrimary"
  },
  [BannerTypes.subtle]: {
    background: "$inputBackgroundDisabled",
    titleColor: "$onSurfaceTextPrimary"
  }
};
var ActivityToolboxBanner = ({
  title,
  type,
  iconUrl,
  richText,
  css: css14,
  componentId
}) => {
  var _a;
  const isVisible = !!(richText || title);
  const emphasisType = type === BannerTypes.primary || type === BannerTypes.secondary;
  const { background, titleColor } = (_a = backgroundColorContainer[type]) != null ? _a : backgroundColorContainer[BannerTypes.subtle];
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ React121.createElement(Box64, { css: css14, "data-testid": componentId }, /* @__PURE__ */ React121.createElement(
    StackLayout35,
    {
      horizontalAlignment: emphasisType ? "center" : "start",
      css: {
        backgroundColor: background,
        borderRadius: "$medium",
        padding: "$one"
      }
    },
    /* @__PURE__ */ React121.createElement(
      StackLayout35,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        horizontalAlignment: emphasisType ? "center" : "start",
        spacing: "$one",
        css: {
          paddingBottom: "$one"
        }
      },
      iconUrl ? /* @__PURE__ */ React121.createElement(
        Box64,
        {
          as: "img",
          alt: "",
          src: iconUrl,
          css: { width: "$one", height: "$one" }
        }
      ) : /* @__PURE__ */ React121.createElement(
        Icon8,
        {
          icon: "interfaceQuestionCircleFilled",
          size: "16px",
          tint: "$onSurfaceIconPrimary"
        }
      ),
      title && /* @__PURE__ */ React121.createElement(UtilityText19, { css: { color: titleColor }, size: "eyebrow" }, title)
    ),
    richText && /* @__PURE__ */ React121.createElement(ActivityToolboxRichText, { richText, css: options[type] })
  ));
};

// src/pages/health-activity/components/page-components/activity-toolbox-list.component.tsx
import React122 from "react";
import { Box as Box65, Icon as Icon9, StackLayout as StackLayout36 } from "@leagueplatform/genesis-core";
var ActivityToolboxList = ({
  list,
  css: css14,
  componentId
}) => /* @__PURE__ */ React122.createElement(
  StackLayout36,
  {
    as: "ul",
    orientation: "vertical",
    spacing: "$one",
    css: __spreadValues({ flexGrow: 0, height: "auto" }, css14),
    "data-testid": componentId
  },
  list == null ? void 0 : list.map((item, index) => {
    const key = `${componentId}-${index}`;
    return /* @__PURE__ */ React122.createElement(Box65, { as: "li", key, css: { display: "flex", gap: "$one" } }, /* @__PURE__ */ React122.createElement(
      Icon9,
      {
        icon: "statusSuccessStatusFilled",
        size: "24px",
        css: { color: "$onSurfaceTextPrimary", flexShrink: 0 }
      }
    ), /* @__PURE__ */ React122.createElement(ActivityToolboxRichText, { richText: item }));
  })
);

// src/pages/health-activity/components/page-components/activity-toolbox-decimal-input.component.tsx
import React123 from "react";
import { TextInput } from "@leagueplatform/genesis-core";
import { ControlledFormField } from "@leagueplatform/web-common";

// src/pages/health-activity/hooks/use-number-input-options.hook.ts
import { useMemo as useMemo24 } from "react";
import { useIntl as useIntl51 } from "@leagueplatform/locales";
var useNumberInputOptions = ({
  validation,
  isInteger = false
}) => {
  const { formatMessage } = useIntl51();
  return useMemo24(() => {
    const {
      required,
      minimumValue,
      maximumValue,
      customWarning,
      editable = true
    } = validation || {};
    const pattern = isInteger ? {
      pattern: {
        value: /^[0-9]*$/,
        message: customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_ENTER_WHOLE_NUMBER" })
      }
    } : {};
    return __spreadProps(__spreadValues({}, pattern), {
      disabled: !editable,
      required: {
        value: required,
        message: customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_REQUIRED_FIELD" })
      },
      min: {
        value: minimumValue,
        message: customWarning || formatMessage(
          { id: "TOOLBOX_VALIDATION_NUMBER_MINIMUM" },
          { value: minimumValue }
        )
      },
      max: {
        value: maximumValue,
        message: customWarning || formatMessage(
          { id: "TOOLBOX_VALIDATION_NUMBER_MAXIMUM" },
          { value: maximumValue }
        )
      }
    });
  }, [formatMessage, isInteger, validation]);
};

// src/pages/health-activity/components/activity-toolbox-input-wrapper.component.tsx
import { useEffect as useEffect17, useContext as useContext3, useRef as useRef6 } from "react";
import { useFormContext } from "@leagueplatform/web-common";
var defaultValueMapper = (value, component) => Object.assign(component, {
  componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), { answer: value })
});
var ActivityToolboxInputWrapper = ({ inputName, mapValueToProps = defaultValueMapper, children }) => {
  const { watch } = useFormContext();
  const { toolboxComponentMap } = useContext3(ToolboxComponentContext);
  const { current: component } = useRef6(toolboxComponentMap[inputName]);
  const value = watch(inputName);
  useEffect17(() => {
    if (component) {
      mapValueToProps(value, component);
    }
  }, [mapValueToProps, component, value]);
  return children;
};

// src/pages/health-activity/components/page-components/activity-toolbox-decimal-input.component.tsx
var ActivityToolboxDecimalInput = ({
  answer,
  altText,
  suffix,
  prefix,
  placeholder,
  validation,
  css: css14,
  componentId
}) => {
  const inputOptions = useNumberInputOptions({ validation });
  const mapValueToProps = (value, component) => {
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: Number(value)
      })
    });
    return component;
  };
  return /* @__PURE__ */ React123.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React123.createElement(
      ControlledFormField,
      {
        css: css14,
        hideLabel: true,
        id: componentId,
        label: altText,
        name: componentId,
        inputOptions
      },
      /* @__PURE__ */ React123.createElement(
        TextInput,
        {
          "aria-label": altText,
          type: "number",
          addOnStart: prefix || null,
          addOnEnd: suffix || null,
          placeholder,
          defaultValue: answer,
          step: 0.1,
          "data-testid": componentId
        }
      )
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-integer-input.component.tsx
import React124 from "react";
import { TextInput as TextInput2 } from "@leagueplatform/genesis-core";
import { ControlledFormField as ControlledFormField2 } from "@leagueplatform/web-common";
var ActivityToolboxIntegerInput = ({
  answer,
  altText,
  suffix,
  prefix,
  css: css14,
  placeholder,
  validation,
  componentId
}) => {
  const inputOptions = useNumberInputOptions({
    validation,
    isInteger: true
  });
  const mapValueToProps = (value, component) => {
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: Number(value)
      })
    });
    return component;
  };
  return /* @__PURE__ */ React124.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React124.createElement(
      ControlledFormField2,
      {
        css: css14,
        hideLabel: true,
        id: componentId,
        label: altText,
        name: componentId,
        inputOptions
      },
      /* @__PURE__ */ React124.createElement(
        TextInput2,
        {
          "aria-label": altText,
          type: "number",
          addOnStart: prefix || null,
          addOnEnd: suffix || null,
          placeholder,
          defaultValue: answer,
          "data-testid": componentId
        }
      )
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-string-input.component.tsx
import React125, { createElement as createElement20, forwardRef } from "react";
import {
  Box as Box66,
  Icon as Icon10,
  TextInput as TextInput3
} from "@leagueplatform/genesis-core";
import {
  StringInputMethodType
} from "@leagueplatform/health-journey-api";
import {
  ControlledFormField as ControlledFormField3,
  useFormContext as useFormContext2
} from "@leagueplatform/web-common";

// src/pages/health-activity/hooks/use-string-input-options.hook.ts
import { useMemo as useMemo25 } from "react";
import { useIntl as useIntl52 } from "@leagueplatform/locales";
var useStringInputOptions = (validation) => {
  const { formatMessage } = useIntl52();
  const {
    required,
    characterLimit,
    customWarning,
    editable = true
  } = validation || {};
  return useMemo25(
    () => ({
      disabled: !editable,
      required: {
        value: required,
        message: customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_REQUIRED_FIELD" })
      },
      maxLength: {
        value: characterLimit,
        message: customWarning || formatMessage(
          { id: "TOOLBOX_VALIDATION_MAXIMUM_CHARACTERS" },
          { limit: characterLimit }
        )
      }
    }),
    [editable, required, customWarning, formatMessage, characterLimit]
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-string-input.component.tsx
var commonStyles = {
  "> *": {
    flexShrink: "1",
    width: "auto"
  }
};
var textareaStyles = {
  resize: "vertical",
  padding: "$space$threeQuarters $space$one",
  minHeight: "$five",
  border: "none",
  background: "inherit",
  paddingInlineStart: "$quarter"
};
var Textarea = forwardRef(
  (props, ref) => createElement20(Box66, __spreadValues({ ref, as: "textarea", css: textareaStyles }, props))
);
var ActivityToolboxStringInput = ({
  answer,
  altText,
  suffix,
  prefix,
  css: css14,
  placeholder,
  validation,
  inputMethod,
  componentId
}) => {
  const { setValue } = useFormContext2();
  const isTextarea = inputMethod === StringInputMethodType.box;
  const renderAs = isTextarea ? Textarea : null;
  const conditionalStyles = isTextarea ? __spreadProps(__spreadValues({}, commonStyles), {
    ".GDS-text-input-wrapper": {
      padding: "0",
      paddingInlineStart: "$one",
      "textarea:focus": {
        boxShadow: "none"
      }
    }
  }) : commonStyles;
  const inputOptions = useStringInputOptions(validation);
  return /* @__PURE__ */ React125.createElement(ActivityToolboxInputWrapper, { inputName: componentId }, /* @__PURE__ */ React125.createElement(
    ControlledFormField3,
    {
      name: componentId,
      css: css14,
      label: altText,
      hideLabel: true,
      id: componentId,
      inputOptions
    },
    /* @__PURE__ */ React125.createElement(
      TextInput3,
      {
        as: renderAs,
        "aria-label": altText,
        addOnStart: prefix || null,
        addOnEnd: suffix || null,
        placeholder,
        defaultValue: answer,
        "data-testid": componentId,
        clearable: !isTextarea,
        onClear: () => {
          setValue(componentId, "");
        },
        leadingContent: /* @__PURE__ */ React125.createElement(Icon10, { size: 20, icon: "interfaceEdit" }),
        css: conditionalStyles
      }
    )
  ));
};

// src/pages/health-activity/components/page-components/multiple-select/activity-toolbox-multiple-select-input.component.tsx
import React129, { useMemo as useMemo28, useCallback as useCallback16 } from "react";
import { useIntl as useIntl56 } from "@leagueplatform/locales";
import { Fieldset, StackLayout as StackLayout38 } from "@leagueplatform/genesis-core";
import {
  useControlledInput as useControlledInput2,
  useFormContext as useFormContext4
} from "@leagueplatform/web-common";

// src/pages/health-activity/hooks/use-multi-select-input-validation.hook.ts
import { useCallback as useCallback14 } from "react";
import { useIntl as useIntl53 } from "react-intl";
var useMultiSelectInputValidation = ({
  minimumSelectionRequired,
  maximumSelectionRequired,
  customWarning
}) => {
  const { formatMessage } = useIntl53();
  const selectedOverMaxOptions = useCallback14(
    (value) => {
      const message = customWarning || formatMessage(
        { id: "TOOLBOX_VALIDATION_SELECT_MAX_SELECTION" },
        { integer: maximumSelectionRequired }
      );
      return (value == null ? void 0 : value.length) > maximumSelectionRequired ? message : void 0;
    },
    [customWarning, formatMessage, maximumSelectionRequired]
  );
  const selectedUnderMinOptions = useCallback14(
    (value) => {
      const message = customWarning || formatMessage(
        { id: "TOOLBOX_VALIDATION_SELECT_OPTIONS_TO_CONTINUE" },
        { integer: minimumSelectionRequired }
      );
      return (value == null ? void 0 : value.length) < minimumSelectionRequired ? message : void 0;
    },
    [customWarning, formatMessage, minimumSelectionRequired]
  );
  return {
    selectedOverMaxOptions,
    selectedUnderMinOptions
  };
};

// src/pages/health-activity/components/page-components/multiple-select/activity-toolbox-multi-select-option.component.tsx
import React126, {
  forwardRef as forwardRef2,
  useState as useState16,
  useEffect as useEffect18,
  useMemo as useMemo26
} from "react";
import { useIntl as useIntl54 } from "@leagueplatform/locales";
import {
  Checkbox,
  Radio,
  Card as Card5,
  TextInput as TextInput4,
  Icon as Icon11,
  FormField
} from "@leagueplatform/genesis-core";
import {
  FreeTextInputType
} from "@leagueplatform/health-journey-api";
import { useControlledInput, useFormContext as useFormContext3 } from "@leagueplatform/web-common";
var optionCardStyles = {
  borderColor: "$onSurfaceBorderSubdued",
  borderWidth: "$thin",
  borderStyle: "solid",
  "&:hover": { backgroundColor: "$inputBackgroundHovered" },
  "&:has(:checked)": { borderColor: "$interactiveActionPrimary" }
};
var OptionWrapper = ({ children }) => /* @__PURE__ */ React126.createElement(Card5.Elevated, { className: "toolbox-option-wrapper", css: optionCardStyles }, children);
var RadioOption = forwardRef2(
  (_a, ref) => {
    var _b = _a, { isSelected, label, id, name, value } = _b, rest = __objRest(_b, ["isSelected", "label", "id", "name", "value"]);
    return /* @__PURE__ */ React126.createElement(OptionWrapper, null, /* @__PURE__ */ React126.createElement(
      Radio,
      __spreadProps(__spreadValues({}, rest), {
        id,
        name,
        value,
        layout: "row",
        checked: isSelected,
        css: { ".GDS-radio-label-hint": { padding: "$one" } },
        label,
        ref
      })
    ));
  }
);
var CheckboxOption = forwardRef2(
  (_a, ref) => {
    var _b = _a, { isSelected, label, id, name, value } = _b, rest = __objRest(_b, ["isSelected", "label", "id", "name", "value"]);
    return /* @__PURE__ */ React126.createElement(OptionWrapper, null, /* @__PURE__ */ React126.createElement(
      Checkbox,
      __spreadProps(__spreadValues({}, rest), {
        id,
        name,
        layout: "row",
        value,
        label,
        checked: isSelected,
        css: { ".GDS-checkbox-label": { padding: "$one" } },
        ref
      })
    ));
  }
);
var FreeTextOption = ({
  ariaLabel,
  validation = {},
  value,
  isSelected,
  onChange,
  disabled,
  id,
  name
}) => {
  const { formatMessage } = useIntl54();
  const { clearErrors, trigger } = useFormContext3();
  const [workingValue, setWorkingValue] = useState16(value != null ? value : "");
  const {
    inputType,
    maximumValue,
    minimumValue = 0,
    characterLimit,
    placeholder
  } = validation;
  const isNumber = inputType === FreeTextInputType.integer;
  const copy = {
    validationRequired: formatMessage({
      id: "TOOLBOX_VALIDATION_FIELD_CANNOT_BE_EMPTY"
    }),
    validationMax: formatMessage(
      { id: "TOOLBOX_VALIDATION_NUMBER_MAXIMUM" },
      { value: maximumValue }
    ),
    validationMin: formatMessage(
      { id: "TOOLBOX_VALIDATION_NUMBER_MINIMUM" },
      { value: minimumValue }
    ),
    validationCharLimit: formatMessage(
      { id: "TOOLBOX_VALIDATION_MAXIMUM_CHARACTERS" },
      { limit: characterLimit }
    )
  };
  const { field, inputValidationState, fieldState } = useControlledInput({
    name,
    defaultValue: workingValue,
    rules: {
      value: workingValue,
      onChange,
      required: {
        value: isSelected,
        message: copy.validationRequired
      },
      max: {
        value: isSelected && maximumValue || Infinity,
        message: copy.validationMax
      },
      min: {
        value: Number(isSelected && minimumValue),
        message: copy.validationMin
      },
      maxLength: {
        value: isSelected && characterLimit || Infinity,
        message: copy.validationCharLimit
      }
    }
  });
  const { isDirty } = fieldState;
  const { inputStatus, statusMessage } = inputValidationState;
  useEffect18(() => {
    if (!isSelected) {
      clearErrors(name);
    } else if (isSelected && isDirty) {
      trigger(name);
    }
  }, [clearErrors, isDirty, isSelected, name, trigger]);
  const setValueAs = (nextValue) => {
    setWorkingValue(nextValue);
    field.onChange(nextValue);
  };
  const computedAriaLabel = useMemo26(() => {
    const errorLabel = [inputStatus, statusMessage].filter(Boolean).join(": ").trim();
    return [ariaLabel, errorLabel].filter(Boolean).join(": ").trim();
  }, [ariaLabel, inputStatus, statusMessage]);
  return /* @__PURE__ */ React126.createElement(
    FormField,
    {
      label: null,
      hideLabel: true,
      "aria-label": computedAriaLabel,
      id,
      name,
      inputStatus,
      statusMessage
    },
    /* @__PURE__ */ React126.createElement(
      TextInput4,
      __spreadProps(__spreadValues({}, field), {
        value: workingValue,
        type: isNumber ? "number" : void 0,
        checked: isSelected,
        placeholder,
        disabled,
        clearable: true,
        autoComplete: "off",
        leadingContent: /* @__PURE__ */ React126.createElement(Icon11, { size: "$one", icon: "interfaceEdit" }),
        inputStatus,
        css: { input: { background: "inherit" } },
        onChange: ({ target: { value: nextValue } }) => setValueAs(nextValue),
        onClear: () => setValueAs("")
      })
    )
  );
};

// src/pages/health-activity/components/page-components/multiple-select/activity-toolbox-multiple-select-option-resolver.component.tsx
import React128, {
  useRef as useRef7,
  useCallback as useCallback15,
  useMemo as useMemo27,
  forwardRef as forwardRef3,
  createElement as createElement21
} from "react";
import { useIntl as useIntl55 } from "@leagueplatform/locales";

// src/pages/health-activity/common/activity-toolbox-option-label.component.tsx
import React127 from "react";
import {
  Icon as Icon12,
  ParagraphText as ParagraphText10,
  StackLayout as StackLayout37,
  UtilityText as UtilityText20
} from "@leagueplatform/genesis-core";
var ActivityToolboxOptionLabel = ({ text, subText, iconUrl, ariaLabel }) => /* @__PURE__ */ React127.createElement(
  StackLayout37,
  {
    orientation: "horizontal",
    horizontalAlignment: "center",
    verticalAlignment: "center",
    spacing: "$one",
    "aria-label": [text, subText, ariaLabel].filter(Boolean).join("; ")
  },
  iconUrl && /* @__PURE__ */ React127.createElement(Icon12, { icon: iconUrl, "aria-hidden": true }),
  /* @__PURE__ */ React127.createElement(StackLayout37, { spacing: "$quarter" }, /* @__PURE__ */ React127.createElement(UtilityText20, null, text), subText && /* @__PURE__ */ React127.createElement(
    ParagraphText10,
    {
      size: "xs",
      css: { typography: "$caption", color: "$onSurfaceTextSubdued" }
    },
    subText
  ))
);

// src/pages/health-activity/components/page-components/multiple-select/activity-toolbox-multiple-select-option-resolver.component.tsx
var ActivityToolboxMultiSelectOptionResolver = forwardRef3((_a, ref) => {
  var _b = _a, { optionType: Option, option, optionId, name, disabled } = _b, field = __objRest(_b, ["optionType", "option", "optionId", "name", "disabled"]);
  const { formatMessage } = useIntl55();
  const {
    enableFreeText,
    exclusive,
    iconUrl,
    freeTextValidation,
    subText,
    text,
    id,
    isSelected,
    value: initialValue
  } = option;
  const fieldRef = useRef7(null);
  const currentValue = useMemo27(
    () => {
      var _a2;
      return (_a2 = enableFreeText ? text : initialValue) != null ? _a2 : "";
    },
    [enableFreeText, initialValue, text]
  );
  const ariaLabel = useMemo27(
    () => [
      enableFreeText && formatMessage(
        { id: "TOOLBOX_INPUT_OPTION_FREE_TEXT" },
        { hasValue: Boolean(currentValue), value: currentValue }
      ),
      exclusive && formatMessage({ id: "TOOLBOX_INPUT_OPTION_EXCLUSIVE" })
    ].filter(Boolean).join("; ").trim(),
    [currentValue, enableFreeText, exclusive, formatMessage]
  );
  const mapOptionToProps = useCallback15(
    (value, checked = isSelected) => {
      if (fieldRef.current) {
        fieldRef.current.value = value;
        fieldRef.current.checked = checked;
      }
      if (option.enableFreeText) {
        Object.assign(option, { text: value, isSelected: checked });
      } else {
        Object.assign(option, { value, isSelected: checked });
      }
    },
    [isSelected, option]
  );
  const onChange = useCallback15(
    (event) => {
      const { target } = event;
      const { value, checked } = target;
      mapOptionToProps(value, checked);
      field.onChange(option);
    },
    [field, mapOptionToProps, option]
  );
  const commonProps = __spreadProps(__spreadValues({}, field), {
    value: currentValue,
    disabled,
    isSelected,
    onChange
  });
  const optionProps = __spreadValues({ id }, commonProps);
  const OptionLabel = enableFreeText ? createElement21(FreeTextOption, __spreadProps(__spreadValues({}, commonProps), {
    ariaLabel,
    validation: freeTextValidation,
    id: name,
    // using the radio/checkbox name as the id allows the free-text field to act as the label when clicked
    name: optionId
    // using the optionId as the name for the free-text field allows us to track/validate it separately
  })) : createElement21(ActivityToolboxOptionLabel, {
    text,
    subText,
    iconUrl,
    ariaLabel
  });
  return /* @__PURE__ */ React128.createElement(
    Option,
    __spreadProps(__spreadValues({}, optionProps), {
      name,
      id: optionId,
      value: currentValue,
      label: OptionLabel,
      ref: (node7) => {
        fieldRef.current = node7;
        if (typeof ref === "function") {
          ref(node7);
        }
      }
    })
  );
});

// src/pages/health-activity/components/page-components/multiple-select/activity-toolbox-multiple-select-input.component.tsx
var ActivityToolboxMultipleSelectInput = (props) => {
  const { formatMessage } = useIntl56();
  const { setValue } = useFormContext4();
  const { altText, css: css14, componentId, validation, answerOptions } = props;
  const {
    customWarning,
    editable = true,
    maximumSelectionRequired,
    minimumSelectionRequired,
    required
  } = validation;
  const { selectedOverMaxOptions, selectedUnderMinOptions } = useMultiSelectInputValidation({
    maximumSelectionRequired,
    minimumSelectionRequired,
    customWarning
  });
  const isCheckbox = !maximumSelectionRequired || maximumSelectionRequired > 1;
  const OptionElement = useMemo28(
    () => isCheckbox ? CheckboxOption : RadioOption,
    [isCheckbox]
  );
  const getSelectedAnswerOptionValues = useCallback16(
    (options2 = answerOptions) => options2.map(
      ({ isSelected, enableFreeText, value, text }) => isSelected && (enableFreeText ? text : value)
    ).filter((optionValue) => optionValue !== false),
    [answerOptions]
  );
  const setSelectedAnswerOptions = useCallback16(
    (changedOption) => answerOptions.map((option) => {
      let { isSelected } = option;
      const treatAsExclusive = !isCheckbox || (changedOption == null ? void 0 : changedOption.exclusive) || (option == null ? void 0 : option.exclusive);
      const isChangedOptionSelected = option.id === (changedOption == null ? void 0 : changedOption.id) && (changedOption == null ? void 0 : changedOption.isSelected);
      if (treatAsExclusive && !isChangedOptionSelected) {
        isSelected = false;
      }
      return Object.assign(option, { isSelected });
    }),
    [answerOptions, isCheckbox]
  );
  const inputOptions = useMemo28(
    () => ({
      defaultValue: getSelectedAnswerOptionValues(),
      name: componentId,
      rules: {
        disabled: !editable,
        onChange: (event) => {
          const { target } = event;
          const { value: option } = target;
          const updatedOptions = setSelectedAnswerOptions(option);
          const nextValues = getSelectedAnswerOptionValues(updatedOptions);
          setValue(componentId, nextValues, {
            shouldDirty: true
          });
        },
        required: {
          value: required,
          message: customWarning || formatMessage({
            id: "TOOLBOX_VALIDATION_MULTI_SELECT_REQUIRED"
          })
        },
        validate: {
          selectedUnderMinOptions,
          selectedOverMaxOptions
        }
      }
    }),
    [
      componentId,
      editable,
      required,
      customWarning,
      formatMessage,
      setSelectedAnswerOptions,
      getSelectedAnswerOptionValues,
      setValue,
      selectedUnderMinOptions,
      selectedOverMaxOptions
    ]
  );
  const mapValueToProps = useCallback16(
    (currentValue, component) => {
      if (currentValue) {
        const { componentAttributes } = component;
        Object.assign(componentAttributes, __spreadProps(__spreadValues({}, componentAttributes), {
          answerOptions
        }));
      }
      return component;
    },
    [answerOptions]
  );
  const optionProps = useMemo28(
    () => answerOptions.map((option, index) => ({
      option,
      optionId: `${componentId}-${index}`
    })),
    [answerOptions, componentId]
  );
  const {
    field,
    inputValidationState: { inputStatus, statusMessage }
  } = useControlledInput2(inputOptions);
  return /* @__PURE__ */ React129.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React129.createElement(
      Fieldset,
      {
        id: componentId,
        legend: altText,
        hideLegend: true,
        css: css14,
        inputStatus,
        statusMessage,
        "data-testid": componentId
      },
      /* @__PURE__ */ React129.createElement(StackLayout38, { spacing: "$one", horizontalAlignment: "stretch" }, optionProps == null ? void 0 : optionProps.map(({ option, optionId }) => /* @__PURE__ */ React129.createElement(
        ActivityToolboxMultiSelectOptionResolver,
        __spreadValues({
          key: optionId,
          option,
          optionId,
          optionType: OptionElement,
          disabled: !editable
        }, field)
      )))
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-date-input.component.tsx
import React130, { useMemo as useMemo31 } from "react";
import {
  StackLayout as StackLayout39,
  Select,
  Radio as Radio2,
  Card as Card6,
  Box as Box67,
  Fieldset as Fieldset2
} from "@leagueplatform/genesis-core";
import { useControlledInput as useControlledInput3 } from "@leagueplatform/web-common";
import {
  DateInputMethodType,
  AdditionalDateOptionUnit as AdditionalDateOptionUnit2
} from "@leagueplatform/health-journey-api";
import { useIntl as useIntl59 } from "@leagueplatform/locales";

// src/pages/health-activity/hooks/use-date-helpers.hook.ts
import { useMemo as useMemo29 } from "react";
import { useIntl as useIntl57 } from "@leagueplatform/locales";

// src/pages/health-activity/common/format-date.util.ts
import { AdditionalDateOptionUnit } from "@leagueplatform/health-journey-api";
var { day, month, year, week, noAnswer } = AdditionalDateOptionUnit;
var normalizeDateToMidnight = (initialDate) => {
  const normalizedDate = new Date(initialDate);
  const isUTCMidnight = !normalizedDate.getUTCHours();
  const isLocalMidnight = !normalizedDate.getHours();
  const userTimezoneOffset = normalizedDate.getTimezoneOffset();
  if (isUTCMidnight) {
    normalizedDate.setHours(0, userTimezoneOffset, 0, 0);
  } else if (!isLocalMidnight) {
    normalizedDate.setHours(0, 0, 0, 0);
  }
  return normalizedDate;
};
var formatDateToISOString = (initialDate) => new Date(initialDate).toISOString();
var formatDateToParts = (date) => {
  if (!date) {
    return {
      day: -1,
      month: -1,
      year: -1
    };
  }
  const normalizedDate = normalizeDateToMidnight(date);
  return {
    day: normalizedDate.getUTCDate(),
    month: normalizedDate.getUTCMonth(),
    year: normalizedDate.getUTCFullYear()
  };
};
var getAbsoluteDate = ({
  year: selectedYear,
  month: selectedMonth,
  day: selectedDay
}) => {
  if (selectedYear && selectedMonth && selectedDay) {
    const normalizedDate = normalizeDateToMidnight(
      new Date(
        Number(selectedYear),
        Number(selectedMonth),
        Number(selectedDay)
      )
    );
    return formatDateToISOString(normalizedDate);
  }
  return NaN;
};
var getRelativeDate = ({
  unit,
  value,
  date = Date.now()
}) => {
  const normalizedDate = normalizeDateToMidnight(date);
  const {
    day: dayValue,
    month: monthValue,
    year: yearValue
  } = formatDateToParts(normalizedDate);
  switch (unit) {
    case day:
      normalizedDate.setUTCDate(dayValue + value);
      break;
    case week:
      normalizedDate.setUTCDate(dayValue + value * 7);
      break;
    case month:
      normalizedDate.setUTCMonth(monthValue + value);
      break;
    case year:
      normalizedDate.setUTCFullYear(yearValue + value);
      break;
    case noAnswer:
    default:
      return "";
  }
  return formatDateToISOString(normalizedDate);
};

// src/pages/health-activity/hooks/use-date-helpers.hook.ts
var currentDate = /* @__PURE__ */ new Date();
var currentYear = currentDate.getFullYear();
var getDaysInMonth = (month3, year3) => new Date(Number(year3), Number(month3), 0).getDate();
var buildMonthOptions = (formatDate) => {
  const monthOptions = Array.from({ length: 12 }, (_, monthIndex) => ({
    label: formatDate(new Date(0, monthIndex, 10), { month: "long" }),
    value: String(monthIndex)
  }));
  return monthOptions;
};
var buildDaysInMonthOptions = () => Array.from({ length: 31 }, (_, optionIndex) => {
  const day3 = (optionIndex + 1).toString();
  return { key: day3, label: day3, value: day3 };
});
var buildYearOptions = (minimumDate, maximumDate) => {
  const { year: maximumYear } = formatDateToParts(maximumDate || currentDate);
  const { year: minimumYear } = formatDateToParts(
    minimumDate || new Date(currentYear - 100, 0, 1)
  );
  const yearsOptions = Array.from(
    { length: Math.abs(maximumYear - minimumYear) + 1 },
    // + 1 to be inclusive of the min year option
    (_, optionIndex) => {
      const year3 = String(minimumYear + optionIndex);
      return { key: year3, label: year3, value: year3 };
    }
  );
  return yearsOptions;
};
var useDateSelectOptions = ({
  maximumDate,
  minimumDate
} = {}) => {
  const { formatDate, formatMessage } = useIntl57();
  const daySelectOptions = useMemo29(
    () => [
      { key: "", label: formatMessage({ id: "DAY" }), value: "" },
      ...buildDaysInMonthOptions()
    ],
    [formatMessage]
  );
  const monthSelectOptions = useMemo29(
    () => [
      { key: "", label: formatMessage({ id: "MONTH" }), value: "" },
      ...buildMonthOptions(formatDate)
    ],
    [formatDate, formatMessage]
  );
  const yearSelectOptions = useMemo29(
    () => [
      { key: "", label: formatMessage({ id: "YEAR" }), value: "" },
      ...buildYearOptions(minimumDate, maximumDate)
    ],
    [formatMessage, maximumDate, minimumDate]
  );
  return {
    daySelectOptions,
    monthSelectOptions,
    yearSelectOptions
  };
};

// src/pages/health-activity/hooks/use-toolbox-date-inputs.ts
import { useCallback as useCallback17, useRef as useRef8 } from "react";
import { useIntl as useIntl58 } from "@leagueplatform/locales";
import { useFormContext as useFormContext5 } from "@leagueplatform/web-common";
var useToolboxDateInputs = ({
  componentId,
  showDayInput,
  validation
}) => {
  const { formatMessage, $tifelse } = useIntl58();
  const { setValue } = useFormContext5();
  const dayInputRef = useRef8(null);
  const monthInputRef = useRef8(null);
  const yearInputRef = useRef8(null);
  const radioInputsRef = useRef8([]);
  const fieldRef = useRef8(null);
  const getDateSelectValues = useCallback17(
    () => {
      var _a, _b, _c;
      return {
        day: (_a = dayInputRef.current) == null ? void 0 : _a.value,
        month: (_b = monthInputRef.current) == null ? void 0 : _b.value,
        year: (_c = yearInputRef.current) == null ? void 0 : _c.value
      };
    },
    []
  );
  const isDateSelectEmpty = useCallback17(() => {
    const { day: day3, month: month3, year: year3 } = getDateSelectValues();
    return [day3, month3, year3].filter((selectValue) => selectValue !== void 0).every((selectValue) => selectValue === "");
  }, [getDateSelectValues]);
  const isRadioSelected = useCallback17(
    () => {
      var _a;
      return (_a = radioInputsRef.current) == null ? void 0 : _a.some((input) => input.checked);
    },
    []
  );
  const clearRadioInputs = useCallback17(() => {
    if (radioInputsRef.current.length) {
      radioInputsRef.current.forEach((item) => {
        const radio = item;
        radio.checked = false;
      });
    }
  }, []);
  const clearSelectInputs = useCallback17(() => {
    if (dayInputRef.current)
      dayInputRef.current.value = "";
    if (monthInputRef.current)
      monthInputRef.current.value = "";
    if (yearInputRef.current)
      yearInputRef.current.value = "";
  }, []);
  const { maximumDate, minimumDate, required, customWarning } = validation;
  const validatePartialDateSelect = useCallback17(
    (value) => Number.isNaN(value) || value === "NaN" ? $tifelse(
      showDayInput,
      "TOOLBOX_VALIDATION_DAY_MONTH_YEAR",
      "TOOLBOX_VALIDATION_MONTH_YEAR"
    ) : void 0,
    [$tifelse, showDayInput]
  );
  const validateMaxDate = useCallback17(
    (value) => {
      if (!maximumDate || !value)
        return void 0;
      const selectedDate = normalizeDateToMidnight(value);
      const maxDate = normalizeDateToMidnight(maximumDate);
      if (!showDayInput) {
        maxDate.setDate(1);
      }
      const message = customWarning || formatMessage(
        { id: "TOOLBOX_VALIDATION_SELECT_DATE_EARLIER" },
        { date: maxDate }
      );
      return selectedDate > maxDate ? message : void 0;
    },
    [customWarning, formatMessage, showDayInput, maximumDate]
  );
  const validateMinDate = useCallback17(
    (value) => {
      if (!minimumDate || !value)
        return void 0;
      const selectedDate = normalizeDateToMidnight(value);
      const minDate = normalizeDateToMidnight(minimumDate);
      if (!showDayInput) {
        minDate.setDate(1);
      }
      const message = customWarning || formatMessage(
        { id: "TOOLBOX_VALIDATION_SELECT_DATE_LATER" },
        { date: minDate }
      );
      return minDate > selectedDate ? message : void 0;
    },
    [minimumDate, showDayInput, customWarning, formatMessage]
  );
  const validateRequired = useCallback17(() => {
    if (!required)
      return void 0;
    const message = customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_DATE_INPUT_REQUIRED" });
    return isDateSelectEmpty() && !isRadioSelected() ? message : void 0;
  }, [
    customWarning,
    formatMessage,
    isDateSelectEmpty,
    isRadioSelected,
    required
  ]);
  const setValueAndValidate = useCallback17(
    (newValue) => {
      setValue(componentId, String(newValue), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
    },
    [componentId, setValue]
  );
  const onAdditionalOptionChange = useCallback17(
    (event, option) => {
      const newDate = getRelativeDate(option);
      clearSelectInputs();
      setValueAndValidate(newDate);
    },
    [clearSelectInputs, setValueAndValidate]
  );
  const onDateSelectChange = useCallback17(() => {
    var _a;
    const { day: day3, month: month3, year: year3 } = getDateSelectValues();
    clearRadioInputs();
    if (isDateSelectEmpty())
      return setValueAndValidate(null);
    const daysInMonth = getDaysInMonth(Number(month3) + 1, year3);
    const computedDay = Math.min(Number(day3), daysInMonth);
    const newDate = getAbsoluteDate({ day: day3 != null ? day3 : 1, month: month3, year: year3 });
    if (((_a = dayInputRef.current) == null ? void 0 : _a.value) && Number(day3) !== computedDay) {
      dayInputRef.current.value = computedDay.toString();
    }
    return setValueAndValidate(newDate);
  }, [
    clearRadioInputs,
    getDateSelectValues,
    isDateSelectEmpty,
    setValueAndValidate
  ]);
  const refs = {
    dayInputRef,
    monthInputRef,
    yearInputRef,
    radioInputsRef,
    fieldRef
  };
  const validateMethods = {
    validatePartialDateSelect,
    validateMinDate,
    validateMaxDate,
    validateRequired
  };
  const handlers = { onAdditionalOptionChange, onDateSelectChange };
  return { handlers, validateMethods, refs };
};

// src/pages/health-activity/hooks/use-toolbox-error-focus.hook.ts
import { useMemo as useMemo30, useEffect as useEffect19 } from "react";
import { useFormContext as useFormContext6 } from "@leagueplatform/web-common";
var useToolboxErrorFocus = ({
  name,
  focusTarget,
  onValidationError
}) => {
  const { formState } = useFormContext6();
  const { isValidating, error } = useMemo30(
    () => {
      var _a;
      return {
        isValidating: formState.isValidating,
        error: (_a = formState.errors) == null ? void 0 : _a[name]
      };
    },
    [formState, name]
  );
  useEffect19(() => {
    var _a, _b;
    if (!isValidating && error) {
      const shouldSwitchFocus = (_a = onValidationError == null ? void 0 : onValidationError()) != null ? _a : true;
      if (shouldSwitchFocus && focusTarget) {
        focusTarget.focus();
      } else if ((_b = error == null ? void 0 : error.ref) == null ? void 0 : _b.focus) {
        error.ref.focus();
      }
    }
  }, [name, focusTarget, isValidating, error, onValidationError]);
};

// src/pages/health-activity/components/page-components/activity-toolbox-date-input.component.tsx
var { day: day2, month: month2, year: year2 } = AdditionalDateOptionUnit2;
var additionalOptionFieldsetStyle = {
  legend: {
    display: "block",
    textAlign: "center",
    width: "100%",
    paddingTop: "$oneAndHalf",
    paddingBottom: "$oneAndHalf"
  }
};
var additionalOptionCardStyle = {
  border: "$borderWidths$thin solid $colors$onSurfaceBorderSubdued",
  width: "100%"
};
var additionalOptionRadioStyle = {
  label: {
    padding: "$oneAndHalf $one"
  }
};
var ActivityToolboxDateInput = ({
  answer,
  dateInputMethod,
  additionalDateOptions,
  altText,
  css: css14,
  validation = {},
  componentId
}) => {
  var _a, _b, _c;
  const { editable = true, minimumDate, maximumDate } = validation;
  const { formatMessage } = useIntl59();
  const showDayInput = dateInputMethod !== DateInputMethodType.monthYear;
  const showAdditionalOptions = Boolean(additionalDateOptions == null ? void 0 : additionalDateOptions.length);
  const { handlers, validateMethods, refs } = useToolboxDateInputs({
    componentId,
    showDayInput,
    validation
  });
  const { onAdditionalOptionChange, onDateSelectChange } = handlers;
  const { dayInputRef, monthInputRef, yearInputRef, radioInputsRef, fieldRef } = refs;
  const inputOptions = {
    name: componentId,
    defaultValue: answer != null ? answer : void 0,
    disabled: !editable,
    rules: { validate: validateMethods }
  };
  const { inputValidationState } = useControlledInput3(inputOptions);
  const { daySelectOptions, monthSelectOptions, yearSelectOptions } = useDateSelectOptions({ maximumDate, minimumDate });
  const {
    day: initialDay,
    month: initialMonth,
    year: initialYear
  } = useMemo31(() => formatDateToParts(answer), [answer]);
  const selectedMonth = (_a = monthInputRef.current) == null ? void 0 : _a.value;
  const selectedYear = (_b = yearInputRef.current) == null ? void 0 : _b.value;
  const daysInSelectedMonth = getDaysInMonth(
    Number(selectedMonth) + 1,
    Number(selectedYear)
  );
  useToolboxErrorFocus({
    name: componentId,
    focusTarget: !((_c = fieldRef.current) == null ? void 0 : _c.contains(document.activeElement)) && monthInputRef.current
  });
  const mapValueToProps = (value, component) => {
    const selectedOptions = additionalDateOptions == null ? void 0 : additionalDateOptions.map((option, index) => {
      var _a2;
      return __spreadProps(__spreadValues({}, option), {
        isSelected: (_a2 = radioInputsRef.current) == null ? void 0 : _a2[index].checked
      });
    });
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: value != null ? value : answer,
        additionalDateOptions: selectedOptions
      })
    });
    return component;
  };
  return /* @__PURE__ */ React130.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React130.createElement(Box67, { css: css14, ref: fieldRef, "data-testid": componentId }, /* @__PURE__ */ React130.createElement(
      Fieldset2,
      {
        id: componentId,
        legend: altText,
        hideLegend: true,
        inputStatus: inputValidationState.inputStatus,
        statusMessage: inputValidationState.statusMessage
      },
      /* @__PURE__ */ React130.createElement(
        StackLayout39,
        {
          spacing: "$one",
          orientation: "horizontal",
          horizontalAlignment: "stretch"
        },
        /* @__PURE__ */ React130.createElement(
          Select,
          {
            className: "date-input-select",
            id: `${componentId}-input-month`,
            options: monthSelectOptions,
            defaultValue: initialMonth,
            ref: monthInputRef,
            name: `${componentId}-select-${month2}`,
            onChange: onDateSelectChange,
            disabled: !editable,
            "aria-label": formatMessage({ id: "MONTH" })
          }
        ),
        showDayInput && /* @__PURE__ */ React130.createElement(
          Select,
          {
            className: "date-input-select",
            id: `${componentId}-input-day`,
            options: daySelectOptions.slice(
              0,
              daysInSelectedMonth + 1 || daySelectOptions.length
            ),
            defaultValue: initialDay,
            ref: dayInputRef,
            name: `${componentId}-select-${day2}`,
            onChange: onDateSelectChange,
            disabled: !editable,
            "aria-label": formatMessage({ id: "DAY" })
          }
        ),
        /* @__PURE__ */ React130.createElement(
          Select,
          {
            className: "date-input-select",
            id: `${componentId}-input-year`,
            options: yearSelectOptions,
            defaultValue: initialYear,
            ref: yearInputRef,
            name: `${componentId}-select-${year2}`,
            onChange: onDateSelectChange,
            disabled: !editable,
            "aria-label": formatMessage({ id: "YEAR" })
          }
        )
      )
    ), showAdditionalOptions && /* @__PURE__ */ React130.createElement(
      Fieldset2,
      {
        legend: formatMessage({ id: "OR_SELECT_BETWEEN_THESE" }),
        css: additionalOptionFieldsetStyle
      },
      /* @__PURE__ */ React130.createElement(StackLayout39, { spacing: "$one" }, additionalDateOptions == null ? void 0 : additionalDateOptions.map((option, index) => /* @__PURE__ */ React130.createElement(
        Card6.Elevated,
        {
          css: additionalOptionCardStyle,
          key: option.text
        },
        /* @__PURE__ */ React130.createElement(Card6.Section, { padding: "$none" }, /* @__PURE__ */ React130.createElement(
          Radio2,
          {
            id: `${componentId}-additional-option-${index}`,
            disabled: !editable,
            defaultChecked: option == null ? void 0 : option.isSelected,
            name: `${componentId}-option`,
            value: option.value.toString(),
            label: /* @__PURE__ */ React130.createElement(ActivityToolboxOptionLabel, { text: option.text }),
            layout: "row",
            css: additionalOptionRadioStyle,
            ref: (element) => {
              radioInputsRef.current[index] = element;
            },
            onChange: (event) => onAdditionalOptionChange(event, option)
          }
        ))
      )))
    ))
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-progress-tracking.component.tsx
import React133, {
  useMemo as useMemo33,
  useCallback as useCallback18,
  Suspense,
  useRef as useRef9,
  useEffect as useEffect20
} from "react";
import {
  Button as Button9,
  StackLayout as StackLayout42,
  InputStatusMessage,
  useTheme as useTheme3,
  Modal as Modal3
} from "@leagueplatform/genesis-core";
import { ConfettiAnimation } from "@leagueplatform/lottie";

// src/components/progress-tracker-chart.component.tsx
import React131 from "react";
import { useIntl as useIntl60 } from "@leagueplatform/locales";
import {
  Box as Box68,
  HeadingText as HeadingText17,
  ParagraphText as ParagraphText11,
  UtilityText as UtilityText21,
  styled as styled8,
  StackLayout as StackLayout40
} from "@leagueplatform/genesis-core";
var STROKE_DASHARRAY = 569;
var Chart = styled8("svg", {
  path: {
    strokeLinecap: "round",
    strokeWidth: 16,
    "&.base": {
      stroke: "$onSurfaceBorderSubdued"
    },
    "&.progress": {
      stroke: "$inputBorderSuccess",
      strokeDasharray: STROKE_DASHARRAY,
      strokeDashoffset: "$$strokeDashoffset"
    }
  }
});
function ProgressTrackerChart({
  unit,
  currentProgress,
  goal,
  progressPercentage,
  css: css14
}) {
  const { formatMessage, formatNumber } = useIntl60();
  const progressPercentageToDisplay = Math.min(progressPercentage, 100);
  const progressString = `${progressPercentageToDisplay}% ${formatMessage({
    id: "COMPLETE"
  })}`;
  const strokeDashoffset = STROKE_DASHARRAY - STROKE_DASHARRAY * (progressPercentageToDisplay / 100);
  return /* @__PURE__ */ React131.createElement(Box68, { "aria-hidden": "true", css: __spreadValues({ position: "relative", width: 265 }, css14) }, /* @__PURE__ */ React131.createElement(
    Chart,
    {
      width: "265",
      height: "230",
      css: {
        $$strokeDashoffset: strokeDashoffset
      }
    },
    /* @__PURE__ */ React131.createElement(
      "path",
      {
        className: "base",
        d: "M 47 218 A 120 120 0 1 1 217 218",
        fill: "none"
      }
    ),
    /* @__PURE__ */ React131.createElement(
      "path",
      {
        className: "progress",
        d: "M 47 218 A 120 120 0 1 1 217 218",
        fill: "none"
      }
    )
  ), /* @__PURE__ */ React131.createElement(
    StackLayout40,
    {
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%"
      }
    },
    /* @__PURE__ */ React131.createElement(
      UtilityText21,
      {
        size: "eyebrow",
        emphasis: "emphasized",
        css: { marginTop: "$quarter" }
      },
      unit
    ),
    /* @__PURE__ */ React131.createElement(
      HeadingText17,
      {
        as: "p",
        size: "xxl",
        level: "1",
        css: { marginTop: "$quarter" }
      },
      formatNumber(currentProgress)
    ),
    /* @__PURE__ */ React131.createElement(
      ParagraphText11,
      {
        size: "sm",
        emphasis: "subtle",
        css: { marginTop: "$quarter" }
      },
      "/ ",
      formatNumber(goal),
      " ",
      unit
    ),
    /* @__PURE__ */ React131.createElement(
      UtilityText21,
      {
        emphasis: "emphasized",
        css: {
          marginTop: "$threeQuarters",
          textTransform: "lowercase",
          color: "$successIcon"
        }
      },
      progressString
    )
  ));
}

// src/pages/health-activity/components/page-components/activity-toolbox-progress-tracking.component.tsx
import { useControlledInput as useControlledInput4, useFormContext as useFormContext7 } from "@leagueplatform/web-common";

// src/components/edit-progress-count-modal.component.tsx
import React132, { useState as useState17, useMemo as useMemo32 } from "react";
import {
  HeadingText as HeadingText18,
  TextInput as TextInput5,
  Box as Box69,
  StackLayout as StackLayout41,
  Button as Button8,
  styled as styled9,
  UtilityText as UtilityText22,
  VisuallyHidden as VisuallyHidden4,
  Modal as Modal2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl61 } from "@leagueplatform/locales";
import { usePageViewAnalytics as usePageViewAnalytics3, PRODUCT_AREA as PRODUCT_AREA26 } from "@leagueplatform/analytics";
import {
  ControlledFormField as ControlledFormField4,
  FormProvider,
  useForm
} from "@leagueplatform/web-common";

// src/utils/normalize-number-from-string.util.ts
var minValue = 0;
var maxChars = 5;
var nonDigitChars = new RegExp(/[\D]/, "gi");
var normalizeNumberFromString = ({
  value,
  minValue: min = minValue,
  maxChars: max = maxChars
}) => {
  const formattedValue = value.toString().replace(nonDigitChars, "");
  const trimmedValue = formattedValue.slice(0, max);
  const normalizedValue = Math.max(min, Number(trimmedValue));
  return normalizedValue;
};

// src/components/edit-progress-count-modal.component.tsx
var StyledTextInput = styled9(TextInput5, {
  border: "none",
  borderBottomWidth: "$thick",
  borderBottomStyle: "solid",
  borderBottomColor: "$onSurfaceBorderSubdued",
  borderRadius: "initial",
  transition: "width 0.1s ease-out",
  fontSize: "$headingOne",
  lineHeight: "$headingOne",
  textAlign: "center",
  width: "100%",
  maxWidth: "160px",
  ":focus": {
    borderBottomWidth: "initial"
  },
  "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  }
});
var ariaLabelledById = "edit-count-modal-label";
var EditProgressCountModal = ({
  altText,
  heading,
  subtitle,
  initialValue,
  name,
  onSave,
  inputOptions = {}
}) => {
  const { formatMessage, formatNumber } = useIntl61();
  const formMethods = useForm({ mode: "onChange" });
  const [workingValue, setWorkingValue] = useState17(initialValue);
  usePageViewAnalytics3({
    product_area: PRODUCT_AREA26.JOURNEY,
    screen_name: "health journey activities goal progress"
  });
  const options2 = useMemo32(
    () => __spreadProps(__spreadValues({}, inputOptions), {
      setValueAs(value) {
        const normalizedValue = normalizeNumberFromString({
          value,
          maxChars: 6
        });
        setWorkingValue(normalizedValue);
        return normalizedValue;
      }
    }),
    [inputOptions]
  );
  const width = useActivityContentWidth();
  return /* @__PURE__ */ React132.createElement(
    Modal2.Content,
    {
      "aria-labelledby": ariaLabelledById,
      padding: "0 $oneAndHalf $oneAndHalf",
      width: `min(${width}px, 100%)`
    },
    /* @__PURE__ */ React132.createElement(VisuallyHidden4, null, /* @__PURE__ */ React132.createElement(HeadingText18, { level: "display", size: "xl", id: ariaLabelledById }, altText)),
    /* @__PURE__ */ React132.createElement(
      FormProvider,
      {
        includesFormElement: true,
        formMethods,
        onSubmit: (data) => onSave == null ? void 0 : onSave(data[name])
      },
      /* @__PURE__ */ React132.createElement(
        StackLayout41,
        {
          spacing: "$two",
          horizontalAlignment: "center",
          css: { maxWidth: "100%" }
        },
        /* @__PURE__ */ React132.createElement(
          StackLayout41,
          {
            orientation: "vertical",
            spacing: "$half",
            horizontalAlignment: "start",
            css: { width: "100%" }
          },
          /* @__PURE__ */ React132.createElement(
            HeadingText18,
            {
              level: "2",
              size: "xl",
              css: { textTransform: "capitalize" }
            },
            heading
          ),
          /* @__PURE__ */ React132.createElement(UtilityText22, { size: "eyebrow", emphasis: "emphasized" }, subtitle)
        ),
        /* @__PURE__ */ React132.createElement(Box69, { css: { maxWidth: "100%" } }, /* @__PURE__ */ React132.createElement(
          ControlledFormField4,
          {
            inputOptions: options2,
            id: name,
            name,
            label: altText,
            hideLabel: true,
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "$quarter"
            }
          },
          /* @__PURE__ */ React132.createElement(StyledTextInput, { type: "text", value: formatNumber(workingValue) })
        )),
        /* @__PURE__ */ React132.createElement(Box69, { css: { textAlign: "end", width: "100%" } }, /* @__PURE__ */ React132.createElement(Modal2.Close, null, /* @__PURE__ */ React132.createElement(Button8, { type: "submit" }, formatMessage({ id: "SAVE" }))))
      )
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-progress-tracking.component.tsx
import { useIntl as useIntl62 } from "@leagueplatform/locales";
var progressTrackerChartCss = {
  $$spacing: "0",
  path: { transition: `stroke-dashoffset ${TRANSITIONS.PAGE}` }
};
var useProgressTracking = ({
  componentId,
  currentProgress: initialProgress,
  goal,
  unit,
  validation
}) => {
  const { formatMessage, formatNumber } = useIntl62();
  const { watch } = useFormContext7();
  const { currentProgressLimit, customWarning, editable = true } = validation;
  const inputOptions = useMemo33(
    () => ({
      disabled: !editable,
      max: {
        value: currentProgressLimit,
        message: customWarning || formatMessage(
          { id: "TOOLBOX_VALIDATION_NUMBER_MAXIMUM" },
          { value: formatNumber(currentProgressLimit) }
        )
      }
    }),
    [
      currentProgressLimit,
      customWarning,
      editable,
      formatMessage,
      formatNumber
    ]
  );
  const { field, inputValidationState } = useControlledInput4({
    name: componentId,
    defaultValue: initialProgress,
    rules: inputOptions
  });
  const currentProgress = watch(componentId, initialProgress);
  const progressPercentage = useMemo33(
    () => Math.min(Math.floor(currentProgress / goal * 100), 100),
    [currentProgress, goal]
  );
  const onSave = useCallback18((value) => field.onChange(value), [field]);
  const editCountModalProps = useMemo33(
    () => ({
      altText: formatMessage({ id: "ACTIVITY_COUNT_EDIT" }, { unit }),
      heading: unit,
      initialValue: currentProgress,
      name: componentId,
      onSave,
      inputOptions,
      subtitle: formatMessage({ id: "ACTIVITY_COUNT_GOAL" }, { goal, unit })
    }),
    [
      componentId,
      currentProgress,
      formatMessage,
      goal,
      unit,
      onSave,
      inputOptions
    ]
  );
  return {
    currentProgress,
    progressPercentage,
    editCountModalProps,
    inputValidationState
  };
};
var ActivityToolboxProgressTracking = (props) => {
  const { colors } = useTheme3();
  const { componentId, unit, goal, editButtonLabel, css: css14, validation } = props;
  const { editable = true } = validation;
  const {
    currentProgress,
    progressPercentage,
    editCountModalProps,
    inputValidationState
  } = useProgressTracking(props);
  const { inputStatus, statusMessage } = inputValidationState;
  const celebrationAnimationRef = useRef9(null);
  const editButtonRef = useRef9(null);
  const hasValidationError = inputStatus && statusMessage;
  const isGoalReached = currentProgress >= goal;
  const shouldPlayCelebration = useMemo33(() => {
    const { current: animation } = celebrationAnimationRef;
    if (!isGoalReached && animation) {
      animation.playCount = 0;
    }
    return animation && // The animation has loaded
    isGoalReached && // The goal has been reached
    !(animation == null ? void 0 : animation.playCount) && // The animation has not yet played
    editable && // Input is not disabled
    !hasValidationError;
  }, [editable, hasValidationError, isGoalReached]);
  useToolboxErrorFocus({
    name: componentId,
    focusTarget: editButtonRef.current
  });
  const mapValueToProps = useCallback18(
    (value, component) => {
      Object.assign(component.componentAttributes, {
        currentProgress,
        progressPercentage
      });
      return component;
    },
    [currentProgress, progressPercentage]
  );
  useEffect20(() => {
    const { current: animation } = celebrationAnimationRef;
    if (shouldPlayCelebration && animation) {
      setTimeout(() => {
        animation.goToAndPlay(0);
        animation.playCount += 1;
      }, TRANSITION_DURATION_MS.XLONG);
    }
  }, [shouldPlayCelebration]);
  return /* @__PURE__ */ React133.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React133.createElement(
      StackLayout42,
      {
        horizontalAlignment: "center",
        spacing: "$one",
        css: __spreadValues({ position: "relative" }, css14),
        "data-testid": componentId
      },
      /* @__PURE__ */ React133.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React133.createElement(
        ConfettiAnimation,
        {
          animationRef: celebrationAnimationRef,
          css: {
            maxWidth: "100%",
            maxHeight: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "none",
            svg: {
              width: "900px",
              path: {
                '&[fill="rgb(220,210,246)"]': {
                  fill: colors.decorativeBrandSecondaryDefault.value,
                  stroke: colors.decorativeBrandSecondaryDefault.value
                },
                '&[fill="rgb(185,164,237)"]': {
                  fill: colors.decorativeBrandPrimaryDefault.value,
                  stroke: colors.decorativeBrandPrimaryDefault.value
                },
                '&[fill="rgb(229,207,115)"]': {
                  fill: colors.decorativeBrandSecondaryBrightest.value,
                  stroke: colors.decorativeBrandSecondaryBrightest.value
                }
              },
              opacity: Number(shouldPlayCelebration),
              transition: `opacity 0.2s ease-out ${TRANSITION_DURATION_MS.XLONG}ms`
              // NOTE:  delay the animation to sync it with the setTimeout,
            }
          }
        }
      )),
      /* @__PURE__ */ React133.createElement(
        ProgressTrackerChart,
        {
          unit,
          goal,
          currentProgress,
          progressPercentage,
          css: progressTrackerChartCss
        }
      ),
      /* @__PURE__ */ React133.createElement(Modal3.Root, { defaultOpen: false }, /* @__PURE__ */ React133.createElement(EditProgressCountModal, __spreadValues({}, editCountModalProps)), /* @__PURE__ */ React133.createElement(Modal3.Trigger, null, /* @__PURE__ */ React133.createElement(
        Button9,
        {
          size: "small",
          priority: "primary",
          css: { textTransform: "uppercase" },
          ref: editButtonRef,
          disabled: !editable
        },
        editButtonLabel
      ))),
      hasValidationError && /* @__PURE__ */ React133.createElement(
        InputStatusMessage,
        {
          id: `${componentId}-input-status`,
          inputStatus
        },
        statusMessage
      )
    )
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-biometric.component.tsx
import React134, { useMemo as useMemo34 } from "react";
import { useIntl as useIntl63 } from "@leagueplatform/locales";
import {
  BiometricStatusType
} from "@leagueplatform/health-journey-api";
import {
  StackLayout as StackLayout43,
  HeadingText as HeadingText19,
  ParagraphText as ParagraphText12,
  ImageMessage as ImageMessage3,
  UtilityText as UtilityText23,
  Icon as Icon13,
  Box as Box70
} from "@leagueplatform/genesis-core";
import { ComponentTypes as ComponentTypes6 } from "@leagueplatform/health-journey-common";
var dateFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC"
};
var BiometricStatus = ({
  status,
  statusText
}) => {
  switch (status) {
    case BiometricStatusType.inRange:
      return /* @__PURE__ */ React134.createElement(
        HeadingText19,
        {
          size: "md",
          level: "4",
          css: { paddingTop: "$one", color: "$onSurfaceTextSuccess" }
        },
        statusText
      );
    case BiometricStatusType.outOfRange:
      return /* @__PURE__ */ React134.createElement(
        HeadingText19,
        {
          size: "md",
          level: "4",
          css: { paddingTop: "$one", color: "$onSurfaceTextCritical" }
        },
        statusText
      );
    case BiometricStatusType.inconclusive:
    case BiometricStatusType.noDataAvailable:
      return /* @__PURE__ */ React134.createElement(ParagraphText12, { css: { paddingTop: "$one" } }, statusText);
    default:
      return null;
  }
};
var ActivityToolboxBiometric = ({
  iconUrl = "",
  name,
  value,
  unit,
  collectedOn,
  status,
  statusText,
  ctaUrl = "",
  ctaText,
  css: css14,
  componentId
}) => {
  const { formatMessage, formatDate } = useIntl63();
  const { actions } = useToolboxComponentContext(ComponentTypes6.Biometric);
  const { isLinkOut, linkProps } = useToolboxLink(ctaUrl);
  const linkCta = linkProps && (ctaUrl == null ? void 0 : ctaUrl.trim());
  const collectedOnDate = useMemo34(
    () => collectedOn && formatMessage(
      { id: "DATA_COLLECTED" },
      {
        date: formatDate(
          normalizeDateToMidnight(collectedOn),
          dateFormatOptions
        )
      }
    ),
    [collectedOn, formatDate, formatMessage]
  );
  const handleLinkClick = (event) => {
    var _a, _b;
    if (!linkCta)
      return;
    const actionAttributes = { url: linkCta, title: ctaText };
    if (isLinkOut) {
      (_a = actions == null ? void 0 : actions.onLinkOut) == null ? void 0 : _a.call(actions, event, actionAttributes);
    } else {
      (_b = actions == null ? void 0 : actions.onDeepLink) == null ? void 0 : _b.call(actions, event, actionAttributes);
    }
  };
  return /* @__PURE__ */ React134.createElement(Box70, { css: css14 }, /* @__PURE__ */ React134.createElement(
    StackLayout43,
    __spreadProps(__spreadValues({}, linkProps), {
      as: linkCta ? "a" : void 0,
      onClick: handleLinkClick,
      css: {
        borderRadius: "$large",
        borderStyle: "solid",
        borderColor: "$onSurfaceBorderSubdued",
        borderWidth: "$thin",
        padding: "$one $oneAndHalf",
        textDecoration: "none",
        "&:hover": {
          borderColor: linkCta ? "$interactiveBorderHovered" : "$onSurfaceBorderSubdued"
        }
      },
      "data-testid": componentId,
      horizontalAlignment: "center",
      orientation: "vertical"
    }),
    /* @__PURE__ */ React134.createElement(
      ImageMessage3,
      {
        imageAlt: "",
        imageGap: "$none",
        imageHeight: 36,
        imageWidth: 36,
        css: {
          borderRadius: "$circle"
        },
        image: iconUrl
      },
      /* @__PURE__ */ React134.createElement(HeadingText19, { size: "md", level: "4", as: "h3", css: { paddingTop: "$one" } }, name)
    ),
    statusText && /* @__PURE__ */ React134.createElement(BiometricStatus, { status, statusText }),
    value && /* @__PURE__ */ React134.createElement(ParagraphText12, null, value, " ", unit),
    collectedOnDate && /* @__PURE__ */ React134.createElement(
      UtilityText23,
      {
        emphasis: "subtle",
        size: "xs",
        css: { paddingTop: "$half" }
      },
      collectedOnDate
    ),
    ctaUrl && linkProps && /* @__PURE__ */ React134.createElement(
      StackLayout43,
      {
        horizontalAlignment: "center",
        orientation: "horizontal",
        css: { gap: "$quarter", paddingTop: "$one" }
      },
      /* @__PURE__ */ React134.createElement(
        ParagraphText12,
        {
          as: "p",
          size: "xs",
          css: {
            textTransform: "uppercase",
            fontWeight: "700",
            color: "$interactiveActionSubdued"
          }
        },
        ctaText
      ),
      /* @__PURE__ */ React134.createElement(
        Icon13,
        {
          icon: "tinyExternalLink",
          size: "16px",
          tint: "$onSurfaceIconPrimary"
        }
      )
    )
  ));
};

// src/pages/health-activity/components/page-components/measure-person/activity-toolbox-person-height-input.component.tsx
import React136, { useCallback as useCallback20, useEffect as useEffect21, useMemo as useMemo36, useState as useState18 } from "react";
import { useIntl as useIntl65 } from "@leagueplatform/locales";
import {
  Box as Box71,
  Fieldset as Fieldset3,
  FormField as FormField2,
  StackLayout as StackLayout44,
  TextInput as TextInput6
} from "@leagueplatform/genesis-core";
import {
  HeightUnits as HeightUnits2
} from "@leagueplatform/health-journey-api";
import {
  useControlledInput as useControlledInput5
} from "@leagueplatform/web-common";

// src/pages/health-activity/hooks/use-toolbox-person-height-inputs.hook.ts
import { useCallback as useCallback19, useMemo as useMemo35, useRef as useRef10 } from "react";
import { useIntl as useIntl64 } from "@leagueplatform/locales";
import { useFormContext as useFormContext8 } from "@leagueplatform/web-common";
import {
  HeightUnits
} from "@leagueplatform/health-journey-api";

// src/pages/health-activity/utils/unit-converters.util.ts
var DECIMAL_PRECISION = 2;
var INCH_CM_RATIO = 0.393700787;
var POUNDS_KG_RATIO = 0.45359237;
var round = (value, places) => Number(value.toFixed(places));
var fromInchesToCentimeters = (inches, precision = DECIMAL_PRECISION) => round(inches / INCH_CM_RATIO, precision);
var fromCentimetersToInches = (centimeters, precision = DECIMAL_PRECISION) => round(centimeters * INCH_CM_RATIO, precision);
var fromInchesToFeetAndInches = (initialInches) => {
  const feet = Math.floor(initialInches / 12);
  const inches = Math.round(initialInches % 12);
  const extraFoot = inches === 12;
  if (extraFoot) {
    return { feet: feet + 1, inches: 0 };
  }
  return { feet, inches };
};
var fromCentimetersToFeetAndInches = (centimeters) => {
  const inches = fromCentimetersToInches(centimeters);
  return fromInchesToFeetAndInches(inches);
};
var fromPoundsToKilograms = (pounds, precision = DECIMAL_PRECISION) => round(pounds * POUNDS_KG_RATIO, precision);
var fromKilogramsToPounds = (kilograms, precision = DECIMAL_PRECISION) => round(kilograms / POUNDS_KG_RATIO, precision);

// src/pages/health-activity/hooks/use-toolbox-person-height-inputs.hook.ts
var useToolboxPersonHeightInputs = ({
  componentId,
  outputUnit,
  selectedUnit,
  validation
}) => {
  const { $tmap } = useIntl64();
  const formatMappedMessage = $tmap({
    min: "TOOLBOX_VALIDATION_HEIGHT_MINIMUM",
    max: "TOOLBOX_VALIDATION_HEIGHT_MAXIMUM"
  });
  const { setValue } = useFormContext8();
  const feetInputRef = useRef10(null);
  const inchesInputRef = useRef10(null);
  const centimetersInputRef = useRef10(null);
  const fieldRef = useRef10(null);
  const getValueAsOutputUnit = useMemo35(
    () => ({
      totalInches: () => {
        var _a, _b, _c, _d;
        if (!((_a = feetInputRef.current) == null ? void 0 : _a.value) && !((_b = inchesInputRef.current) == null ? void 0 : _b.value))
          return "";
        const nextValue = Number((_c = feetInputRef.current) == null ? void 0 : _c.value) * 12 + Number((_d = inchesInputRef.current) == null ? void 0 : _d.value);
        return outputUnit === HeightUnits.centimeter ? fromInchesToCentimeters(nextValue) : nextValue;
      },
      totalCentimeters: () => {
        var _a, _b;
        if (!((_a = centimetersInputRef.current) == null ? void 0 : _a.value))
          return "";
        const nextValue = Number((_b = centimetersInputRef.current) == null ? void 0 : _b.value);
        return outputUnit === HeightUnits.inches ? fromCentimetersToInches(nextValue) : nextValue;
      }
    }),
    [outputUnit]
  );
  const getUnitValues = useCallback19(
    (currentValue) => {
      if (typeof currentValue !== "number")
        return { feet: "", inches: "", centimeters: "" };
      if (outputUnit === HeightUnits.inches) {
        const { feet: feet2, inches: inches2 } = fromInchesToFeetAndInches(currentValue);
        const centimeters = fromInchesToCentimeters(currentValue);
        return { feet: feet2, inches: inches2, centimeters };
      }
      const { feet, inches } = fromCentimetersToFeetAndInches(currentValue);
      return { feet, inches, centimeters: currentValue };
    },
    [outputUnit]
  );
  const syncUnitInputs = useCallback19(
    (currentValue) => {
      const { feet, centimeters, inches } = getUnitValues(currentValue);
      if (selectedUnit === HeightUnits.centimeter && centimetersInputRef.current) {
        centimetersInputRef.current.value = centimeters.toString();
      }
      if (selectedUnit === HeightUnits.inches && inchesInputRef.current && feetInputRef.current) {
        feetInputRef.current.value = feet.toString();
        inchesInputRef.current.value = inches.toString();
      }
    },
    [getUnitValues, selectedUnit]
  );
  const { customWarning, maximumValue, minimumValue } = validation;
  const getMinMaxValidationMessage = useCallback19(
    (messageKey, validationValue) => {
      if (customWarning)
        return customWarning;
      const { feet, inches, centimeters } = getUnitValues(validationValue);
      return formatMappedMessage(messageKey, {
        imperial: `${feet}\u2019 ${inches}\u201D`,
        metric: centimeters
      });
    },
    [customWarning, formatMappedMessage, getUnitValues]
  );
  const validateMaxValue = useCallback19(
    (currentValue) => maximumValue && currentValue > maximumValue ? getMinMaxValidationMessage("max", maximumValue) : void 0,
    [maximumValue, getMinMaxValidationMessage]
  );
  const validateMinValue = useCallback19(
    (currentValue) => minimumValue && minimumValue > currentValue ? getMinMaxValidationMessage("min", minimumValue) : void 0,
    [getMinMaxValidationMessage, minimumValue]
  );
  const setValueAndValidate = useCallback19(
    (newValue) => setValue(componentId, newValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    }),
    [componentId, setValue]
  );
  const onInputChange = useCallback19(() => {
    const nextValue = selectedUnit === HeightUnits.inches ? getValueAsOutputUnit.totalInches() : getValueAsOutputUnit.totalCentimeters();
    setValueAndValidate(nextValue);
  }, [getValueAsOutputUnit, selectedUnit, setValueAndValidate]);
  const refs = { feetInputRef, inchesInputRef, centimetersInputRef, fieldRef };
  const validateMethods = { validateMinValue, validateMaxValue };
  const valueHandlers = { onInputChange, getUnitValues, syncUnitInputs };
  return { valueHandlers, validateMethods, refs };
};

// src/pages/health-activity/components/segmented-controls.component.tsx
import React135 from "react";
import {
  PillTabs as PillTabs2,
  PillTabList as PillTabList2,
  PillTab as PillTab2
} from "@leagueplatform/web-common-components";
import { Card as Card7, Tabs as Tabs4 } from "@leagueplatform/genesis-core";
var SegmentedControls = ({
  controlTabLabels,
  controlTabContents,
  controlTabOnChange,
  defaultIndex = 0
}) => /* @__PURE__ */ React135.createElement(
  Card7.Flat,
  {
    css: {
      borderColor: "$onSurfaceBorderSubdued",
      borderRadius: "$medium",
      borderWidth: "$thin",
      borderStyle: "solid",
      boxShadow: "$card"
    }
  },
  /* @__PURE__ */ React135.createElement(Card7.Section, { padding: "$oneAndHalf $one" }, /* @__PURE__ */ React135.createElement(
    PillTabs2,
    {
      defaultValue: `${defaultIndex}`,
      onValueChange: controlTabOnChange
    },
    /* @__PURE__ */ React135.createElement(
      PillTabList2,
      {
        css: {
          borderWidth: "none",
          boxShadow: "none",
          width: "fit-content",
          margin: "auto",
          marginBottom: "$one",
          "& .GDS-tab-list": {
            borderRadius: "$extraLarge",
            backgroundColor: "$interactiveBackgroundDisabled",
            padding: "6px"
          }
        }
      },
      controlTabLabels == null ? void 0 : controlTabLabels.map(({ label, ariaLabel }, index) => /* @__PURE__ */ React135.createElement(
        PillTab2,
        {
          key: label,
          value: `${index}`,
          "aria-label": ariaLabel,
          css: {
            borderRadius: "$large",
            marginInlineEnd: "$none",
            minWidth: "75px",
            minHeight: "35px"
          }
        },
        label
      ))
    ),
    controlTabContents == null ? void 0 : controlTabContents.map(({ content, contentKey }, index) => /* @__PURE__ */ React135.createElement(Tabs4.TabPanel, { key: contentKey, value: `${index}` }, content))
  ))
);

// src/pages/health-activity/components/page-components/measure-person/activity-toolbox-person-height-input.component.tsx
var ActivityToolboxPersonHeightInput = (props) => {
  const { formatMessage } = useIntl65();
  const {
    altText,
    componentId,
    css: css14,
    validation,
    answer,
    unit: outputUnit
  } = props;
  const { customWarning, required, editable = true } = validation;
  const feetString = formatMessage({ id: "FT" });
  const centimeterString = formatMessage({ id: "CM" });
  const inchesString = formatMessage({ id: "IN" });
  const heightString = formatMessage({ id: "HEIGHT" });
  const measurementTypes = useMemo36(
    () => [
      {
        unit: HeightUnits2.inches,
        label: feetString,
        ariaLabel: `${heightString} ${feetString}`
      },
      {
        unit: HeightUnits2.centimeter,
        label: centimeterString,
        ariaLabel: `${heightString} ${centimeterString}`
      }
    ],
    [feetString, centimeterString, heightString]
  );
  const initialControlIndex = useMemo36(
    () => measurementTypes.findIndex(({ unit }) => unit === outputUnit),
    [outputUnit, measurementTypes]
  );
  const [selectedMeasurement, setSelectedMeasurement] = useState18(
    measurementTypes[initialControlIndex]
  );
  const { unit: selectedUnit } = selectedMeasurement;
  const { valueHandlers, validateMethods, refs } = useToolboxPersonHeightInputs(
    { componentId, outputUnit, selectedUnit, validation }
  );
  const { onInputChange, syncUnitInputs, getUnitValues } = valueHandlers;
  const { feetInputRef, inchesInputRef, centimetersInputRef, fieldRef } = refs;
  const defaultDisplayValues = useMemo36(
    () => getUnitValues(answer),
    [answer, getUnitValues]
  );
  const inputOptions = {
    name: componentId,
    defaultValue: answer,
    rules: {
      // @ts-expect-error
      disabled: !editable,
      // Disables validation without disabling the inputs themselves
      required: {
        value: required,
        message: customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_REQUIRED_FIELD" })
      },
      validate: validateMethods
    }
  };
  const { field, fieldState, inputValidationState } = useControlledInput5(inputOptions);
  const { inputStatus, statusMessage } = inputValidationState;
  const findFocusableInput = useCallback20(() => {
    var _a;
    if (selectedUnit === HeightUnits2.inches) {
      return ((_a = inchesInputRef.current) == null ? void 0 : _a.value) === "" ? inchesInputRef.current : feetInputRef.current;
    }
    return centimetersInputRef.current;
  }, [centimetersInputRef, feetInputRef, inchesInputRef, selectedUnit]);
  useToolboxErrorFocus({
    name: componentId,
    focusTarget: findFocusableInput(),
    onValidationError: () => {
      var _a;
      return !((_a = fieldRef.current) == null ? void 0 : _a.contains(document.activeElement));
    }
  });
  useEffect21(() => {
    if (selectedUnit && fieldState.invalid) {
      field.onChange(field.value);
    }
  }, [selectedUnit]);
  const mapValueToProps = (value, component) => {
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: value != null ? value : answer
      })
    });
    return component;
  };
  const onTabChange = (newTabIndex) => {
    const nextMeasurement = measurementTypes[newTabIndex];
    setSelectedMeasurement(nextMeasurement);
  };
  useEffect21(() => {
    syncUnitInputs(field.value);
  }, [syncUnitInputs]);
  return /* @__PURE__ */ React136.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React136.createElement(Box71, { css: css14, ref: fieldRef, "data-testid": componentId }, /* @__PURE__ */ React136.createElement(
      SegmentedControls,
      {
        defaultIndex: initialControlIndex,
        controlTabOnChange: (value) => onTabChange(
          measurementTypes.findIndex((_, index) => `${index}` === value)
        ),
        controlTabLabels: measurementTypes,
        controlTabContents: [
          {
            contentKey: `${componentId}-ft`,
            content: /* @__PURE__ */ React136.createElement(
              Fieldset3,
              {
                id: componentId,
                legend: altText,
                hideLegend: true,
                inputStatus,
                statusMessage
              },
              /* @__PURE__ */ React136.createElement(
                StackLayout44,
                {
                  orientation: "horizontal",
                  spacing: "$one",
                  css: {
                    ".GDS-text-input-group": { flex: "1 1 0" },
                    ".GDS-base-input": { width: 0 }
                  }
                },
                /* @__PURE__ */ React136.createElement(
                  TextInput6,
                  {
                    "aria-label": formatMessage({
                      id: "ENTER_YOUR_HEIGHT_IN_FEET"
                    }),
                    type: "number",
                    ref: feetInputRef,
                    addOnEnd: feetString,
                    min: "0",
                    defaultValue: defaultDisplayValues.feet,
                    disabled: !editable,
                    "data-testid": `${componentId}-ft`,
                    onChange: onInputChange,
                    inputStatus
                  }
                ),
                /* @__PURE__ */ React136.createElement(
                  TextInput6,
                  {
                    "aria-label": formatMessage({
                      id: "ENTER_YOUR_HEIGHT_IN_INCHES"
                    }),
                    type: "number",
                    ref: inchesInputRef,
                    addOnEnd: inchesString,
                    min: "0",
                    max: "11",
                    defaultValue: defaultDisplayValues.inches,
                    disabled: !editable,
                    "data-testid": `${componentId}-in`,
                    onChange: onInputChange,
                    inputStatus
                  }
                )
              )
            )
          },
          {
            contentKey: `${componentId}-cm`,
            content: /* @__PURE__ */ React136.createElement(
              FormField2,
              {
                id: componentId,
                label: altText,
                hideLabel: true,
                inputStatus,
                statusMessage
              },
              /* @__PURE__ */ React136.createElement(
                StackLayout44,
                {
                  orientation: "horizontal",
                  spacing: "$one",
                  css: {
                    ".GDS-text-input-group": { flex: "1 1 0" },
                    ".GDS-base-input": { width: 0 }
                  }
                },
                /* @__PURE__ */ React136.createElement(
                  TextInput6,
                  {
                    "aria-label": formatMessage({
                      id: "ENTER_YOUR_HEIGHT_IN_CENTIMETERS"
                    }),
                    type: "number",
                    step: 0.01,
                    addOnEnd: centimeterString,
                    ref: centimetersInputRef,
                    min: "0",
                    defaultValue: defaultDisplayValues.centimeters,
                    disabled: !editable,
                    "data-testid": `${componentId}-cm`,
                    onChange: onInputChange,
                    inputStatus
                  }
                )
              )
            )
          }
        ]
      }
    ))
  );
};

// src/pages/health-activity/components/page-components/measure-person/activity-toolbox-person-weight-input.component.tsx
import React137, { useState as useState19, useEffect as useEffect22, useMemo as useMemo38, useCallback as useCallback22 } from "react";
import { useIntl as useIntl67 } from "@leagueplatform/locales";
import {
  Box as Box72,
  FormField as FormField3,
  StackLayout as StackLayout45,
  TextInput as TextInput7
} from "@leagueplatform/genesis-core";
import {
  WeightUnits as WeightUnits2
} from "@leagueplatform/health-journey-api";
import {
  useControlledInput as useControlledInput6
} from "@leagueplatform/web-common";

// src/pages/health-activity/hooks/use-toolbox-person-weight-inputs.hook.ts
import { useCallback as useCallback21, useMemo as useMemo37, useRef as useRef11 } from "react";
import { useIntl as useIntl66 } from "@leagueplatform/locales";
import { useFormContext as useFormContext9 } from "@leagueplatform/web-common";
import {
  WeightUnits
} from "@leagueplatform/health-journey-api";
var useToolboxPersonWeightInputs = ({
  componentId,
  outputUnit,
  selectedUnit,
  validation
}) => {
  const { $tmap } = useIntl66();
  const formatMappedMessage = $tmap({
    min: "TOOLBOX_VALIDATION_WEIGHT_MINIMUM",
    max: "TOOLBOX_VALIDATION_WEIGHT_MAXIMUM"
  });
  const { setValue } = useFormContext9();
  const poundsInputRef = useRef11(null);
  const kilogramsInputRef = useRef11(null);
  const fieldRef = useRef11(null);
  const getValueAsOutputUnit = useMemo37(
    () => ({
      totalPounds: () => {
        var _a, _b;
        if (!((_a = poundsInputRef.current) == null ? void 0 : _a.value))
          return "";
        const nextValue = Number((_b = poundsInputRef.current) == null ? void 0 : _b.value);
        return outputUnit === WeightUnits.kilogram ? fromPoundsToKilograms(nextValue) : nextValue;
      },
      totalKilograms: () => {
        var _a, _b;
        if (!((_a = kilogramsInputRef.current) == null ? void 0 : _a.value))
          return "";
        const nextValue = Number((_b = kilogramsInputRef.current) == null ? void 0 : _b.value);
        return outputUnit === WeightUnits.pounds ? fromKilogramsToPounds(nextValue) : nextValue;
      }
    }),
    [outputUnit]
  );
  const getUnitValues = useCallback21(
    (currentValue) => {
      if (typeof currentValue !== "number")
        return { lbs: "", kg: "" };
      return outputUnit === WeightUnits.pounds ? {
        lbs: round(currentValue, 2),
        kg: fromPoundsToKilograms(currentValue)
      } : {
        lbs: fromKilogramsToPounds(currentValue),
        kg: round(currentValue, 2)
      };
    },
    [outputUnit]
  );
  const syncUnitInputs = useCallback21(
    (currentValue) => {
      const { lbs, kg } = getUnitValues(currentValue);
      if (selectedUnit === WeightUnits.kilogram && kilogramsInputRef.current) {
        kilogramsInputRef.current.value = kg.toString();
      }
      if (selectedUnit === WeightUnits.pounds && poundsInputRef.current) {
        poundsInputRef.current.value = lbs.toString();
      }
    },
    [getUnitValues, selectedUnit]
  );
  const { maximumValue, minimumValue, customWarning } = validation;
  const getMinMaxValidationMessage = useCallback21(
    (messageKey, validationValue) => {
      if (customWarning)
        return customWarning;
      const { lbs, kg } = getUnitValues(validationValue);
      return formatMappedMessage(messageKey, { imperial: lbs, metric: kg });
    },
    [customWarning, formatMappedMessage, getUnitValues]
  );
  const validateMaxValue = useCallback21(
    (currentValue) => maximumValue && currentValue > maximumValue ? getMinMaxValidationMessage("max", maximumValue) : void 0,
    [maximumValue, getMinMaxValidationMessage]
  );
  const validateMinValue = useCallback21(
    (currentValue) => minimumValue && minimumValue > currentValue ? getMinMaxValidationMessage("min", minimumValue) : void 0,
    [getMinMaxValidationMessage, minimumValue]
  );
  const setValueAndValidate = useCallback21(
    (newValue) => setValue(componentId, newValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    }),
    [componentId, setValue]
  );
  const onInputChange = useCallback21(() => {
    const nextValue = selectedUnit === WeightUnits.pounds ? getValueAsOutputUnit.totalPounds() : getValueAsOutputUnit.totalKilograms();
    setValueAndValidate(nextValue);
  }, [getValueAsOutputUnit, selectedUnit, setValueAndValidate]);
  const refs = { poundsInputRef, kilogramsInputRef, fieldRef };
  const validateMethods = { validateMinValue, validateMaxValue };
  const valueHandlers = { onInputChange, getUnitValues, syncUnitInputs };
  return { valueHandlers, validateMethods, refs };
};

// src/pages/health-activity/components/page-components/measure-person/activity-toolbox-person-weight-input.component.tsx
var ActivityToolboxPersonWeightInput = (props) => {
  const { formatMessage } = useIntl67();
  const {
    altText,
    componentId,
    css: css14,
    validation,
    answer,
    unit: outputUnit
  } = props;
  const { customWarning, required, editable = true } = validation;
  const poundsString = formatMessage({ id: "LB" });
  const kilogramsString = formatMessage({ id: "KG" });
  const weightString = formatMessage({ id: "WEIGHT" });
  const measurementTypes = useMemo38(
    () => [
      {
        unit: WeightUnits2.pounds,
        label: poundsString,
        ariaLabel: `${weightString} ${poundsString}`
      },
      {
        unit: WeightUnits2.kilogram,
        label: kilogramsString,
        ariaLabel: `${weightString} ${kilogramsString}`
      }
    ],
    [poundsString, kilogramsString, weightString]
  );
  const initialControlIndex = useMemo38(
    () => measurementTypes.findIndex(({ unit }) => unit === outputUnit),
    [outputUnit, measurementTypes]
  );
  const [selectedMeasurement, setSelectedMeasurement] = useState19(
    measurementTypes[initialControlIndex]
  );
  const { unit: selectedUnit } = selectedMeasurement;
  const { valueHandlers, validateMethods, refs } = useToolboxPersonWeightInputs(
    { componentId, outputUnit, selectedUnit, validation }
  );
  const { onInputChange, syncUnitInputs, getUnitValues } = valueHandlers;
  const { poundsInputRef, kilogramsInputRef, fieldRef } = refs;
  const defaultDisplayValues = useMemo38(
    () => getUnitValues(answer),
    [answer, getUnitValues]
  );
  const inputOptions = {
    name: componentId,
    defaultValue: answer,
    rules: {
      // @ts-expect-error
      disabled: !editable,
      // Disables validation without disabling the inputs themselves
      required: {
        value: required,
        message: customWarning || formatMessage({ id: "TOOLBOX_VALIDATION_REQUIRED_FIELD" })
      },
      validate: validateMethods
    }
  };
  const { field, fieldState, inputValidationState } = useControlledInput6(inputOptions);
  const { inputStatus, statusMessage } = inputValidationState;
  const findFocusableInput = useCallback22(
    () => selectedUnit === WeightUnits2.pounds ? poundsInputRef.current : kilogramsInputRef.current,
    [kilogramsInputRef, poundsInputRef, selectedUnit]
  );
  useToolboxErrorFocus({
    name: componentId,
    focusTarget: findFocusableInput(),
    onValidationError: () => {
      var _a;
      return !((_a = fieldRef.current) == null ? void 0 : _a.contains(document.activeElement));
    }
  });
  useEffect22(() => {
    if (selectedUnit && fieldState.invalid) {
      field.onChange(field.value);
    }
  }, [selectedUnit]);
  const mapValueToProps = (value, component) => {
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: value != null ? value : answer
      })
    });
    return component;
  };
  const onTabChange = (newTabIndex) => {
    const nextMeasurement = measurementTypes[newTabIndex];
    setSelectedMeasurement(nextMeasurement);
  };
  useEffect22(() => {
    syncUnitInputs(field.value);
  }, [syncUnitInputs]);
  return /* @__PURE__ */ React137.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React137.createElement(Box72, { css: css14, ref: fieldRef, "data-testid": componentId }, /* @__PURE__ */ React137.createElement(
      SegmentedControls,
      {
        controlTabOnChange: (value) => onTabChange(
          measurementTypes.findIndex((_, index) => `${index}` === value)
        ),
        controlTabLabels: measurementTypes,
        defaultIndex: initialControlIndex,
        controlTabContents: [
          {
            contentKey: `${componentId}-lb`,
            content: /* @__PURE__ */ React137.createElement(
              FormField3,
              {
                id: componentId,
                label: altText,
                hideLabel: true,
                inputStatus,
                statusMessage
              },
              /* @__PURE__ */ React137.createElement(
                StackLayout45,
                {
                  orientation: "horizontal",
                  spacing: "$one",
                  css: {
                    ".GDS-text-input-group": { flex: "1 1 0" },
                    ".GDS-base-input": { width: 0 }
                  }
                },
                /* @__PURE__ */ React137.createElement(
                  TextInput7,
                  {
                    "aria-label": formatMessage({
                      id: "ENTER_YOUR_WEIGHT_IN_POUNDS"
                    }),
                    type: "number",
                    step: 0.01,
                    ref: poundsInputRef,
                    addOnEnd: poundsString,
                    min: "0",
                    disabled: !editable,
                    defaultValue: defaultDisplayValues.lbs,
                    "data-testid": `${componentId}-lb`,
                    onChange: onInputChange,
                    inputStatus
                  }
                )
              )
            )
          },
          {
            contentKey: `${componentId}-kg`,
            content: /* @__PURE__ */ React137.createElement(
              FormField3,
              {
                id: componentId,
                label: altText,
                hideLabel: true,
                inputStatus,
                statusMessage
              },
              /* @__PURE__ */ React137.createElement(
                StackLayout45,
                {
                  orientation: "horizontal",
                  spacing: "$one",
                  css: {
                    ".GDS-text-input-group": { flex: "1 1 0" },
                    ".GDS-base-input": { width: 0 }
                  }
                },
                /* @__PURE__ */ React137.createElement(
                  TextInput7,
                  {
                    "aria-label": formatMessage({
                      id: "ENTER_YOUR_WEIGHT_IN_KILOGRAMS"
                    }),
                    type: "number",
                    step: 0.01,
                    addOnEnd: kilogramsString,
                    ref: kilogramsInputRef,
                    min: "0",
                    disabled: !editable,
                    defaultValue: defaultDisplayValues.kg,
                    "data-testid": `${componentId}-kg`,
                    onChange: onInputChange,
                    inputStatus
                  }
                )
              )
            )
          }
        ]
      }
    ))
  );
};

// src/pages/health-activity/components/page-components/activity-toolbox-challenge-progress.component.tsx
import React138 from "react";
import {
  Card as Card8,
  HeadingText as HeadingText20,
  StackLayout as StackLayout46,
  styled as styled10,
  useClickableCard as useClickableCard3,
  Box as Box73
} from "@leagueplatform/genesis-core";
var TitleLink = styled10("a", {
  textDecoration: "none"
});
var ActivityToolboxChallengeProgress = ({
  componentId,
  css: css14,
  title,
  unit,
  goal,
  currentProgress,
  progressPercentage,
  deeplink
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard3();
  return /* @__PURE__ */ React138.createElement(Box73, { css: css14, "data-testid": componentId }, /* @__PURE__ */ React138.createElement(Card8.Elevated, null, /* @__PURE__ */ React138.createElement(
    Card8.ClickArea,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown
    },
    /* @__PURE__ */ React138.createElement(Card8.Section, { padding: "$one $oneAndHalf" }, /* @__PURE__ */ React138.createElement(StackLayout46, { orientation: "vertical", spacing: "$half" }, /* @__PURE__ */ React138.createElement(TitleLink, { href: deeplink, ref: primaryActionRef }, /* @__PURE__ */ React138.createElement(HeadingText20, { size: "sm", level: "3" }, title)), /* @__PURE__ */ React138.createElement(
      ProgramProgress,
      {
        currentProgress: progressPercentage,
        currentText: currentProgress.toLocaleString(),
        suffixText: `/ ${goal.toLocaleString()} ${unit}`
      }
    )))
  )));
};

// src/pages/health-activity/components/page-components/activity-toolbox-date-time-input.component.tsx
import { StackLayout as StackLayout47, TextInput as TextInput8, styled as styled11 } from "@leagueplatform/genesis-core";
import React139 from "react";

// src/pages/health-activity/hooks/use-toolbox-date-time-input.hook.ts
import { useCallback as useCallback23 } from "react";
import { useFormContext as useFormContext10 } from "@leagueplatform/web-common";
var useToolboxDateTimeInput = ({
  componentId
}) => {
  const { setValue } = useFormContext10();
  const setValueAndValidate = useCallback23(
    (newValue) => {
      setValue(componentId, String(newValue), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
    },
    [componentId, setValue]
  );
  const handleDateTimeChange = useCallback23(
    (value) => {
      setValueAndValidate(value.toString());
    },
    [setValueAndValidate]
  );
  return {
    handleDateTimeChange
  };
};

// src/pages/health-activity/components/page-components/activity-toolbox-date-time-input.component.tsx
import {
  DateTimeInputDisplay
} from "@leagueplatform/health-journey-api";
import {
  DateField,
  DateInput,
  DateSegment,
  TimeField
} from "react-aria-components";
import { parseDate, parseTime, parseDateTime } from "@internationalized/date";
import { ControlledFormField as ControlledFormField5 } from "@leagueplatform/web-common";
var StyledDateTimeInput = styled11(StackLayout47, {
  ".react-aria-DateInput": {
    display: "flex"
  },
  ".react-aria-DateSegment:nth-child(6)": {
    marginInlineEnd: "$half"
  }
});
var ActivityToolboxDateTimeInput = (props) => {
  const {
    componentId,
    answer,
    display = DateTimeInputDisplay.full,
    css: css14,
    altText
  } = props;
  const { handleDateTimeChange } = useToolboxDateTimeInput({
    componentId
  });
  const displayFull = display === DateTimeInputDisplay.full;
  const displayTimeOnly = display === DateTimeInputDisplay.timeOnly;
  const displayDateOnly = display === DateTimeInputDisplay.dateOnly;
  const mapValueToProps = (value2, component) => {
    Object.assign(component, {
      componentAttributes: __spreadProps(__spreadValues({}, component.componentAttributes), {
        answer: value2 == null ? void 0 : value2.toString()
      })
    });
    return component;
  };
  const value = (answer == null ? void 0 : answer.toString()) || "";
  const dateDefaultValue = displayDateOnly && value ? parseDate(value) : null;
  const dateTimeDefaultValue = displayFull && value ? parseDateTime(value) : null;
  return /* @__PURE__ */ React139.createElement(
    ActivityToolboxInputWrapper,
    {
      inputName: componentId,
      mapValueToProps
    },
    /* @__PURE__ */ React139.createElement(
      ControlledFormField5,
      {
        css: css14,
        hideLabel: true,
        id: componentId,
        label: altText,
        name: componentId,
        inputOptions: {},
        "aria-label": altText
      },
      /* @__PURE__ */ React139.createElement(
        TextInput8,
        {
          leadingContent: /* @__PURE__ */ React139.createElement(StyledDateTimeInput, { orientation: "horizontal" }, (displayFull || displayDateOnly) && /* @__PURE__ */ React139.createElement(
            DateField,
            {
              defaultValue: displayFull ? dateTimeDefaultValue : dateDefaultValue,
              granularity: displayDateOnly ? "day" : "minute",
              onChange: handleDateTimeChange
            },
            /* @__PURE__ */ React139.createElement(DateInput, null, (segment) => /* @__PURE__ */ React139.createElement(DateSegment, { segment }))
          ), displayTimeOnly && /* @__PURE__ */ React139.createElement(
            TimeField,
            {
              defaultValue: value ? parseTime(value) : null,
              granularity: "minute",
              onChange: handleDateTimeChange
            },
            /* @__PURE__ */ React139.createElement(DateInput, null, (segment) => /* @__PURE__ */ React139.createElement(DateSegment, { segment }))
          )),
          css: {
            ".GDS-base-input:read-only": {
              backgroundColor: "$surfaceBackgroundPrimary",
              display: "none"
            }
          },
          readOnly: true
        }
      )
    )
  );
};

// src/pages/health-activity/components/styles/activity-toolbox-component-layout.styles.ts
import { ComponentTypes as ComponentTypes7 } from "@leagueplatform/health-journey-common";
var {
  FullPageHighlight,
  Header,
  IntegerInput,
  StringInput,
  MultipleSelectInput,
  DateInput: DateInput2,
  DecimalInput,
  ProgressTracking,
  Badge: Badge10,
  Video: Video2
} = ComponentTypes7;
var safeFirstChildSelector = "&:first-of-type:not(:first-of-type ~ *)";
var wrappedComponentLayout = {
  paddingInlineStart: "$two",
  paddingInlineEnd: "$two",
  [safeFirstChildSelector]: {
    paddingTop: "$two"
  },
  "&:last-child": {
    paddingBottom: "$two"
  }
};
var wrappedInputComponentStyles = __spreadProps(__spreadValues({}, wrappedComponentLayout), {
  marginTop: "$two",
  // Remove margin top for the next input if it's the same type of element.
  "& + &": { marginTop: "0" }
});
var wrappedBadgeComponentStyles = __spreadProps(__spreadValues({}, wrappedComponentLayout), {
  [safeFirstChildSelector]: {
    paddingTop: "$two"
  }
});
var fullBleedComponentLayout = {
  padding: "initial"
};
var deriveComponentLayoutStyles = (componentType) => {
  switch (componentType) {
    case FullPageHighlight:
    case Header:
    case Video2:
      return fullBleedComponentLayout;
    case IntegerInput:
    case StringInput:
    case MultipleSelectInput:
    case DateInput2:
    case DecimalInput:
    case ProgressTracking:
      return wrappedInputComponentStyles;
    case Badge10:
      return wrappedBadgeComponentStyles;
    default:
      return wrappedComponentLayout;
  }
};

// src/pages/health-activity/contexts/toolbox-input-provider.component.tsx
import React140, {
  useCallback as useCallback24,
  useEffect as useEffect23,
  useMemo as useMemo39,
  useContext as useContext4,
  useState as useState20
} from "react";
import {
  useForm as useForm2,
  FormProvider as FormProvider2
} from "@leagueplatform/web-common";

// src/pages/health-activity/utils/toolbox-component-payload-transformer.utils.ts
import { ComponentTypes as ComponentTypes8 } from "@leagueplatform/health-journey-common";
var {
  DateInput: DateInput3,
  DecimalInput: DecimalInput2,
  IntegerInput: IntegerInput2,
  MultipleSelectInput: MultipleSelectInput2,
  StringInput: StringInput2,
  ProgressTracking: ProgressTracking2,
  PersonHeight,
  PersonWeight
} = ComponentTypes8;
var toolboxComponentPayloadTransformer = (component) => {
  var _a;
  const componentCopy = JSON.parse(
    JSON.stringify(component)
  );
  const {
    answerOptions,
    answer,
    unit,
    currentProgress,
    additionalDateOptions = [],
    validation
  } = (_a = componentCopy.componentAttributes) != null ? _a : {};
  const { required } = validation != null ? validation : {};
  switch (componentCopy.componentType) {
    case MultipleSelectInput2:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: {
          answerOptions: answerOptions.filter(({ isSelected }) => Boolean(isSelected)).map(
            ({
              id,
              isSelected,
              value,
              text,
              enableFreeText,
              inputType = "",
              freeTextValidation
            }) => ({
              id,
              isSelected,
              value,
              text,
              enableFreeText,
              inputType: (freeTextValidation == null ? void 0 : freeTextValidation.inputType) || inputType
            })
          ),
          required
        }
      });
    case DateInput3:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: {
          answer,
          required,
          additionalDateOptions: additionalDateOptions.filter(({ isSelected }) => Boolean(isSelected)).map(
            ({
              id,
              isSelected,
              value,
              unit: dateOptionUnit,
              text,
              code = ""
            }) => ({
              id,
              isSelected,
              value,
              text,
              unit: dateOptionUnit,
              code
            })
          )
        }
      });
    case DecimalInput2:
    case IntegerInput2:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: { answer, required, unit }
      });
    case StringInput2:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: { answer, required }
      });
    case ProgressTracking2:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: { unit, currentProgress }
      });
    case PersonHeight:
    case PersonWeight:
      return __spreadProps(__spreadValues({}, componentCopy), {
        componentAttributes: { unit, answer }
      });
    default:
      return componentCopy;
  }
};

// src/pages/health-activity/contexts/toolbox-input-provider.component.tsx
var defaultFormConfig = {
  mode: "onChange",
  shouldFocusError: true
};
var formStyles = {
  height: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "$one"
};
var ToolboxInputProvider = ({
  children,
  onFormRegister,
  formConfig = defaultFormConfig
}) => {
  const { toolboxComponentMap } = useContext4(ToolboxComponentContext);
  const _a = useForm2(formConfig), { register, control } = _a, formMethods = __objRest(_a, ["register", "control"]);
  const {
    getValues,
    formState: { dirtyFields }
  } = formMethods;
  const inputMap = useMemo39(() => ({}), []);
  const [includesFormElement, setIncludesFormElement] = useState20();
  const registerWrapper = useCallback24(
    (name, options2 = {}) => {
      inputMap[name] = toolboxComponentMap[name];
      return register(name, options2);
    },
    [inputMap, toolboxComponentMap, register]
  );
  useEffect23(() => {
    const hasInputs = Boolean(Object.keys(inputMap).length);
    setIncludesFormElement(hasInputs);
  }, [inputMap]);
  const getDirtyFieldValues = useCallback24(
    () => Object.keys(dirtyFields).reduce(
      (fields, fieldName) => __spreadProps(__spreadValues({}, fields), {
        [fieldName]: getValues(fieldName)
      }),
      {}
    ),
    [dirtyFields, getValues]
  );
  const getInputComponents = useCallback24(
    ({ includeCleanFields } = {}) => {
      const formValues = includeCleanFields ? getValues() : getDirtyFieldValues();
      const inputs = Object.entries(formValues).filter(
        ([inputName, inputValue]) => inputValue !== null && inputMap[inputName]
      ).map(
        ([inputName]) => toolboxComponentPayloadTransformer(inputMap[inputName])
      );
      return inputs;
    },
    [getDirtyFieldValues, getValues, inputMap]
  );
  useEffect23(() => {
    if (onFormRegister && includesFormElement) {
      onFormRegister(__spreadProps(__spreadValues({}, formMethods), {
        register: registerWrapper,
        control: __spreadProps(__spreadValues({}, control), { register: registerWrapper }),
        getInputComponents
      }));
    }
  }, [
    formMethods,
    getInputComponents,
    onFormRegister,
    registerWrapper,
    includesFormElement,
    control
  ]);
  return /* @__PURE__ */ React140.createElement(
    FormProvider2,
    {
      formMethods: __spreadProps(__spreadValues({}, formMethods), {
        register: registerWrapper,
        control: __spreadProps(__spreadValues({}, control), { register: registerWrapper })
      }),
      includesFormElement,
      css: formStyles
    },
    children
  );
};

// src/pages/health-activity/components/toolbox-component-resolver.component.tsx
var {
  Badge: Badge11,
  Banner,
  Blockquote: Blockquote2,
  FullPageHighlight: FullPageHighlight2,
  Header: Header2,
  Image: Image13,
  Link: Link13,
  List,
  RichText,
  DecimalInput: DecimalInput3,
  IntegerInput: IntegerInput3,
  StringInput: StringInput3,
  MultipleSelectInput: MultipleSelectInput3,
  DateInput: DateInput4,
  ChallengeProgress,
  ProgressTracking: ProgressTracking3,
  Biometric,
  PersonHeight: PersonHeight2,
  PersonWeight: PersonWeight2,
  DateTimeInput,
  Video: Video3
} = ComponentTypes9;
var ToolboxComponentResolver = ({
  components = [],
  isVisible = true,
  baseComponentId,
  onFormRegister,
  formConfig
}) => {
  const { registerToolboxComponent } = useContext5(ToolboxComponentContext);
  return /* @__PURE__ */ React141.createElement(
    ToolboxInputProvider,
    {
      onFormRegister,
      formConfig
    },
    components.map((component, componentIndex) => {
      const { componentType, componentAttributes } = component;
      const componentId = `${baseComponentId}-${componentIndex}`;
      registerToolboxComponent(componentId, component);
      const props = __spreadProps(__spreadValues({}, componentAttributes), {
        componentId,
        isVisible,
        css: deriveComponentLayoutStyles(componentType),
        key: componentId
      });
      switch (componentType) {
        case Badge11:
          return createElement22(ActivityToolboxBadge, props);
        case Banner:
          return createElement22(ActivityToolboxBanner, props);
        case Blockquote2:
          return createElement22(ActivityToolboxBlockquote, props);
        case FullPageHighlight2:
          return createElement22(ActivityToolboxFullPageHighlight, props);
        case Header2:
          return createElement22(ActivityToolboxHeader, props);
        case Image13:
          return createElement22(ActivityToolboxImage, props);
        case Link13:
          return createElement22(ActivityToolboxLink, props);
        case List:
          return createElement22(ActivityToolboxList, props);
        case RichText:
          return createElement22(ActivityToolboxRichText, props);
        case DecimalInput3:
          return createElement22(ActivityToolboxDecimalInput, props);
        case IntegerInput3:
          return createElement22(ActivityToolboxIntegerInput, props);
        case StringInput3:
          return createElement22(ActivityToolboxStringInput, props);
        case MultipleSelectInput3:
          return createElement22(ActivityToolboxMultipleSelectInput, props);
        case DateInput4:
          return createElement22(ActivityToolboxDateInput, props);
        case ProgressTracking3:
          return createElement22(ActivityToolboxProgressTracking, props);
        case Biometric:
          return createElement22(ActivityToolboxBiometric, props);
        case PersonHeight2:
          return createElement22(ActivityToolboxPersonHeightInput, props);
        case PersonWeight2:
          return createElement22(ActivityToolboxPersonWeightInput, props);
        case ChallengeProgress:
          return createElement22(ActivityToolboxChallengeProgress, props);
        case DateTimeInput:
          return createElement22(ActivityToolboxDateTimeInput, props);
        case Video3:
          return createElement22(ActivityToolboxVideo, props);
        default:
          return null;
      }
    })
  );
};

// src/pages/health-activity/components/activity-modal-controller.component.tsx
import React144, { useCallback as useCallback26, useEffect as useEffect26, useRef as useRef12 } from "react";
import {
  JourneyDelayModal,
  useApiDelayOverlay as useApiDelayOverlay2,
  ViewTransitionController as ViewTransitionController4
} from "@leagueplatform/health-journey-common";
import { Modal as Modal6 } from "@leagueplatform/genesis-core";

// src/pages/health-activity/components/modals/activity-exit-modal.component.tsx
import React142, { useContext as useContext6, useEffect as useEffect24 } from "react";
import { useIntl as useIntl68 } from "@leagueplatform/locales";
import { useStaticAsset as useStaticAsset3 } from "@leagueplatform/asset-config";
import {
  Box as Box74,
  Button as Button10,
  HeadingText as HeadingText21,
  Modal as Modal4,
  ParagraphText as ParagraphText13,
  StackLayout as StackLayout48
} from "@leagueplatform/genesis-core";
var { WAVE_GOODBYE: WAVE_GOODBYE2 } = HEALTH_JOURNEY_ASSET_KEYS;
var modalStyles = {
  ".GDS-modal-content": {
    display: "flex",
    flexWrap: "wrap",
    gap: "$twoAndHalf"
  }
};
var contentLayoutStyles = {
  display: "flex",
  gap: "$oneAndHalf",
  alignItems: "center",
  flexDirection: "column"
};
var imageContainerStyles = {
  maxWidth: `34%`,
  img: { width: "100%", display: "block" },
  "@mobile": { maxWidth: `176px` }
};
var copyContainerStyles = {
  "&, > .GDS-heading-text": { width: "100%" },
  textAlign: "center"
};
var modalFooterStyles = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap-reverse",
  justifyContent: "flex-end",
  gap: "$oneAndHalf",
  "@mobile": { gap: "$one" }
};
var modalButtonStyles = {
  justifyContent: "center",
  minWidth: "200px",
  // Determines the width at which the buttons must wrap
  "@mobile": { flexGrow: 1 }
};
var ActivityExitModal = ({ onClose }) => {
  const { formatMessage, $tmap } = useIntl68();
  const { returnToEntrypoint } = useActivityLink();
  const leaveActivityAsset = useStaticAsset3(WAVE_GOODBYE2);
  const { currentPage, healthActivityAnalytics } = useContext6(
    HealthActivityContext
  );
  useEffect24(() => {
    if (healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendViewExitModal) {
      healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendViewExitModal(currentPage + 1);
    }
  }, [currentPage, healthActivityAnalytics]);
  const onContinue = () => {
    healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendContinueActivity();
    onClose();
  };
  const onExit = () => {
    healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendConfirmCloseActivity();
    returnToEntrypoint();
  };
  const formatMessageWithFallback = (messageId, defaultValue = "") => $tmap({
    title: "EXIT_ACTIVITY_TITLE",
    subtitle: "EXIT_ACTIVITY_BODY"
  })(messageId).replace(messageId, defaultValue);
  const copy = {
    title: formatMessageWithFallback("title"),
    subtitle: formatMessageWithFallback("subtitle"),
    continue: formatMessage({ id: "KEEP_GOING" }),
    cancel: formatMessage({ id: "EXIT_ACTIVITY_CTA" })
  };
  return /* @__PURE__ */ React142.createElement(
    Modal4.Content,
    {
      forceModalFocus: false,
      onInteractOutside: onContinue,
      padding: { "@initial": "$two", "@mobile": "$one" },
      width: `min(${ACTIVITY_MODAL_MAX_WIDTH}px, 100%)`,
      css: modalStyles
    },
    /* @__PURE__ */ React142.createElement(Box74, { css: contentLayoutStyles }, leaveActivityAsset && typeof leaveActivityAsset === "string" && /* @__PURE__ */ React142.createElement(Box74, { css: imageContainerStyles }, /* @__PURE__ */ React142.createElement("img", { src: leaveActivityAsset, alt: "" })), /* @__PURE__ */ React142.createElement(
      StackLayout48,
      {
        orientation: "vertical",
        spacing: "$one",
        verticalAlignment: "center",
        css: copyContainerStyles
      },
      copy.title && /* @__PURE__ */ React142.createElement(HeadingText21, { level: "2", size: "xl" }, copy.title),
      copy.subtitle && /* @__PURE__ */ React142.createElement(ParagraphText13, null, copy.subtitle)
    )),
    /* @__PURE__ */ React142.createElement(Box74, { css: modalFooterStyles }, /* @__PURE__ */ React142.createElement(
      Button10,
      {
        onClick: onContinue,
        priority: "tertiary",
        quiet: true,
        css: modalButtonStyles
      },
      copy.continue
    ), /* @__PURE__ */ React142.createElement(Button10, { onClick: onExit, css: modalButtonStyles }, copy.cancel))
  );
};

// src/pages/health-activity/components/modals/activity-warning-modal.component.tsx
import React143, { useCallback as useCallback25, useContext as useContext7, useEffect as useEffect25 } from "react";
import { useIntl as useIntl69 } from "@leagueplatform/locales";
import {
  Box as Box75,
  Button as Button11,
  HeadingBar,
  HeadingText as HeadingText22,
  Modal as Modal5,
  ParagraphText as ParagraphText14,
  StackLayout as StackLayout49
} from "@leagueplatform/genesis-core";
var ActivityWarningModal = ({
  title,
  subTitle,
  ctaText
}) => {
  const { returnToEntrypoint } = useActivityLink();
  const { formatMessage } = useIntl69();
  const { healthActivityAnalytics, currentPage } = useContext7(
    HealthActivityContext
  );
  const copy = {
    title: title != null ? title : formatMessage({ id: "EXIT_ACTIVITY_TITLE" }),
    description: subTitle != null ? subTitle : formatMessage({ id: "EXIT_ACTIVITY_BODY" }),
    buttonOk: ctaText != null ? ctaText : formatMessage({ id: "EXIT_ACTIVITY_CTA" }),
    buttonNo: formatMessage({ id: "CANCEL" })
  };
  const onConfirm = useCallback25(() => {
    var _a;
    (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendContinueActivity) == null ? void 0 : _a.call(healthActivityAnalytics);
    returnToEntrypoint();
  }, [healthActivityAnalytics, returnToEntrypoint]);
  const onContinue = useCallback25(() => {
    var _a;
    (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendConfirmCloseActivity) == null ? void 0 : _a.call(healthActivityAnalytics);
  }, [healthActivityAnalytics]);
  useEffect25(() => {
    var _a;
    if (healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendViewExitModal) {
      (_a = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendViewExitModal) == null ? void 0 : _a.call(healthActivityAnalytics, currentPage + 1);
    }
  }, [healthActivityAnalytics, currentPage]);
  return /* @__PURE__ */ React143.createElement(
    Modal5.Content,
    {
      showCloseButton: false,
      forceModalFocus: false,
      padding: 0,
      width: `min(${ACTIVITY_MODAL_MAX_WIDTH}px, 100%)`,
      onInteractOutside: onContinue,
      css: { ".GDS-modal": { maxWidth: "100%", "@mobile": { width: "auto" } } }
    },
    /* @__PURE__ */ React143.createElement(Modal5.Title, null, copy.title),
    /* @__PURE__ */ React143.createElement(Modal5.Description, null, copy.description),
    /* @__PURE__ */ React143.createElement(
      HeadingBar,
      {
        css: { ".GDS-heading-bar-base": { padding: "$half" } },
        trailingAction: /* @__PURE__ */ React143.createElement(Modal5.Close, null, /* @__PURE__ */ React143.createElement(
          Button11,
          {
            priority: "tertiary",
            quiet: true,
            icon: "tinyClose",
            hideLabel: true,
            size: "small",
            onClick: onContinue
          },
          copy.buttonNo
        ))
      }
    ),
    /* @__PURE__ */ React143.createElement(Box75, { css: { padding: "0 $two $three" } }, /* @__PURE__ */ React143.createElement(StackLayout49, { orientation: "vertical", spacing: "$half" }, /* @__PURE__ */ React143.createElement(HeadingText22, { level: "2", size: "xl" }, copy.title), /* @__PURE__ */ React143.createElement(ParagraphText14, null, copy.description)), /* @__PURE__ */ React143.createElement(
      StackLayout49,
      {
        orientation: "horizontal",
        horizontalAlignment: "end",
        spacing: "$oneAndHalf",
        css: { marginTop: "$oneAndHalf" }
      },
      /* @__PURE__ */ React143.createElement(Modal5.Close, null, /* @__PURE__ */ React143.createElement(Button11, { priority: "tertiary", quiet: true, onClick: onContinue }, copy.buttonNo)),
      /* @__PURE__ */ React143.createElement(Button11, { priority: "primary", destructive: true, onClick: onConfirm }, copy.buttonOk)
    ))
  );
};

// src/pages/health-activity/components/activity-modal-controller.component.tsx
var { ApiDelay, Exit, Warning, Remove, None } = HealthActivityModalTypes;
var HealthActivityModalController = () => {
  const { activeModal, setActiveModal } = useActivityModals();
  const { delayOverlayActive } = useApiDelayOverlay2();
  const modalTrigger = useRef12(null);
  const onClose = useCallback26(() => setActiveModal(None), [setActiveModal]);
  const baseProps = __spreadValues({ onClose }, activeModal == null ? void 0 : activeModal.props);
  const width = useActivityContentWidth();
  const modals = {
    [Exit]: {
      view: ActivityExitModal,
      props: baseProps
    },
    [Warning]: {
      view: ActivityWarningModal,
      props: baseProps
    },
    [ApiDelay]: {
      view: JourneyDelayModal,
      props: __spreadProps(__spreadValues({}, baseProps), { width })
    },
    [Remove]: {
      view: DeleteActivityModal,
      props: baseProps
    }
  };
  useEffect26(() => {
    var _a, _b;
    if ((activeModal == null ? void 0 : activeModal.type) && document.activeElement instanceof HTMLElement) {
      modalTrigger.current = document.activeElement;
    } else {
      modalTrigger.current = (_b = (_a = modalTrigger.current) == null ? void 0 : _a.focus()) != null ? _b : null;
    }
  }, [activeModal == null ? void 0 : activeModal.type]);
  useEffect26(() => {
    if (delayOverlayActive) {
      setActiveModal(ApiDelay);
    }
  }, [delayOverlayActive, setActiveModal]);
  return /* @__PURE__ */ React144.createElement(React144.Suspense, { fallback: null }, /* @__PURE__ */ React144.createElement(
    Modal6.Root,
    {
      open: Boolean(activeModal == null ? void 0 : activeModal.type),
      onOpenChange: (isOpen) => !isOpen && onClose()
    },
    /* @__PURE__ */ React144.createElement(
      ViewTransitionController4,
      {
        duration: 300,
        handleActiveView: () => activeModal == null ? void 0 : activeModal.type,
        transitionType: "fade",
        views: modals
      }
    )
  ));
};

// src/pages/health-activity/components/buttons/activity-close-button.component.tsx
import React145 from "react";
import { useIntl as useIntl70 } from "@leagueplatform/locales";
var ActivityCloseButton = (_a) => {
  var _b = _a, {
    css: css14,
    icon = "tinyClose",
    size = "small",
    quiet = true,
    priority = "tertiary"
  } = _b, props = __objRest(_b, [
    "css",
    "icon",
    "size",
    "quiet",
    "priority"
  ]);
  const { formatMessage } = useIntl70();
  return /* @__PURE__ */ React145.createElement(
    ActivityCircleButton,
    __spreadValues({
      size,
      quiet,
      priority,
      icon,
      css: __spreadValues({
        position: "absolute",
        insetBlockStart: "$oneAndHalf",
        insetInlineEnd: "$oneAndHalf",
        padding: "$one"
      }, css14),
      hideLabel: true
    }, props),
    formatMessage({ id: "CLOSE_ACTIVITY" })
  );
};

// src/pages/health-activity/components/buttons/activity-remove-button.component.tsx
import React146 from "react";
import { useIntl as useIntl71 } from "@leagueplatform/locales";
var ActivityRemoveButton = (_a) => {
  var _b = _a, {
    css: css14,
    priority = "secondary",
    icon = "interfaceDelete"
  } = _b, props = __objRest(_b, [
    "css",
    "priority",
    "icon"
  ]);
  const { formatMessage } = useIntl71();
  return /* @__PURE__ */ React146.createElement(
    ActivityCircleButton,
    __spreadValues({
      css: __spreadValues({
        position: "absolute",
        insetBlockStart: "$oneAndHalf",
        insetInlineStart: "$oneAndHalf"
      }, css14),
      quiet: true,
      priority,
      icon,
      hideLabel: true
    }, props),
    formatMessage({ id: "REMOVE_ACTIVITY_PROMPT" })
  );
};

// src/pages/health-activity/components/activity-toolbox-status-overlay.component.tsx
import React147 from "react";
import { UserHealthActivityStatus as UserHealthActivityStatus3 } from "@leagueplatform/health-journey-common";
import { Box as Box76, HeadingText as HeadingText23, ParagraphText as ParagraphText15 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl72 } from "@leagueplatform/locales";
var { UPCOMING: UPCOMING9 } = UserHealthActivityStatus3;
var OverlayWrapper = ({ children }) => /* @__PURE__ */ React147.createElement(
  Box76,
  {
    css: {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "100%",
      background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 88.83%)",
      bottom: "0",
      alignItems: "flex-end",
      zIndex: "1",
      paddingY: "inherit",
      borderRadius: "$large",
      overflow: "hidden"
    }
  },
  children
);
var SneakPeek = () => {
  const { formatMessage } = useIntl72();
  return /* @__PURE__ */ React147.createElement(
    Box76,
    {
      css: {
        display: "flex",
        width: "inherit",
        alignItems: "center",
        flexDirection: "column",
        padding: "$three",
        backgroundColor: "$surfaceBackgroundTertiary",
        gap: "$half",
        textAlign: "center"
      }
    },
    /* @__PURE__ */ React147.createElement(HeadingText23, { level: "4", size: "md" }, formatMessage({ id: "THIS_IS_JUST_A_SNEAK_PEAK" })),
    /* @__PURE__ */ React147.createElement(ParagraphText15, { size: "xs", emphasis: "subtle" }, formatMessage({ id: "COME_BACK_COMPLETE_ACTIVITY_LATER" }))
  );
};
var StatusOverlayBody = ({ status }) => {
  switch (status) {
    case UPCOMING9:
      return /* @__PURE__ */ React147.createElement(SneakPeek, null);
    default:
      return null;
  }
};
var ActivityToolboxStatusOverlay = ({ status }) => /* @__PURE__ */ React147.createElement(OverlayWrapper, null, /* @__PURE__ */ React147.createElement(StatusOverlayBody, { status }));

// src/pages/health-activity/health-activity.component.tsx
var saveAsyncInputMutationConfig = {
  onMutate() {
    addActivityBreadcrumb({
      message: "Calling the Toolbox Interaction Hub prior to completing the Activity"
    });
  },
  onError(error) {
    addActivityBreadcrumb({
      data: { error },
      message: "ERROR: Call to the Toolbox Interaction Hub failed prior to completing the Activity"
    });
    toastActions3.add({
      type: TOAST_STATUS3.ERROR,
      textId: "ERROR_STATE_TITLE",
      contentId: "ANSWERS_NOT_SAVED"
    });
  }
};
var { Exit: Exit2, ApiDelay: ApiDelay2, Warning: Warning2, Remove: Remove2, None: None2 } = HealthActivityModalTypes;
var { ACTIVE: ACTIVE9, UPCOMING: UPCOMING10 } = UserHealthActivityStatus4;
var HealthActivity = ({
  healthActivityData
}) => {
  var _a, _b, _c;
  const { healthActivityAnalytics, healthAssessmentManager } = useContext8(
    HealthActivityContext
  );
  const { formatMessage } = useIntl73();
  const [isPageTransitioning, setIsPageTransitioning] = useState21(false);
  const {
    pages = [],
    id: userActivityId,
    status,
    removable,
    warning,
    name: activityName,
    completeOverlay: apiDelayConfig
  } = healthActivityData;
  const {
    currentPage,
    pageHistory,
    skippedPages,
    isLastPage,
    navigateActivity
  } = useActivityNavigation({
    healthActivityData
  });
  const {
    mutateAsync: completeActivity,
    isLoading: isLoadingCompleteActivity
  } = useCompleteUserHealthActivity(healthActivityData == null ? void 0 : healthActivityData.id, apiDelayConfig);
  const { mutate: removeActivity } = useDismissUserHealthActivity(
    healthActivityData == null ? void 0 : healthActivityData.id
  );
  const { setActiveModal } = useActivityModals();
  const { followLink, returnToEntrypoint } = useActivityLink();
  const {
    isValidating,
    registerForm,
    validatePages,
    validatePage,
    getQuestionsForPages,
    getQuestionsForPage
  } = healthAssessmentManager;
  const {
    mutate: saveToolboxResponses,
    mutateAsync: saveToolboxResponsesAsync,
    isLoading: isLoadingSaveResponses
  } = useSetToolboxInteractionHub(
    userActivityId,
    (_b = (_a = healthActivityData == null ? void 0 : healthActivityData.userHealthCampaign) == null ? void 0 : _a.data) == null ? void 0 : _b.id
    // userHealthCampaignId
  );
  useEffect27(() => {
    healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendViewPage(currentPage + 1);
    return () => {
      setActiveModal(None2);
    };
  }, [currentPage]);
  const totalPages = pages.length;
  const { callToAction } = (_c = pages[currentPage]) != null ? _c : {};
  const { text: ctaText, url } = callToAction != null ? callToAction : {};
  const ctaUrl = url == null ? void 0 : url.trim();
  const {
    isActive,
    isRemovable,
    isInteractionDisabled,
    isNextActionReady,
    isLoading
  } = useMemo40(() => {
    const loading = isLoadingCompleteActivity || isLoadingSaveResponses || isValidating;
    return {
      isLoading: loading,
      isNextActionReady: !loading && !isPageTransitioning,
      isActive: status === ACTIVE9,
      isRemovable: status === ACTIVE9 && removable,
      isInteractionDisabled: status === UPCOMING10
    };
  }, [
    isLoadingCompleteActivity,
    isLoadingSaveResponses,
    isPageTransitioning,
    status,
    removable,
    isValidating
  ]);
  const isProd = isProduction5();
  const deriveCtaText = () => isLastPage && !isActive ? formatMessage({ id: "CLOSE" }) : ctaText;
  useDocumentTitle6(
    `${activityName} - ${formatMessage(
      { id: "PAGE_OF_TOTAL" },
      { current: currentPage + 1, total: totalPages }
    )}`
  );
  const handleNextPage = (_0) => __async(void 0, [_0], function* ({ nextPage, goToNextPage }) {
    addActivityBreadcrumb({
      message: "Activity Navigation \u2013 Saving inputs",
      data: {
        isUpcoming: isInteractionDisabled,
        ctaUrl,
        currentPage,
        nextPage
      }
    });
    if (isInteractionDisabled || !isNextActionReady)
      return;
    if (ctaUrl) {
      followLink(ctaUrl);
      return;
    }
    const currentPageQuestions = [...getQuestionsForPage(currentPage) || []];
    const isCurrentPageValid = yield validatePage(currentPage);
    if (!isCurrentPageValid)
      return;
    if (!isProd) {
      console.log({ isCurrentPageValid, currentPageQuestions });
    }
    if (currentPageQuestions == null ? void 0 : currentPageQuestions.length) {
      saveToolboxResponses({ components: currentPageQuestions });
    }
    goToNextPage();
    healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendNextPage(nextPage);
  });
  const handleLastPage = () => __async(void 0, null, function* () {
    addActivityBreadcrumb({
      message: "START: Handle last page of Activity"
    });
    const areVisitedPagesValid = yield validatePages(pageHistory);
    if (!areVisitedPagesValid || !isNextActionReady)
      return;
    const answeredQuestions = getQuestionsForPages(pageHistory, {
      includeCleanFields: isActive
    });
    const skippedQuestions = getQuestionsForPages(skippedPages, {
      includeCleanFields: true
    }).flatMap((component) => component == null ? void 0 : component.componentStorageSources).filter(Boolean);
    if (answeredQuestions == null ? void 0 : answeredQuestions.length) {
      if (!isProd) {
        console.log({
          areVisitedPagesValid,
          answeredQuestions,
          skippedQuestions
        });
      }
      yield saveToolboxResponsesAsync(
        {
          components: answeredQuestions,
          skippedComponents: skippedQuestions,
          completedActivity: true
        },
        saveAsyncInputMutationConfig
      );
    }
    if (isActive) {
      yield completeActivity({ ctaUrl });
      healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendCompleteActivity(deriveCtaText());
    } else {
      returnToEntrypoint();
    }
  });
  const onNext = debounce(
    () => {
      if (isLoadingCompleteActivity) {
        setActiveModal(ApiDelay2);
      } else {
        navigateActivity.next({
          onNextPage: handleNextPage,
          onLastPage: handleLastPage
        });
      }
    },
    TRANSITION_DURATION_MS.MEDIUM,
    { leading: true, trailing: false }
  );
  const onPrev = () => {
    const prevPageIndex = navigateActivity.previous();
    healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendPreviousPage(prevPageIndex);
  };
  const onActivityClose = useCallback27(() => {
    var _a2;
    (_a2 = healthActivityAnalytics == null ? void 0 : healthActivityAnalytics.sendCloseActivity) == null ? void 0 : _a2.call(healthActivityAnalytics, currentPage + 1);
    if ((pages == null ? void 0 : pages.length) <= 1 || !isActive) {
      returnToEntrypoint();
    } else if (warning) {
      setActiveModal(Warning2, warning);
    } else {
      setActiveModal(Exit2);
    }
  }, [
    currentPage,
    healthActivityAnalytics,
    isActive,
    pages == null ? void 0 : pages.length,
    returnToEntrypoint,
    setActiveModal,
    warning
  ]);
  const onActivityRemove = () => {
    const props = {
      activityId: userActivityId,
      requestSetUserHealthActivityDelete: removeActivity
    };
    setActiveModal(Remove2, props);
  };
  const shouldApplyActivityLayoutFixes = useShouldApplyActivityLayoutFixes();
  const Slider = shouldApplyActivityLayoutFixes ? HealthActivitySliderV2 : HealthActivitySlider;
  const Slide = shouldApplyActivityLayoutFixes ? HealthActivitySlideV2 : HealthActivitySlide;
  const Footer = shouldApplyActivityLayoutFixes ? HealthActivityFooterV2 : HealthActivityFooter;
  return /* @__PURE__ */ React148.createElement(React148.Fragment, null, /* @__PURE__ */ React148.createElement(
    ActivityCloseButton,
    {
      className: "health-activity-close",
      onClick: onActivityClose
    }
  ), isRemovable && /* @__PURE__ */ React148.createElement(
    ActivityRemoveButton,
    {
      className: "health-activity-remove",
      onClick: onActivityRemove
    }
  ), /* @__PURE__ */ React148.createElement(HealthActivityLayout, null, /* @__PURE__ */ React148.createElement(Slider, null, pages == null ? void 0 : pages.map(({ components }, pageIndex) => /* @__PURE__ */ React148.createElement(
    Slide,
    {
      key: `health-activity-page-${pageIndex}`,
      activeIndex: currentPage,
      gap: "120%",
      slideIndex: pageIndex,
      onTransition: setIsPageTransitioning
    },
    /* @__PURE__ */ React148.createElement(HealthActivityContent, null, /* @__PURE__ */ React148.createElement(
      ToolboxComponentResolver,
      {
        components,
        isVisible: currentPage === pageIndex,
        baseComponentId: `${userActivityId}-${pageIndex}`,
        onFormRegister: registerForm(pageIndex)
      }
    ))
  ))), /* @__PURE__ */ React148.createElement(
    Footer,
    {
      totalPages,
      currentPage,
      isLastPage,
      ctaText: deriveCtaText(),
      onNext,
      onPrev,
      loading: isLoading,
      disabled: isInteractionDisabled,
      transitioning: isPageTransitioning
    }
  ), isInteractionDisabled && /* @__PURE__ */ React148.createElement(ActivityToolboxStatusOverlay, { status })), /* @__PURE__ */ React148.createElement(HealthActivityModalController, null));
};

// src/pages/health-activity/health-activity-page.component.tsx
var HealthActivityPage = ({
  initialPageIndex = 0
}) => {
  const { hasError, ready, healthActivityData } = useHealthActivityToolbox();
  const healthActivityAnalytics = useHealthActivityAnalytics();
  if (!ready)
    return /* @__PURE__ */ React149.createElement(HealthActivityLoading, null);
  if (hasError || !healthActivityData)
    return /* @__PURE__ */ React149.createElement(HealthActivityError, null);
  return /* @__PURE__ */ React149.createElement(
    HealthActivityProvider,
    {
      healthActivityAnalytics,
      currentPage: initialPageIndex
    },
    /* @__PURE__ */ React149.createElement(HealthActivity, { healthActivityData })
  );
};

// src/pages/activity-steps/activity-steps.component.js
import React150, { useState as useState22, useEffect as useEffect28 } from "react";
import PropTypes14 from "prop-types";
import { Transition as Transition2 } from "react-transition-group";
import { Box as Box77, Flex as Flex25, genesisStyled as genesisStyled20, css as css12 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl74 } from "@leagueplatform/locales";
import {
  SingleProgressBar,
  Icon as Icon14,
  ICONS as Icons
} from "@leagueplatform/ui-kit";
import {
  HtmlToReact as HtmlToReact2,
  useOnEscape,
  easeOutCubic
} from "@leagueplatform/web-common";
import {
  AssessmentExitModal,
  VeryQuietButton as VeryQuietButton3
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset15 } from "@leagueplatform/asset-config";
import {
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS15,
  useApiDelayOverlay as useApiDelayOverlay3,
  ApiDelayOverlay
} from "@leagueplatform/health-journey-common";

// src/common/activity-html-to-react-options.js
import { BodyTwo as BodyTwo5, css as css11, genesisStyled as genesisStyled19 } from "@leagueplatform/genesis-commons";
var StyledListItem = genesisStyled19(BodyTwo5)(
  css11({
    marginTop: "half",
    marginBottom: "half",
    "> p, > ul": {
      marginBottom: 0
    }
  })
);
var ActivityHtmlToReactOptions = {
  h1: {
    props: {
      marginBottom: "oneAndHalf"
    }
  },
  h2: {
    props: { marginBottom: "one" }
  },
  p: {
    component: BodyTwo5,
    props: {
      marginBottom: "oneAndHalf"
    }
  },
  img: {
    component: DynamicImage,
    props: {
      maxWidth: "100%",
      maxHeight: "75vh",
      width: "auto",
      display: "block",
      marginBottom: "twoAndHalf"
    }
  },
  a: {
    props: {
      fontSize: "inherit",
      lineHeight: "inherit",
      target: "_blank"
    }
  },
  li: {
    component: StyledListItem,
    props: {
      as: "li"
    }
  },
  sup: {
    props: {
      marginBottom: "$one"
    }
  }
};

// src/pages/activity-steps/activity-steps.component.js
var { CLOSE } = Icons;
var { COMPLETED: COMPLETED7 } = HEALTH_JOURNEY_ACTIVITY_STATUS15;
var { WAVE_GOODBYE: WAVE_GOODBYE3 } = HEALTH_JOURNEY_ASSET_KEYS;
var SLIDE_TRANSITION_DUR = 500;
var HideableBox = genesisStyled20(Flex25)(
  ({ hidden }) => css12({
    visibility: hidden ? "hidden" : "visible"
  })
);
var ExitModalWrapper = ({ showExitModal, children }) => /* @__PURE__ */ React150.createElement(Transition2, { in: showExitModal, unmountOnExit: true, timeout: 250 }, (state) => /* @__PURE__ */ React150.createElement(
  Box77,
  {
    backgroundColor: "surface.background.primary",
    opacity: state === "entered" ? 1 : 0,
    transition: "opacity 200ms ease-out",
    position: "fixed",
    width: "100%",
    height: "100%",
    zIndex: "99"
  },
  children
));
ExitModalWrapper.propTypes = {
  showExitModal: PropTypes14.bool.isRequired,
  children: PropTypes14.node.isRequired
};
var BtnContainer = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React150.createElement(
    Flex25,
    {
      maxHeight: "100vh",
      alignSelf: "stretch",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "sticky",
      top: "0"
    },
    /* @__PURE__ */ React150.createElement(HideableBox, __spreadValues({ justifyContent: "center", position: "relative" }, props))
  );
};
var ActivityStepsPage = () => {
  var _a;
  const leaveActivityAsset = handleStaticAsset15(WAVE_GOODBYE3);
  const { formatMessage } = useIntl74();
  const { returnToEntrypoint } = useActivityLink();
  const { ready, cta, status } = useHealthActivity();
  const activityStepsAnalytics = useActivityStepsAnalytics();
  const { delayOverlayActive, setDelayOverlayActive } = useApiDelayOverlay3();
  const [currentStep, setCurrentStep] = useState22(0);
  const [showExitModal, setShowExitModal] = useState22(false);
  const { steps = [] } = (_a = cta == null ? void 0 : cta.completion_method) != null ? _a : {};
  const stepCount = steps == null ? void 0 : steps.length;
  const isFinalStep = !steps.length || currentStep === steps.length - 1;
  const onExit = () => {
    activityStepsAnalytics.sendConfirmCloseActivity();
    returnToEntrypoint();
  };
  const toggleExitModal = (isOpen) => {
    if (isOpen) {
      activityStepsAnalytics.sendCloseActivity(currentStep + 1);
    } else {
      activityStepsAnalytics.sendContinueActivity();
    }
    setShowExitModal(isOpen);
  };
  const closeButtonAction = () => {
    switch (status) {
      case COMPLETED7:
        return onExit();
      default:
        return toggleExitModal(true);
    }
  };
  useOnEscape(() => closeButtonAction());
  const focusRef = (node7) => {
    var _a2;
    return (_a2 = node7 == null ? void 0 : node7.focus) == null ? void 0 : _a2.call(node7);
  };
  useEffect28(
    () => {
      if (ready) {
        activityStepsAnalytics.sendViewStep(currentStep + 1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentStep, ready]
  );
  if (ready && !steps.length) {
    onExit();
    return null;
  }
  const onNext = () => {
    setCurrentStep((step) => {
      const newStep = (step + 1) % stepCount;
      activityStepsAnalytics.sendNextStep(newStep);
      return newStep;
    });
  };
  const onPrev = () => {
    setCurrentStep((step) => {
      const newStep = (stepCount + (step - 1)) % stepCount;
      activityStepsAnalytics.sendPreviousStep(newStep + 2);
      return newStep;
    });
  };
  const progressBarColor = "decorative.brand.primary.dark";
  return /* @__PURE__ */ React150.createElement(Box77, { height: "100%", "aria-live": "assertive" }, /* @__PURE__ */ React150.createElement(ExitModalWrapper, { showExitModal }, /* @__PURE__ */ React150.createElement(
    AssessmentExitModal,
    {
      backgroundColor: "surface.background.primary",
      exitScreen: {
        title: formatMessage({ id: "EXIT_ACTIVITY_TITLE" }),
        description: formatMessage({ id: "EXIT_ACTIVITY_BODY" }),
        buttonOk: formatMessage({ id: "EXIT_ACTIVITY_CTA" }),
        buttonNo: formatMessage({ id: "KEEP_GOING" }),
        imageId: "",
        image: leaveActivityAsset
      },
      setShowExit: toggleExitModal,
      ctaHandler: onExit,
      sendPageAnalytics: () => activityStepsAnalytics.sendViewExitModal(currentStep + 1)
    }
  )), /* @__PURE__ */ React150.createElement(Flex25, { minHeight: "100%", width: "100%", paddingX: `${174 / 1440 * 100}%` }, /* @__PURE__ */ React150.createElement(BtnContainer, { hidden: currentStep <= 0 }, /* @__PURE__ */ React150.createElement(
    ArrowButton,
    {
      orientation: LEFT,
      disabled: currentStep <= 0,
      onClick: onPrev
    }
  )), /* @__PURE__ */ React150.createElement(
    Flex25,
    {
      overflowX: "hidden",
      paddingTop: "four",
      paddingBottom: "five",
      marginX: "five",
      width: "100%",
      flexWrap: "wrap"
    },
    /* @__PURE__ */ React150.createElement(Box77, { marginBottom: "three", width: "100%" }, /* @__PURE__ */ React150.createElement(
      SingleProgressBar,
      {
        active: true,
        showContentTooltip: false,
        name: formatMessage(
          { id: "X_OF_Y" },
          { current: currentStep + 1, total: steps.length }
        ),
        color: progressBarColor,
        totalSteps: steps.length,
        completedSteps: currentStep + 1
      }
    )),
    /* @__PURE__ */ React150.createElement(
      Flex25,
      {
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        transition: `transform ${SLIDE_TRANSITION_DUR}ms ${easeOutCubic}`,
        transform: `translateX(-${currentStep * 115}%)`
      },
      steps.map((step, index) => /* @__PURE__ */ React150.createElement(
        Box77,
        {
          minWidth: "100%",
          paddingBottom: isFinalStep ? "five" : "none",
          marginInlineEnd: "15%",
          minHeight: "20vmin",
          opacity: index === currentStep ? 1 : 0,
          transition: `opacity ${SLIDE_TRANSITION_DUR}ms ease-in-out`
        },
        /* @__PURE__ */ React150.createElement(
          HtmlToReact2,
          {
            htmlString: step,
            options: ActivityHtmlToReactOptions
          }
        )
      ))
    )
  ), /* @__PURE__ */ React150.createElement(BtnContainer, { hidden: isFinalStep }, /* @__PURE__ */ React150.createElement(
    ArrowButton,
    {
      orientation: RIGHT,
      disabled: isFinalStep,
      onClick: onNext,
      focusRef
    }
  ))), /* @__PURE__ */ React150.createElement(Box77, { zIndex: "1", position: "fixed", top: "four", insetInlineEnd: "four" }, /* @__PURE__ */ React150.createElement(
    VeryQuietButton3,
    {
      onClick: () => closeButtonAction(),
      "aria-label": formatMessage({ id: "CLOSE" }),
      hideUnderline: true
    },
    /* @__PURE__ */ React150.createElement(Icon14, { icon: CLOSE, size: "medium" })
  )), isFinalStep && /* @__PURE__ */ React150.createElement(ActivityFooter, { isRemovable: false, isActivityDetailsView: false }), /* @__PURE__ */ React150.createElement(React150.Suspense, { fallback: null }, delayOverlayActive && /* @__PURE__ */ React150.createElement(ApiDelayOverlay, { onClose: () => setDelayOverlayActive(false) })));
};

// src/pages/activity-details/activity-details.component.js
import React162, { useEffect as useEffect31, useState as useState24 } from "react";
import { useNavigateLegacy as useNavigate10 } from "@leagueplatform/routing";
import {
  Flex as Flex31,
  Box as Box85,
  HeadingFour as HeadingFour8,
  BodyTwo as BodyTwo8,
  genesisStyled as genesisStyled25
} from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow as BackButtonArrow7,
  LoadingIndicator as LoadingIndicator5,
  ErrorState as ErrorState7
} from "@leagueplatform/web-common-components";
import {
  splitAtNewlines as splitAtNewlines2,
  useDocumentTitle as useDocumentTitle7,
  useScrollTopOnLocationChange
} from "@leagueplatform/web-common";
import { useIntl as useIntl82 } from "@leagueplatform/locales";
import { UnavailableDeviceConnectModal } from "@leagueplatform/health-programs";
import {
  useApiDelayOverlay as useApiDelayOverlay4,
  ApiDelayOverlay as ApiDelayOverlay2,
  JOURNEY_MANAGER_ENABLED as JOURNEY_MANAGER_ENABLED5,
  JOURNEY_ROUTES as JOURNEY_ROUTES28
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery19 } from "@leagueplatform/user-profile-api";

// src/hooks/use-activity-progress-counter.hook.js
import { debounce as debounce2 } from "lodash";
import {
  COMPLETION_METHOD_TYPES as COMPLETION_METHOD_TYPES4,
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS16
} from "@leagueplatform/health-journey-common";

// src/hooks/use-set-activity-progress.hook.js
import { useMutation as useMutation4, useQueryClient as useQueryClient10 } from "react-query";
import {
  GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE3,
  setActivityProgress,
  SET_ACTIVITY_PROGRESS_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
var useSetActivityProgress = () => {
  const queryClient = useQueryClient10();
  const { userActivityId, campaignId, contentActivityId } = useActivityParams();
  const mutation = useMutation4(
    (activityProgress) => setActivityProgress(userActivityId, activityProgress),
    {
      mutationKey: [SET_ACTIVITY_PROGRESS_MESSAGE_TYPE, userActivityId],
      onSettled(data, error, activityProgress) {
        queryClient.setQueryData(
          [
            GET_USER_HEALTH_ACTIVITY_MESSAGE_TYPE3,
            userActivityId,
            contentActivityId,
            campaignId
          ],
          (prevActivityData) => {
            if (!prevActivityData || !(prevActivityData == null ? void 0 : prevActivityData.health_activity))
              return prevActivityData;
            const newActivityData = Object.assign(prevActivityData, {
              health_activity: __spreadProps(__spreadValues({}, prevActivityData.health_activity), {
                activity_verification_progress: __spreadValues(__spreadValues({}, prevActivityData.health_activity.activity_verification_progress), activityProgress)
              })
            });
            return newActivityData;
          }
        );
      }
    }
  );
  return mutation;
};

// src/hooks/use-activity-progress-counter.hook.js
var { COMPLETED: COMPLETED8 } = HEALTH_JOURNEY_ACTIVITY_STATUS16;
var { COUNTER: COUNTER3 } = COMPLETION_METHOD_TYPES4;
var PROGRESS_WAIT_INTERVAL = 250;
var useActivityProgressCounter = () => {
  var _a, _b;
  const activity = useHealthActivity();
  const activityProgressMutation = useSetActivityProgress();
  const activityAnalytics = useActivityAnalytics();
  const ready = !activityProgressMutation.isLoading;
  const hasError = activityProgressMutation.isError;
  const status = activity == null ? void 0 : activity.status;
  const cta = (_a = activity == null ? void 0 : activity.cta) != null ? _a : {};
  const { count_progress: progress = 0 } = (_b = activity == null ? void 0 : activity.activityProgress) != null ? _b : {};
  const { completion_method: completionMethod = {} } = cta;
  const { type, counter } = completionMethod;
  const { goal } = counter != null ? counter : {};
  const name = `${activity == null ? void 0 : activity.activityId}-${counter == null ? void 0 : counter.unit}-counter`;
  const shouldUseCounter = type === COUNTER3 && counter;
  const promptToCompleteActivity = progress >= goal && status !== COMPLETED8;
  const handleChange = debounce2(({ newValue, oldValue, inputMethod }) => {
    activityAnalytics.sendEditActivityProgress({
      inputMethod,
      newValue,
      oldValue
    });
    activityProgressMutation.mutate({ count_progress: newValue });
  }, PROGRESS_WAIT_INTERVAL);
  const counterProps = {
    ready,
    hasError,
    cta,
    status,
    progress,
    handleChange,
    name
  };
  return { shouldUseCounter, promptToCompleteActivity, counterProps };
};

// src/pages/activity-details/activity-details.component.js
import { USER_CONNECTED_DEVICE_CAMPAIGN_MODES as USER_CONNECTED_DEVICE_CAMPAIGN_MODES2 } from "@leagueplatform/health-journey-api";

// src/hooks/use-verifiable-activity-progress-query.hook.ts
import { useLeagueWSQuery } from "@leagueplatform/api";
function useVerifiableActivityProgressQuery(activityId, isVerifiableActivity = true) {
  const messageType = "get_verifiable_activity_progress";
  const info = {
    activity_id: activityId
  };
  return useLeagueWSQuery(
    [messageType, activityId],
    {
      message_type: messageType,
      info
    },
    { enabled: isVerifiableActivity }
  );
}

// src/pages/activity-details/types/exit-modals.type.ts
var ACTIVITY_EXIT_MODAL_TYPES = /* @__PURE__ */ ((ACTIVITY_EXIT_MODAL_TYPES2) => {
  ACTIVITY_EXIT_MODAL_TYPES2["SAVE_PROGRESS"] = "SAVE_PROGRESS";
  return ACTIVITY_EXIT_MODAL_TYPES2;
})(ACTIVITY_EXIT_MODAL_TYPES || {});

// src/pages/activity-details/components/activity-helpful-tip.component.js
import React151 from "react";
import PropTypes15 from "prop-types";
import { useIntl as useIntl75 } from "@leagueplatform/locales";
import {
  Flex as Flex26,
  Overline as Overline5,
  SubtitleOne as SubtitleOne6,
  Link as Link14,
  genesisStyled as genesisStyled21
} from "@leagueplatform/genesis-commons";
import { Icon as Icon15 } from "@leagueplatform/genesis-core";
import { useNavigateLegacy as useNavigate9 } from "@leagueplatform/routing";

// src/hooks/use-activity-mark-as-done.hook.js
var useActivityMarkAsDone = (id) => {
  var _a;
  const activity = useHealthActivity();
  const { isLoading, mutate, isError, isDone } = useSetActivityProgress();
  const { helpful_tips: helpfulTips = [] } = (_a = activity == null ? void 0 : activity.activityProgress) != null ? _a : {};
  const newHelpFulTips = new Array(helpfulTips);
  const index = newHelpFulTips == null ? void 0 : newHelpFulTips.findIndex(
    (tip) => {
      var _a2;
      return ((_a2 = tip.id) == null ? void 0 : _a2.toLowerCase()) === (id == null ? void 0 : id.toLowerCase());
    }
  );
  if (index >= 0) {
    newHelpFulTips[index].opened = true;
  } else {
    newHelpFulTips.push({ id, opened: true });
  }
  const markAsDone = () => mutate({ helpful_tips: newHelpFulTips });
  return { isDone, isLoading, isError, markAsDone };
};

// src/pages/activity-details/components/activity-helpful-tip.component.js
import { useConfigProperty as useConfigProperty4 } from "@leagueplatform/core";
import { isValidUrl as isValidUrl3 } from "@leagueplatform/web-common";
var StyledFlexLink = genesisStyled21(Flex26)`
  &:hover, &:focus {
    text-decoration: none;
    .pseudo-link {
      text-decoration: underline;
    }
  }
`;
var ActivityHelpfulTip = ({
  id,
  type,
  title,
  image,
  url,
  isAssigned: isAssigned2,
  redirectBackToAssigned,
  activityId,
  activityType
}) => {
  const { formatMessage } = useIntl75();
  const { sendSelectHelpfulTip } = useActivityAnalytics();
  const navigate = useNavigate9();
  const { markAsDone } = useActivityMarkAsDone(id);
  const handleLinkCallback = useConfigProperty4("core.customMethods.handleLink");
  const handleClick = (e) => {
    markAsDone();
    if (redirectBackToAssigned) {
      e.preventDefault();
      navigate(url.replace(window.location.origin, ""), {
        state: {
          activityId,
          activityType
        }
      });
    } else if (isValidUrl3(url) && !!handleLinkCallback) {
      e.preventDefault();
      handleLinkCallback(url);
    }
    sendSelectHelpfulTip({ type, title, url });
  };
  return /* @__PURE__ */ React151.createElement(
    StyledFlexLink,
    {
      as: Link14,
      href: url,
      target: redirectBackToAssigned ? "_self" : "_blank",
      rel: "noopener noreferrer",
      onClick: handleClick,
      flexDirection: { _: "column-reverse", phone: "row" },
      alignItems: { _: "flex-start", phone: "center" },
      justifyContent: "space-between",
      padding: "oneAndHalf",
      marginTop: "three",
      marginBottom: "oneAndHalf",
      borderRadius: "medium",
      backgroundColor: "surface.background.secondary"
    },
    /* @__PURE__ */ React151.createElement(Flex26, { flexDirection: "column", marginInlineEnd: "oneAndHalf" }, type && /* @__PURE__ */ React151.createElement(Overline5, { as: "p", paddingBottom: "half", color: "onSurface.text.subdued" }, type), title && /* @__PURE__ */ React151.createElement(SubtitleOne6, { as: "h3", paddingBottom: "quarter" }, title), /* @__PURE__ */ React151.createElement(
      SubtitleOne6,
      {
        as: "p",
        className: "pseudo-link",
        marginInlineEnd: "quarter",
        color: "interactive.action.primary",
        paddingTop: "one",
        display: "flex",
        css: { gap: "0.5ch" },
        alignItems: "center"
      },
      isAssigned2 ? formatMessage({ id: "VISIT_LINK" }) : formatMessage({ id: "LEARN_MORE" }),
      /* @__PURE__ */ React151.createElement(Icon15, { icon: "tinyExternalLink", size: "1em" })
    )),
    /* @__PURE__ */ React151.createElement(
      DynamicCoverImage,
      {
        src: image,
        backgroundSize: "contain",
        alt: "helpful tip",
        size: { _: 32, phone: 64 },
        minWidth: { _: "32px", phone: "64px" },
        marginBottom: { _: "one", phone: "none" }
      }
    )
  );
};
ActivityHelpfulTip.propTypes = {
  id: PropTypes15.string.isRequired,
  type: PropTypes15.string.isRequired,
  title: PropTypes15.string.isRequired,
  image: PropTypes15.string.isRequired,
  url: PropTypes15.string.isRequired,
  redirectBackToAssigned: PropTypes15.bool.isRequired,
  isAssigned: PropTypes15.bool.isRequired,
  activityId: PropTypes15.string.isRequired,
  activityType: PropTypes15.string.isRequired
};

// src/pages/activity-details/components/activity-status-badge.component.js
import * as React152 from "react";
import PropTypes16 from "prop-types";
import { useIntl as useIntl76 } from "@leagueplatform/locales";
import {
  Flex as Flex27,
  HeadingFour as HeadingFour7,
  VisuallyHidden as VisuallyHidden5
} from "@leagueplatform/genesis-commons";
import { HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS17 } from "@leagueplatform/health-journey-common";
var { EXPIRED: EXPIRED6, REMOVED: REMOVED6, UPCOMING: UPCOMING11, COMPLETED: COMPLETED9 } = HEALTH_JOURNEY_ACTIVITY_STATUS17;
var mapStatus = {
  [EXPIRED6]: {
    backgroundColor: "onSurface.text.subdued",
    color: "primary.text.default"
  },
  [REMOVED6]: {
    backgroundColor: "onSurface.text.primary",
    color: "primary.text.default"
  },
  [UPCOMING11]: {
    backgroundColor: "decorative.brand.primary.pastel",
    color: "onSurface.text.primary"
  },
  [COMPLETED9]: {
    backgroundColor: "success.background.subdued",
    color: "onSurface.text.primary"
  }
};
var ActivityStatusBadge = (_a) => {
  var _b = _a, { status } = _b, props = __objRest(_b, ["status"]);
  const { formatMessage, $tmap } = useIntl76();
  const label = $tmap({
    [EXPIRED6]: "ACTIVITY_STATUS_EXPIRED",
    [REMOVED6]: "ACTIVITY_STATUS_REMOVED",
    [UPCOMING11]: "ACTIVITY_STATUS_UPCOMING",
    [COMPLETED9]: "COMPLETED"
  })(status);
  if (!status || !mapStatus[status])
    return null;
  const { backgroundColor, color } = mapStatus[status];
  return /* @__PURE__ */ React152.createElement(
    Flex27,
    __spreadValues({
      alignItems: "center",
      backgroundColor,
      borderRadius: "pill",
      justifyContent: "flex-start",
      paddingY: "quarter",
      paddingX: "threeQuarters",
      width: "fit-content",
      "data-testid": "activity-status-badge"
    }, props),
    /* @__PURE__ */ React152.createElement(HeadingFour7, { as: "span", color }, /* @__PURE__ */ React152.createElement(VisuallyHidden5, null, formatMessage({ id: "ACTIVITY_STATUS" })), label)
  );
};
ActivityStatusBadge.propTypes = {
  status: PropTypes16.string.isRequired
};

// src/pages/activity-details/components/activity-references.component.js
import * as React153 from "react";
import { string as string8 } from "prop-types";
import { Box as Box78, HeadingThree as HeadingThree10 } from "@leagueplatform/genesis-commons";
import { HtmlToReact as HtmlToReact3 } from "@leagueplatform/web-common";
import { useIntl as useIntl77 } from "@leagueplatform/locales";
var ActivityReferences = (_a) => {
  var _b = _a, { references } = _b, props = __objRest(_b, ["references"]);
  const { formatMessage } = useIntl77();
  if (!references)
    return null;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    /* @__PURE__ */ React153.createElement(Box78, __spreadProps(__spreadValues({}, props), { "data-testid": "activity-references" }), /* @__PURE__ */ React153.createElement(HeadingThree10, { as: "h2", marginBottom: "half" }, formatMessage({ id: "REFERENCES" })), /* @__PURE__ */ React153.createElement(
      HtmlToReact3,
      {
        htmlString: references,
        options: ActivityHtmlToReactOptions
      }
    ))
  );
};
ActivityReferences.propTypes = {
  references: string8
};
ActivityReferences.defaultProps = {
  references: ""
};

// src/components/progress-tracker.component.tsx
import React154 from "react";
import { useIntl as useIntl78 } from "@leagueplatform/locales";
import {
  Box as Box79,
  ParagraphText as ParagraphText16,
  UtilityText as UtilityText24,
  VisuallyHidden as VisuallyHidden6
} from "@leagueplatform/genesis-core";

// src/utils/time-ago-from-now.util.ts
var ranges = {
  years: 3600 * 24 * 365,
  months: 3600 * 24 * 30,
  weeks: 3600 * 24 * 7,
  days: 3600 * 24,
  hours: 3600,
  minutes: 60,
  seconds: 1
};
function timeAgoFromNow(date) {
  const secondsElapsed = (new Date(date).getTime() - Date.now()) / 1e3;
  const range = Object.entries(ranges).find(
    ([, t]) => t < Math.abs(secondsElapsed)
  );
  if (range) {
    const time = secondsElapsed / range[1];
    return { time: Math.round(time), suffix: range[0] };
  }
  return { time: 0, suffix: "seconds" };
}

// src/components/progress-tracker.component.tsx
function ProgressTracker({ activityId }) {
  const { formatRelativeTime, formatMessage } = useIntl78();
  const { isLoading, isError, data } = useVerifiableActivityProgressQuery(activityId);
  if (isLoading || isError || !data)
    return null;
  const {
    unit,
    current_progress: current,
    goal_total: total,
    last_updated: lastUpdated
  } = data;
  const progressPercentage = Math.min(current / total, 1);
  const percentage = Math.floor(progressPercentage * 100);
  const { time, suffix } = timeAgoFromNow(lastUpdated);
  const yourProgressInNumbers = formatMessage(
    { id: "YOUR_PROGRESS_IN_NUMBERS" },
    {
      current,
      total,
      unit,
      percentage
    }
  );
  return /* @__PURE__ */ React154.createElement(Box79, { css: { marginTop: "$two" } }, /* @__PURE__ */ React154.createElement(UtilityText24, { as: "h2", emphasis: "emphasized" }, formatMessage({ id: "YOUR_PROGRESS" })), /* @__PURE__ */ React154.createElement(VisuallyHidden6, null, yourProgressInNumbers), /* @__PURE__ */ React154.createElement(ParagraphText16, { size: "xs" }, formatMessage({ id: "UPDATED" }), " ", formatRelativeTime(time, suffix)), /* @__PURE__ */ React154.createElement(
    Box79,
    {
      css: {
        marginTop: "$one",
        marginInlineStart: "$twoAndHalf"
      }
    },
    /* @__PURE__ */ React154.createElement(
      ProgressTrackerChart,
      {
        unit,
        currentProgress: current,
        goal: total,
        progressPercentage: percentage
      }
    )
  ));
}

// src/pages/activity-details/components/save-progress-modal.component.js
import React155, { useEffect as useEffect29 } from "react";
import {
  Flex as Flex28,
  Box as Box80,
  HeadingThree as HeadingThree11,
  genesisStyled as genesisStyled22,
  BodyOne as BodyOne4,
  PrimaryButton as PrimaryButton5,
  QuietButton,
  css as css13,
  useTheme as useTheme4
} from "@leagueplatform/genesis-commons";
import { func as func3, string as string9 } from "prop-types";
import { LinkLegacy as Link15 } from "@leagueplatform/routing";
import { useIntl as useIntl79 } from "@leagueplatform/locales";
import { HealthActivityModal as HealthActivityModal2 } from "@leagueplatform/health-journey-common";
var HeaderLine = genesisStyled22(Box80)(
  ({ theme: { space } }) => css13({
    "&:after": {
      content: '""',
      display: "block",
      width: `calc(100% + ${space.two * 2}px )`,
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin",
      marginInlineStart: "minusTwo",
      marginBottom: "oneAndHalf"
    }
  })
);
var SaveProgressModal = (props) => {
  const { onDismiss, onBack, activityId: userActivityId } = props;
  const theme = useTheme4();
  const { formatMessage } = useIntl79();
  const completeActivityMutation = useCompleteUserHealthActivity(userActivityId);
  const activityAnalytics = useActivityAnalytics();
  const copy = {
    heading: formatMessage({ id: "GOAL_REACHED" }),
    completeNow: formatMessage({ id: "ACTIVITY_COMPLETE_PROMPT" }),
    completeLater: formatMessage({ id: "ACTIVITY_COMPLETE_LATER_PROMPT" }),
    close: formatMessage({ id: "BACK_TO_JOURNEY" }),
    complete: formatMessage({ id: "MARK_AS_DONE" })
  };
  useEffect29(() => {
    activityAnalytics.sendViewSaveProgressModal();
  }, [activityAnalytics]);
  const onComplete = () => {
    completeActivityMutation.mutate();
    activityAnalytics.sendSaveProgressModalAction({
      isCompletion: true,
      ctaText: copy.complete
    });
    onDismiss();
  };
  const onClose = () => {
    activityAnalytics.sendDismissSaveProgressModal();
    onDismiss();
  };
  return /* @__PURE__ */ React155.createElement(HealthActivityModal2, { onClose, "aria-label": copy.heading, isNarrow: true }, /* @__PURE__ */ React155.createElement(HeaderLine, { theme }, /* @__PURE__ */ React155.createElement(HeadingThree11, { marginBottom: "oneAndHalf" }, copy.heading)), /* @__PURE__ */ React155.createElement(
    Box80,
    {
      position: "absolute",
      top: "0",
      insetInlineStart: "0",
      width: "100%",
      borderBottomColor: "onSurface.border.subdued",
      borderBottomWidth: "thin",
      borderBottomStyle: "solid"
    }
  ), /* @__PURE__ */ React155.createElement(BodyOne4, null, copy.completeNow), /* @__PURE__ */ React155.createElement(BodyOne4, { marginTop: "one" }, copy.completeLater), /* @__PURE__ */ React155.createElement(Flex28, { justifyContent: "flex-end", marginTop: "two" }, /* @__PURE__ */ React155.createElement(
    QuietButton,
    {
      as: Link15,
      to: onBack,
      onClick: () => activityAnalytics.sendSaveProgressModalAction({
        isCompletion: false
      })
    },
    copy.close
  ), /* @__PURE__ */ React155.createElement(PrimaryButton5, { marginInlineStart: "threeQuarters", onClick: onComplete }, copy.complete)));
};
SaveProgressModal.propTypes = {
  activityId: string9.isRequired,
  onDismiss: func3.isRequired,
  onBack: func3.isRequired
};

// src/pages/activity-details/components/activity-sync-error-banner.component.tsx
import React156 from "react";
import { Box as Box81, Link as Link16, genesisStyled as genesisStyled23 } from "@leagueplatform/genesis-commons";
import { HighlightBanner } from "@leagueplatform/web-common-components";
import { useIntl as useIntl80 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset16 } from "@leagueplatform/asset-config";
var { WARNING_ICON: WARNING_ICON2 } = HEALTH_JOURNEY_ASSET_KEYS;
var ButtonLink = genesisStyled23(Link16)`
  background: none;
  border: none;
`;
var SyncErrorBanner = ({
  programDataPoints,
  onClickFixSyncIssue
}) => {
  const warningOrangeIcon = handleStaticAsset16(WARNING_ICON2);
  const { formatMessage, formatList, $tmap } = useIntl80();
  const getDataPointMessage = $tmap({
    distance: "DISTANCE",
    steps: "STEPS",
    active_duration: "ACTIVE_DURATION",
    mindful_duration: "MINDFUL_DURATION",
    floors_climbed: "FLOORS_CLIMBED",
    energy_burned: "ENERGY_BURNED"
  });
  return /* @__PURE__ */ React156.createElement(
    HighlightBanner,
    {
      title: formatMessage({ id: "SYNC_ISSUE" }),
      icon: warningOrangeIcon,
      backgroundColor: "warning.background.subdued"
    },
    formatMessage(
      { id: "DATAPOINT_SYNC_ISSUE" },
      {
        dataPoint: formatList(
          programDataPoints.map(
            (dataPoint) => getDataPointMessage(dataPoint)
          )
        )
      }
    ),
    /* @__PURE__ */ React156.createElement(Box81, null, /* @__PURE__ */ React156.createElement(
      ButtonLink,
      {
        as: "button",
        fontSize: "subtitle2",
        marginTop: "half",
        onClick: onClickFixSyncIssue
      },
      formatMessage({ id: "FIX_SYNC_ISSUE" })
    ))
  );
};

// src/pages/activity-details/components/activity-caption.component.js
import React157 from "react";
import { SubtitleTwo as SubtitleTwo5, Flex as Flex29, Box as Box82 } from "@leagueplatform/genesis-commons";
import { arrayToTag as arrayToTag3 } from "@leagueplatform/web-common";
import { ChallengeActivityTokenCaption as ChallengeActivityTokenCaption2 } from "@leagueplatform/challenges";
import { Icon as Icon16 } from "@leagueplatform/genesis-core";
import {
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS18,
  ACTIVITY_CAMPAIGN_TYPE as ACTIVITY_CAMPAIGN_TYPE13
} from "@leagueplatform/health-journey-common";

// src/common/health-activity.props.js
import {
  bool as bool5,
  string as string10,
  number as number9,
  func as func4,
  arrayOf as arrayOf3,
  shape as shape3,
  oneOf as oneOf3,
  node as node6
} from "prop-types";
import { COMPLETION_METHOD_TYPES as COMPLETION_METHOD_TYPES5 } from "@leagueplatform/health-journey-common";
var { BASE: BASE3 } = COMPLETION_METHOD_TYPES5;
var activityPropType = {
  hasError: bool5,
  startDate: string10,
  campaignInfo: shape3({
    campaign_type: string10,
    assigned: bool5,
    assigned_by_title: string10
  }),
  ready: bool5,
  activityType: string10,
  tagline: string10,
  name: string10,
  activityPoints: number9,
  suggestionDescription: string10,
  iconUrl: string10,
  description: string10,
  richTextDescription: string10,
  informationTitle: string10,
  informationDescription: string10,
  helpfulTips: arrayOf3(
    shape3({
      type: string10,
      title: string10,
      url: string10,
      helpfulTipImage: string10
    })
  ),
  disclaimerTitle: string10,
  disclaimerDescription: string10,
  status: string10,
  cta: shape3({
    mark_as_complete: bool5,
    text: string10,
    url: string10,
    completion_method: shape3({
      type: oneOf3(Object.values(COMPLETION_METHOD_TYPES5)),
      text: string10,
      steps: arrayOf3(string10)
    })
  }),
  activityId: string10,
  campaignMode: string10,
  references: string10,
  activityTokens: number9,
  tokensEarned: number9
};
var activityDefaultProps = {
  hasError: false,
  startDate: "",
  campaignInfo: {
    campaign_type: "",
    assigned: false,
    assigned_by_title: ""
  },
  ready: true,
  activityPoints: 0,
  activityType: "",
  suggestionDescription: "",
  tagline: "",
  name: "",
  iconUrl: "",
  description: "",
  richTextDescription: "",
  informationTitle: "",
  informationDescription: "",
  helpfulTips: [],
  disclaimerTitle: "",
  disclaimerDescription: "",
  status: "",
  cta: {
    mark_as_complete: false,
    text: "",
    url: "",
    completion_method: {
      type: BASE3,
      text: ""
    }
  },
  activityId: "",
  campaignMode: null,
  references: "",
  tokensEarned: 0
};
var achievementPropType = shape3({
  id: string10,
  name: string10,
  description: string10,
  image: shape3({
    small: string10,
    medium: string10,
    large: string10
  }),
  progress: shape3({
    overall: number9,
    title: string10,
    criteria: shape3({
      action: string10,
      message: string10,
      threshold: number9,
      current: number9,
      is_completed: bool5
    })
  }),
  description_earned: string10,
  description_title: string10,
  celebration_subtitle: string10,
  completions: number9
});
var achievementArrayPropType = arrayOf3(achievementPropType);
var activityFooterPropType = __spreadProps(__spreadValues({}, activityPropType), {
  requestSetUserHealthActivityComplete: func4.isRequired,
  primaryAction: func4.isRequired,
  primaryCtaText: func4.isRequired,
  onCloseCompleteActivityModal: func4.isRequired,
  showCompleteActivityModal: bool5,
  showDeleteActivityModal: bool5,
  toggleDeleteActivityModal: func4.isRequired,
  requestSetUserHealthActivityDelete: func4.isRequired,
  onClose: func4.isRequired,
  isRemovable: bool5,
  completionData: shape3({
    eyebrow_headline: string10,
    title: string10,
    description_one: string10,
    description_two: string10,
    image: string10,
    rewards_message: string10
  }),
  isActivityDetailsView: bool5,
  activityHasMetCompletionCriteria: bool5.isRequired,
  startDate: string10,
  endDate: string10,
  canExpire: bool5.isRequired,
  showAchievements: bool5,
  inProgressProgramAchievements: achievementArrayPropType,
  inProgressWeeklyStreakAchievements: achievementArrayPropType,
  inProgressActivityAchievements: achievementArrayPropType,
  completedTotalAchievements: achievementArrayPropType,
  showCelebrationAchievementModal: bool5,
  toggleCelebrationAchievementModal: func4.isRequired,
  errorMsg: node6
});
var activityFooterDefaultProps = __spreadProps(__spreadValues({}, activityDefaultProps), {
  showCompleteActivityModal: false,
  showDeleteActivityModal: false,
  isRemovable: true,
  completionData: {
    eyebrow_headline: "",
    title: "",
    description_one: "",
    description_two: "",
    image: "",
    rewards_message: ""
  },
  isActivityDetailsView: true,
  startDate: "",
  endDate: "",
  showAchievements: false,
  inProgressProgramAchievements: [],
  inProgressWeeklyStreakAchievements: [],
  inProgressActivityAchievements: [],
  completedTotalAchievements: [],
  showCelebrationAchievementModal: false,
  errorMsg: null
});
var mapToProps = (activity) => {
  const _a = activity, {
    status,
    activityPoints,
    pointsEarned,
    tokensEarned,
    activityTokens,
    campaignInfo,
    startDate
  } = _a, activityShort = __objRest(_a, [
    "status",
    "activityPoints",
    "pointsEarned",
    "tokensEarned",
    "activityTokens",
    "campaignInfo",
    "startDate"
  ]);
  return __spreadValues({
    status,
    activity_points: activityPoints,
    points_earned: pointsEarned,
    tokens_earned: tokensEarned,
    activity_tokens: activityTokens,
    campaign_info: campaignInfo,
    start_date: startDate
  }, activityShort);
};

// src/pages/activity-details/components/activity-caption.component.js
var { COMPLETED: COMPLETED10 } = HEALTH_JOURNEY_ACTIVITY_STATUS18;
var { CHALLENGE: CHALLENGE9 } = ACTIVITY_CAMPAIGN_TYPE13;
var ActivityCaption = (activity) => {
  const activityAll = mapToProps(activity);
  const { expires, points, assigned } = useHealthActivityCaption(activityAll);
  const { status, tokensEarned, activityTokens, campaignInfo } = activity;
  const fullCaptionText = campaignInfo.campaignType === CHALLENGE9 ? arrayToTag3([expires], true) : arrayToTag3([assigned, expires, points], true);
  return /* @__PURE__ */ React157.createElement(Flex29, { marginBottom: "oneAndHalf" }, (assigned || expires) && /* @__PURE__ */ React157.createElement(
    Icon16,
    {
      icon: "descriptiveCalendar",
      size: "12px",
      css: { marginY: "auto", marginInlineEnd: "$half" }
    }
  ), /* @__PURE__ */ React157.createElement(
    SubtitleTwo5,
    {
      as: "span",
      color: status.toLowerCase() === COMPLETED10 ? "onSurface.text.subdued" : "inherit"
    },
    fullCaptionText,
    campaignInfo.campaignType === CHALLENGE9 && points && /* @__PURE__ */ React157.createElement(React157.Fragment, null, fullCaptionText && /* @__PURE__ */ React157.createElement(Box82, { as: "span", marginX: "quarter" }, "\u2219"), /* @__PURE__ */ React157.createElement(
      ChallengeActivityTokenCaption2,
      {
        tokens: activityTokens || tokensEarned,
        activityDesc: points
      }
    ))
  ));
};
ActivityCaption.propTypes = activityPropType;
ActivityCaption.defaultProps = activityDefaultProps;

// src/pages/activity-details/components/activity-progress-counter.component.js
import React158, { Suspense as Suspense2, useEffect as useEffect30, useState as useState23, useRef as useRef13 } from "react";
import { func as func5 } from "prop-types";
import {
  Box as Box83,
  Flex as Flex30,
  HeadingOne as HeadingOne4,
  HeadingThree as HeadingThree12,
  Overline as Overline6,
  PrimaryButton as PrimaryButton6,
  SubtitleOne as SubtitleOne7,
  genesisStyled as genesisStyled24,
  SecondaryButton,
  useTheme as useTheme5
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl81 } from "@leagueplatform/locales";
import { CompoundProgressBar as CompoundProgressBar3 } from "@leagueplatform/ui-kit";
import { ConfettiAnimation as ConfettiAnimation2 } from "@leagueplatform/lottie";
import {
  HEALTH_JOURNEY_ACTIVITY_STATUS as HEALTH_JOURNEY_ACTIVITY_STATUS19,
  ViewTransitionController as ViewTransitionController5
} from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset17 } from "@leagueplatform/asset-config";
var COUNT_ACTIVITY_INPUT_METHODS = Object.freeze({
  SINGLE: "single",
  MULTI: "multi"
});
var { ACTIVE: ACTIVE10 } = HEALTH_JOURNEY_ACTIVITY_STATUS19;
var { SINGLE, MULTI } = COUNT_ACTIVITY_INPUT_METHODS;
var { MINUS: MINUS2, PLUS: PLUS2 } = HEALTH_JOURNEY_ASSET_KEYS;
var acceptedInputMethods = Object.values(COUNT_ACTIVITY_INPUT_METHODS);
var transitionTempo2 = "0.2s ease-out";
var maxValue = 99999;
var MinusIcon2 = ({ disabled }) => handleStaticAsset17(MINUS2, {
  isComponent: true,
  props: { disabled, display: "block" }
});
var PlusIcon2 = ({ disabled }) => handleStaticAsset17(PLUS2, {
  isComponent: true,
  props: { disabled, display: "block" }
});
var CircleButton = genesisStyled24(PrimaryButton6)`
  border-radius: 50%;
  padding: ${({ theme: { space } }) => space.threeQuarters}px;
  transition: background ${transitionTempo2};
  &:disabled, &:disabled:hover {
    background-color: ${({ theme: { colors } }) => colors.surface.card.disabled}
  };
`;
var ConfettiAnimationContainer = genesisStyled24(Flex30)`
  align-items: center;
  opacity: ${({ isVisible }) => isVisible ? 1 : 0};
  pointer-events: none;
  position: relative;
  transition: opacity 0.2s ease-out;
  width: 100%;
  `;
var ActivityProgressCounter = ({
  hasError,
  cta,
  status,
  handleChange,
  name,
  progress = 0
}) => {
  const activityAnalytics = useActivityAnalytics();
  const { completion_method: completionMethod } = cta;
  const { text: title, counter } = completionMethod;
  const { goal, unit, inputMethods } = counter;
  const { colors } = useTheme5();
  const { formatMessage, formatNumber } = useIntl81();
  const celebrationAnimationRef = useRef13(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState23(false);
  const [count, setCount] = useState23(progress);
  const [inputMethodUsed, setInputMethodUsed] = useState23(null);
  useEffect30(() => {
    if (count !== progress && inputMethodUsed) {
      handleChange({
        newValue: count,
        oldValue: progress,
        inputMethod: inputMethodUsed
      });
    }
  }, [count, progress, inputMethodUsed]);
  const progressPercent = count / goal * 100;
  const progressBarConfig = [
    {
      key: "activity-progress-count",
      color: colors.highlight.icon,
      percent: progressPercent,
      transition: `width 0.5s ease-out`
    }
  ];
  const subtitle = formatMessage({ id: "ACTIVITY_COUNT_GOAL" }, { goal, unit });
  const editLabel = `${formatMessage({ id: "EDIT" })} ${unit}`;
  const incrementButtonLabel = `${formatMessage({ id: "ADD" })} 1`;
  const decrementButtonLabel = `${formatMessage({ id: "REMOVE" })} 1`;
  const isActivityActive = status === ACTIVE10;
  const isGoalReached = count >= goal;
  const shouldPlayCelebration = isActivityActive && isGoalReached;
  const disableCountChange = status !== HEALTH_JOURNEY_ACTIVITY_STATUS19.ACTIVE;
  const disableCountDecrement = disableCountChange || count === 0;
  const disableCountIncrement = disableCountChange || count === maxValue;
  const inferDefaultInputMethod = !(inputMethods == null ? void 0 : inputMethods.some(
    (inputMethod) => acceptedInputMethods.includes(inputMethod)
  ));
  const handleIncrementDecrement = (value) => () => {
    if (value <= maxValue) {
      setInputMethodUsed(SINGLE);
      setCount(normalizeNumberFromString({ value }));
    }
  };
  const handleEditCount = (value) => {
    setInputMethodUsed(MULTI);
    setCount(normalizeNumberFromString({ value }));
  };
  const handleEditModalClose = () => setIsEditModalOpen(false);
  const modals = {
    [MULTI]: {
      view: EditProgressCountModal,
      props: {
        name,
        heading: unit,
        subtitle,
        initialValue: count,
        altText: editLabel,
        disabled: disableCountChange,
        onClose: handleEditModalClose,
        onSave: handleEditCount
      }
    }
  };
  const handleActiveModal = () => {
    if (isEditModalOpen) {
      activityAnalytics.sendOpenEditActivityProgressModal(editLabel);
      return MULTI;
    }
    return "";
  };
  useEffect30(() => {
    const { current: animation } = celebrationAnimationRef;
    if (shouldPlayCelebration) {
      animation == null ? void 0 : animation.goToAndPlay(0);
    }
  }, [shouldPlayCelebration]);
  return /* @__PURE__ */ React158.createElement(Box83, { marginTop: "oneAndHalf", maxWidth: "408px" }, title && /* @__PURE__ */ React158.createElement(
    HeadingThree12,
    {
      as: "h2",
      marginBottom: "quarter",
      display: "flex",
      alignItems: "center"
    },
    title
  ), subtitle && /* @__PURE__ */ React158.createElement(Overline6, { as: "p", color: "onSurface.text.subdued", fontWeight: "medium" }, subtitle), /* @__PURE__ */ React158.createElement(Box83, { marginTop: "one" }, /* @__PURE__ */ React158.createElement(Flex30, { justifyContent: "space-between", marginBottom: "one" }, /* @__PURE__ */ React158.createElement(Flex30, { alignItems: "flex-end" }, /* @__PURE__ */ React158.createElement(HeadingOne4, { as: "p", "data-testid": "count-text" }, formatNumber(count), /* @__PURE__ */ React158.createElement(
    SubtitleOne7,
    {
      as: "span",
      color: "onSurface.text.subdued",
      marginInlineStart: "quarter"
    },
    unit
  ))), (inputMethods == null ? void 0 : inputMethods.includes(SINGLE)) && /* @__PURE__ */ React158.createElement(Flex30, null, /* @__PURE__ */ React158.createElement(
    CircleButton,
    {
      "data-testid": "increment-btn",
      "aria-label": decrementButtonLabel,
      disabled: disableCountDecrement,
      onClick: handleIncrementDecrement(count - 1)
    },
    /* @__PURE__ */ React158.createElement(MinusIcon2, { disabled: disableCountDecrement })
  ), /* @__PURE__ */ React158.createElement(
    CircleButton,
    {
      "data-testid": "increment-btn",
      "aria-label": incrementButtonLabel,
      disabled: disableCountIncrement,
      marginInlineStart: "one",
      onClick: handleIncrementDecrement(count + 1)
    },
    /* @__PURE__ */ React158.createElement(PlusIcon2, { disabled: disableCountIncrement })
  ))), /* @__PURE__ */ React158.createElement(ConfettiAnimationContainer, { isVisible: shouldPlayCelebration }, /* @__PURE__ */ React158.createElement(Suspense2, { fallback: null }, /* @__PURE__ */ React158.createElement(
    ConfettiAnimation2,
    {
      animationRef: celebrationAnimationRef,
      lottieConfig: { autoplay: shouldPlayCelebration }
    }
  ))), /* @__PURE__ */ React158.createElement(CompoundProgressBar3, { segments: progressBarConfig }), hasError && /* @__PURE__ */ React158.createElement(ActivityErrorMessage, { marginTop: "one", justifyContent: "flex-start" }, formatMessage({ id: "PROGRESS_RECORD_ERROR" }))), ((inputMethods == null ? void 0 : inputMethods.includes(MULTI)) || inferDefaultInputMethod) && /* @__PURE__ */ React158.createElement(Box83, { marginTop: "three" }, /* @__PURE__ */ React158.createElement(
    SecondaryButton,
    {
      "data-testid": "edit-btn",
      disabled: disableCountChange,
      onClick: () => setIsEditModalOpen(true),
      transition: `color ${transitionTempo2}, background ${transitionTempo2}`
    },
    editLabel
  )), /* @__PURE__ */ React158.createElement(
    ViewTransitionController5,
    {
      views: modals,
      handleActiveView: handleActiveModal
    }
  ));
};
ActivityProgressCounter.propTypes = __spreadProps(__spreadValues({}, activityPropType), {
  handleChange: func5.isRequired
});
ActivityProgressCounter.defaultProps = activityDefaultProps;

// src/pages/activity-details/components/activity-details-description.component.js
import React159 from "react";
import { string as string11 } from "prop-types";
import { Box as Box84, BodyTwo as BodyTwo6 } from "@leagueplatform/genesis-commons";
import { splitAtNewlines, HtmlToReact as HtmlToReact4 } from "@leagueplatform/web-common";
var ActivityDetailsDescription = ({ text, richText }) => {
  if (richText) {
    return /* @__PURE__ */ React159.createElement(Box84, { css: { whiteSpace: "pre-line" } }, /* @__PURE__ */ React159.createElement(
      HtmlToReact4,
      {
        htmlString: richText,
        options: ActivityHtmlToReactOptions
      }
    ));
  }
  if (text) {
    return splitAtNewlines(text).map((line) => /* @__PURE__ */ React159.createElement(BodyTwo6, { key: line, marginBottom: "oneAndHalf" }, line));
  }
  return null;
};
ActivityDetailsDescription.propTypes = {
  text: string11,
  richText: string11
};
ActivityDetailsDescription.defaultProps = {
  text: "",
  richText: ""
};

// src/pages/activity-details/components/activity-suggestion-banner.component.js
import React160 from "react";
import { string as string12 } from "prop-types";
import { BodyTwo as BodyTwo7 } from "@leagueplatform/genesis-commons";
import { HighlightBanner as HighlightBanner2 } from "@leagueplatform/web-common-components";
var ActivitySuggestionBanner = ({
  title,
  description,
  iconUrl,
  campaignMode
}) => campaignMode ? /* @__PURE__ */ React160.createElement(HighlightBanner2, { title, icon: iconUrl }, description) : /* @__PURE__ */ React160.createElement(BodyTwo7, { marginBottom: "oneAndHalf", color: "onSurface.text.subdued" }, description);
ActivitySuggestionBanner.propTypes = {
  title: string12.isRequired,
  description: string12.isRequired,
  iconUrl: string12.isRequired,
  campaignMode: string12
};
ActivitySuggestionBanner.defaultProps = {
  campaignMode: void 0
};

// src/pages/activity-details/components/activity-exit-modals.component.js
import React161 from "react";
import PropTypes17 from "prop-types";
import { ViewTransitionController as ViewTransitionController6 } from "@leagueplatform/health-journey-common";
var { SAVE_PROGRESS } = ACTIVITY_EXIT_MODAL_TYPES;
var ExitModals = ({
  handleActiveView,
  activityId,
  onBack,
  onDismiss
}) => {
  const modals = {
    [SAVE_PROGRESS]: {
      view: SaveProgressModal,
      props: {
        activityId,
        onBack,
        onDismiss
      }
    }
  };
  return /* @__PURE__ */ React161.createElement(
    ViewTransitionController6,
    {
      views: modals,
      handleActiveView
    }
  );
};
ExitModals.propTypes = {
  handleActiveView: PropTypes17.func.isRequired,
  activityId: PropTypes17.string.isRequired,
  onBack: PropTypes17.func.isRequired,
  onDismiss: PropTypes17.func.isRequired
};

// src/pages/activity-details/activity-details.component.js
var { SAVE_PROGRESS: SAVE_PROGRESS2 } = ACTIVITY_EXIT_MODAL_TYPES;
var { AUTOMATIC } = USER_CONNECTED_DEVICE_CAMPAIGN_MODES2;
var ActivityDetailsLayout = genesisStyled25(Flex31)`
  flex-direction: column;
  height: 100%;
  inset: 0;
  position: absolute;
`;
var ActivityDetailsPage = () => {
  const navigate = useNavigate10();
  const { formatMessage } = useIntl82();
  useDocumentTitle7(formatMessage({ id: "PAGE_TITLE_ACTIVITY_DETAILS" }));
  useScrollTopOnLocationChange();
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery19(
    JOURNEY_MANAGER_ENABLED5
  );
  const {
    activityId,
    activityPoints,
    activityTokens,
    activityType,
    campaignInfo,
    campaignMode,
    description,
    disclaimerBanner,
    hasError,
    helpfulTips,
    iconUrl,
    informationBanner,
    name,
    startDate,
    pointsEarned,
    ready,
    redirectLink,
    references,
    richTextDescription,
    status,
    suggestionBanner,
    tagline,
    tokensEarned,
    error
  } = useHealthActivity();
  const { entrypointPath, returnToEntrypoint } = useActivityLink();
  const { delayOverlayActive, setDelayOverlayActive } = useApiDelayOverlay4();
  const { promptToCompleteActivity, shouldUseCounter, counterProps } = useActivityProgressCounter();
  const activityAnalytics = useActivityAnalytics();
  const isActivityVerifiable = campaignMode === AUTOMATIC;
  const {
    isLoading: verifiableProgressIsLoading,
    data: verifiableProgressData
  } = useVerifiableActivityProgressQuery(activityId, isActivityVerifiable);
  const hasSyncError = isActivityVerifiable && !verifiableProgressIsLoading && !(verifiableProgressData == null ? void 0 : verifiableProgressData.receiving_data);
  const verifiableProgressDataType = verifiableProgressData == null ? void 0 : verifiableProgressData.data_type;
  const isAssigned2 = Boolean(campaignInfo == null ? void 0 : campaignInfo.assigned) && isJourneyManagerEnabled;
  const getIsAssignedInternalProgram = (url) => {
    let redirectBackToActivity = false;
    if (isAssigned2 && url.includes(JOURNEY_ROUTES28.programsHome())) {
      redirectBackToActivity = true;
    }
    return redirectBackToActivity;
  };
  const [isExiting, setIsExiting] = useState24(false);
  const [
    isUnavailableDeviceConnectModalOpen,
    setIsUnavailableDeviceConnectModalOpen
  ] = useState24(false);
  useEffect31(() => {
    if (ready && activityId) {
      activityAnalytics.sendViewActivity();
    }
  }, [ready, activityId]);
  if (redirectLink) {
    navigate(redirectLink);
  }
  if (!ready) {
    return /* @__PURE__ */ React162.createElement(LoadingIndicator5, null);
  }
  if (hasError) {
    return /* @__PURE__ */ React162.createElement(
      Flex31,
      {
        padding: { _: "oneAndHalf", phone: "twoAndHalf" },
        flexDirection: { _: "column", phone: "row" },
        margin: "0 auto",
        justifyContent: "center"
      },
      /* @__PURE__ */ React162.createElement(
        BackButtonArrow7,
        {
          fontSize: "heading3",
          color: "onSurface.text.primary",
          marginInlineEnd: "one",
          marginY: "half",
          justifyContent: "initial",
          onClick: returnToEntrypoint
        }
      ),
      /* @__PURE__ */ React162.createElement(Box85, { marginTop: "three" }, /* @__PURE__ */ React162.createElement(ErrorState7, { error }))
    );
  }
  const onBack = () => entrypointPath;
  const handleBackClick = (e) => {
    if (promptToCompleteActivity) {
      e.preventDefault();
      setIsExiting(true);
      return;
    }
    activityAnalytics.sendCloseActivity();
  };
  const controlExitModal = () => isExiting && promptToCompleteActivity ? SAVE_PROGRESS2 : "";
  const handleSaveProgressModalDismiss = () => setIsExiting(false);
  return /* @__PURE__ */ React162.createElement(ActivityDetailsLayout, null, isUnavailableDeviceConnectModalOpen && /* @__PURE__ */ React162.createElement(
    UnavailableDeviceConnectModal,
    {
      onClose: () => setIsUnavailableDeviceConnectModalOpen(false)
    }
  ), /* @__PURE__ */ React162.createElement(
    ActivityDetailsWrapper,
    {
      to: onBack,
      onBackClick: handleBackClick,
      flex: "1"
    },
    /* @__PURE__ */ React162.createElement(
      ActivityDetailsHeader,
      {
        title: name,
        overline: tagline,
        iconUrl
      },
      /* @__PURE__ */ React162.createElement(
        ActivityCaption,
        {
          activityPoints,
          pointsEarned,
          status,
          startDate,
          tokensEarned,
          activityTokens,
          campaignInfo
        }
      ),
      /* @__PURE__ */ React162.createElement(
        ActivityStatusBadge,
        {
          marginBottom: "two",
          marginTop: "oneAndHalf",
          status
        }
      ),
      hasSyncError && verifiableProgressDataType && /* @__PURE__ */ React162.createElement(
        SyncErrorBanner,
        {
          programDataPoints: [verifiableProgressDataType],
          onClickFixSyncIssue: () => setIsUnavailableDeviceConnectModalOpen(true)
        }
      ),
      isActivityVerifiable && /* @__PURE__ */ React162.createElement(ProgressTracker, { activityId }),
      suggestionBanner && /* @__PURE__ */ React162.createElement(
        ActivitySuggestionBanner,
        {
          campaignMode,
          title: suggestionBanner == null ? void 0 : suggestionBanner.title,
          description: suggestionBanner == null ? void 0 : suggestionBanner.description,
          iconUrl: suggestionBanner == null ? void 0 : suggestionBanner.icon_url
        }
      )
    ),
    /* @__PURE__ */ React162.createElement(Box85, null, /* @__PURE__ */ React162.createElement(
      ActivityDetailsDescription,
      {
        text: description,
        richText: richTextDescription
      }
    ), informationBanner && /* @__PURE__ */ React162.createElement(React162.Fragment, null, /* @__PURE__ */ React162.createElement(HeadingFour8, { as: "h2", marginBottom: "one" }, informationBanner == null ? void 0 : informationBanner.title), splitAtNewlines2(informationBanner == null ? void 0 : informationBanner.description).map(
      (partDescription) => /* @__PURE__ */ React162.createElement(BodyTwo8, { key: partDescription, marginBottom: "oneAndHalf" }, partDescription)
    )), helpfulTips && (helpfulTips == null ? void 0 : helpfulTips.length) && helpfulTips.map(({ id, type, title, url, helpfulTipImage }) => /* @__PURE__ */ React162.createElement(
      ActivityHelpfulTip,
      {
        key: title,
        id,
        type,
        title,
        url,
        activityName: name,
        activityType,
        image: helpfulTipImage,
        activityId,
        isAssigned: isAssigned2,
        redirectBackToAssigned: getIsAssignedInternalProgram(url)
      }
    )), shouldUseCounter && /* @__PURE__ */ React162.createElement(
      ActivityProgressCounter,
      __spreadValues({}, counterProps)
    ), disclaimerBanner && /* @__PURE__ */ React162.createElement(BodyTwo8, { marginTop: "oneAndHalf" }, `${disclaimerBanner == null ? void 0 : disclaimerBanner.title}: ${disclaimerBanner == null ? void 0 : disclaimerBanner.description}`), /* @__PURE__ */ React162.createElement(
      ActivityReferences,
      {
        marginBottom: "one",
        marginTop: "three",
        references
      }
    ))
  ), /* @__PURE__ */ React162.createElement(
    ExitModals,
    {
      activityId,
      onBack,
      onDismiss: handleSaveProgressModalDismiss,
      handleActiveView: controlExitModal
    }
  ), /* @__PURE__ */ React162.createElement(React162.Suspense, { fallback: null }, delayOverlayActive && /* @__PURE__ */ React162.createElement(ApiDelayOverlay2, { onClose: () => setDelayOverlayActive(false) })), /* @__PURE__ */ React162.createElement(ActivityFooter, null));
};

// src/components/masonry/program-overview/program-overview-history.page.tsx
import { Box as Box86 } from "@leagueplatform/genesis-core";
import { getMasonryDriver as getMasonryDriver5 } from "@leagueplatform/masonry";
import { MasonryEngine as MasonryEngine5 } from "@leagueplatform/masonry-engine";
import { useParams as useParams5 } from "@leagueplatform/routing";
import React163, { useMemo as useMemo41 } from "react";
function ProgramOverviewHistoryPage() {
  const { programId } = useParams5();
  const MasonryActivitiesDriver2 = useMemo41(
    () => getMasonryDriver5({
      rootNodeId: "journeyProgramOverview$allProgramActivityHistory",
      queryParams: {
        programId: programId || ""
      }
    }),
    [programId]
  );
  return /* @__PURE__ */ React163.createElement(
    Box86,
    {
      css: {
        padding: "$two",
        maxWidth: "600px"
      }
    },
    /* @__PURE__ */ React163.createElement(MasonryEngine5, { driver: MasonryActivitiesDriver2 })
  );
}

// src/components/masonry/program-overview/program-overview.page.tsx
import { Box as Box87, StackLayout as StackLayout50 } from "@leagueplatform/genesis-core";
import { getMasonryDriver as getMasonryDriver6 } from "@leagueplatform/masonry";
import { MasonryEngine as MasonryEngine6 } from "@leagueplatform/masonry-engine";
import { useParams as useParams6 } from "@leagueplatform/routing";
import React164 from "react";
function ProgramOverviewPage() {
  const { programId } = useParams6();
  const MasonryActivitiesDriver2 = getMasonryDriver6({
    rootNodeId: "journeyProgramOverview$root",
    queryParams: {
      programId: programId || ""
    }
  });
  return /* @__PURE__ */ React164.createElement(StackLayout50, { horizontalAlignment: "center" }, /* @__PURE__ */ React164.createElement(
    Box87,
    {
      css: {
        maxWidth: PROGRAM_OVERVIEW_PAGE_LAYOUT_MAX_WIDTH
      }
    },
    /* @__PURE__ */ React164.createElement(MasonryEngine6, { driver: MasonryActivitiesDriver2 })
  ));
}

// src/health-journey-subroutes.tsx
var HealthJourneySubroutes = () => {
  const { isChallengesEnabled } = useIsChallengesEnabled();
  const { data: isJourneyWellnessAndRewardsEnabled } = useFeatureFlagQuery20(
    JOURNEY_WELLNESS_AND_REWARDS
  );
  const { data: isRewardProgramsEnabled } = useFeatureFlagQuery20(
    REWARDS_PROGRAMS_ENABLED
  );
  return /* @__PURE__ */ React165.createElement(Routes2, null, /* @__PURE__ */ React165.createElement(Route2, { path: "activities-list", element: /* @__PURE__ */ React165.createElement(ViewAllPageWrapper, null) }), isJourneyWellnessAndRewardsEnabled && /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: `${HEALTH_ASSESSMENT_REPORT2}`,
      element: /* @__PURE__ */ React165.createElement(HealthAssessmentReport, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "campaign/:campaignId/activity/:activityId",
      element: /* @__PURE__ */ React165.createElement(ActivityDetailsPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "campaign/:campaignId/activity/:activityId/toolbox",
      element: /* @__PURE__ */ React165.createElement(HealthActivityPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "activity/:userActivityId/toolbox",
      element: /* @__PURE__ */ React165.createElement(HealthActivityPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(Route2, { path: ":userActivityId/steps", element: /* @__PURE__ */ React165.createElement(ActivityStepsPage, null) }), /* @__PURE__ */ React165.createElement(Route2, { path: ":userActivityId", element: /* @__PURE__ */ React165.createElement(ActivityDetailsPage, null) }), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "activity/:userActivityId/steps",
      element: /* @__PURE__ */ React165.createElement(ActivityStepsPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "activity/:userActivityId",
      element: /* @__PURE__ */ React165.createElement(ActivityDetailsPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "suggested/:groupId/*",
      element: /* @__PURE__ */ React165.createElement(SuggestedActivitiesPage, null)
    }
  ), isChallengesEnabled && /* @__PURE__ */ React165.createElement(Route2, { path: "challenges/*", element: /* @__PURE__ */ React165.createElement(ChallengeRoutes, null) }), isRewardProgramsEnabled && /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "reward-program/:userHealthCampaignId/*",
      element: /* @__PURE__ */ React165.createElement(RewardProgramLandingPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(
    Route2,
    {
      path: "program/:programId/history",
      element: /* @__PURE__ */ React165.createElement(ProgramOverviewHistoryPage, null)
    }
  ), /* @__PURE__ */ React165.createElement(Route2, { path: "program/:programId", element: /* @__PURE__ */ React165.createElement(ProgramOverviewPage, null) }), /* @__PURE__ */ React165.createElement(Route2, { element: /* @__PURE__ */ React165.createElement(HealthJourneyPage, null), path: "/*" }));
};

// src/health-journey-routes.tsx
var HealthJourneyRoutes = () => {
  const {
    data: isNewJourneyExperienceEnabled,
    isLoading: isNewJourneyExperienceEnabledLoading
  } = useFeatureFlagQuery21(ENABLE_NEW_JOURNEY_EXPERIENCE2);
  const routes = /* @__PURE__ */ React166.createElement(React166.Fragment, null, isNewJourneyExperienceEnabled && /* @__PURE__ */ React166.createElement(Route3, { index: true, element: /* @__PURE__ */ React166.createElement(ConfigurableJourneyExperience, null) }), useNestedAbsoluteRoute({
    element: /* @__PURE__ */ React166.createElement(HealthProgramsRoutes, null),
    base: getModulePath6(LEAGUE_MODULE_NAMES6.healthPrograms),
    path: "/*"
  }), useNestedAbsoluteRoute({
    element: /* @__PURE__ */ React166.createElement(HealthJourneyProgressSubroutes, null),
    base: getModulePath6(LEAGUE_MODULE_NAMES6.healthProgress),
    path: "/*"
  }), useNestedAbsoluteRoute({
    element: /* @__PURE__ */ React166.createElement(HealthJourneySubroutes, null),
    base: getModulePath6(LEAGUE_MODULE_NAMES6.healthJourney),
    path: "/*"
  }), useNestedAbsoluteRoute({
    element: /* @__PURE__ */ React166.createElement(CareCollectionsPage, null),
    base: getModulePath6(LEAGUE_MODULE_NAMES6.careLibrary),
    path: "care-collections/:tag/*"
  }), useNestedAbsoluteRoute({
    element: /* @__PURE__ */ React166.createElement(TopicPage, null),
    base: getModulePath6(LEAGUE_MODULE_NAMES6.careLibrary),
    path: ":tag/*"
  }));
  if (isNewJourneyExperienceEnabledLoading) {
    return /* @__PURE__ */ React166.createElement(LoadingIndicator6, null);
  }
  return /* @__PURE__ */ React166.createElement(React166.Suspense, { fallback: /* @__PURE__ */ React166.createElement(LoadingIndicator6, null) }, /* @__PURE__ */ React166.createElement(Routes3, null, routes));
};

// src/index.ts
initModule();
initMasonryRegistry();
export {
  ActiveCampaigns,
  ActivityDetailsHeader,
  ActivityDetailsPage,
  ActivityDetailsWrapper,
  ActivityErrorMessage,
  ActivityFooter,
  ActivityStackWidget,
  ActivityStackWidgetV2,
  ActivityStepsPage,
  ArrowButton,
  BTN_SIZE,
  CompleteActivityModal,
  DeleteActivityModal,
  DynamicCoverImage,
  DynamicImage,
  EmptyStateCard2 as EmptyStateCard,
  HEALTH_JOURNEY_ASSET_KEYS,
  HEALTH_JOURNEY_ASSET_MAP,
  HEALTH_JOURNEY_NAMESPACE,
  HEALTH_JOURNEY_NODE_TYPES,
  HealthActivityCardList,
  HealthAssessmentReport,
  HealthJourneyHome,
  HealthJourneyPage,
  HealthJourneyRoutes,
  HealthRewardsSidebar,
  JourneyPageLayout,
  LEFT,
  NavigateByDate,
  PriorityActivityCTACard,
  ProgressActiveProgram,
  RIGHT,
  RewardsProgramCardCarouselWidget,
  RewardsProgramCardCarouselWidgetV2,
  SuggestedActivitiesPage,
  activitiesArrayPropType,
  activitiesGroupPropType,
  activitiesGroupsDefaultProps,
  activitiesGroupsProps,
  activityShortDefaultProps,
  activityShortPropType,
  activityStatusByDate,
  deriveActivityStatusFromDate,
  getDiffOfDates,
  hasActivityMetCompletionCriteria,
  isOptionValueInCurrentValue,
  journeyPageEmptyStateProps,
  journeyPageProps,
  normalizeEpochDate,
  sortByDate,
  useActivitiesTimelineAnalytics,
  useActivityAchievementsActions,
  useActivityAnalytics,
  useActivityFooterErrorMessage,
  useActivityStepsAnalytics,
  useCompleteUserHealthActivity,
  useDismissUserHealthActivity,
  useEmptyActivitiesState,
  useGetUserHealthActivities,
  useGetUserHealthActivity,
  useHealthActivityFooter,
  useHealthJourneyPage,
  useHealthJourneyProgress,
  useHealthPills,
  useJourneyProgressAnalytics,
  useSetActivityProgress
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/health-journey'] = window.leagueSDKsPresent['@leagueplatform/health-journey'] || [];
    window.leagueSDKsPresent['@leagueplatform/health-journey'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/health-journey'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/health-journey module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map